
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired76f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired76f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("MJPZu", function(module, exports) {
$parcel$export(module.exports, "css", () => (parcelRequire("hOpwk")).css);
$parcel$export(module.exports, "html", () => (parcelRequire("9UZF0")).html);
$parcel$export(module.exports, "LitElement", () => (parcelRequire("78EKQ")).LitElement);
$parcel$export(module.exports, "nothing", () => (parcelRequire("9UZF0")).nothing);
$parcel$export(module.exports, "render", () => (parcelRequire("9UZF0")).render);
parcelRequire("ksYdx");
parcelRequire("9UZF0");
parcelRequire("78EKQ");
parcelRequire("cOmOV");

});
parcelRegister("ksYdx", function(module, exports) {

$parcel$export(module.exports, "defaultConverter", () => $ee65220f9d593eba$export$7312b35fbf521afb);
$parcel$export(module.exports, "notEqual", () => $ee65220f9d593eba$export$53a6892c50694894);
$parcel$export(module.exports, "ReactiveElement", () => $ee65220f9d593eba$export$c7c07a37856565d);
$parcel$export(module.exports, "css", () => (parcelRequire("hOpwk")).css);

var $hOpwk = parcelRequire("hOpwk");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: $ee65220f9d593eba$var$i, defineProperty: $ee65220f9d593eba$var$e, getOwnPropertyDescriptor: $ee65220f9d593eba$var$r, getOwnPropertyNames: $ee65220f9d593eba$var$h, getOwnPropertySymbols: $ee65220f9d593eba$var$o, getPrototypeOf: $ee65220f9d593eba$var$n } = Object, $ee65220f9d593eba$var$a = globalThis, $ee65220f9d593eba$var$c = $ee65220f9d593eba$var$a.trustedTypes, $ee65220f9d593eba$var$l = $ee65220f9d593eba$var$c ? $ee65220f9d593eba$var$c.emptyScript : "", $ee65220f9d593eba$var$p = $ee65220f9d593eba$var$a.reactiveElementPolyfillSupport, $ee65220f9d593eba$var$d = (t, s)=>t, $ee65220f9d593eba$export$7312b35fbf521afb = {
    toAttribute (t, s) {
        switch(s){
            case Boolean:
                t = t ? $ee65220f9d593eba$var$l : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, s) {
        let i = t;
        switch(s){
            case Boolean:
                i = null !== t;
                break;
            case Number:
                i = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(t);
                } catch (t) {
                    i = null;
                }
        }
        return i;
    }
}, $ee65220f9d593eba$export$53a6892c50694894 = (t, s)=>!$ee65220f9d593eba$var$i(t, s), $ee65220f9d593eba$var$y = {
    attribute: !0,
    type: String,
    converter: $ee65220f9d593eba$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $ee65220f9d593eba$export$53a6892c50694894
};
Symbol.metadata ??= Symbol("metadata"), $ee65220f9d593eba$var$a.litPropertyMetadata ??= new WeakMap;
class $ee65220f9d593eba$export$c7c07a37856565d extends HTMLElement {
    static addInitializer(t) {
        this._$Ei(), (this.l ??= []).push(t);
    }
    static get observedAttributes() {
        return this.finalize(), this._$Eh && [
            ...this._$Eh.keys()
        ];
    }
    static createProperty(t, s = $ee65220f9d593eba$var$y) {
        if (s.state && (s.attribute = !1), this._$Ei(), this.elementProperties.set(t, s), !s.noAccessor) {
            const i = Symbol(), r = this.getPropertyDescriptor(t, i, s);
            void 0 !== r && $ee65220f9d593eba$var$e(this.prototype, t, r);
        }
    }
    static getPropertyDescriptor(t, s, i) {
        const { get: e, set: h } = $ee65220f9d593eba$var$r(this.prototype, t) ?? {
            get () {
                return this[s];
            },
            set (t) {
                this[s] = t;
            }
        };
        return {
            get () {
                return e?.call(this);
            },
            set (s) {
                const r = e?.call(this);
                h.call(this, s), this.requestUpdate(t, r, i);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) ?? $ee65220f9d593eba$var$y;
    }
    static _$Ei() {
        if (this.hasOwnProperty($ee65220f9d593eba$var$d("elementProperties"))) return;
        const t = $ee65220f9d593eba$var$n(this);
        t.finalize(), void 0 !== t.l && (this.l = [
            ...t.l
        ]), this.elementProperties = new Map(t.elementProperties);
    }
    static finalize() {
        if (this.hasOwnProperty($ee65220f9d593eba$var$d("finalized"))) return;
        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty($ee65220f9d593eba$var$d("properties"))) {
            const t = this.properties, s = [
                ...$ee65220f9d593eba$var$h(t),
                ...$ee65220f9d593eba$var$o(t)
            ];
            for (const i of s)this.createProperty(i, t[i]);
        }
        const t = this[Symbol.metadata];
        if (null !== t) {
            const s = litPropertyMetadata.get(t);
            if (void 0 !== s) for (const [t, i] of s)this.elementProperties.set(t, i);
        }
        this._$Eh = new Map;
        for (const [t, s] of this.elementProperties){
            const i = this._$Eu(t, s);
            void 0 !== i && this._$Eh.set(i, t);
        }
        this.elementStyles = this.finalizeStyles(this.styles);
    }
    static finalizeStyles(s) {
        const i = [];
        if (Array.isArray(s)) {
            const e = new Set(s.flat(1 / 0).reverse());
            for (const s of e)i.unshift((0, $hOpwk.getCompatibleStyle)(s));
        } else void 0 !== s && i.push((0, $hOpwk.getCompatibleStyle)(s));
        return i;
    }
    static _$Eu(t, s) {
        const i = s.attribute;
        return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    constructor(){
        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
    }
    _$Ev() {
        this._$ES = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t)=>t(this));
    }
    addController(t) {
        (this._$EO ??= new Set).add(t), void 0 !== this.renderRoot && this.isConnected && t.hostConnected?.();
    }
    removeController(t) {
        this._$EO?.delete(t);
    }
    _$E_() {
        const t = new Map, s = this.constructor.elementProperties;
        for (const i of s.keys())this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
        t.size > 0 && (this._$Ep = t);
    }
    createRenderRoot() {
        const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $hOpwk.adoptStyles)(t, this.constructor.elementStyles), t;
    }
    connectedCallback() {
        this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((t)=>t.hostConnected?.());
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        this._$EO?.forEach((t)=>t.hostDisconnected?.());
    }
    attributeChangedCallback(t, s, i) {
        this._$AK(t, i);
    }
    _$EC(t, s) {
        const i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
        if (void 0 !== e && !0 === i.reflect) {
            const r = (void 0 !== i.converter?.toAttribute ? i.converter : $ee65220f9d593eba$export$7312b35fbf521afb).toAttribute(s, i.type);
            this._$Em = t, null == r ? this.removeAttribute(e) : this.setAttribute(e, r), this._$Em = null;
        }
    }
    _$AK(t, s) {
        const i = this.constructor, e = i._$Eh.get(t);
        if (void 0 !== e && this._$Em !== e) {
            const t = i.getPropertyOptions(e), r = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== t.converter?.fromAttribute ? t.converter : $ee65220f9d593eba$export$7312b35fbf521afb;
            this._$Em = e, this[e] = r.fromAttribute(s, t.type), this._$Em = null;
        }
    }
    requestUpdate(t, s, i) {
        if (void 0 !== t) {
            if (i ??= this.constructor.getPropertyOptions(t), !(i.hasChanged ?? $ee65220f9d593eba$export$53a6892c50694894)(this[t], s)) return;
            this.P(t, s, i);
        }
        !1 === this.isUpdatePending && (this._$ES = this._$ET());
    }
    P(t, s, i) {
        this._$AL.has(t) || this._$AL.set(t, s), !0 === i.reflect && this._$Em !== t && (this._$Ej ??= new Set).add(t);
    }
    async _$ET() {
        this.isUpdatePending = !0;
        try {
            await this._$ES;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        if (!this.isUpdatePending) return;
        if (!this.hasUpdated) {
            if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
                for (const [t, s] of this._$Ep)this[t] = s;
                this._$Ep = void 0;
            }
            const t = this.constructor.elementProperties;
            if (t.size > 0) for (const [s, i] of t)!0 !== i.wrapped || this._$AL.has(s) || void 0 === this[s] || this.P(s, this[s], i);
        }
        let t = !1;
        const s = this._$AL;
        try {
            t = this.shouldUpdate(s), t ? (this.willUpdate(s), this._$EO?.forEach((t)=>t.hostUpdate?.()), this.update(s)) : this._$EU();
        } catch (s) {
            throw t = !1, this._$EU(), s;
        }
        t && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        this._$EO?.forEach((t)=>t.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$EU() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$ES;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        this._$Ej &&= this._$Ej.forEach((t)=>this._$EC(t, this[t])), this._$EU();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$ee65220f9d593eba$export$c7c07a37856565d.elementStyles = [], $ee65220f9d593eba$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, $ee65220f9d593eba$export$c7c07a37856565d[$ee65220f9d593eba$var$d("elementProperties")] = new Map, $ee65220f9d593eba$export$c7c07a37856565d[$ee65220f9d593eba$var$d("finalized")] = new Map, $ee65220f9d593eba$var$p?.({
    ReactiveElement: $ee65220f9d593eba$export$c7c07a37856565d
}), ($ee65220f9d593eba$var$a.reactiveElementVersions ??= []).push("2.0.4");

});
parcelRegister("hOpwk", function(module, exports) {

$parcel$export(module.exports, "css", () => $cf7ae70403817af6$export$dbf350e5966cf602);
$parcel$export(module.exports, "adoptStyles", () => $cf7ae70403817af6$export$2ca4a66ec4cecb90);
$parcel$export(module.exports, "getCompatibleStyle", () => $cf7ae70403817af6$export$ee69dfd951e24778);
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $cf7ae70403817af6$var$t = globalThis, $cf7ae70403817af6$export$b4d10f6001c083c2 = $cf7ae70403817af6$var$t.ShadowRoot && (void 0 === $cf7ae70403817af6$var$t.ShadyCSS || $cf7ae70403817af6$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $cf7ae70403817af6$var$s = Symbol(), $cf7ae70403817af6$var$o = new WeakMap;
class $cf7ae70403817af6$export$505d1e8739bad805 {
    constructor(t, e, o){
        if (this._$cssResult$ = !0, o !== $cf7ae70403817af6$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($cf7ae70403817af6$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $cf7ae70403817af6$var$o.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $cf7ae70403817af6$var$o.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $cf7ae70403817af6$export$8d80f9cac07cdb3 = (t)=>new $cf7ae70403817af6$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $cf7ae70403817af6$var$s), $cf7ae70403817af6$export$dbf350e5966cf602 = (t, ...e)=>{
    const o = 1 === t.length ? t[0] : e.reduce((e, s, o)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[o + 1], t[0]);
    return new $cf7ae70403817af6$export$505d1e8739bad805(o, t, $cf7ae70403817af6$var$s);
}, $cf7ae70403817af6$export$2ca4a66ec4cecb90 = (s, o)=>{
    if ($cf7ae70403817af6$export$b4d10f6001c083c2) s.adoptedStyleSheets = o.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet);
    else for (const e of o){
        const o = document.createElement("style"), n = $cf7ae70403817af6$var$t.litNonce;
        void 0 !== n && o.setAttribute("nonce", n), o.textContent = e.cssText, s.appendChild(o);
    }
}, $cf7ae70403817af6$export$ee69dfd951e24778 = $cf7ae70403817af6$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $cf7ae70403817af6$export$8d80f9cac07cdb3(e);
    })(t) : t;

});


parcelRegister("9UZF0", function(module, exports) {

$parcel$export(module.exports, "html", () => $73892c8321f141f4$export$c0bb0b647f701bb5);
$parcel$export(module.exports, "noChange", () => $73892c8321f141f4$export$9c068ae9cc5db4e8);
$parcel$export(module.exports, "nothing", () => $73892c8321f141f4$export$45b790e32b2810ee);
$parcel$export(module.exports, "_$LH", () => $73892c8321f141f4$export$8613d1ca9052b22e);
$parcel$export(module.exports, "render", () => $73892c8321f141f4$export$b3890eb0ae9dca99);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $73892c8321f141f4$var$t = globalThis, $73892c8321f141f4$var$i = $73892c8321f141f4$var$t.trustedTypes, $73892c8321f141f4$var$s = $73892c8321f141f4$var$i ? $73892c8321f141f4$var$i.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $73892c8321f141f4$var$e = "$lit$", $73892c8321f141f4$var$h = `lit$${(Math.random() + "").slice(9)}$`, $73892c8321f141f4$var$o = "?" + $73892c8321f141f4$var$h, $73892c8321f141f4$var$n = `<${$73892c8321f141f4$var$o}>`, $73892c8321f141f4$var$r = document, $73892c8321f141f4$var$l = ()=>$73892c8321f141f4$var$r.createComment(""), $73892c8321f141f4$var$c = (t)=>null === t || "object" != typeof t && "function" != typeof t, $73892c8321f141f4$var$a = Array.isArray, $73892c8321f141f4$var$u = (t)=>$73892c8321f141f4$var$a(t) || "function" == typeof t?.[Symbol.iterator], $73892c8321f141f4$var$d = "[ 	\n\f\r]", $73892c8321f141f4$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $73892c8321f141f4$var$v = /-->/g, $73892c8321f141f4$var$_ = />/g, $73892c8321f141f4$var$m = RegExp(`>|${$73892c8321f141f4$var$d}(?:([^\\s"'>=/]+)(${$73892c8321f141f4$var$d}*=${$73892c8321f141f4$var$d}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $73892c8321f141f4$var$p = /'/g, $73892c8321f141f4$var$g = /"/g, $73892c8321f141f4$var$$ = /^(?:script|style|textarea|title)$/i, $73892c8321f141f4$var$y = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $73892c8321f141f4$export$c0bb0b647f701bb5 = $73892c8321f141f4$var$y(1), $73892c8321f141f4$export$7ed1367e7fa1ad68 = $73892c8321f141f4$var$y(2), $73892c8321f141f4$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $73892c8321f141f4$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $73892c8321f141f4$var$A = new WeakMap, $73892c8321f141f4$var$E = $73892c8321f141f4$var$r.createTreeWalker($73892c8321f141f4$var$r, 129);
function $73892c8321f141f4$var$C(t, i) {
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $73892c8321f141f4$var$s ? $73892c8321f141f4$var$s.createHTML(i) : i;
}
const $73892c8321f141f4$var$P = (t, i)=>{
    const s = t.length - 1, o = [];
    let r, l = 2 === i ? "<svg>" : "", c = $73892c8321f141f4$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let a, u, d = -1, y = 0;
        for(; y < s.length && (c.lastIndex = y, u = c.exec(s), null !== u);)y = c.lastIndex, c === $73892c8321f141f4$var$f ? "!--" === u[1] ? c = $73892c8321f141f4$var$v : void 0 !== u[1] ? c = $73892c8321f141f4$var$_ : void 0 !== u[2] ? ($73892c8321f141f4$var$$.test(u[2]) && (r = RegExp("</" + u[2], "g")), c = $73892c8321f141f4$var$m) : void 0 !== u[3] && (c = $73892c8321f141f4$var$m) : c === $73892c8321f141f4$var$m ? ">" === u[0] ? (c = r ?? $73892c8321f141f4$var$f, d = -1) : void 0 === u[1] ? d = -2 : (d = c.lastIndex - u[2].length, a = u[1], c = void 0 === u[3] ? $73892c8321f141f4$var$m : '"' === u[3] ? $73892c8321f141f4$var$g : $73892c8321f141f4$var$p) : c === $73892c8321f141f4$var$g || c === $73892c8321f141f4$var$p ? c = $73892c8321f141f4$var$m : c === $73892c8321f141f4$var$v || c === $73892c8321f141f4$var$_ ? c = $73892c8321f141f4$var$f : (c = $73892c8321f141f4$var$m, r = void 0);
        const x = c === $73892c8321f141f4$var$m && t[i + 1].startsWith("/>") ? " " : "";
        l += c === $73892c8321f141f4$var$f ? s + $73892c8321f141f4$var$n : d >= 0 ? (o.push(a), s.slice(0, d) + $73892c8321f141f4$var$e + s.slice(d) + $73892c8321f141f4$var$h + x) : s + $73892c8321f141f4$var$h + (-2 === d ? i : x);
    }
    return [
        $73892c8321f141f4$var$C(t, l + (t[s] || "<?>") + (2 === i ? "</svg>" : "")),
        o
    ];
};
class $73892c8321f141f4$var$V {
    constructor({ strings: t, _$litType$: s }, n){
        let r;
        this.parts = [];
        let c = 0, a = 0;
        const u = t.length - 1, d = this.parts, [f, v] = $73892c8321f141f4$var$P(t, s);
        if (this.el = $73892c8321f141f4$var$V.createElement(f, n), $73892c8321f141f4$var$E.currentNode = this.el.content, 2 === s) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (r = $73892c8321f141f4$var$E.nextNode()) && d.length < u;){
            if (1 === r.nodeType) {
                if (r.hasAttributes()) for (const t of r.getAttributeNames())if (t.endsWith($73892c8321f141f4$var$e)) {
                    const i = v[a++], s = r.getAttribute(t).split($73892c8321f141f4$var$h), e = /([.?@])?(.*)/.exec(i);
                    d.push({
                        type: 1,
                        index: c,
                        name: e[2],
                        strings: s,
                        ctor: "." === e[1] ? $73892c8321f141f4$var$k : "?" === e[1] ? $73892c8321f141f4$var$H : "@" === e[1] ? $73892c8321f141f4$var$I : $73892c8321f141f4$var$R
                    }), r.removeAttribute(t);
                } else t.startsWith($73892c8321f141f4$var$h) && (d.push({
                    type: 6,
                    index: c
                }), r.removeAttribute(t));
                if ($73892c8321f141f4$var$$.test(r.tagName)) {
                    const t = r.textContent.split($73892c8321f141f4$var$h), s = t.length - 1;
                    if (s > 0) {
                        r.textContent = $73892c8321f141f4$var$i ? $73892c8321f141f4$var$i.emptyScript : "";
                        for(let i = 0; i < s; i++)r.append(t[i], $73892c8321f141f4$var$l()), $73892c8321f141f4$var$E.nextNode(), d.push({
                            type: 2,
                            index: ++c
                        });
                        r.append(t[s], $73892c8321f141f4$var$l());
                    }
                }
            } else if (8 === r.nodeType) {
                if (r.data === $73892c8321f141f4$var$o) d.push({
                    type: 2,
                    index: c
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = r.data.indexOf($73892c8321f141f4$var$h, t + 1));)d.push({
                        type: 7,
                        index: c
                    }), t += $73892c8321f141f4$var$h.length - 1;
                }
            }
            c++;
        }
    }
    static createElement(t, i) {
        const s = $73892c8321f141f4$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $73892c8321f141f4$var$N(t, i, s = t, e) {
    if (i === $73892c8321f141f4$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? s._$Co?.[e] : s._$Cl;
    const o = $73892c8321f141f4$var$c(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s._$Co ??= [])[e] = h : s._$Cl = h), void 0 !== h && (i = $73892c8321f141f4$var$N(t, h._$AS(t, i.values), h, e)), i;
}
class $73892c8321f141f4$var$S {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? $73892c8321f141f4$var$r).importNode(i, !0);
        $73892c8321f141f4$var$E.currentNode = e;
        let h = $73892c8321f141f4$var$E.nextNode(), o = 0, n = 0, l = s[0];
        for(; void 0 !== l;){
            if (o === l.index) {
                let i;
                2 === l.type ? i = new $73892c8321f141f4$var$M(h, h.nextSibling, this, t) : 1 === l.type ? i = new l.ctor(h, l.name, l.strings, this, t) : 6 === l.type && (i = new $73892c8321f141f4$var$L(h, this, t)), this._$AV.push(i), l = s[++n];
            }
            o !== l?.index && (h = $73892c8321f141f4$var$E.nextNode(), o++);
        }
        return $73892c8321f141f4$var$E.currentNode = $73892c8321f141f4$var$r, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $73892c8321f141f4$var$M {
    get _$AU() {
        return this._$AM?._$AU ?? this._$Cv;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = $73892c8321f141f4$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cv = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $73892c8321f141f4$var$N(this, t, i), $73892c8321f141f4$var$c(t) ? t === $73892c8321f141f4$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $73892c8321f141f4$export$45b790e32b2810ee && this._$AR(), this._$AH = $73892c8321f141f4$export$45b790e32b2810ee) : t !== this._$AH && t !== $73892c8321f141f4$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $73892c8321f141f4$var$u(t) ? this.k(t) : this._(t);
    }
    S(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.S(t));
    }
    _(t) {
        this._$AH !== $73892c8321f141f4$export$45b790e32b2810ee && $73892c8321f141f4$var$c(this._$AH) ? this._$AA.nextSibling.data = t : this.T($73892c8321f141f4$var$r.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $73892c8321f141f4$var$V.createElement($73892c8321f141f4$var$C(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new $73892c8321f141f4$var$S(e, this), s = t.u(this.options);
            t.p(i), this.T(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $73892c8321f141f4$var$A.get(t.strings);
        return void 0 === i && $73892c8321f141f4$var$A.set(t.strings, i = new $73892c8321f141f4$var$V(t)), i;
    }
    k(t) {
        $73892c8321f141f4$var$a(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $73892c8321f141f4$var$M(this.S($73892c8321f141f4$var$l()), this.S($73892c8321f141f4$var$l()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        for(this._$AP?.(!1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this._$Cv = t, this._$AP?.(t));
    }
}
class $73892c8321f141f4$var$R {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $73892c8321f141f4$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $73892c8321f141f4$export$45b790e32b2810ee;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $73892c8321f141f4$var$N(this, t, i, 0), o = !$73892c8321f141f4$var$c(t) || t !== this._$AH && t !== $73892c8321f141f4$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $73892c8321f141f4$var$N(this, e[s + n], i, n), r === $73892c8321f141f4$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o ||= !$73892c8321f141f4$var$c(r) || r !== this._$AH[n], r === $73892c8321f141f4$export$45b790e32b2810ee ? t = $73892c8321f141f4$export$45b790e32b2810ee : t !== $73892c8321f141f4$export$45b790e32b2810ee && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.j(t);
    }
    j(t) {
        t === $73892c8321f141f4$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class $73892c8321f141f4$var$k extends $73892c8321f141f4$var$R {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $73892c8321f141f4$export$45b790e32b2810ee ? void 0 : t;
    }
}
class $73892c8321f141f4$var$H extends $73892c8321f141f4$var$R {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $73892c8321f141f4$export$45b790e32b2810ee);
    }
}
class $73892c8321f141f4$var$I extends $73892c8321f141f4$var$R {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = $73892c8321f141f4$var$N(this, t, i, 0) ?? $73892c8321f141f4$export$45b790e32b2810ee) === $73892c8321f141f4$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $73892c8321f141f4$export$45b790e32b2810ee && s !== $73892c8321f141f4$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $73892c8321f141f4$export$45b790e32b2810ee && (s === $73892c8321f141f4$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class $73892c8321f141f4$var$L {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $73892c8321f141f4$var$N(this, t);
    }
}
const $73892c8321f141f4$export$8613d1ca9052b22e = {
    P: $73892c8321f141f4$var$e,
    A: $73892c8321f141f4$var$h,
    C: $73892c8321f141f4$var$o,
    M: 1,
    L: $73892c8321f141f4$var$P,
    R: $73892c8321f141f4$var$S,
    D: $73892c8321f141f4$var$u,
    V: $73892c8321f141f4$var$N,
    I: $73892c8321f141f4$var$M,
    H: $73892c8321f141f4$var$R,
    N: $73892c8321f141f4$var$H,
    U: $73892c8321f141f4$var$I,
    B: $73892c8321f141f4$var$k,
    F: $73892c8321f141f4$var$L
}, $73892c8321f141f4$var$Z = $73892c8321f141f4$var$t.litHtmlPolyfillSupport;
$73892c8321f141f4$var$Z?.($73892c8321f141f4$var$V, $73892c8321f141f4$var$M), ($73892c8321f141f4$var$t.litHtmlVersions ??= []).push("3.1.2");
const $73892c8321f141f4$export$b3890eb0ae9dca99 = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new $73892c8321f141f4$var$M(i.insertBefore($73892c8321f141f4$var$l(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};

});

parcelRegister("78EKQ", function(module, exports) {
$parcel$export(module.exports, "css", () => (parcelRequire("hOpwk")).css);
$parcel$export(module.exports, "ReactiveElement", () => (parcelRequire("ksYdx")).ReactiveElement);
$parcel$export(module.exports, "html", () => (parcelRequire("9UZF0")).html);
$parcel$export(module.exports, "noChange", () => (parcelRequire("9UZF0")).noChange);
$parcel$export(module.exports, "nothing", () => (parcelRequire("9UZF0")).nothing);
$parcel$export(module.exports, "render", () => (parcelRequire("9UZF0")).render);

$parcel$export(module.exports, "LitElement", () => $5328e4c00616bf7e$export$3f2f9f5909897157);

var $ksYdx = parcelRequire("ksYdx");

var $9UZF0 = parcelRequire("9UZF0");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $5328e4c00616bf7e$export$3f2f9f5909897157 extends (0, $ksYdx.ReactiveElement) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        const t = super.createRenderRoot();
        return this.renderOptions.renderBefore ??= t.firstChild, t;
    }
    update(t) {
        const i = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $9UZF0.render)(i, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        super.connectedCallback(), this._$Do?.setConnected(!0);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this._$Do?.setConnected(!1);
    }
    render() {
        return 0, $9UZF0.noChange;
    }
}
$5328e4c00616bf7e$export$3f2f9f5909897157._$litElement$ = !0, $5328e4c00616bf7e$export$3f2f9f5909897157["finalized"] = !0, globalThis.litElementHydrateSupport?.({
    LitElement: $5328e4c00616bf7e$export$3f2f9f5909897157
});
const $5328e4c00616bf7e$var$r = globalThis.litElementPolyfillSupport;
$5328e4c00616bf7e$var$r?.({
    LitElement: $5328e4c00616bf7e$export$3f2f9f5909897157
});
const $5328e4c00616bf7e$export$f5c524615a7708d6 = {
    _$AK: (t, e, i)=>{
        t._$AK(e, i);
    },
    _$AL: (t)=>t._$AL
};
(globalThis.litElementVersions ??= []).push("4.0.4");

});

parcelRegister("cOmOV", function(module, exports) {
/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $953bdb38c17e3aca$export$6acf61af03e62db = !1;

});


parcelRegister("fb0eT", function(module, exports) {

$parcel$export(module.exports, "apiDomain", () => $0c8bf563c955c239$export$bffb709715ad22db);
$parcel$export(module.exports, "captchaSiteKey", () => $0c8bf563c955c239$export$54560681513e8f79);
$parcel$export(module.exports, "googleMapsApiKey", () => $0c8bf563c955c239$export$a6a5c72c4d68483d);
$parcel$export(module.exports, "version", () => $0c8bf563c955c239$export$83d89fbfd8236492);
$parcel$export(module.exports, "debug", () => $0c8bf563c955c239$export$1c9f709888824e05);
const $0c8bf563c955c239$export$bffb709715ad22db = "https://dev-analytics.autotrack.nl/api/AUTOTRACK/v1";
const $0c8bf563c955c239$export$54560681513e8f79 = "6LfDQAoaAAAAANZL_YoYyKiaLB8Jp5rEaDLJlkQN";
const $0c8bf563c955c239$export$a6a5c72c4d68483d = "AIzaSyBVkpkwMBF7DPuzZrc-ATfDxUiBrb34UHg";
const $0c8bf563c955c239$export$83d89fbfd8236492 = undefined;
const $0c8bf563c955c239$export$1c9f709888824e05 = false;

});

parcelRegister("dErh8", function(module, exports) {

$parcel$export(module.exports, "Msg", () => $505ba9e74bc78be2$export$ed7753698ef54f84);
const $505ba9e74bc78be2$export$ed7753698ef54f84 = {
    DeviceLayout: (payload)=>({
            type: "DeviceLayout",
            payload: payload
        }),
    OnRoute: (payload)=>({
            type: "OnRoute",
            payload: payload
        }),
    NavigateBack: ()=>({
            type: "NavigateBack"
        }),
    Navigate: (payload)=>({
            type: "Navigate",
            payload: payload
        }),
    ToggleNavigation: ()=>({
            type: "ToggleNavigation"
        }),
    Application_LoginWithToken: (payload)=>({
            type: "Application_LoginWithToken",
            payload: payload
        }),
    Application_IncomingLogout: (payload)=>({
            type: "Application_IncomingLogout",
            payload: payload
        }),
    Incoming_Token: (payload)=>({
            type: "Incoming_Token",
            payload: payload
        }),
    Incoming_Session: (payload)=>({
            type: "Incoming_Session",
            payload: payload
        }),
    Incoming_Vehicle: (payload)=>({
            type: "Incoming_Vehicle",
            payload: payload
        }),
    Incoming_CompetingDealerProfiles: (payload)=>({
            type: "Incoming_CompetingDealerProfiles",
            payload: payload
        }),
    Incoming_DaysInStockGoal: (payload)=>({
            type: "Incoming_DaysInStockGoal",
            payload: payload
        }),
    Incoming_Dealers: (payload)=>({
            type: "Incoming_Dealers",
            payload: payload
        }),
    Incoming_DealerFilter: (payload)=>({
            type: "Incoming_DealerFilter",
            payload: payload
        }),
    Incoming_StockSelection: (payload)=>({
            type: "Incoming_StockSelection",
            payload: payload
        }),
    TaxationWidget_OnInputLicensePlate: (payload)=>({
            type: "TaxationWidget_OnInputLicensePlate",
            payload: payload
        }),
    TaxationWidget_OnInputMileage: (payload)=>({
            type: "TaxationWidget_OnInputMileage",
            payload: payload
        }),
    TaxationWidget_OnSubmit: ()=>({
            type: "TaxationWidget_OnSubmit"
        }),
    TaxationWidget_OnClearErrorMessage: ()=>({
            type: "TaxationWidget_OnClearErrorMessage"
        }),
    TaxationWidget_IncomingSubmit: (payload)=>({
            type: "TaxationWidget_IncomingSubmit",
            payload: payload
        }),
    Login_OnInputUsername: (payload)=>({
            type: "Login_OnInputUsername",
            payload: payload
        }),
    Login_OnInputPassword: (payload)=>({
            type: "Login_OnInputPassword",
            payload: payload
        }),
    Login_OnInputCaptcha: (payload)=>({
            type: "Login_OnInputCaptcha",
            payload: payload
        }),
    Login_OnSubmit: ()=>({
            type: "Login_OnSubmit"
        }),
    Login_IncomingAuthentication: (payload)=>({
            type: "Login_IncomingAuthentication",
            payload: payload
        }),
    Dashboard_IncomingDealerDashboard: (payload)=>({
            type: "Dashboard_IncomingDealerDashboard",
            payload: payload
        }),
    Dashboard_OnSortStockSummary: (payload)=>({
            type: "Dashboard_OnSortStockSummary",
            payload: payload
        }),
    Dashboard_OnToggleInfoBlock: ()=>({
            type: "Dashboard_OnToggleInfoBlock"
        }),
    Dashboard_OnPrint: ()=>({
            type: "Dashboard_OnPrint"
        }),
    Dashboard_OnSelectDealer: (payload)=>({
            type: "Dashboard_OnSelectDealer",
            payload: payload
        }),
    Dashboard_OnSelectAllDealers: ()=>({
            type: "Dashboard_OnSelectAllDealers"
        }),
    Stock_OnDownloadExcel: ()=>({
            type: "Stock_OnDownloadExcel"
        }),
    Stock_OnToggleInfoBlock: ()=>({
            type: "Stock_OnToggleInfoBlock"
        }),
    Stock_OnPrint: ()=>({
            type: "Stock_OnPrint"
        }),
    Stock_OnInputSearch: (payload)=>({
            type: "Stock_OnInputSearch",
            payload: payload
        }),
    Stock_OnSearch: (payload)=>({
            type: "Stock_OnSearch",
            payload: payload
        }),
    Stock_OnSort: (payload)=>({
            type: "Stock_OnSort",
            payload: payload
        }),
    Stock_OnSortDirection: (payload)=>({
            type: "Stock_OnSortDirection",
            payload: payload
        }),
    Stock_OnOnlyWithWarnings: (payload)=>({
            type: "Stock_OnOnlyWithWarnings",
            payload: payload
        }),
    Stock_OnPageChange: (payload)=>({
            type: "Stock_OnPageChange",
            payload: payload
        }),
    Stock_OnAmountPerPageChange: (payload)=>({
            type: "Stock_OnAmountPerPageChange",
            payload: payload
        }),
    Stock_Incoming: (payload)=>({
            type: "Stock_Incoming",
            payload: payload
        }),
    Reach_Incoming: (payload)=>({
            type: "Reach_Incoming",
            payload: payload
        }),
    Reach_OnToggleInfoBlock: ()=>({
            type: "Reach_OnToggleInfoBlock"
        }),
    Reach_OnPrint: ()=>({
            type: "Reach_OnPrint"
        }),
    Reach_OnDateRangeChange: (payload)=>({
            type: "Reach_OnDateRangeChange",
            payload: payload
        }),
    Leads_Incoming: (payload)=>({
            type: "Leads_Incoming",
            payload: payload
        }),
    Leads_OnToggleInfoBlock: ()=>({
            type: "Leads_OnToggleInfoBlock"
        }),
    Leads_OnToggleFilterVisibility: ()=>({
            type: "Leads_OnToggleFilterVisibility"
        }),
    Leads_OnDownloadExcel: ()=>({
            type: "Leads_OnDownloadExcel"
        }),
    Leads_OnPrint: ()=>({
            type: "Leads_OnPrint"
        }),
    Leads_OnSortChange: (payload)=>({
            type: "Leads_OnSortChange",
            payload: payload
        }),
    Leads_OnAmountPerPageChange: (payload)=>({
            type: "Leads_OnAmountPerPageChange",
            payload: payload
        }),
    Leads_OnPageChange: (payload)=>({
            type: "Leads_OnPageChange",
            payload: payload
        }),
    Leads_OnSearchInput: (payload)=>({
            type: "Leads_OnSearchInput",
            payload: payload
        }),
    Leads_OnFilterChange: (payload)=>({
            type: "Leads_OnFilterChange",
            payload: payload
        }),
    Leads_OnPeriodChange: (payload)=>({
            type: "Leads_OnPeriodChange",
            payload: payload
        }),
    Prospects_Incoming: (payload)=>({
            type: "Prospects_Incoming",
            payload: payload
        }),
    Prospects_OnDownloadExcel: ()=>({
            type: "Prospects_OnDownloadExcel"
        }),
    Prospects_OnToggleInfoBlock: ()=>({
            type: "Prospects_OnToggleInfoBlock"
        }),
    Prospects_OnPrint: ()=>({
            type: "Prospects_OnPrint"
        }),
    Prospects_OnPageChange: (payload)=>({
            type: "Prospects_OnPageChange",
            payload: payload
        }),
    Prospects_OnAmountPerPageChange: (payload)=>({
            type: "Prospects_OnAmountPerPageChange",
            payload: payload
        }),
    Prospects_OnPeriodChange: (payload)=>({
            type: "Prospects_OnPeriodChange",
            payload: payload
        }),
    AnalysisOverview_Incoming: (payload)=>({
            type: "AnalysisOverview_Incoming",
            payload: payload
        }),
    AnalysisOverview_OnToggleInfoBlock: ()=>({
            type: "AnalysisOverview_OnToggleInfoBlock"
        }),
    AnalysisOverview_OnPrint: ()=>({
            type: "AnalysisOverview_OnPrint"
        }),
    AnalysisOverview_OnProfileChange: (payload)=>({
            type: "AnalysisOverview_OnProfileChange",
            payload: payload
        }),
    AnalysisLeadPerformance_Incoming: (payload)=>({
            type: "AnalysisLeadPerformance_Incoming",
            payload: payload
        }),
    AnalysisLeadPerformance_OnPrint: ()=>({
            type: "AnalysisLeadPerformance_OnPrint"
        }),
    AnalysisLeadPerformance_OnToggleInfoBlock: ()=>({
            type: "AnalysisLeadPerformance_OnToggleInfoBlock"
        }),
    AnalysisLeadPerformance_OnPeriodChange: (payload)=>({
            type: "AnalysisLeadPerformance_OnPeriodChange",
            payload: payload
        }),
    AnalysisMakeModel_Incoming: (payload)=>({
            type: "AnalysisMakeModel_Incoming",
            payload: payload
        }),
    AnalysisMakeModel_OnToggleInfoBlock: ()=>({
            type: "AnalysisMakeModel_OnToggleInfoBlock"
        }),
    AnalysisMakeModel_OnPrint: ()=>({
            type: "AnalysisMakeModel_OnPrint"
        }),
    AnalysisMakeModel_OnChangeTab: (payload)=>({
            type: "AnalysisMakeModel_OnChangeTab",
            payload: payload
        }),
    AnalysisCostBenefit_Incoming: (payload)=>({
            type: "AnalysisCostBenefit_Incoming",
            payload: payload
        }),
    AnalysisCostBenefit_OnPrint: ()=>({
            type: "AnalysisCostBenefit_OnPrint"
        }),
    ComparisonAdvicePrice_Incoming: (payload)=>({
            type: "ComparisonAdvicePrice_Incoming",
            payload: payload
        }),
    ComparisonAdvicePrice_OnPrint: ()=>({
            type: "ComparisonAdvicePrice_OnPrint"
        }),
    ComparisonAdvicePrice_OnToggleInfoBlock: ()=>({
            type: "ComparisonAdvicePrice_OnToggleInfoBlock"
        }),
    ComparisonAdvicePrice_OnProfileChange: (payload)=>({
            type: "ComparisonAdvicePrice_OnProfileChange",
            payload: payload
        }),
    ComparisonAdvicePrice_OnMakeFilterChange: (payload)=>({
            type: "ComparisonAdvicePrice_OnMakeFilterChange",
            payload: payload
        }),
    ComparisonAdvicePrice_OnModelFilterChange: (payload)=>({
            type: "ComparisonAdvicePrice_OnModelFilterChange",
            payload: payload
        }),
    ComparisonDaysInStock_Incoming: (payload)=>({
            type: "ComparisonDaysInStock_Incoming",
            payload: payload
        }),
    ComparisonDaysInStock_OnPrint: ()=>({
            type: "ComparisonDaysInStock_OnPrint"
        }),
    ComparisonDaysInStock_OnToggleInfoBlock: ()=>({
            type: "ComparisonDaysInStock_OnToggleInfoBlock"
        }),
    ComparisonDaysInStock_OnProfileChange: (payload)=>({
            type: "ComparisonDaysInStock_OnProfileChange",
            payload: payload
        }),
    ComparisonDaysInStock_OnMakeFilterChange: (payload)=>({
            type: "ComparisonDaysInStock_OnMakeFilterChange",
            payload: payload
        }),
    ComparisonDaysInStock_OnModelFilterChange: (payload)=>({
            type: "ComparisonDaysInStock_OnModelFilterChange",
            payload: payload
        }),
    ComparisonGeographic_Incoming: (payload)=>({
            type: "ComparisonGeographic_Incoming",
            payload: payload
        }),
    ComparisonGeographic_OnToggleInfoBlock: ()=>({
            type: "ComparisonGeographic_OnToggleInfoBlock"
        }),
    ComparisonGeographic_OnPrint: ()=>({
            type: "ComparisonGeographic_OnPrint"
        }),
    ComparisonGeographic_OnTabChange: (payload)=>({
            type: "ComparisonGeographic_OnTabChange",
            payload: payload
        }),
    ComparisonGeographic_OnProfileChange: (payload)=>({
            type: "ComparisonGeographic_OnProfileChange",
            payload: payload
        }),
    SettingsScenarios_Incoming: (payload)=>({
            type: "SettingsScenarios_Incoming",
            payload: payload
        }),
    SettingsScenarios_OnDelete: (payload)=>({
            type: "SettingsScenarios_OnDelete",
            payload: payload
        }),
    SettingsScenarios_IncomingDelete: (payload)=>({
            type: "SettingsScenarios_IncomingDelete",
            payload: payload
        }),
    SettingsScenario_Incoming: (payload)=>({
            type: "SettingsScenario_Incoming",
            payload: payload
        }),
    SettingsScenario_IncomingSave: (payload)=>({
            type: "SettingsScenario_IncomingSave",
            payload: payload
        }),
    SettingsScenario_OnUpdate: (payload)=>({
            type: "SettingsScenario_OnUpdate",
            payload: payload
        }),
    SettingsScenario_OnSave: ()=>({
            type: "SettingsScenario_OnSave"
        }),
    SettingsScenario_OnCancel: ()=>({
            type: "SettingsScenario_OnCancel"
        }),
    SettingsScenario_OnSelectedAvailableDealerChange: (payload)=>({
            type: "SettingsScenario_OnSelectedAvailableDealerChange",
            payload: payload
        }),
    SettingsBranches_IncomingScenarioList: (payload)=>({
            type: "SettingsBranches_IncomingScenarioList",
            payload: payload
        }),
    SettingsBranches_IncomingScenario: (payload)=>({
            type: "SettingsBranches_IncomingScenario",
            payload: payload
        }),
    SettingsBranches_IncomingDealerFilter: (payload)=>({
            type: "SettingsBranches_IncomingDealerFilter",
            payload: payload
        }),
    SettingsBranches_IncomingSave: (payload)=>({
            type: "SettingsBranches_IncomingSave",
            payload: payload
        }),
    SettingsBranches_OnChangeScenario: (payload)=>({
            type: "SettingsBranches_OnChangeScenario",
            payload: payload
        }),
    SettingsBranches_OnUpdate: (payload)=>({
            type: "SettingsBranches_OnUpdate",
            payload: payload
        }),
    SettingsBranches_OnSave: ()=>({
            type: "SettingsBranches_OnSave"
        }),
    SettingsBranches_OnCancel: ()=>({
            type: "SettingsBranches_OnCancel"
        }),
    SettingsCompetingDealers_Incoming: (payload)=>({
            type: "SettingsCompetingDealers_Incoming",
            payload: payload
        }),
    SettingsCompetingDealers_IncomingRemove: (payload)=>({
            type: "SettingsCompetingDealers_IncomingRemove",
            payload: payload
        }),
    SettingsCompetingDealers_OnRemove: (payload)=>({
            type: "SettingsCompetingDealers_OnRemove",
            payload: payload
        }),
    SettingsCompetingDealersProfile_Incoming: (payload)=>({
            type: "SettingsCompetingDealersProfile_Incoming",
            payload: payload
        }),
    SettingsCompetingDealersProfile_IncomingFilters: (payload)=>({
            type: "SettingsCompetingDealersProfile_IncomingFilters",
            payload: payload
        }),
    SettingsCompetingDealersProfile_IncomingSave: (payload)=>({
            type: "SettingsCompetingDealersProfile_IncomingSave",
            payload: payload
        }),
    SettingsCompetingDealersProfile_IncomingDealers: (payload)=>({
            type: "SettingsCompetingDealersProfile_IncomingDealers",
            payload: payload
        }),
    SettingsCompetingDealersProfile_OnViewChange: (payload)=>({
            type: "SettingsCompetingDealersProfile_OnViewChange",
            payload: payload
        }),
    SettingsCompetingDealersProfile_OnChangeName: (payload)=>({
            type: "SettingsCompetingDealersProfile_OnChangeName",
            payload: payload
        }),
    SettingsCompetingDealersProfile_OnChangeSearch: (payload)=>({
            type: "SettingsCompetingDealersProfile_OnChangeSearch",
            payload: payload
        }),
    SettingsCompetingDealersProfile_OnChangeDealerFilter: (payload)=>({
            type: "SettingsCompetingDealersProfile_OnChangeDealerFilter",
            payload: payload
        }),
    SettingsCompetingDealersProfile_OnChangeProvinceFilter: (payload)=>({
            type: "SettingsCompetingDealersProfile_OnChangeProvinceFilter",
            payload: payload
        }),
    SettingsCompetingDealersProfile_OnChangeDealerMakeFilter: (payload)=>({
            type: "SettingsCompetingDealersProfile_OnChangeDealerMakeFilter",
            payload: payload
        }),
    SettingsCompetingDealersProfile_OnChangeStockMakeFilter: (payload)=>({
            type: "SettingsCompetingDealersProfile_OnChangeStockMakeFilter",
            payload: payload
        }),
    SettingsCompetingDealersProfile_OnAddCompetition: (payload)=>({
            type: "SettingsCompetingDealersProfile_OnAddCompetition",
            payload: payload
        }),
    SettingsCompetingDealersProfile_OnRemoveCompetition: (payload)=>({
            type: "SettingsCompetingDealersProfile_OnRemoveCompetition",
            payload: payload
        }),
    SettingsCompetingDealersProfile_OnAddCompetitionAll: (payload)=>({
            type: "SettingsCompetingDealersProfile_OnAddCompetitionAll",
            payload: payload
        }),
    SettingsCompetingDealersProfile_OnRemoveCompetitionAll: (payload)=>({
            type: "SettingsCompetingDealersProfile_OnRemoveCompetitionAll",
            payload: payload
        }),
    SettingsCompetingDealersProfile_OnSave: ()=>({
            type: "SettingsCompetingDealersProfile_OnSave"
        }),
    SettingsCompetingDealersProfile_OnCancel: ()=>({
            type: "SettingsCompetingDealersProfile_OnCancel"
        }),
    TaxationDashboard_Incoming: (payload)=>({
            type: "TaxationDashboard_Incoming",
            payload: payload
        }),
    TaxationDashboard_OnToggleInfoBlock: ()=>({
            type: "TaxationDashboard_OnToggleInfoBlock"
        }),
    TaxationDashboard_OnPrint: ()=>({
            type: "TaxationDashboard_OnPrint"
        }),
    TaxationComparison_Incoming: (payload)=>({
            type: "TaxationComparison_Incoming",
            payload: payload
        }),
    TaxationComparisonGeographic_Incoming: (payload)=>({
            type: "TaxationComparisonGeographic_Incoming",
            payload: payload
        }),
    TaxationComparisonGeographic_OnPrint: ()=>({
            type: "TaxationComparisonGeographic_OnPrint"
        }),
    TaxationComparisonGeographic_OnStatusChange: (payload)=>({
            type: "TaxationComparisonGeographic_OnStatusChange",
            payload: payload
        }),
    TaxationComparisonGeographic_OnToggleInfoBlock: ()=>({
            type: "TaxationComparisonGeographic_OnToggleInfoBlock"
        }),
    TaxationComparisonOverview_OnAmountPerPageChange: (payload)=>({
            type: "TaxationComparisonOverview_OnAmountPerPageChange",
            payload: payload
        }),
    TaxationComparisonOverview_OnPageChange: (payload)=>({
            type: "TaxationComparisonOverview_OnPageChange",
            payload: payload
        }),
    TaxationComparisonOverview_OnPrint: ()=>({
            type: "TaxationComparisonOverview_OnPrint"
        }),
    TaxationComparisonOverview_OnSortChange: (payload)=>({
            type: "TaxationComparisonOverview_OnSortChange",
            payload: payload
        }),
    TaxationComparisonOverview_OnSortDirectionChange: (payload)=>({
            type: "TaxationComparisonOverview_OnSortDirectionChange",
            payload: payload
        }),
    TaxationComparisonOverview_OnStatusChange: (payload)=>({
            type: "TaxationComparisonOverview_OnStatusChange",
            payload: payload
        }),
    TaxationComparisonOverview_OnToggleInfoBlock: ()=>({
            type: "TaxationComparisonOverview_OnToggleInfoBlock"
        }),
    TaxationComparisonPriceAnalysis_OnPrint: ()=>({
            type: "TaxationComparisonPriceAnalysis_OnPrint"
        }),
    TaxationComparisonPriceAnalysis_OnStatusChange: (payload)=>({
            type: "TaxationComparisonPriceAnalysis_OnStatusChange",
            payload: payload
        }),
    TaxationComparisonPriceAnalysis_OnToggleInfoBlock: ()=>({
            type: "TaxationComparisonPriceAnalysis_OnToggleInfoBlock"
        }),
    TaxationComparisonPriceHistory_Incoming: (payload)=>({
            type: "TaxationComparisonPriceHistory_Incoming",
            payload: payload
        }),
    TaxationComparisonPriceHistory_OnPrint: ()=>({
            type: "TaxationComparisonPriceHistory_OnPrint"
        }),
    TaxationComparisonPriceHistory_OnStatusChange: (payload)=>({
            type: "TaxationComparisonPriceHistory_OnStatusChange",
            payload: payload
        }),
    TaxationComparisonPriceHistory_OnToggleInfoBlock: ()=>({
            type: "TaxationComparisonPriceHistory_OnToggleInfoBlock"
        }),
    TaxationSettings_Incoming: (payload)=>({
            type: "TaxationSettings_Incoming",
            payload: payload
        }),
    TaxationSettings_IncomingReset: (payload)=>({
            type: "TaxationSettings_IncomingReset",
            payload: payload
        }),
    TaxationSettings_IncomingSave: (payload)=>({
            type: "TaxationSettings_IncomingSave",
            payload: payload
        }),
    TaxationSettings_OnCancel: (payload)=>({
            type: "TaxationSettings_OnCancel",
            payload: payload
        }),
    TaxationSettings_OnChange: (payload)=>({
            type: "TaxationSettings_OnChange",
            payload: payload
        }),
    TaxationSettings_OnReset: (payload)=>({
            type: "TaxationSettings_OnReset",
            payload: payload
        }),
    TaxationSettings_OnSave: (payload)=>({
            type: "TaxationSettings_OnSave",
            payload: payload
        }),
    TaxationSettings_OnToggleInfoBlock: ()=>({
            type: "TaxationSettings_OnToggleInfoBlock"
        }),
    VehicleDashboard_Incoming: (payload)=>({
            type: "VehicleDashboard_Incoming",
            payload: payload
        }),
    VehicleDashboard_OnToggleInfoBlock: ()=>({
            type: "VehicleDashboard_OnToggleInfoBlock"
        }),
    VehicleDashboard_OnPrint: ()=>({
            type: "VehicleDashboard_OnPrint"
        }),
    VehicleReachOverview_Incoming: (payload)=>({
            type: "VehicleReachOverview_Incoming",
            payload: payload
        }),
    VehicleReachOverview_OnToggleInfoBlock: ()=>({
            type: "VehicleReachOverview_OnToggleInfoBlock"
        }),
    VehicleReachOverview_OnPrint: ()=>({
            type: "VehicleReachOverview_OnPrint"
        }),
    VehicleReachPriceEffect_Incoming: (payload)=>({
            type: "VehicleReachPriceEffect_Incoming",
            payload: payload
        }),
    VehicleReachPriceEffect_OnTabClick: (payload)=>({
            type: "VehicleReachPriceEffect_OnTabClick",
            payload: payload
        }),
    VehicleReachPriceEffect_OnToggleInfoBlock: ()=>({
            type: "VehicleReachPriceEffect_OnToggleInfoBlock"
        }),
    VehicleReachPriceEffect_OnPrint: ()=>({
            type: "VehicleReachPriceEffect_OnPrint"
        }),
    VehicleComparison_Incoming: (payload)=>({
            type: "VehicleComparison_Incoming",
            payload: payload
        }),
    VehicleComparisonOverview_OnStatusChange: (payload)=>({
            type: "VehicleComparisonOverview_OnStatusChange",
            payload: payload
        }),
    VehicleComparisonOverview_OnPrint: ()=>({
            type: "VehicleComparisonOverview_OnPrint"
        }),
    VehicleComparisonOverview_OnSortChange: (payload)=>({
            type: "VehicleComparisonOverview_OnSortChange",
            payload: payload
        }),
    VehicleComparisonOverview_OnSortDirectionChange: (payload)=>({
            type: "VehicleComparisonOverview_OnSortDirectionChange",
            payload: payload
        }),
    VehicleComparisonOverview_OnToggleInfoBlock: ()=>({
            type: "VehicleComparisonOverview_OnToggleInfoBlock"
        }),
    VehicleComparisonOverview_OnPageChange: (payload)=>({
            type: "VehicleComparisonOverview_OnPageChange",
            payload: payload
        }),
    VehicleComparisonOverview_OnAmountPerPageChange: (payload)=>({
            type: "VehicleComparisonOverview_OnAmountPerPageChange",
            payload: payload
        }),
    VehicleComparisonPriceAnalysis_OnStatusChange: (payload)=>({
            type: "VehicleComparisonPriceAnalysis_OnStatusChange",
            payload: payload
        }),
    VehicleComparisonPriceAnalysis_OnToggleInfoBlock: ()=>({
            type: "VehicleComparisonPriceAnalysis_OnToggleInfoBlock"
        }),
    VehicleComparisonPriceAnalysis_OnPrint: ()=>({
            type: "VehicleComparisonPriceAnalysis_OnPrint"
        }),
    VehicleComparisonPriceHistory_Incoming: (payload)=>({
            type: "VehicleComparisonPriceHistory_Incoming",
            payload: payload
        }),
    VehicleComparisonPriceHistory_OnStatusChange: (payload)=>({
            type: "VehicleComparisonPriceHistory_OnStatusChange",
            payload: payload
        }),
    VehicleComparisonPriceHistory_OnToggleInfoBlock: ()=>({
            type: "VehicleComparisonPriceHistory_OnToggleInfoBlock"
        }),
    VehicleComparisonPriceHistory_OnPrint: ()=>({
            type: "VehicleComparisonPriceHistory_OnPrint"
        }),
    VehicleComparisonGeographic_Incoming: (payload)=>({
            type: "VehicleComparisonGeographic_Incoming",
            payload: payload
        }),
    VehicleComparisonGeographic_OnStatusChange: (payload)=>({
            type: "VehicleComparisonGeographic_OnStatusChange",
            payload: payload
        }),
    VehicleComparisonGeographic_OnToggleInfoBlock: ()=>({
            type: "VehicleComparisonGeographic_OnToggleInfoBlock"
        }),
    VehicleComparisonGeographic_OnPrint: ()=>({
            type: "VehicleComparisonGeographic_OnPrint"
        }),
    VehicleSettings_Incoming: (payload)=>({
            type: "VehicleSettings_Incoming",
            payload: payload
        }),
    VehicleSettings_IncomingSave: (payload)=>({
            type: "VehicleSettings_IncomingSave",
            payload: payload
        }),
    VehicleSettings_IncomingReset: (payload)=>({
            type: "VehicleSettings_IncomingReset",
            payload: payload
        }),
    VehicleSettings_OnChange: (payload)=>({
            type: "VehicleSettings_OnChange",
            payload: payload
        }),
    VehicleSettings_OnSave: (payload)=>({
            type: "VehicleSettings_OnSave",
            payload: payload
        }),
    VehicleSettings_OnCancel: (payload)=>({
            type: "VehicleSettings_OnCancel",
            payload: payload
        }),
    VehicleSettings_OnReset: (payload)=>({
            type: "VehicleSettings_OnReset",
            payload: payload
        }),
    VehicleSettings_OnToggleInfoBlock: ()=>({
            type: "VehicleSettings_OnToggleInfoBlock"
        }),
    SettingsStock_Incoming: (payload)=>({
            type: "SettingsStock_Incoming",
            payload: payload
        }),
    SettingsStock_IncomingVehicleCount: (payload)=>({
            type: "SettingsStock_IncomingVehicleCount",
            payload: payload
        }),
    SettingsStock_IncomingSave: (payload)=>({
            type: "SettingsStock_IncomingSave",
            payload: payload
        }),
    SettingsStock_IncomingReset: (payload)=>({
            type: "SettingsStock_IncomingReset",
            payload: payload
        }),
    SettingsStock_OnChange: (payload)=>({
            type: "SettingsStock_OnChange",
            payload: payload
        }),
    SettingsStock_OnCancel: ()=>({
            type: "SettingsStock_OnCancel"
        }),
    SettingsStock_OnReset: ()=>({
            type: "SettingsStock_OnReset"
        }),
    SettingsStock_OnSave: ()=>({
            type: "SettingsStock_OnSave"
        }),
    SettingsStock_OnSearchVehicle: (payload)=>({
            type: "SettingsStock_OnSearchVehicle",
            payload: payload
        }),
    SettingsStock_IncomingSearchVehicle: (payload)=>({
            type: "SettingsStock_IncomingSearchVehicle",
            payload: payload
        }),
    SettingsNotifications_Incoming: (payload)=>({
            type: "SettingsNotifications_Incoming",
            payload: payload
        }),
    SettingsNotifications_IncomingReset: (payload)=>({
            type: "SettingsNotifications_IncomingReset",
            payload: payload
        }),
    SettingsNotifications_IncomingSave: (payload)=>({
            type: "SettingsNotifications_IncomingSave",
            payload: payload
        }),
    SettingsNotifications_IncomingSendTestMail: (payload)=>({
            type: "SettingsNotifications_IncomingSendTestMail",
            payload: payload
        }),
    SettingsNotifications_OnSendTestMail: ()=>({
            type: "SettingsNotifications_OnSendTestMail"
        }),
    SettingsNotifications_OnChange: (payload)=>({
            type: "SettingsNotifications_OnChange",
            payload: payload
        }),
    SettingsNotifications_OnSave: ()=>({
            type: "SettingsNotifications_OnSave"
        }),
    SettingsNotifications_OnReset: ()=>({
            type: "SettingsNotifications_OnReset"
        }),
    SettingsNotifications_OnCancel: ()=>({
            type: "SettingsNotifications_OnCancel"
        }),
    SettingsCompetingVehicles_Incoming: (payload)=>({
            type: "SettingsCompetingVehicles_Incoming",
            payload: payload
        }),
    SettingsCompetingVehicles_IncomingSave: (payload)=>({
            type: "SettingsCompetingVehicles_IncomingSave",
            payload: payload
        }),
    SettingsCompetingVehicles_IncomingReset: (payload)=>({
            type: "SettingsCompetingVehicles_IncomingReset",
            payload: payload
        }),
    SettingsCompetingVehicles_OnChange: (payload)=>({
            type: "SettingsCompetingVehicles_OnChange",
            payload: payload
        }),
    SettingsCompetingVehicles_OnSave: ()=>({
            type: "SettingsCompetingVehicles_OnSave"
        }),
    SettingsCompetingVehicles_OnCancel: ()=>({
            type: "SettingsCompetingVehicles_OnCancel"
        }),
    SettingsCompetingVehicles_OnReset: ()=>({
            type: "SettingsCompetingVehicles_OnReset"
        })
};

});

parcelRegister("bKIDm", function(module, exports) {

$parcel$export(module.exports, "mapN", () => $d867ffd56cd514e8$export$f25361c8d26ece68);
$parcel$export(module.exports, "match", () => $d867ffd56cd514e8$export$4659b591c19bdf3d);
$parcel$export(module.exports, "fromNullable", () => $d867ffd56cd514e8$export$b601f49376b4621a);
$parcel$export(module.exports, "fromUndefined", () => $d867ffd56cd514e8$export$ef22d37d2d93ceac);
function $d867ffd56cd514e8$export$4cc3e71b83557584(value) {
    return {
        type: "Just",
        value: value
    };
}
function $d867ffd56cd514e8$export$45b790e32b2810ee() {
    return {
        type: "Nothing"
    };
}
function $d867ffd56cd514e8$export$c15bd07a493e1236(maybe) {
    return maybe.type === "Just";
}
function $d867ffd56cd514e8$export$4967676db1b89293(maybe) {
    return maybe.type === "Nothing";
}
function $d867ffd56cd514e8$export$36faa878fcded3d7(maybe, defaultValue) {
    return $d867ffd56cd514e8$export$c15bd07a493e1236(maybe) ? maybe.value : defaultValue;
}
function $d867ffd56cd514e8$export$871de8747c9eaa88(maybe, fn) {
    return $d867ffd56cd514e8$export$c15bd07a493e1236(maybe) ? $d867ffd56cd514e8$export$4cc3e71b83557584(fn(maybe.value)) : $d867ffd56cd514e8$export$45b790e32b2810ee();
}
function $d867ffd56cd514e8$export$f25361c8d26ece68(results, fn) {
    const args = [];
    for (const result of results){
        if ($d867ffd56cd514e8$export$4967676db1b89293(result)) return result;
        args.push(result.value);
    }
    return $d867ffd56cd514e8$export$4cc3e71b83557584(fn(...args));
}
function $d867ffd56cd514e8$export$9768a9ae43d7f016(maybe, fn) {
    return $d867ffd56cd514e8$export$4659b591c19bdf3d(maybe, {
        Just: fn,
        Nothing: ()=>$d867ffd56cd514e8$export$45b790e32b2810ee()
    });
}
function $d867ffd56cd514e8$export$4659b591c19bdf3d(maybe, callbacks) {
    switch(maybe.type){
        case "Just":
            return callbacks.Just(maybe.value);
        case "Nothing":
            return callbacks.Nothing();
    }
}
function $d867ffd56cd514e8$export$b601f49376b4621a(value) {
    return value === null || value === undefined ? $d867ffd56cd514e8$export$45b790e32b2810ee() : $d867ffd56cd514e8$export$4cc3e71b83557584(value);
}
function $d867ffd56cd514e8$export$ef22d37d2d93ceac(value) {
    return value === undefined ? $d867ffd56cd514e8$export$45b790e32b2810ee() : $d867ffd56cd514e8$export$4cc3e71b83557584(value);
}

});

parcelRegister("1ubKN", function(module, exports) {

$parcel$export(module.exports, "init", () => $52262828df9286f1$export$2cd8252107eb640b);
$parcel$export(module.exports, "isIdle", () => $52262828df9286f1$export$3b89eb874deb568a);
$parcel$export(module.exports, "isLoaded", () => $52262828df9286f1$export$e141060ad697f932);
$parcel$export(module.exports, "markAsLoading", () => $52262828df9286f1$export$4958b66af9dfaac4);
$parcel$export(module.exports, "markAsLoaded", () => $52262828df9286f1$export$f4f5dc5cd61fbad8);
$parcel$export(module.exports, "markAsFailed", () => $52262828df9286f1$export$55d14156d51f5886);
$parcel$export(module.exports, "match", () => $52262828df9286f1$export$4659b591c19bdf3d);
$parcel$export(module.exports, "value", () => $52262828df9286f1$export$2ab9a8f9f1186f14);
$parcel$export(module.exports, "map", () => $52262828df9286f1$export$871de8747c9eaa88);
$parcel$export(module.exports, "mapN", () => $52262828df9286f1$export$f25361c8d26ece68);
$parcel$export(module.exports, "fromResult", () => $52262828df9286f1$export$bc338c567c21eab8);

var $jqoka = parcelRequire("jqoka");
function $52262828df9286f1$export$2cd8252107eb640b() {
    return {
        type: "Idle"
    };
}
function $52262828df9286f1$var$loading(previousValue) {
    return {
        type: "Loading",
        previousValue: previousValue
    };
}
function $52262828df9286f1$var$loaded(value) {
    return {
        type: "Loaded",
        value: value
    };
}
function $52262828df9286f1$var$failed(previousValue) {
    return {
        type: "Failed",
        previousValue: previousValue
    };
}
function $52262828df9286f1$export$3b89eb874deb568a(async) {
    return async.type === "Idle";
}
function $52262828df9286f1$export$20bb0d907fbbe433(async) {
    return async.type === "Loading";
}
function $52262828df9286f1$export$e141060ad697f932(async) {
    return async.type === "Loaded";
}
function $52262828df9286f1$export$7c5a8cf353babc66(async) {
    return async.type === "Failed";
}
function $52262828df9286f1$export$4958b66af9dfaac4(async) {
    switch(async.type){
        case "Idle":
            return $52262828df9286f1$var$loading();
        case "Loading":
            return async;
        case "Loaded":
            return $52262828df9286f1$var$loading(async.value);
        case "Failed":
            return $52262828df9286f1$var$loading(async.previousValue);
    }
}
function $52262828df9286f1$export$f4f5dc5cd61fbad8(_, value) {
    return $52262828df9286f1$var$loaded(value);
}
function $52262828df9286f1$export$55d14156d51f5886(async) {
    switch(async.type){
        case "Idle":
            return $52262828df9286f1$var$failed();
        case "Loading":
            return $52262828df9286f1$var$failed(async.previousValue);
        case "Loaded":
            return $52262828df9286f1$var$failed(async.value);
        case "Failed":
            return async;
    }
}
function $52262828df9286f1$export$4659b591c19bdf3d(async, callback) {
    switch(async.type){
        case "Idle":
            return callback.Idle();
        case "Loading":
            return callback.Loading(async.previousValue);
        case "Loaded":
            return callback.Loaded(async.value);
        case "Failed":
            return callback.Failed(async.previousValue);
    }
}
function $52262828df9286f1$export$2ab9a8f9f1186f14(result) {
    return $52262828df9286f1$export$4659b591c19bdf3d(result, {
        Idle: ()=>undefined,
        Loading: (previousValue)=>previousValue,
        Loaded: (value)=>value,
        Failed: (previousValue)=>previousValue
    });
}
function $52262828df9286f1$export$871de8747c9eaa88(async, fn) {
    return $52262828df9286f1$export$4659b591c19bdf3d(async, {
        Idle: ()=>$52262828df9286f1$export$2cd8252107eb640b(),
        Loading: (previousValue)=>$52262828df9286f1$var$loading(previousValue ? fn(previousValue) : undefined),
        Loaded: (value)=>$52262828df9286f1$var$loaded(fn(value)),
        Failed: (previousValue)=>$52262828df9286f1$var$failed(previousValue ? fn(previousValue) : undefined)
    });
}
function $52262828df9286f1$export$f25361c8d26ece68(results, fn) {
    if (results.length === 0) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return $52262828df9286f1$var$loaded(fn());
    const [first, ...rest] = results;
    return $52262828df9286f1$var$andMap(first, $52262828df9286f1$export$f25361c8d26ece68(rest, (...restArgs)=>{
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return (firstArg)=>fn(firstArg, ...restArgs);
    }));
}
function $52262828df9286f1$var$andMap(wrappedValue, wrappedFunction) {
    if ($52262828df9286f1$export$e141060ad697f932(wrappedValue) && $52262828df9286f1$export$e141060ad697f932(wrappedFunction)) return $52262828df9286f1$var$loaded(wrappedFunction.value(wrappedValue.value));
    if ($52262828df9286f1$export$7c5a8cf353babc66(wrappedFunction)) return $52262828df9286f1$var$failed();
    if ($52262828df9286f1$export$7c5a8cf353babc66(wrappedValue)) return $52262828df9286f1$var$failed();
    if ($52262828df9286f1$export$20bb0d907fbbe433(wrappedFunction)) return $52262828df9286f1$var$loading();
    if ($52262828df9286f1$export$20bb0d907fbbe433(wrappedValue)) return $52262828df9286f1$var$loading();
    return $52262828df9286f1$export$2cd8252107eb640b();
}
function $52262828df9286f1$export$bc338c567c21eab8(result, async) {
    return $jqoka.match(result, {
        Ok: (value)=>$52262828df9286f1$var$loaded(value),
        Err: ()=>async ? $52262828df9286f1$export$55d14156d51f5886(async) : $52262828df9286f1$var$failed()
    });
}

});
parcelRegister("jqoka", function(module, exports) {

$parcel$export(module.exports, "ok", () => $552d3b799a69e7a9$export$dcb8b3f0e2de7e49);
$parcel$export(module.exports, "err", () => $552d3b799a69e7a9$export$8048b892d651b310);
$parcel$export(module.exports, "isOk", () => $552d3b799a69e7a9$export$71a04ee6075aae31);
$parcel$export(module.exports, "match", () => $552d3b799a69e7a9$export$4659b591c19bdf3d);
$parcel$export(module.exports, "map", () => $552d3b799a69e7a9$export$871de8747c9eaa88);
$parcel$export(module.exports, "andThen", () => $552d3b799a69e7a9$export$9768a9ae43d7f016);
function $552d3b799a69e7a9$export$dcb8b3f0e2de7e49(value) {
    return {
        type: "Ok",
        value: value
    };
}
function $552d3b799a69e7a9$export$8048b892d651b310(error) {
    return {
        type: "Err",
        error: error
    };
}
function $552d3b799a69e7a9$export$2d69f7cde60d20d7(result) {
    return $552d3b799a69e7a9$export$71a04ee6075aae31(result) || $552d3b799a69e7a9$export$5edd8010b0a12d92(result);
}
function $552d3b799a69e7a9$export$71a04ee6075aae31(result) {
    return result.type === "Ok";
}
function $552d3b799a69e7a9$export$5edd8010b0a12d92(result) {
    return result.type === "Err";
}
function $552d3b799a69e7a9$export$4659b591c19bdf3d(result, callback) {
    switch(result.type){
        case "Ok":
            return callback.Ok(result.value);
        case "Err":
            return callback.Err(result.error);
    }
}
function $552d3b799a69e7a9$export$36faa878fcded3d7(result, defaultValue) {
    return $552d3b799a69e7a9$export$4659b591c19bdf3d(result, {
        Ok: (value)=>value,
        Err: ()=>defaultValue
    });
}
function $552d3b799a69e7a9$export$871de8747c9eaa88(result, fn) {
    return $552d3b799a69e7a9$export$4659b591c19bdf3d(result, {
        Ok: (value)=>$552d3b799a69e7a9$export$dcb8b3f0e2de7e49(fn(value)),
        Err: (error)=>$552d3b799a69e7a9$export$8048b892d651b310(error)
    });
}
function $552d3b799a69e7a9$export$f25361c8d26ece68(results, fn) {
    const args = [];
    for (const result of results){
        if ($552d3b799a69e7a9$export$5edd8010b0a12d92(result)) return result;
        args.push(result.value);
    }
    return $552d3b799a69e7a9$export$dcb8b3f0e2de7e49(fn(...args));
}
function $552d3b799a69e7a9$export$d0f6f6f8d08fe167(result, fn) {
    return $552d3b799a69e7a9$export$4659b591c19bdf3d(result, {
        Ok: (value)=>$552d3b799a69e7a9$export$dcb8b3f0e2de7e49(value),
        Err: (error)=>$552d3b799a69e7a9$export$8048b892d651b310(fn(error))
    });
}
function $552d3b799a69e7a9$export$9768a9ae43d7f016(result, fn) {
    return $552d3b799a69e7a9$export$4659b591c19bdf3d(result, {
        Ok: fn,
        Err: (error)=>$552d3b799a69e7a9$export$8048b892d651b310(error)
    });
}

});


parcelRegister("dGa5T", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $9f57071707a24f44$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $9f57071707a24f44$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $9f57071707a24f44$export$3c9a16f847548506);
$parcel$export(module.exports, "__decorate", () => $9f57071707a24f44$export$29e00dfd3077644b);
$parcel$export(module.exports, "__spreadArray", () => $9f57071707a24f44$export$1216008129fb82ed);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $9f57071707a24f44$var$extendStatics = function(d, b) {
    $9f57071707a24f44$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $9f57071707a24f44$var$extendStatics(d, b);
};
function $9f57071707a24f44$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $9f57071707a24f44$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $9f57071707a24f44$export$18ce0697a983be9b = function() {
    $9f57071707a24f44$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9f57071707a24f44$export$18ce0697a983be9b.apply(this, arguments);
};
function $9f57071707a24f44$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $9f57071707a24f44$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $9f57071707a24f44$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $9f57071707a24f44$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $9f57071707a24f44$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $9f57071707a24f44$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $9f57071707a24f44$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $9f57071707a24f44$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $9f57071707a24f44$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $9f57071707a24f44$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $9f57071707a24f44$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $9f57071707a24f44$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $9f57071707a24f44$export$45d3717a4c69092e(o, m, p);
}
function $9f57071707a24f44$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $9f57071707a24f44$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $9f57071707a24f44$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($9f57071707a24f44$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $9f57071707a24f44$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $9f57071707a24f44$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $9f57071707a24f44$export$10c90e4f7922046c(v) {
    return this instanceof $9f57071707a24f44$export$10c90e4f7922046c ? (this.v = v, this) : new $9f57071707a24f44$export$10c90e4f7922046c(v);
}
function $9f57071707a24f44$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $9f57071707a24f44$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $9f57071707a24f44$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $9f57071707a24f44$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $9f57071707a24f44$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $9f57071707a24f44$export$19a8beecd37a4c45 === "function" ? $9f57071707a24f44$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $9f57071707a24f44$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $9f57071707a24f44$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $9f57071707a24f44$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $9f57071707a24f44$export$45d3717a4c69092e(result, mod, k);
    }
    $9f57071707a24f44$var$__setModuleDefault(result, mod);
    return result;
}
function $9f57071707a24f44$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $9f57071707a24f44$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $9f57071707a24f44$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $9f57071707a24f44$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $9f57071707a24f44$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $9f57071707a24f44$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $9f57071707a24f44$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $9f57071707a24f44$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $9f57071707a24f44$export$2e2bcd8739ae039 = {
    __extends: $9f57071707a24f44$export$a8ba968b8961cb8a,
    __assign: $9f57071707a24f44$export$18ce0697a983be9b,
    __rest: $9f57071707a24f44$export$3c9a16f847548506,
    __decorate: $9f57071707a24f44$export$29e00dfd3077644b,
    __param: $9f57071707a24f44$export$d5ad3fd78186038f,
    __metadata: $9f57071707a24f44$export$f1db080c865becb9,
    __awaiter: $9f57071707a24f44$export$1050f835b63b671e,
    __generator: $9f57071707a24f44$export$67ebef60e6f28a6,
    __createBinding: $9f57071707a24f44$export$45d3717a4c69092e,
    __exportStar: $9f57071707a24f44$export$f33643c0debef087,
    __values: $9f57071707a24f44$export$19a8beecd37a4c45,
    __read: $9f57071707a24f44$export$8d051b38c9118094,
    __spread: $9f57071707a24f44$export$afc72e2116322959,
    __spreadArrays: $9f57071707a24f44$export$6388937ca91ccae8,
    __spreadArray: $9f57071707a24f44$export$1216008129fb82ed,
    __await: $9f57071707a24f44$export$10c90e4f7922046c,
    __asyncGenerator: $9f57071707a24f44$export$e427f37a30a4de9b,
    __asyncDelegator: $9f57071707a24f44$export$bbd80228419bb833,
    __asyncValues: $9f57071707a24f44$export$e3b29a3d6162315f,
    __makeTemplateObject: $9f57071707a24f44$export$4fb47efe1390b86f,
    __importStar: $9f57071707a24f44$export$c21735bcef00d192,
    __importDefault: $9f57071707a24f44$export$da59b14a69baef04,
    __classPrivateFieldGet: $9f57071707a24f44$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $9f57071707a24f44$export$d40a35129aaff81f,
    __classPrivateFieldIn: $9f57071707a24f44$export$81fdc39f203e4e04,
    __addDisposableResource: $9f57071707a24f44$export$88ac25d8e944e405,
    __disposeResources: $9f57071707a24f44$export$8f076105dc360e92
};

});

parcelRegister("bFoC6", function(module, exports) {
$parcel$export(module.exports, "customElement", () => (parcelRequire("d92i1")).customElement);
$parcel$export(module.exports, "property", () => (parcelRequire("4Kcgn")).property);
parcelRequire("d92i1");
parcelRequire("4Kcgn");
parcelRequire("01Sex");
parcelRequire("g0qxW");
parcelRequire("ewrMi");
parcelRequire("iDov5");
parcelRequire("bsa9T");
parcelRequire("iIoDa");
parcelRequire("4S8mu");

});
parcelRegister("d92i1", function(module, exports) {

$parcel$export(module.exports, "customElement", () => $991de45082828842$export$da64fc29f17f9d0e);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $991de45082828842$export$da64fc29f17f9d0e = (t)=>(e, o)=>{
        void 0 !== o ? o.addInitializer(()=>{
            customElements.define(t, e);
        }) : customElements.define(t, e);
    };

});

parcelRegister("4Kcgn", function(module, exports) {

$parcel$export(module.exports, "property", () => $3744f87d3f278ad6$export$d541bacb2bda4494);

var $ksYdx = parcelRequire("ksYdx");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $3744f87d3f278ad6$var$o = {
    attribute: !0,
    type: String,
    converter: (0, $ksYdx.defaultConverter),
    reflect: !1,
    hasChanged: (0, $ksYdx.notEqual)
}, $3744f87d3f278ad6$export$8d623b1670eb40f4 = (t = $3744f87d3f278ad6$var$o, e, r)=>{
    const { kind: n, metadata: i } = r;
    let s = globalThis.litPropertyMetadata.get(i);
    if (void 0 === s && globalThis.litPropertyMetadata.set(i, s = new Map), s.set(r.name, t), "accessor" === n) {
        const { name: o } = r;
        return {
            set (r) {
                const n = e.get.call(this);
                e.set.call(this, r), this.requestUpdate(o, n, t);
            },
            init (e) {
                return void 0 !== e && this.P(o, void 0, t), e;
            }
        };
    }
    if ("setter" === n) {
        const { name: o } = r;
        return function(r) {
            const n = this[o];
            e.call(this, r), this.requestUpdate(o, n, t);
        };
    }
    throw Error("Unsupported decorator location: " + n);
};
function $3744f87d3f278ad6$export$d541bacb2bda4494(t) {
    return (e, o)=>"object" == typeof o ? $3744f87d3f278ad6$export$8d623b1670eb40f4(t, e, o) : ((t, e, o)=>{
            const r = e.hasOwnProperty(o);
            return e.constructor.createProperty(o, r ? {
                ...t,
                wrapped: !0
            } : t), r ? Object.getOwnPropertyDescriptor(e, o) : void 0;
        })(t, e, o);
}

});

parcelRegister("01Sex", function(module, exports) {

var $4Kcgn = parcelRequire("4Kcgn");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $005a29bc526d9396$export$ca000e230c0caa3e(r) {
    return (0, $4Kcgn.property)({
        ...r,
        state: !0,
        attribute: !1
    });
}

});

parcelRegister("g0qxW", function(module, exports) {
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $ba713cfb622ee36f$export$b2b799818fbabcf3(t) {
    return (n, o)=>{
        const c = "function" == typeof n ? n : n[o];
        Object.assign(c, t);
    };
}

});

parcelRegister("ewrMi", function(module, exports) {

var $44JLR = parcelRequire("44JLR");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $a92999fa6ac267ff$export$2fa187e846a241c4(e, r) {
    return (n, s, i)=>{
        const o = (t)=>t.renderRoot?.querySelector(e) ?? null;
        if (r) {
            const { get: e, set: r } = "object" == typeof s ? n : i ?? (()=>{
                const t = Symbol();
                return {
                    get () {
                        return this[t];
                    },
                    set (e) {
                        this[t] = e;
                    }
                };
            })();
            return (0, $44JLR.desc)(n, s, {
                get () {
                    let t = e.call(this);
                    return void 0 === t && (t = o(this), (null !== t || this.hasUpdated) && r.call(this, t)), t;
                }
            });
        }
        return (0, $44JLR.desc)(n, s, {
            get () {
                return o(this);
            }
        });
    };
}

});
parcelRegister("44JLR", function(module, exports) {

$parcel$export(module.exports, "desc", () => $2f7b0a51a9448d48$export$51987bb50e1f6752);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $2f7b0a51a9448d48$export$51987bb50e1f6752 = (e, t, c)=>(c.configurable = !0, c.enumerable = !0, Reflect.decorate && "object" != typeof t && Object.defineProperty(e, t, c), c);

});


parcelRegister("iDov5", function(module, exports) {

var $44JLR = parcelRequire("44JLR");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ let $d90edfcc9cf8850c$var$e;
function $d90edfcc9cf8850c$export$dcd0d083aa86c355(r) {
    return (n, o)=>(0, $44JLR.desc)(n, o, {
            get () {
                return (this.renderRoot ?? ($d90edfcc9cf8850c$var$e ??= document.createDocumentFragment())).querySelectorAll(r);
            }
        });
}

});

parcelRegister("bsa9T", function(module, exports) {

var $44JLR = parcelRequire("44JLR");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $856a30824140fcfb$export$163dfc35cc43f240(r) {
    return (n, e)=>(0, $44JLR.desc)(n, e, {
            async get () {
                return await this.updateComplete, this.renderRoot?.querySelector(r) ?? null;
            }
        });
}

});

parcelRegister("iIoDa", function(module, exports) {

var $44JLR = parcelRequire("44JLR");
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $d9ff712e00e75244$export$4682af2d9ee91415(o) {
    return (e, n)=>{
        const { slot: r, selector: s } = o ?? {}, c = "slot" + (r ? `[name=${r}]` : ":not([name])");
        return (0, $44JLR.desc)(e, n, {
            get () {
                const t = this.renderRoot?.querySelector(c), e = t?.assignedElements(o) ?? [];
                return void 0 === s ? e : e.filter((t)=>t.matches(s));
            }
        });
    };
}

});

parcelRegister("4S8mu", function(module, exports) {

var $44JLR = parcelRequire("44JLR");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $38c2b1084fc777ed$export$1bdbe53f9df1b8(n) {
    return (o, r)=>{
        const { slot: e } = n ?? {}, s = "slot" + (e ? `[name=${e}]` : ":not([name])");
        return (0, $44JLR.desc)(o, r, {
            get () {
                const t = this.renderRoot?.querySelector(s);
                return t?.assignedNodes(n) ?? [];
            }
        });
    };
}

});


parcelRegister("kjhzP", function(module, exports) {

$parcel$export(module.exports, "default", () => $a65a69852408fe2c$export$2e2bcd8739ae039);
parcelRequire("MJPZu");
var $hOpwk = parcelRequire("hOpwk");
var $9UZF0 = parcelRequire("9UZF0");

var $2dbqg = parcelRequire("2dbqg");
(0, $2dbqg.declareStyle)((0, $hOpwk.css)`
    ata-app-bar {
        display: grid;
        grid-template-columns: 1fr auto 1fr;
        grid-template-areas: 'start center end';
        align-items: center;
        justify-content: center;
        background: var(--color--primary);
        color: var(--ata--app--bar--foregroundColor);
        fill: var(--ata--app--bar--foregroundColor);
        block-size: var(--ata--app--bar--blockSize);
        position: sticky;
        top: 0;
        z-index: 1;
    }

    [slot='start'] {
        grid-area: start;
        justify-self: start;
    }

    [slot='center'] {
        grid-area: center;
        justify-self: center;
    }

    [slot='end'] {
        grid-area: end;
        justify-self: end;
    }
`);
function $a65a69852408fe2c$export$2e2bcd8739ae039(config) {
    const start = config.start ?? (0, $9UZF0.nothing);
    const center = config.center ?? (0, $9UZF0.nothing);
    const end = config.end ?? (0, $9UZF0.nothing);
    return (0, $9UZF0.html)`
        <ata-app-bar>
            <div slot="start">${start}</div>
            <div slot="center">${center}</div>
            <div slot="end">${end}</div>
        </ata-app-bar>
    `;
}

});
parcelRegister("2dbqg", function(module, exports) {

$parcel$export(module.exports, "declareStyle", () => $a257d21ac559643e$export$7d2bd5e79e7a7dfd);
function $a257d21ac559643e$export$7d2bd5e79e7a7dfd(value) {
    const styleEl = document.createElement("style");
    styleEl.innerHTML = value.cssText;
    document.head.append(styleEl);
}

});


parcelRegister("ksfXA", function(module, exports) {

$parcel$export(module.exports, "padding", () => $3cfa134816130c8d$export$6f98e8eaf0be1996);
$parcel$export(module.exports, "paddingEach", () => $3cfa134816130c8d$export$ca1daf5e3302a30e);
$parcel$export(module.exports, "paddingBlockInline", () => $3cfa134816130c8d$export$e02b1fe389cc1f29);
parcelRequire("MJPZu");
var $9UZF0 = parcelRequire("9UZF0");
function $3cfa134816130c8d$export$6f98e8eaf0be1996(size, content) {
    return $3cfa134816130c8d$export$ca1daf5e3302a30e({
        blockStart: size,
        blockEnd: size,
        inlineStart: size,
        inlineEnd: size
    }, content);
}
function $3cfa134816130c8d$export$e02b1fe389cc1f29(size, content) {
    return $3cfa134816130c8d$export$ca1daf5e3302a30e({
        blockStart: size.block,
        blockEnd: size.block,
        inlineStart: size.inline,
        inlineEnd: size.inline
    }, content);
}
function $3cfa134816130c8d$export$ca1daf5e3302a30e(size, content) {
    const padding = `
        padding: 
            ${$3cfa134816130c8d$var$toSizeCssVariable(size.blockStart)} 
            ${$3cfa134816130c8d$var$toSizeCssVariable(size.inlineEnd)}
            ${$3cfa134816130c8d$var$toSizeCssVariable(size.blockEnd)}
            ${$3cfa134816130c8d$var$toSizeCssVariable(size.inlineStart)}; 
    `;
    return (0, $9UZF0.html)`<ata-spacing style="display: block; ${padding}">
        ${content}
    </ata-spacing>`;
}
function $3cfa134816130c8d$var$toSizeCssVariable(size) {
    switch(size){
        case "small":
            return "var(--dimensions--spacing--small)";
        case "medium":
            return "var(--dimensions--spacing--medium)";
        case "large":
            return "var(--dimensions--spacing--large)";
        case "none":
            return "0";
    }
}

});

parcelRegister("fjcCR", function(module, exports) {

$parcel$export(module.exports, "horizontalLayout", () => $64fbc568f7277dc0$export$7bbf90a9bfbd261b);
$parcel$export(module.exports, "verticalLayout", () => $64fbc568f7277dc0$export$6e1af8d829851935);
$parcel$export(module.exports, "fillContainer", () => $64fbc568f7277dc0$export$14f957517b707d9f);
$parcel$export(module.exports, "noShrink", () => $64fbc568f7277dc0$export$569368b544e1cd57);
parcelRequire("MJPZu");
var $9UZF0 = parcelRequire("9UZF0");
parcelRequire("4CCe6");
parcelRequire("6yjXZ");
function $64fbc568f7277dc0$export$7bbf90a9bfbd261b(alignment, gap, items) {
    return (0, $9UZF0.html)`<ata-horizontal-layout
        align="${alignment.join(" ")}"
        gap="${gap}"
    >
        ${items}
    </ata-horizontal-layout>`;
}
function $64fbc568f7277dc0$export$6e1af8d829851935(alignment, gap, items) {
    return (0, $9UZF0.html)`<ata-vertical-layout
        align="${alignment.join(" ")}"
        gap="${gap}"
    >
        ${items}
    </ata-vertical-layout>`;
}
function $64fbc568f7277dc0$export$14f957517b707d9f(content, basisPercentage = 1) {
    return (0, $9UZF0.html)`<div style="flex: 1 1 ${basisPercentage * 100}%;"
        >${content}</div
    >`;
}
function $64fbc568f7277dc0$export$569368b544e1cd57(content) {
    return (0, $9UZF0.html)`<div style="flex-shrink: 0;">${content}</div>`;
}

});
parcelRegister("4CCe6", function(module, exports) {

var $dGa5T = parcelRequire("dGa5T");
parcelRequire("bFoC6");
var $d92i1 = parcelRequire("d92i1");
parcelRequire("MJPZu");
var $hOpwk = parcelRequire("hOpwk");

var $1D1vN = parcelRequire("1D1vN");
class $b420128a2dcbe965$export$2e2bcd8739ae039 extends (0, $1D1vN.default) {
    static styles = [
        (0, $1D1vN.gapCss),
        (0, $1D1vN.alignmentCss),
        (0, $1D1vN.horizontalAlignmentCss),
        (0, $hOpwk.css)`
            :host {
                display: flex;
                flex-direction: row;
            }
        `
    ];
}
$b420128a2dcbe965$export$2e2bcd8739ae039 = (0, $dGa5T.__decorate)([
    (0, $d92i1.customElement)("ata-horizontal-layout")
], $b420128a2dcbe965$export$2e2bcd8739ae039);

});
parcelRegister("1D1vN", function(module, exports) {

$parcel$export(module.exports, "gapCss", () => $3313cdb011dcd2ca$export$da1d8c99b9ef394b);
$parcel$export(module.exports, "alignmentCss", () => $3313cdb011dcd2ca$export$952e031cd885382c);
$parcel$export(module.exports, "horizontalAlignmentCss", () => $3313cdb011dcd2ca$export$bc679b5b248b152);
$parcel$export(module.exports, "verticalAlignmentCss", () => $3313cdb011dcd2ca$export$9ec36c30f5a7d8b5);
$parcel$export(module.exports, "default", () => $3313cdb011dcd2ca$export$2e2bcd8739ae039);

var $dGa5T = parcelRequire("dGa5T");
parcelRequire("MJPZu");
var $hOpwk = parcelRequire("hOpwk");
var $9UZF0 = parcelRequire("9UZF0");
var $78EKQ = parcelRequire("78EKQ");
parcelRequire("bFoC6");
var $4Kcgn = parcelRequire("4Kcgn");

var $02YGq = parcelRequire("02YGq");
const $3313cdb011dcd2ca$export$da1d8c99b9ef394b = (0, $hOpwk.css)`
    :host([gap='none']) {
        gap: 0;
    }

    :host([gap='small']) {
        gap: var(--dimensions--spacing--small);
    }

    :host([gap='medium']) {
        gap: var(--dimensions--spacing--medium);
    }

    :host([gap='large']) {
        gap: var(--dimensions--spacing--large);
    }
`;
const $3313cdb011dcd2ca$export$952e031cd885382c = (0, $hOpwk.css)`
    :host([align='start']) {
        justify-content: flex-start;
        align-items: flex-start;
    }

    :host([align='center']) {
        justify-content: center;
        align-items: center;
    }

    :host([align='end']) {
        justify-content: flex-end;
        align-items: flex-end;
    }

    :host([align='fill']) {
        justify-content: space-between;
        align-items: stretch;
    }
`;
const $3313cdb011dcd2ca$export$bc679b5b248b152 = (0, $hOpwk.css)`
    :host([align^='start ']) {
        justify-content: flex-start;
    }

    :host([align^='center ']) {
        justify-content: center;
    }

    :host([align^='end ']) {
        justify-content: flex-end;
    }

    :host([align^='fill ']) {
        justify-content: space-between;
    }

    :host([align$=' start']) {
        align-items: flex-start;
    }

    :host([align$=' center']) {
        align-items: center;
    }

    :host([align$=' end']) {
        align-items: flex-end;
    }

    :host([align$=' fill']) {
        align-items: stretch;
    }
`;
const $3313cdb011dcd2ca$export$9ec36c30f5a7d8b5 = (0, $hOpwk.css)`
    :host([align$=' start']) {
        justify-content: flex-start;
    }

    :host([align$=' center']) {
        justify-content: center;
    }

    :host([align$=' end']) {
        justify-content: flex-end;
    }

    :host([align$=' fill']) {
        justify-content: space-between;
    }

    :host([align^='start ']) {
        align-items: flex-start;
    }

    :host([align^='center ']) {
        align-items: center;
    }

    :host([align^='end ']) {
        align-items: flex-end;
    }

    :host([align^='fill ']) {
        align-items: stretch;
    }
`;
class $3313cdb011dcd2ca$export$2e2bcd8739ae039 extends (0, $78EKQ.LitElement) {
    align = [
        "start",
        "start"
    ];
    gap = "none";
    render() {
        return (0, $9UZF0.html)`<slot></slot>`;
    }
    connectedCallback() {
        // this.updateAlignStyles();
        super.connectedCallback();
    }
    updated(_changedProperties) {
        _changedProperties.has("align");
        super.updated(_changedProperties);
    }
}
(0, $dGa5T.__decorate)([
    (0, $4Kcgn.property)({
        converter: $3313cdb011dcd2ca$var$alignAttributeConverter(),
        hasChanged: (0, (/*@__PURE__*/$parcel$interopDefault($02YGq))),
        reflect: true
    })
], $3313cdb011dcd2ca$export$2e2bcd8739ae039.prototype, "align", void 0);
(0, $dGa5T.__decorate)([
    (0, $4Kcgn.property)({
        reflect: true,
        converter: $3313cdb011dcd2ca$var$gapAttributeConverter()
    })
], $3313cdb011dcd2ca$export$2e2bcd8739ae039.prototype, "gap", void 0);
function $3313cdb011dcd2ca$var$alignAttributeConverter() {
    return {
        fromAttribute (value) {
            let [x, y] = value?.split(" ") ?? [
                "start",
                "start"
            ];
            if (!$3313cdb011dcd2ca$var$isAlignment(x)) x = "start";
            if (y === undefined) y = String(x);
            if (!$3313cdb011dcd2ca$var$isAlignment(y)) y = "start";
            return [
                x,
                y
            ];
        },
        toAttribute (value) {
            return value.join(" ");
        }
    };
}
function $3313cdb011dcd2ca$var$gapAttributeConverter() {
    return {
        fromAttribute (value) {
            if (value !== null && $3313cdb011dcd2ca$var$isGap(value)) return value;
            return "none";
        }
    };
}
function $3313cdb011dcd2ca$var$isAlignment(value) {
    return [
        "start",
        "center",
        "end",
        "fill"
    ].includes(value);
}
function $3313cdb011dcd2ca$var$isGap(value) {
    return [
        "none",
        "small",
        "medium",
        "large"
    ].includes(value);
}

});
parcelRegister("02YGq", function(module, exports) {
"use strict";
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});



parcelRegister("6yjXZ", function(module, exports) {

var $dGa5T = parcelRequire("dGa5T");
parcelRequire("bFoC6");
var $d92i1 = parcelRequire("d92i1");
parcelRequire("MJPZu");
var $hOpwk = parcelRequire("hOpwk");

var $1D1vN = parcelRequire("1D1vN");
class $b68e98f0f5f930c0$export$2e2bcd8739ae039 extends (0, $1D1vN.default) {
    static styles = [
        (0, $1D1vN.gapCss),
        (0, $1D1vN.alignmentCss),
        (0, $1D1vN.verticalAlignmentCss),
        (0, $hOpwk.css)`
            :host {
                display: flex;
                flex-direction: column;
            }
        `
    ];
}
$b68e98f0f5f930c0$export$2e2bcd8739ae039 = (0, $dGa5T.__decorate)([
    (0, $d92i1.customElement)("ata-vertical-layout")
], $b68e98f0f5f930c0$export$2e2bcd8739ae039);

});


parcelRegister("5jpwE", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fa0c962ce48c775$export$2e2bcd8739ae039);
$parcel$export(module.exports, "percentage", () => $9fa0c962ce48c775$export$a3560dfa62c7efe0);

var $9oMz1 = parcelRequire("9oMz1");
parcelRequire("MJPZu");
var $9UZF0 = parcelRequire("9UZF0");
var $9fa0c962ce48c775$export$2e2bcd8739ae039 = {
    number: $9fa0c962ce48c775$export$98e628dec113755e,
    currency: $9fa0c962ce48c775$export$f4f21ed02b0ddb8f,
    percentage: $9fa0c962ce48c775$export$a3560dfa62c7efe0,
    date: $9fa0c962ce48c775$export$324d90190a8b822a,
    datetime: $9fa0c962ce48c775$export$7ba4466dbd0f07e1,
    relativeTime: $9fa0c962ce48c775$export$caddcc104251c1d7
};
function $9fa0c962ce48c775$export$98e628dec113755e(value, fractions = 0, sign = "auto") {
    return $9fa0c962ce48c775$var$toHtml(`{value, number, ::${$9fa0c962ce48c775$var$toFractionsOption(fractions)} sign-${sign}}`, value);
}
function $9fa0c962ce48c775$export$f4f21ed02b0ddb8f(value, fractions = 0, sign = "auto") {
    return $9fa0c962ce48c775$var$toHtml(`{value, number, ::${$9fa0c962ce48c775$var$toFractionsOption(fractions)} sign-${sign} currency/EUR}`, value);
}
function $9fa0c962ce48c775$export$a3560dfa62c7efe0(value, fractions = 0, sign = "auto") {
    return $9fa0c962ce48c775$var$toHtml(`{value, number, ::${$9fa0c962ce48c775$var$toFractionsOption(fractions)} sign-${sign} percent}`, value);
}
function $9fa0c962ce48c775$export$324d90190a8b822a(value) {
    return $9fa0c962ce48c775$var$toHtml("{value, date, ::yyyyMMdd}", value.valueOf());
}
function $9fa0c962ce48c775$export$7ba4466dbd0f07e1(value) {
    return $9fa0c962ce48c775$var$toHtml("{value, date, ::yyyyMMddHHmm}", value.valueOf());
}
function $9fa0c962ce48c775$export$caddcc104251c1d7(unit, value) {
    const text = new Intl.RelativeTimeFormat("nl-NL", {
        style: "long"
    }).format(value, unit);
    return (0, $9UZF0.html)`${text}`;
}
function $9fa0c962ce48c775$var$toFractionsOption(amount) {
    if (amount === 0) return ".";
    const zeros = Array.from({
        length: amount
    }).map(()=>"0").join("");
    return `.${zeros}`;
}
function $9fa0c962ce48c775$var$toHtml(string, value) {
    return (0, $9oMz1.intlText)(string, {
        value: value
    });
}

});
parcelRegister("9oMz1", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ab9e67859692db2$export$2e2bcd8739ae039);
$parcel$export(module.exports, "intlText", () => $8ab9e67859692db2$export$90d10f3f3a68cbe7);

var $dGa5T = parcelRequire("dGa5T");
parcelRequire("bFoC6");
var $d92i1 = parcelRequire("d92i1");

var $4RBO5 = parcelRequire("4RBO5");
parcelRequire("MJPZu");
var $9UZF0 = parcelRequire("9UZF0");
var $8ab9e67859692db2$export$2e2bcd8739ae039 = {
    intlText: $8ab9e67859692db2$export$90d10f3f3a68cbe7
};
function $8ab9e67859692db2$export$90d10f3f3a68cbe7(message, data) {
    return (0, $9UZF0.html)`${new (0, $4RBO5.default)(message, "nl-NL").format(data)}`;
}
class $8ab9e67859692db2$export$b073684f8e45a7e2 extends HTMLElement {
    observer = new MutationObserver(this.formatTextContent.bind(this));
    constructor(){
        super();
        this.attachShadow({
            mode: "open"
        });
    }
    connectedCallback() {
        this.formatTextContent();
        this.observer.observe(this, {
            characterData: true,
            childList: true,
            attributes: true
        });
    }
    disconnectedCallback() {
        this.observer.disconnect();
    }
    formatTextContent() {
        let text = new (0, $4RBO5.default)(this.textContent ?? "", "nl-NL").format(this.dataset);
        if (Array.isArray(text)) text = text.join("");
        if (this.shadowRoot) this.shadowRoot.textContent = text ?? "";
    }
}
$8ab9e67859692db2$export$b073684f8e45a7e2 = (0, $dGa5T.__decorate)([
    (0, $d92i1.customElement)("intl-text")
], $8ab9e67859692db2$export$b073684f8e45a7e2);

});
parcelRegister("4RBO5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $38a97052a67d41c2$export$2e2bcd8739ae039);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $8Uubj = parcelRequire("8Uubj");


var $38a97052a67d41c2$export$2e2bcd8739ae039 = (0, $8Uubj.IntlMessageFormat);

});
parcelRegister("8Uubj", function(module, exports) {

$parcel$export(module.exports, "IntlMessageFormat", () => $67caf71fce180e33$export$d342343268debc40);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $dGa5T = parcelRequire("dGa5T");

var $12ZnM = parcelRequire("12ZnM");

var $lEKDF = parcelRequire("lEKDF");

var $bDk31 = parcelRequire("bDk31");
// -- MessageFormat --------------------------------------------------------
function $67caf71fce180e33$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $dGa5T.__assign)((0, $dGa5T.__assign)((0, $dGa5T.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $dGa5T.__assign)((0, $dGa5T.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $67caf71fce180e33$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $67caf71fce180e33$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $dGa5T.__assign)({}, defaultConfig));
}
function $67caf71fce180e33$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $67caf71fce180e33$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $lEKDF.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $dGa5T.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $67caf71fce180e33$var$createFastMemoizeCache(cache.number),
            strategy: (0, $lEKDF.strategies).variadic
        }),
        getDateTimeFormat: (0, $lEKDF.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $dGa5T.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $67caf71fce180e33$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $lEKDF.strategies).variadic
        }),
        getPluralRules: (0, $lEKDF.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $dGa5T.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $67caf71fce180e33$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $lEKDF.strategies).variadic
        })
    };
}
var $67caf71fce180e33$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        var _this = this;
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $bDk31.PART_TYPE).literal || typeof all[all.length - 1] !== "string") all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || "";
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $bDk31.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === "string") {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, $dGa5T.__rest)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, $dGa5T.__assign)((0, $dGa5T.__assign)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError("A message must be provided as a String or AST.");
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $67caf71fce180e33$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $67caf71fce180e33$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === "undefined") return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === "string" ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $12ZnM.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: "currency"
            },
            percent: {
                style: "percent"
            }
        },
        date: {
            short: {
                month: "numeric",
                day: "numeric",
                year: "2-digit"
            },
            medium: {
                month: "short",
                day: "numeric",
                year: "numeric"
            },
            long: {
                month: "long",
                day: "numeric",
                year: "numeric"
            },
            full: {
                weekday: "long",
                month: "long",
                day: "numeric",
                year: "numeric"
            }
        },
        time: {
            short: {
                hour: "numeric",
                minute: "numeric"
            },
            medium: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric"
            },
            long: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            },
            full: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            }
        }
    };
    return IntlMessageFormat;
}();

});
parcelRegister("12ZnM", function(module, exports) {
$parcel$export(module.exports, "isArgumentElement", () => (parcelRequire("3gZro")).isArgumentElement);
$parcel$export(module.exports, "isDateElement", () => (parcelRequire("3gZro")).isDateElement);
$parcel$export(module.exports, "isDateTimeSkeleton", () => (parcelRequire("3gZro")).isDateTimeSkeleton);
$parcel$export(module.exports, "isLiteralElement", () => (parcelRequire("3gZro")).isLiteralElement);
$parcel$export(module.exports, "isNumberElement", () => (parcelRequire("3gZro")).isNumberElement);
$parcel$export(module.exports, "isNumberSkeleton", () => (parcelRequire("3gZro")).isNumberSkeleton);
$parcel$export(module.exports, "isPluralElement", () => (parcelRequire("3gZro")).isPluralElement);
$parcel$export(module.exports, "isPoundElement", () => (parcelRequire("3gZro")).isPoundElement);
$parcel$export(module.exports, "isSelectElement", () => (parcelRequire("3gZro")).isSelectElement);
$parcel$export(module.exports, "isTagElement", () => (parcelRequire("3gZro")).isTagElement);
$parcel$export(module.exports, "isTimeElement", () => (parcelRequire("3gZro")).isTimeElement);

$parcel$export(module.exports, "parse", () => $0c3597a45ff0f0d8$export$98e6a39c04603d36);

var $dGa5T = parcelRequire("dGa5T");

var $3cWRX = parcelRequire("3cWRX");

var $gBv3Z = parcelRequire("gBv3Z");

var $3gZro = parcelRequire("3gZro");
function $0c3597a45ff0f0d8$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $3gZro.isSelectElement)(el) || (0, $3gZro.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $0c3597a45ff0f0d8$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $3gZro.isNumberElement)(el) && (0, $3gZro.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $3gZro.isDateElement)(el) || (0, $3gZro.isTimeElement)(el)) && (0, $3gZro.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $3gZro.isTagElement)(el)) $0c3597a45ff0f0d8$var$pruneLocation(el.children);
    });
}
function $0c3597a45ff0f0d8$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $dGa5T.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $gBv3Z.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $3cWRX.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $0c3597a45ff0f0d8$var$pruneLocation(result.val);
    return result.val;
}
var $0c3597a45ff0f0d8$export$d3c1bfa0f7d806e9 = (0, $gBv3Z.Parser);

});
parcelRegister("3cWRX", function(module, exports) {

$parcel$export(module.exports, "ErrorKind", () => $25602849e1868b14$export$896afd8541959ee5);
var $25602849e1868b14$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($25602849e1868b14$export$896afd8541959ee5 || ($25602849e1868b14$export$896afd8541959ee5 = {}));

});

parcelRegister("gBv3Z", function(module, exports) {

$parcel$export(module.exports, "Parser", () => $c16832951168152d$export$7acfa6ed01010e37);

var $dGa5T = parcelRequire("dGa5T");

var $3cWRX = parcelRequire("3cWRX");

var $3gZro = parcelRequire("3gZro");

var $dM3Pi = parcelRequire("dM3Pi");
parcelRequire("dvRZv");
var $l2xeT = parcelRequire("l2xeT");
var $jo0ag = parcelRequire("jo0ag");

var $8iBhK = parcelRequire("8iBhK");
var $c16832951168152d$var$_a;
var $c16832951168152d$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $dM3Pi.SPACE_SEPARATOR_REGEX).source, "*"));
var $c16832951168152d$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $dM3Pi.SPACE_SEPARATOR_REGEX).source, "*$"));
function $c16832951168152d$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $c16832951168152d$var$hasNativeStartsWith = !!String.prototype.startsWith && "_a".startsWith("a", 1);
var $c16832951168152d$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $c16832951168152d$var$hasNativeFromEntries = !!Object.fromEntries;
var $c16832951168152d$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $c16832951168152d$var$hasTrimStart = !!String.prototype.trimStart;
var $c16832951168152d$var$hasTrimEnd = !!String.prototype.trimEnd;
var $c16832951168152d$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $c16832951168152d$var$isSafeInteger = $c16832951168152d$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === "number" && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $c16832951168152d$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $c16832951168152d$var$re = $c16832951168152d$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $c16832951168152d$var$REGEX_SUPPORTS_U_AND_Y = (($c16832951168152d$var$_a = $c16832951168152d$var$re.exec("a")) === null || $c16832951168152d$var$_a === void 0 ? void 0 : $c16832951168152d$var$_a[0]) === "a";
} catch (_) {
    $c16832951168152d$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $c16832951168152d$var$startsWith = $c16832951168152d$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $c16832951168152d$var$fromCodePoint = $c16832951168152d$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = "";
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + " is not a valid code point");
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $c16832951168152d$var$fromEntries = // native
$c16832951168152d$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $c16832951168152d$var$codePointAt = $c16832951168152d$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $c16832951168152d$var$trimStart = $c16832951168152d$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($c16832951168152d$var$SPACE_SEPARATOR_START_REGEX, "");
};
var $c16832951168152d$var$trimEnd = $c16832951168152d$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($c16832951168152d$var$SPACE_SEPARATOR_END_REGEX, "");
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $c16832951168152d$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $c16832951168152d$var$matchIdentifierAtIndex;
if ($c16832951168152d$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $c16832951168152d$var$IDENTIFIER_PREFIX_RE_1 = $c16832951168152d$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    $c16832951168152d$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $c16832951168152d$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $c16832951168152d$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : "";
    };
} else // IE11
$c16832951168152d$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $c16832951168152d$var$codePointAt(s, index);
        if (c === undefined || $c16832951168152d$var$_isWhiteSpace(c) || $c16832951168152d$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $c16832951168152d$var$fromCodePoint.apply(void 0, match);
};
var $c16832951168152d$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error("parser can only be used once");
        return this.parseMessage(0, "", false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal")) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $3gZro.TYPE).pound,
                    location: $c16832951168152d$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $3cWRX.ErrorKind).UNMATCHED_CLOSING_TAG, $c16832951168152d$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $c16832951168152d$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf("/>")) // Self closing tag
        return {
            val: {
                type: (0, $3gZro.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $c16832951168152d$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf(">")) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf("</")) {
                if (this.isEOF() || !$c16832951168152d$var$_isAlpha(this.char())) return this.error((0, $3cWRX.ErrorKind).INVALID_TAG, $c16832951168152d$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $3cWRX.ErrorKind).UNMATCHED_CLOSING_TAG, $c16832951168152d$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf(">")) return this.error((0, $3cWRX.ErrorKind).INVALID_TAG, $c16832951168152d$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $3gZro.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $c16832951168152d$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $3cWRX.ErrorKind).UNCLOSED_TAG, $c16832951168152d$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $3cWRX.ErrorKind).INVALID_TAG, $c16832951168152d$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $c16832951168152d$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = "";
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $c16832951168152d$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $3gZro.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$c16832951168152d$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return "<";
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === "plural" || parentArgType === "selectordinal") break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $c16832951168152d$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal") || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $c16832951168152d$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $3cWRX.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $c16832951168152d$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $3cWRX.ErrorKind).EMPTY_ARGUMENT, $c16832951168152d$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $3cWRX.ErrorKind).MALFORMED_ARGUMENT, $c16832951168152d$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $3cWRX.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $c16832951168152d$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $3gZro.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $c16832951168152d$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $3cWRX.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $c16832951168152d$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $3cWRX.ErrorKind).MALFORMED_ARGUMENT, $c16832951168152d$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $c16832951168152d$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $c16832951168152d$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case "":
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $3cWRX.ErrorKind).EXPECT_ARGUMENT_TYPE, $c16832951168152d$var$createLocation(typeStartPosition, typeEndPosition));
            case "number":
            case "date":
            case "time":
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(",")) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $c16832951168152d$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $3cWRX.ErrorKind).EXPECT_ARGUMENT_STYLE, $c16832951168152d$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $c16832951168152d$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $c16832951168152d$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $c16832951168152d$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, "::", 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $c16832951168152d$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === "number") {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $3gZro.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $3cWRX.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $8iBhK.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $3gZro.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $l2xeT.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === "date" ? (0, $3gZro.TYPE).date : (0, $3gZro.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === "number" ? (0, $3gZro.TYPE).number : argType === "date" ? (0, $3gZro.TYPE).date : (0, $3gZro.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case "plural":
            case "selectordinal":
            case "select":
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(",")) return this.error((0, $3cWRX.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $c16832951168152d$var$createLocation(typeEndPosition_1, (0, $dGa5T.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== "select" && identifierAndLocation.value === "offset") {
                    if (!this.bumpIf(":")) return this.error((0, $3cWRX.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $c16832951168152d$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $3cWRX.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $3cWRX.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $c16832951168152d$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === "select") return {
                    val: {
                        type: (0, $3gZro.TYPE).select,
                        value: value,
                        options: $c16832951168152d$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $3gZro.TYPE).plural,
                        value: value,
                        options: $c16832951168152d$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === "plural" ? "cardinal" : "ordinal",
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $3cWRX.ErrorKind).INVALID_ARGUMENT_TYPE, $c16832951168152d$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $3cWRX.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $c16832951168152d$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $3cWRX.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $c16832951168152d$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $jo0ag.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $3cWRX.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $3gZro.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $jo0ag.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== "select" && this.bumpIf("=")) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $3cWRX.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $3cWRX.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $c16832951168152d$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === "select" ? (0, $3cWRX.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $3cWRX.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === "other") hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf("{")) return this.error(parentArgType === "select" ? (0, $3cWRX.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $3cWRX.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $c16832951168152d$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $c16832951168152d$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === "select" ? (0, $3cWRX.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $3cWRX.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $c16832951168152d$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $3cWRX.ErrorKind).MISSING_OTHER_CLAUSE, $c16832951168152d$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf("+")) ;
        else if (this.bumpIf("-")) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $c16832951168152d$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$c16832951168152d$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error("out of bound");
        var code = $c16832951168152d$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($c16832951168152d$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $c16832951168152d$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $c16832951168152d$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $c16832951168152d$var$_isAlphaOrSlash(codepoint) {
    return $c16832951168152d$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $c16832951168152d$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $c16832951168152d$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $c16832951168152d$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("3gZro", function(module, exports) {

$parcel$export(module.exports, "TYPE", () => $2622869a2348080c$export$b87f371cbc396fcf);
$parcel$export(module.exports, "SKELETON_TYPE", () => $2622869a2348080c$export$906452485466fa53);
$parcel$export(module.exports, "isLiteralElement", () => $2622869a2348080c$export$cfa10c5697238752);
$parcel$export(module.exports, "isArgumentElement", () => $2622869a2348080c$export$4f55724281bdfaf9);
$parcel$export(module.exports, "isNumberElement", () => $2622869a2348080c$export$e11187b219e191e1);
$parcel$export(module.exports, "isDateElement", () => $2622869a2348080c$export$32d811605da75f40);
$parcel$export(module.exports, "isTimeElement", () => $2622869a2348080c$export$34ec46f596b1702f);
$parcel$export(module.exports, "isSelectElement", () => $2622869a2348080c$export$dcfe1c11d168b5a1);
$parcel$export(module.exports, "isPluralElement", () => $2622869a2348080c$export$6c796d116f0a4fbc);
$parcel$export(module.exports, "isPoundElement", () => $2622869a2348080c$export$c0ece297bdd0c082);
$parcel$export(module.exports, "isTagElement", () => $2622869a2348080c$export$5c83de34745812b);
$parcel$export(module.exports, "isNumberSkeleton", () => $2622869a2348080c$export$3f9a19cd4152eda3);
$parcel$export(module.exports, "isDateTimeSkeleton", () => $2622869a2348080c$export$7680c41f1a55f4cf);
var $2622869a2348080c$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($2622869a2348080c$export$b87f371cbc396fcf || ($2622869a2348080c$export$b87f371cbc396fcf = {}));
var $2622869a2348080c$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($2622869a2348080c$export$906452485466fa53 || ($2622869a2348080c$export$906452485466fa53 = {}));
function $2622869a2348080c$export$cfa10c5697238752(el) {
    return el.type === $2622869a2348080c$export$b87f371cbc396fcf.literal;
}
function $2622869a2348080c$export$4f55724281bdfaf9(el) {
    return el.type === $2622869a2348080c$export$b87f371cbc396fcf.argument;
}
function $2622869a2348080c$export$e11187b219e191e1(el) {
    return el.type === $2622869a2348080c$export$b87f371cbc396fcf.number;
}
function $2622869a2348080c$export$32d811605da75f40(el) {
    return el.type === $2622869a2348080c$export$b87f371cbc396fcf.date;
}
function $2622869a2348080c$export$34ec46f596b1702f(el) {
    return el.type === $2622869a2348080c$export$b87f371cbc396fcf.time;
}
function $2622869a2348080c$export$dcfe1c11d168b5a1(el) {
    return el.type === $2622869a2348080c$export$b87f371cbc396fcf.select;
}
function $2622869a2348080c$export$6c796d116f0a4fbc(el) {
    return el.type === $2622869a2348080c$export$b87f371cbc396fcf.plural;
}
function $2622869a2348080c$export$c0ece297bdd0c082(el) {
    return el.type === $2622869a2348080c$export$b87f371cbc396fcf.pound;
}
function $2622869a2348080c$export$5c83de34745812b(el) {
    return el.type === $2622869a2348080c$export$b87f371cbc396fcf.tag;
}
function $2622869a2348080c$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === "object" && el.type === $2622869a2348080c$export$906452485466fa53.number);
}
function $2622869a2348080c$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === "object" && el.type === $2622869a2348080c$export$906452485466fa53.dateTime);
}
function $2622869a2348080c$export$f0ac572c1121c662(value) {
    return {
        type: $2622869a2348080c$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $2622869a2348080c$export$425e864b0ba114f1(value, style) {
    return {
        type: $2622869a2348080c$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("dM3Pi", function(module, exports) {

$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", () => $a072b9e1a54b060f$export$523451f94304dd6c);
// @generated from regex-gen.ts
var $a072b9e1a54b060f$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $a072b9e1a54b060f$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("dvRZv", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => (parcelRequire("l2xeT")).parseDateTimeSkeleton);
$parcel$export(module.exports, "parseNumberSkeleton", () => (parcelRequire("jo0ag")).parseNumberSkeleton);
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => (parcelRequire("jo0ag")).parseNumberSkeletonFromString);
parcelRequire("l2xeT");
parcelRequire("jo0ag");

});
parcelRegister("l2xeT", function(module, exports) {

$parcel$export(module.exports, "parseDateTimeSkeleton", () => $f513917e4785a787$export$f7b99fb377fe69fa);
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $f513917e4785a787$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $f513917e4785a787$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($f513917e4785a787$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case "G":
                result.era = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            // Year
            case "y":
                result.year = len === 2 ? "2-digit" : "numeric";
                break;
            case "Y":
            case "u":
            case "U":
            case "r":
                throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
            // Quarter
            case "q":
            case "Q":
                throw new RangeError("`q/Q` (quarter) patterns are not supported");
            // Month
            case "M":
            case "L":
                result.month = [
                    "numeric",
                    "2-digit",
                    "short",
                    "long",
                    "narrow"
                ][len - 1];
                break;
            // Week
            case "w":
            case "W":
                throw new RangeError("`w/W` (week) patterns are not supported");
            case "d":
                result.day = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "D":
            case "F":
            case "g":
                throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
            // Weekday
            case "E":
                result.weekday = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            case "e":
                if (len < 4) throw new RangeError("`e..eee` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            case "c":
                if (len < 4) throw new RangeError("`c..ccc` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            // Period
            case "a":
                result.hour12 = true;
                break;
            case "b":
            case "B":
                throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
            // Hour
            case "h":
                result.hourCycle = "h12";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "H":
                result.hourCycle = "h23";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "K":
                result.hourCycle = "h11";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "k":
                result.hourCycle = "h24";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "j":
            case "J":
            case "C":
                throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
            // Minute
            case "m":
                result.minute = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            // Second
            case "s":
                result.second = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "S":
            case "A":
                throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
            // Zone
            case "z":
                result.timeZoneName = len < 4 ? "short" : "long";
                break;
            case "Z":
            case "O":
            case "v":
            case "V":
            case "X":
            case "x":
                throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
        }
        return "";
    });
    return result;
}

});

parcelRegister("jo0ag", function(module, exports) {

$parcel$export(module.exports, "parseNumberSkeletonFromString", () => $e1d062e9ac1051aa$export$71cee2f16fba2480);
$parcel$export(module.exports, "parseNumberSkeleton", () => $e1d062e9ac1051aa$export$47c6f8480bda3e11);

var $dGa5T = parcelRequire("dGa5T");

var $7tx61 = parcelRequire("7tx61");
function $e1d062e9ac1051aa$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error("Number skeleton cannot be empty");
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $7tx61.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split("/");
        if (stemAndOptions.length === 0) throw new Error("Invalid number skeleton");
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error("Invalid number skeleton");
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $e1d062e9ac1051aa$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, "");
}
var $e1d062e9ac1051aa$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $e1d062e9ac1051aa$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $e1d062e9ac1051aa$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $e1d062e9ac1051aa$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $e1d062e9ac1051aa$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === "r") result.roundingPriority = "morePrecision";
    else if (str[str.length - 1] === "s") result.roundingPriority = "lessPrecision";
    str.replace($e1d062e9ac1051aa$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== "string") {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === "+") result.minimumSignificantDigits = g1.length;
        else if (g1[0] === "#") result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === "string" ? g2.length : 0);
        }
        return "";
    });
    return result;
}
function $e1d062e9ac1051aa$var$parseSign(str) {
    switch(str){
        case "sign-auto":
            return {
                signDisplay: "auto"
            };
        case "sign-accounting":
        case "()":
            return {
                currencySign: "accounting"
            };
        case "sign-always":
        case "+!":
            return {
                signDisplay: "always"
            };
        case "sign-accounting-always":
        case "()!":
            return {
                signDisplay: "always",
                currencySign: "accounting"
            };
        case "sign-except-zero":
        case "+?":
            return {
                signDisplay: "exceptZero"
            };
        case "sign-accounting-except-zero":
        case "()?":
            return {
                signDisplay: "exceptZero",
                currencySign: "accounting"
            };
        case "sign-never":
        case "+_":
            return {
                signDisplay: "never"
            };
    }
}
function $e1d062e9ac1051aa$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === "E" && stem[1] === "E") {
        result = {
            notation: "engineering"
        };
        stem = stem.slice(2);
    } else if (stem[0] === "E") {
        result = {
            notation: "scientific"
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === "+!") {
            result.signDisplay = "always";
            stem = stem.slice(2);
        } else if (signDisplay === "+?") {
            result.signDisplay = "exceptZero";
            stem = stem.slice(2);
        }
        if (!$e1d062e9ac1051aa$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error("Malformed concise eng/scientific notation");
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $e1d062e9ac1051aa$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $e1d062e9ac1051aa$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $e1d062e9ac1051aa$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case "percent":
            case "%":
                result.style = "percent";
                continue;
            case "%x100":
                result.style = "percent";
                result.scale = 100;
                continue;
            case "currency":
                result.style = "currency";
                result.currency = token.options[0];
                continue;
            case "group-off":
            case ",_":
                result.useGrouping = false;
                continue;
            case "precision-integer":
            case ".":
                result.maximumFractionDigits = 0;
                continue;
            case "measure-unit":
            case "unit":
                result.style = "unit";
                result.unit = $e1d062e9ac1051aa$var$icuUnitToEcma(token.options[0]);
                continue;
            case "compact-short":
            case "K":
                result.notation = "compact";
                result.compactDisplay = "short";
                continue;
            case "compact-long":
            case "KK":
                result.notation = "compact";
                result.compactDisplay = "long";
                continue;
            case "scientific":
                result = (0, $dGa5T.__assign)((0, $dGa5T.__assign)((0, $dGa5T.__assign)({}, result), {
                    notation: "scientific"
                }), token.options.reduce(function(all, opt) {
                    return (0, $dGa5T.__assign)((0, $dGa5T.__assign)({}, all), $e1d062e9ac1051aa$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "engineering":
                result = (0, $dGa5T.__assign)((0, $dGa5T.__assign)((0, $dGa5T.__assign)({}, result), {
                    notation: "engineering"
                }), token.options.reduce(function(all, opt) {
                    return (0, $dGa5T.__assign)((0, $dGa5T.__assign)({}, all), $e1d062e9ac1051aa$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "notation-simple":
                result.notation = "standard";
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case "unit-width-narrow":
                result.currencyDisplay = "narrowSymbol";
                result.unitDisplay = "narrow";
                continue;
            case "unit-width-short":
                result.currencyDisplay = "code";
                result.unitDisplay = "short";
                continue;
            case "unit-width-full-name":
                result.currencyDisplay = "name";
                result.unitDisplay = "long";
                continue;
            case "unit-width-iso-code":
                result.currencyDisplay = "symbol";
                continue;
            case "scale":
                result.scale = parseFloat(token.options[0]);
                continue;
            case "rounding-mode-floor":
                result.roundingMode = "floor";
                continue;
            case "rounding-mode-ceiling":
                result.roundingMode = "ceil";
                continue;
            case "rounding-mode-down":
                result.roundingMode = "trunc";
                continue;
            case "rounding-mode-up":
                result.roundingMode = "expand";
                continue;
            case "rounding-mode-half-even":
                result.roundingMode = "halfEven";
                continue;
            case "rounding-mode-half-down":
                result.roundingMode = "halfTrunc";
                continue;
            case "rounding-mode-half-up":
                result.roundingMode = "halfExpand";
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case "integer-width":
                if (token.options.length > 1) throw new RangeError("integer-width stems only accept a single optional option");
                token.options[0].replace($e1d062e9ac1051aa$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error("We currently do not support maximum integer digits");
                    else if (g5) throw new Error("We currently do not support exact integer digits");
                    return "";
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($e1d062e9ac1051aa$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($e1d062e9ac1051aa$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError("Fraction-precision stems only accept a single optional option");
            token.stem.replace($e1d062e9ac1051aa$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === "*") result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === "#") result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return "";
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === "w") result = (0, $dGa5T.__assign)((0, $dGa5T.__assign)({}, result), {
                trailingZeroDisplay: "stripIfInteger"
            });
            else if (opt) result = (0, $dGa5T.__assign)((0, $dGa5T.__assign)({}, result), $e1d062e9ac1051aa$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($e1d062e9ac1051aa$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $dGa5T.__assign)((0, $dGa5T.__assign)({}, result), $e1d062e9ac1051aa$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $e1d062e9ac1051aa$var$parseSign(token.stem);
        if (signOpts) result = (0, $dGa5T.__assign)((0, $dGa5T.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $e1d062e9ac1051aa$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $dGa5T.__assign)((0, $dGa5T.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

});
parcelRegister("7tx61", function(module, exports) {

$parcel$export(module.exports, "WHITE_SPACE_REGEX", () => $5714ea0e9e8e0637$export$2b8db14d8bcaece7);
// @generated from regex-gen.ts
var $5714ea0e9e8e0637$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("8iBhK", function(module, exports) {

$parcel$export(module.exports, "getBestPattern", () => $60aced4240b6c84b$export$29c5368be8904d27);

var $5y9Hs = parcelRequire("5y9Hs");
function $60aced4240b6c84b$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = "";
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === "j") {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = "a";
            var hourChar = $60aced4240b6c84b$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == "H" || hourChar == "k") dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === "J") skeletonCopy += "H";
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $60aced4240b6c84b$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case "h24":
            return "k";
        case "h23":
            return "H";
        case "h12":
            return "h";
        case "h11":
            return "K";
        default:
            throw new Error("Invalid hourCycle");
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== "root") regionTag = locale.maximize().region;
    var hourCycles = (0, $5y9Hs.timeData)[regionTag || ""] || (0, $5y9Hs.timeData)[languageTag || ""] || (0, $5y9Hs.timeData)["".concat(languageTag, "-001")] || (0, $5y9Hs.timeData)["001"];
    return hourCycles[0];
}

});
parcelRegister("5y9Hs", function(module, exports) {

$parcel$export(module.exports, "timeData", () => $40a7a6eb0f89c3ba$export$a8c9209db4084317);
// @generated from time-data-gen.ts
// prettier-ignore  
var $40a7a6eb0f89c3ba$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};

});




parcelRegister("lEKDF", function(module, exports) {

$parcel$export(module.exports, "memoize", () => $fc4182e0ce25ebde$export$fc10aeed3a532e2a);
$parcel$export(module.exports, "strategies", () => $fc4182e0ce25ebde$export$c5491a8691a23b9e);
//
// Main
//
function $fc4182e0ce25ebde$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $fc4182e0ce25ebde$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $fc4182e0ce25ebde$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $fc4182e0ce25ebde$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $fc4182e0ce25ebde$var$isPrimitive(value) {
    return value == null || typeof value === "number" || typeof value === "boolean"; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $fc4182e0ce25ebde$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $fc4182e0ce25ebde$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $fc4182e0ce25ebde$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $fc4182e0ce25ebde$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $fc4182e0ce25ebde$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $fc4182e0ce25ebde$var$monadic : $fc4182e0ce25ebde$var$variadic;
    return $fc4182e0ce25ebde$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $fc4182e0ce25ebde$var$strategyVariadic(fn, options) {
    return $fc4182e0ce25ebde$var$assemble(fn, this, $fc4182e0ce25ebde$var$variadic, options.cache.create(), options.serializer);
}
function $fc4182e0ce25ebde$var$strategyMonadic(fn, options) {
    return $fc4182e0ce25ebde$var$assemble(fn, this, $fc4182e0ce25ebde$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $fc4182e0ce25ebde$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $fc4182e0ce25ebde$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$fc4182e0ce25ebde$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$fc4182e0ce25ebde$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $fc4182e0ce25ebde$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $fc4182e0ce25ebde$var$ObjectWithoutPrototypeCache();
    }
};
var $fc4182e0ce25ebde$export$c5491a8691a23b9e = {
    variadic: $fc4182e0ce25ebde$var$strategyVariadic,
    monadic: $fc4182e0ce25ebde$var$strategyMonadic
};

});

parcelRegister("bDk31", function(module, exports) {

$parcel$export(module.exports, "PART_TYPE", () => $8782e346cd61f028$export$49694c2877b44c57);
$parcel$export(module.exports, "formatToParts", () => $8782e346cd61f028$export$275d4a3bb5f66fda);
parcelRequire("12ZnM");
var $3gZro = parcelRequire("3gZro");

var $96SKz = parcelRequire("96SKz");
var $8782e346cd61f028$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($8782e346cd61f028$export$49694c2877b44c57 || ($8782e346cd61f028$export$49694c2877b44c57 = {}));
function $8782e346cd61f028$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $8782e346cd61f028$export$49694c2877b44c57.literal || part.type !== $8782e346cd61f028$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $8782e346cd61f028$export$df0c12a2d414a163(el) {
    return typeof el === "function";
}
function $8782e346cd61f028$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $3gZro.isLiteralElement)(els[0])) return [
        {
            type: $8782e346cd61f028$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $3gZro.isLiteralElement)(el)) {
            result.push({
                type: $8782e346cd61f028$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $3gZro.isPoundElement)(el)) {
            if (typeof currentPluralValue === "number") result.push({
                type: $8782e346cd61f028$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $96SKz.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $3gZro.isArgumentElement)(el)) {
            if (!value || typeof value === "string" || typeof value === "number") value = typeof value === "string" || typeof value === "number" ? String(value) : "";
            result.push({
                type: typeof value === "string" ? $8782e346cd61f028$export$49694c2877b44c57.literal : $8782e346cd61f028$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $3gZro.isDateElement)(el)) {
            var style = typeof el.style === "string" ? formats.date[el.style] : (0, $3gZro.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $8782e346cd61f028$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $3gZro.isTimeElement)(el)) {
            var style = typeof el.style === "string" ? formats.time[el.style] : (0, $3gZro.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $8782e346cd61f028$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $3gZro.isNumberElement)(el)) {
            var style = typeof el.style === "string" ? formats.number[el.style] : (0, $3gZro.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $8782e346cd61f028$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $3gZro.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$8782e346cd61f028$export$df0c12a2d414a163(formatFn)) throw new (0, $96SKz.InvalidValueTypeError)(value_1, "function", originalMessage);
            var parts = $8782e346cd61f028$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === "string" ? $8782e346cd61f028$export$49694c2877b44c57.literal : $8782e346cd61f028$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $3gZro.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $96SKz.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $8782e346cd61f028$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $3gZro.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $96SKz.FormatError)('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', (0, $96SKz.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $96SKz.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $8782e346cd61f028$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $8782e346cd61f028$var$mergeLiteral(result);
}

});
parcelRegister("96SKz", function(module, exports) {

$parcel$export(module.exports, "ErrorCode", () => $6a1f24d4a8f82da4$export$d4e71bc0b80dc0fb);
$parcel$export(module.exports, "FormatError", () => $6a1f24d4a8f82da4$export$7369836851cc1329);
$parcel$export(module.exports, "InvalidValueError", () => $6a1f24d4a8f82da4$export$565c3afc07dfa382);
$parcel$export(module.exports, "InvalidValueTypeError", () => $6a1f24d4a8f82da4$export$cbc0db47c750f7c9);
$parcel$export(module.exports, "MissingValueError", () => $6a1f24d4a8f82da4$export$8bfc137e4d23fdf0);

var $dGa5T = parcelRequire("dGa5T");
var $6a1f24d4a8f82da4$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($6a1f24d4a8f82da4$export$d4e71bc0b80dc0fb || ($6a1f24d4a8f82da4$export$d4e71bc0b80dc0fb = {}));
var $6a1f24d4a8f82da4$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $dGa5T.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $6a1f24d4a8f82da4$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $dGa5T.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, 'Invalid values for "'.concat(variableId, '": "').concat(value, '". Options are "').concat(Object.keys(options).join('", "'), '"'), $6a1f24d4a8f82da4$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($6a1f24d4a8f82da4$export$7369836851cc1329);
var $6a1f24d4a8f82da4$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $dGa5T.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, 'Value for "'.concat(value, '" must be of type ').concat(type), $6a1f24d4a8f82da4$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($6a1f24d4a8f82da4$export$7369836851cc1329);
var $6a1f24d4a8f82da4$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $dGa5T.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, 'The intl string context variable "'.concat(variableId, '" was not provided to the string "').concat(originalMessage, '"'), $6a1f24d4a8f82da4$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($6a1f24d4a8f82da4$export$7369836851cc1329);

});






parcelRegister("ac4D8", function(module, exports) {

$parcel$export(module.exports, "default", () => $5281f9bafc8b4846$export$2e2bcd8739ae039);

var $dGa5T = parcelRequire("dGa5T");
parcelRequire("bFoC6");
var $d92i1 = parcelRequire("d92i1");
parcelRequire("MJPZu");
var $hOpwk = parcelRequire("hOpwk");
var $9UZF0 = parcelRequire("9UZF0");
var $78EKQ = parcelRequire("78EKQ");
var $5281f9bafc8b4846$export$2e2bcd8739ae039 = {
    icon: $5281f9bafc8b4846$export$1ca1ec8b29a4ce27,
    carfax: $5281f9bafc8b4846$export$7167c6aed1579a6,
    analyse: $5281f9bafc8b4846$export$5b85ef841e5e175,
    auto: $5281f9bafc8b4846$export$dfb5619354ba860,
    bereik: $5281f9bafc8b4846$export$862147962880aefa,
    calc: $5281f9bafc8b4846$export$42bfa9b2d4dad91a,
    calendar: $5281f9bafc8b4846$export$56bbcdb8aca31149,
    camera: $5281f9bafc8b4846$export$9d7c7e61b1dce3b0,
    clock: $5281f9bafc8b4846$export$8c9e255416017e56,
    close: $5281f9bafc8b4846$export$8360e631d277ea4d,
    concurrentie: $5281f9bafc8b4846$export$8b21350acf25e411,
    dashboard: $5281f9bafc8b4846$export$a5f98448b9315739,
    dealer: $5281f9bafc8b4846$export$6c5676dc58c894d4,
    download: $5281f9bafc8b4846$export$24422be91ad4011f,
    dropdown: $5281f9bafc8b4846$export$81207e5cc4186890,
    edit: $5281f9bafc8b4846$export$e1a8e267487c59d1,
    goedzo: $5281f9bafc8b4846$export$ae413195ea50c70e,
    hamburger: $5281f9bafc8b4846$export$fbdecc684f217e03,
    info: $5281f9bafc8b4846$export$a80b3bd66acc52ff,
    kenteken: $5281f9bafc8b4846$export$3551c0bbbe6b0dda,
    leads: $5281f9bafc8b4846$export$ec6aea9c3df53a3c,
    logout: $5281f9bafc8b4846$export$a0973bcfe11b05c9,
    loop: $5281f9bafc8b4846$export$f9ef67375ddc185,
    next: $5281f9bafc8b4846$export$48cfd1e771a65c4f,
    pin: $5281f9bafc8b4846$export$6f259e79976a58c8,
    highlight: $5281f9bafc8b4846$export$e4043f67d36cbb26,
    pointer: $5281f9bafc8b4846$export$b7fd2c2937973304,
    prev: $5281f9bafc8b4846$export$232faf9add678146,
    print: $5281f9bafc8b4846$export$c2d084dc44961371,
    prospects: $5281f9bafc8b4846$export$6be81e7acd49b103,
    settings: $5281f9bafc8b4846$export$a5a6e0b888b2c992,
    trash: $5281f9bafc8b4846$export$786fb34efcf0dd02,
    vergelijken: $5281f9bafc8b4846$export$84ddb186c49f4e56,
    video: $5281f9bafc8b4846$export$5f8d3589eb8441ca,
    voorraad: $5281f9bafc8b4846$export$b1df4d220da062a2
};
function $5281f9bafc8b4846$export$7167c6aed1579a6() {
    return $5281f9bafc8b4846$export$1ca1ec8b29a4ce27((0, $9UZF0.html)`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 368 73">
            <path
                d="M359.88 71.97H8.12c-3.91 0-7.09-3.12-7.09-6.95V7.98c0-3.83 3.18-6.95 7.09-6.95h351.76c3.91 0 7.09 3.12 7.09 6.95v57.04c0 3.83-3.18 6.95-7.09 6.95zM8.12 4.03c-2.25 0-4.09 1.77-4.09 3.95v57.04c0 2.18 1.83 3.95 4.09 3.95h351.76c2.25 0 4.09-1.77 4.09-3.95V7.98c0-2.18-1.83-3.95-4.09-3.95H8.12z"
            />
            <path
                d="M6.88 6.89v59.23h56.69V6.89H6.88zM36.53 57.3c-11.76 0-18.02-8.69-18.02-20.43 0-12.74 7.46-20.42 18.08-20.42 9.73 0 13.57 4.18 16.28 11.64l-9.95 3.92C41.51 28.32 40.15 26 36.53 26c-4.58 0-6.56 4.59-6.56 10.88 0 6.07 1.92 10.89 6.68 10.89 3.45 0 4.92-1.87 7.07-5.61l9.27 4.94c-2.66 5.17-7.08 10.2-16.46 10.2zM66.41 6.89v59.23h56.69V6.89H66.41zm36.57 49.33l-2.15-7H88.96l-2.15 7H75.06l14.36-39.57h11.08l14.36 39.57h-11.88z"
            />
            <path
                d="M94.9 28.07c-.51 2.66-1.13 4.85-2.55 9.88l-.73 2.6h6.56l-.73-2.6c-1.42-5.09-2.04-7.23-2.55-9.88zM155.01 25.77h-6.62v8.66h6.45c3.57 0 4.98-1.58 4.98-4.41 0-2.49-1.36-4.25-4.81-4.25z"
            />
            <path
                d="M125.93 6.89v59.23h56.69V6.89h-56.69zm33.32 49.52l-6.45-13.36h-4.41v13.36H137.6V16.84h17.7c9.28 0 15.44 3.51 15.44 12.89 0 5.94-2.78 9.6-7.12 11.57l7.92 15.1h-12.29zM185.46 6.89v59.23h56.69V6.89h-56.69zm43.98 19.27h-20.41v5.52h12.38v9.26h-12.38v15.48h-10.91V16.84h31.32v9.32z"
            />
            <g>
                <path
                    d="M272.92 28.38c-.51 2.66-1.13 4.86-2.54 9.88l-.74 2.6h6.56l-.73-2.6c-1.41-5.09-2.03-7.23-2.55-9.88z"
                />
                <path
                    d="M244.98 6.89v59.23h56.69V6.89h-56.69zm36.03 49.64l-2.15-7h-11.87l-2.15 7h-11.76l14.36-39.57h11.08l14.36 39.57h-11.87z"
                />
            </g>
            <path
                d="M304.5 6.81v59.23h56.69V6.81H304.5zm22.17 57.7l1.91-2.65c1.61-2.47 3.22-5.18 4.21-7.26 1.05 2.14 2.6 4.78 4.15 7.26l1.72 2.65h-11.99zm33 0h-7.26L339.6 46.28l13.67-19.24h-13.61l-2.41 3.82c-1.55 2.47-3.22 5.12-4.21 7.2-.93-2.08-2.6-4.73-4.14-7.2l-2.41-3.82h-13.92l13.68 19.46-13 18h-7.21V8.32h53.64c-.01 1.47-.01 54.73-.01 56.19z"
            />
        </svg>
    `);
}
function $5281f9bafc8b4846$export$5b85ef841e5e175() {
    return $5281f9bafc8b4846$export$1ca1ec8b29a4ce27((0, $9UZF0.html)`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
            <path
                d="M11.67,11.71l0.27,1.24c0.02,0.06,0.01,0.12-0.02,0.18s-0.08,0.09-0.13,0.11c0,0-0.75,0.26-1.7,0.26 c-1.22,0-2.28-0.34-3.2-1.02c-0.91-0.68-1.53-1.59-1.86-2.75H4.3c-0.07,0-0.13-0.02-0.18-0.07C4.07,9.61,4.05,9.55,4.05,9.48V8.6 c0-0.07,0.02-0.13,0.07-0.18C4.17,8.38,4.23,8.35,4.3,8.35h0.52C4.8,8.05,4.8,7.78,4.82,7.53H4.3c-0.07,0-0.13-0.02-0.18-0.07 S4.05,7.35,4.05,7.28V6.39c0-0.07,0.02-0.13,0.07-0.18S4.22,6.14,4.3,6.14h0.77c0.35-1.09,0.98-1.97,1.9-2.64 c0.92-0.67,1.96-1,3.13-1c0.53,0,1.04,0.06,1.52,0.18c0.06,0.02,0.11,0.05,0.16,0.12c0.03,0.06,0.04,0.12,0.02,0.19l-0.34,1.24 c-0.02,0.07-0.05,0.12-0.11,0.15c-0.06,0.03-0.12,0.04-0.19,0.02c0,0-0.52-0.13-1.09-0.13c-0.66,0-1.25,0.17-1.77,0.5 C7.78,5.1,7.39,5.56,7.13,6.14h3.66c0.08,0,0.15,0.03,0.2,0.09c0.05,0.06,0.07,0.13,0.05,0.2l-0.19,0.89 c-0.03,0.14-0.11,0.2-0.25,0.2H6.78C6.77,7.72,6.77,8,6.78,8.35h3.59c0.08,0,0.14,0.03,0.2,0.09c0.05,0.06,0.06,0.13,0.05,0.21 l-0.19,0.88c-0.01,0.06-0.04,0.11-0.09,0.14s-0.1,0.06-0.16,0.06H7.16c0.25,0.61,0.64,1.09,1.17,1.45c0.53,0.36,1.12,0.54,1.79,0.54 c0.64,0,1.24-0.19,1.24-0.19c0.07-0.03,0.14-0.02,0.2,0.02C11.62,11.58,11.66,11.64,11.67,11.71z"
            />
        </svg>
    `);
}
function $5281f9bafc8b4846$export$dfb5619354ba860() {
    return $5281f9bafc8b4846$export$1ca1ec8b29a4ce27((0, $9UZF0.html)`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 16">
            <path
                id="XMLID_24_"
                d="M17.21,5.66h-0.93c-0.21,0-0.39,0.08-0.53,0.21c-0.51-1.13-1.18-2.88-1.56-3.57 C14.03,2,13.68,1.63,13.3,1.63H4.7C4.32,1.63,3.97,2,3.8,2.3C3.42,2.99,2.75,4.74,2.25,5.87C2.11,5.74,1.92,5.66,1.71,5.66H0.79 C0.35,5.66,0,6.01,0,6.45c0,0.44,0.35,0.79,0.79,0.79h0.83c0,0,0,0.01,0,0.01v2.91c0,0.02,0,0.04,0,0.07c0,0.02,0,0.04,0,0.06v0.03 l0,0c0.03,0.93,0.5,1.67,1.07,1.67c0,0,0.01,0,0.01,0c0,0.04-0.01,0.08-0.01,0.12v1.54c0,0.4,0.32,0.73,0.73,0.73h0.68 c0.4,0,0.73-0.33,0.73-0.73V12.1c0-0.04-0.01-0.08-0.01-0.12l0.12,0h8.18l0.12,0c-0.01,0.04-0.01,0.08-0.01,0.12v1.54 c0,0.4,0.32,0.73,0.73,0.73h0.67c0.4,0,0.73-0.33,0.73-0.73V12.1c0-0.04-0.01-0.08-0.01-0.12h0c0.59,0,1.07-0.79,1.07-1.77 c0-0.01,0-0.02,0-0.02l0-2.95c0,0,0-0.01,0-0.01h0.83c0.43,0,0.79-0.35,0.79-0.79C18,6.01,17.65,5.66,17.21,5.66 M4.67,10.18 c-0.62,0-1.12-0.5-1.12-1.12c0-0.62,0.5-1.12,1.12-1.12c0.62,0,1.12,0.5,1.12,1.12C5.79,9.68,5.29,10.18,4.67,10.18 M12.98,10.18 c-0.62,0-1.12-0.5-1.12-1.12c0-0.62,0.5-1.12,1.12-1.12c0.62,0,1.12,0.5,1.12,1.12C14.1,9.68,13.6,10.18,12.98,10.18 M3.2,6.56 C3.69,5.51,4.13,4.02,4.69,3c0.04-0.07,0.16-0.24,0.25-0.27h4.02h0.09h4.02c0.09,0.04,0.21,0.2,0.25,0.27 c0.57,1.03,1.01,2.52,1.5,3.56H3.2z"
            />
        </svg>
    `);
}
function $5281f9bafc8b4846$export$862147962880aefa() {
    return $5281f9bafc8b4846$export$1ca1ec8b29a4ce27((0, $9UZF0.html)`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
            <path
                d="M16,13v1H0V2h1v11H16z M15,3.25v3.4c0,0.11-0.05,0.19-0.15,0.23s-0.19,0.02-0.28-0.06l-0.95-0.95 l-4.95,4.95C8.63,10.87,8.57,10.9,8.5,10.9s-0.13-0.03-0.18-0.08L6.5,9l-3.25,3.25l-1.5-1.5l4.57-4.57C6.37,6.13,6.43,6.1,6.5,6.1 s0.13,0.03,0.18,0.08L8.5,8l3.62-3.62l-0.95-0.95c-0.08-0.08-0.1-0.18-0.06-0.28S11.24,3,11.35,3h3.4c0.07,0,0.13,0.02,0.18,0.07 S15,3.18,15,3.25z"
            />
        </svg>
    `);
}
function $5281f9bafc8b4846$export$42bfa9b2d4dad91a() {
    return $5281f9bafc8b4846$export$1ca1ec8b29a4ce27((0, $9UZF0.html)`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
            <path
                d="M13.5,1h-11c-0.55,0-1,0.45-1,1v12c0,0.55,0.45,1,1,1h11c0.55,0,1-0.45,1-1V2C14.5,1.45,14.05,1,13.5,1z M3.5,14c-0.55,0-1-0.45-1-1c0-0.55,0.45-1,1-1s1,0.45,1,1C4.5,13.55,4.05,14,3.5,14z M3.5,11c-0.55,0-1-0.45-1-1c0-0.55,0.45-1,1-1 s1,0.45,1,1C4.5,10.55,4.05,11,3.5,11z M3.5,8c-0.55,0-1-0.45-1-1c0-0.55,0.45-1,1-1s1,0.45,1,1C4.5,7.55,4.05,8,3.5,8z M6.5,14 c-0.55,0-1-0.45-1-1c0-0.55,0.45-1,1-1s1,0.45,1,1C7.5,13.55,7.05,14,6.5,14z M6.5,11c-0.55,0-1-0.45-1-1c0-0.55,0.45-1,1-1 s1,0.45,1,1C7.5,10.55,7.05,11,6.5,11z M6.5,8c-0.55,0-1-0.45-1-1c0-0.55,0.45-1,1-1s1,0.45,1,1C7.5,7.55,7.05,8,6.5,8z M9.5,14 c-0.55,0-1-0.45-1-1c0-0.55,0.45-1,1-1s1,0.45,1,1C10.5,13.55,10.05,14,9.5,14z M9.5,11c-0.55,0-1-0.45-1-1c0-0.55,0.45-1,1-1 s1,0.45,1,1C10.5,10.55,10.05,11,9.5,11z M9.5,8c-0.55,0-1-0.45-1-1c0-0.55,0.45-1,1-1s1,0.45,1,1C10.5,7.55,10.05,8,9.5,8z M13.5,13c0,0.55-0.45,1-1,1s-1-0.45-1-1v-3c0-0.55,0.45-1,1-1s1,0.45,1,1V13z M12.5,8c-0.55,0-1-0.45-1-1c0-0.55,0.45-1,1-1 s1,0.45,1,1C13.5,7.55,13.05,8,12.5,8z M13.5,4.5C13.5,4.78,13.28,5,13,5H3C2.72,5,2.5,4.78,2.5,4.5v-2C2.5,2.22,2.72,2,3,2h10 c0.28,0,0.5,0.22,0.5,0.5V4.5z"
            />
        </svg>
    `);
}
function $5281f9bafc8b4846$export$56bbcdb8aca31149() {
    return $5281f9bafc8b4846$export$1ca1ec8b29a4ce27((0, $9UZF0.html)`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
            <path
                d="M12.72,3.72h-0.86V3c0-0.55-0.45-1-1-1h-0.59c-0.55,0-1,0.45-1,1v0.72H6.71V3c0-0.55-0.45-1-1-1H5.12 c-0.55,0-1,0.45-1,1v0.72H3.28c-0.47,0-0.85,0.38-0.85,0.85v8.58c0,0.47,0.38,0.85,0.85,0.85h9.44c0.47,0,0.85-0.38,0.85-0.85V4.57 C13.57,4.1,13.19,3.72,12.72,3.72z M5,3.06c0-0.11,0.09-0.2,0.2-0.2h0.46c0.11,0,0.2,0.09,0.2,0.2v1.96c0,0.11-0.09,0.2-0.2,0.2H5.2 C5.09,5.21,5,5.12,5,5.01V3.06z M5.21,13.14H3.29v-1.93h1.93V13.14z M5.21,10.79H3.29V8.64h1.93V10.79z M5.21,8.21H3.29V6.29h1.93 V8.21z M7.79,13.14H5.64v-1.93h2.14V13.14z M7.79,10.79H5.64V8.64h2.14V10.79z M7.79,8.21H5.64V6.29h2.14V8.21z M10.35,13.14H8.21 v-1.93h2.14V13.14z M10.35,10.79H8.21V8.64h2.14V10.79z M10.35,8.21H8.21V6.29h2.14V8.21z M10.15,5.01V3.06c0-0.11,0.09-0.2,0.2-0.2 h0.46c0.11,0,0.2,0.09,0.2,0.2v1.96c0,0.11-0.09,0.2-0.2,0.2h-0.46C10.24,5.21,10.15,5.12,10.15,5.01z M12.71,13.14h-1.93v-1.93 h1.93V13.14z M12.71,10.79h-1.93V8.64h1.93V10.79z M12.71,8.21h-1.93V6.29h1.93V8.21z"
            />
        </svg>
    `);
}
function $5281f9bafc8b4846$export$9d7c7e61b1dce3b0() {
    return $5281f9bafc8b4846$export$1ca1ec8b29a4ce27((0, $9UZF0.html)`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
            <path
                d="M13.43,4.86v6c0,0.94-0.77,1.71-1.71,1.71H2.28c-0.94,0-1.71-0.77-1.71-1.71v-6 c0-0.94,0.77-1.71,1.71-1.71h1.5l0.34-0.91c0.17-0.44,0.69-0.8,1.16-0.8h3.43c0.47,0,0.99,0.36,1.16,0.8l0.34,0.91h1.5 C12.66,3.14,13.43,3.91,13.43,4.86z M10,7.86c0-1.65-1.35-3-3-3s-3,1.35-3,3s1.35,3,3,3S10,9.51,10,7.86z M8.93,7.86 c0,1.06-0.86,1.93-1.93,1.93S5.07,8.92,5.07,7.86S5.94,5.93,7,5.93S8.93,6.79,8.93,7.86z"
            />
        </svg>
    `);
}
function $5281f9bafc8b4846$export$8c9e255416017e56() {
    return $5281f9bafc8b4846$export$1ca1ec8b29a4ce27((0, $9UZF0.html)`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
            <path
                d="M8 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zM8 3.75C5.66 3.75 3.75 5.66 3.75 8S5.66 12.25 8 12.25s4.25-1.91 4.25-4.25S10.34 3.75 8 3.75zm1 5c0 .14-.11.25-.25.25h-2.5C6.11 9 6 8.89 6 8.75v-.5c0-.14.11-.25.25-.25H8V5.25c0-.14.11-.25.25-.25h.5c.14 0 .25.11.25.25v3.5z"
            />
        </svg>
    `);
}
function $5281f9bafc8b4846$export$8360e631d277ea4d() {
    return $5281f9bafc8b4846$export$1ca1ec8b29a4ce27((0, $9UZF0.html)`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
            <path
                d="M11.45 3.68L10.32 2.55 7 5.87 3.68 2.55 2.55 3.68 5.87 7 2.55 10.32 3.68 11.45 7 8.13 10.32 11.45 11.45 10.32 8.13 7"
            />
        </svg>
    `);
}
function $5281f9bafc8b4846$export$8b21350acf25e411() {
    return $5281f9bafc8b4846$export$1ca1ec8b29a4ce27((0, $9UZF0.html)`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
            <path
                d="M14.5 4.8v1c0 .4-.1.7-.3 1.1-.2.4-.5.7-.9 1-.4.3-.8.6-1.4.8-.5.2-1 .3-1.6.3-.3.3-.5.5-.8.7-.2.2-.3.4-.4.6-.1.2-.1.4-.1.7 0 .3.1.5.2.7.2.2.5.3.8.3.4 0 .7.1 1 .4.3.2.5.5.5.9v.5c0 .1 0 .1-.1.2s-.1 0-.2 0H4.8c-.1 0-.1 0-.2-.1s-.1-.1-.1-.2v-.5c0-.4.2-.7.5-.9.3-.2.6-.3 1-.3.3 0 .6-.1.8-.3.1-.2.2-.4.2-.7 0-.3 0-.5-.1-.7-.1-.2-.2-.4-.4-.6-.3-.2-.5-.4-.8-.7-.6 0-1.1-.1-1.6-.4-.5-.2-1-.5-1.4-.8-.4-.2-.7-.6-.9-.9-.2-.4-.3-.8-.3-1.1v-1c0-.2.1-.4.2-.5.2-.2.3-.3.5-.3h2.2v-.8c0-.3.1-.6.4-.9.3-.2.6-.3 1-.3h4.5c.3 0 .6.1.9.4.2.2.4.5.4.9V4h2.2c.2 0 .4.1.5.2.1.2.2.3.2.6zM5.1 7.9c-.4-.8-.6-1.8-.6-2.9h-2v.8c0 .4.2.8.7 1.3s1.1.6 1.9.8zm8.4-2.1V5h-2c0 1.1-.2 2.1-.6 2.9.7-.2 1.3-.4 1.8-.9s.8-.8.8-1.2z"
            />
        </svg>
    `);
}
function $5281f9bafc8b4846$export$a5f98448b9315739() {
    return $5281f9bafc8b4846$export$1ca1ec8b29a4ce27((0, $9UZF0.html)`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
            <path
                d="M5,3.25v1.5c0,0.21-0.07,0.39-0.22,0.53C4.64,5.43,4.46,5.5,4.25,5.5h-2.5c-0.21,0-0.39-0.07-0.53-0.22 C1.07,5.14,1,4.96,1,4.75v-1.5c0-0.21,0.07-0.39,0.22-0.53C1.36,2.57,1.54,2.5,1.75,2.5h2.5c0.21,0,0.39,0.07,0.53,0.22 C4.93,2.86,5,3.04,5,3.25z M5,7.25v1.5c0,0.21-0.07,0.39-0.22,0.53C4.64,9.43,4.46,9.5,4.25,9.5h-2.5c-0.21,0-0.39-0.07-0.53-0.22 C1.07,9.14,1,8.96,1,8.75v-1.5c0-0.21,0.07-0.39,0.22-0.53C1.36,6.57,1.54,6.5,1.75,6.5h2.5c0.21,0,0.39,0.07,0.53,0.22 C4.93,6.86,5,7.04,5,7.25z M5,11.25v1.5c0,0.21-0.07,0.39-0.22,0.53c-0.15,0.15-0.32,0.22-0.53,0.22h-2.5 c-0.21,0-0.39-0.07-0.53-0.22C1.07,13.14,1,12.96,1,12.75v-1.5c0-0.21,0.07-0.39,0.22-0.53c0.15-0.15,0.32-0.22,0.53-0.22h2.5 c0.21,0,0.39,0.07,0.53,0.22C4.93,10.86,5,11.04,5,11.25z M10,3.25v1.5c0,0.21-0.07,0.39-0.22,0.53C9.64,5.43,9.46,5.5,9.25,5.5 h-2.5c-0.21,0-0.39-0.07-0.53-0.22C6.07,5.14,6,4.96,6,4.75v-1.5c0-0.21,0.07-0.39,0.22-0.53C6.36,2.57,6.54,2.5,6.75,2.5h2.5 c0.21,0,0.39,0.07,0.53,0.22C9.93,2.86,10,3.04,10,3.25z M10,7.25v1.5c0,0.21-0.07,0.39-0.22,0.53C9.64,9.43,9.46,9.5,9.25,9.5h-2.5 c-0.21,0-0.39-0.07-0.53-0.22C6.07,9.14,6,8.96,6,8.75v-1.5c0-0.21,0.07-0.39,0.22-0.53C6.36,6.57,6.54,6.5,6.75,6.5h2.5 c0.21,0,0.39,0.07,0.53,0.22C9.93,6.86,10,7.04,10,7.25z M10,11.25v1.5c0,0.21-0.07,0.39-0.22,0.53c-0.15,0.15-0.32,0.22-0.53,0.22 h-2.5c-0.21,0-0.39-0.07-0.53-0.22C6.07,13.14,6,12.96,6,12.75v-1.5c0-0.21,0.07-0.39,0.22-0.53c0.15-0.15,0.32-0.22,0.53-0.22h2.5 c0.21,0,0.39,0.07,0.53,0.22C9.93,10.86,10,11.04,10,11.25z M15,3.25v1.5c0,0.21-0.07,0.39-0.22,0.53 c-0.15,0.15-0.32,0.22-0.53,0.22h-2.5c-0.21,0-0.39-0.07-0.53-0.22C11.07,5.14,11,4.96,11,4.75v-1.5c0-0.21,0.07-0.39,0.22-0.53 c0.15-0.15,0.32-0.22,0.53-0.22h2.5c0.21,0,0.39,0.07,0.53,0.22C14.93,2.86,15,3.04,15,3.25z M15,7.25v1.5 c0,0.21-0.07,0.39-0.22,0.53c-0.15,0.15-0.32,0.22-0.53,0.22h-2.5c-0.21,0-0.39-0.07-0.53-0.22C11.07,9.14,11,8.96,11,8.75v-1.5 c0-0.21,0.07-0.39,0.22-0.53c0.15-0.15,0.32-0.22,0.53-0.22h2.5c0.21,0,0.39,0.07,0.53,0.22C14.93,6.86,15,7.04,15,7.25z M15,11.25 v1.5c0,0.21-0.07,0.39-0.22,0.53c-0.15,0.15-0.32,0.22-0.53,0.22h-2.5c-0.21,0-0.39-0.07-0.53-0.22C11.07,13.14,11,12.96,11,12.75 v-1.5c0-0.21,0.07-0.39,0.22-0.53c0.15-0.15,0.32-0.22,0.53-0.22h2.5c0.21,0,0.39,0.07,0.53,0.22C14.93,10.86,15,11.04,15,11.25z"
            />
        </svg>
    `);
}
function $5281f9bafc8b4846$export$6c5676dc58c894d4() {
    return $5281f9bafc8b4846$export$1ca1ec8b29a4ce27((0, $9UZF0.html)`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
            <g id="XMLID_19_">
                <path id="XMLID_34_" class="st0" d="M2 6H3V7H2z" />
                <path id="XMLID_35_" class="st0" d="M2 9H3V10H2z" />
                <path id="XMLID_36_" class="st0" d="M6 9H10V10H6z" />
                <path id="XMLID_37_" class="st0" d="M6 6H10V7H6z" />
                <path id="XMLID_38_" class="st0" d="M6 3H10V4H6z" />
                <path
                    id="XMLID_41_"
                    class="st0"
                    d="M12,3V0H4v3H0v13h16V3H12z M1,15V4h3v11H1z M7,15v-2h2v2H7z M10,15v-3H6v3H5V1h6v14H10z M15,15 h-3V4h3V15z"
                />
                <path id="XMLID_45_" class="st0" d="M2 12H3V13H2z" />
                <path id="XMLID_46_" class="st0" d="M13 6H14V7H13z" />
                <path id="XMLID_47_" class="st0" d="M13 9H14V10H13z" />
                <path id="XMLID_48_" class="st0" d="M13 12H14V13H13z" />
            </g>
        </svg>
    `);
}
function $5281f9bafc8b4846$export$24422be91ad4011f() {
    return $5281f9bafc8b4846$export$1ca1ec8b29a4ce27((0, $9UZF0.html)`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
            <path
                d="M14.5,10.75v2.5c0,0.21-0.07,0.39-0.22,0.53C14.14,13.93,13.96,14,13.75,14H2.25 c-0.21,0-0.39-0.07-0.53-0.22c-0.15-0.15-0.22-0.32-0.22-0.53v-2.5c0-0.21,0.07-0.39,0.22-0.53C1.86,10.07,2.04,10,2.25,10h3.63 l1.05,1.06C7.24,11.35,7.59,11.5,8,11.5s0.76-0.15,1.06-0.44L10.12,10h3.62c0.21,0,0.39,0.07,0.53,0.22 C14.43,10.36,14.5,10.54,14.5,10.75z M11.96,6.3c0.09,0.21,0.05,0.4-0.11,0.55l-3.5,3.5C8.26,10.45,8.14,10.5,8,10.5 s-0.26-0.05-0.35-0.15l-3.5-3.5C3.99,6.7,3.95,6.52,4.04,6.3C4.13,6.1,4.28,6,4.5,6h2V2.5c0-0.14,0.05-0.25,0.15-0.35 C6.75,2.05,6.86,2,7,2h2c0.14,0,0.25,0.05,0.35,0.15C9.45,2.25,9.5,2.36,9.5,2.5V6h2C11.72,6,11.87,6.1,11.96,6.3z M11.35,12.85 c0.1-0.1,0.15-0.22,0.15-0.35c0-0.14-0.05-0.25-0.15-0.35C11.25,12.05,11.14,12,11,12c-0.14,0-0.25,0.05-0.35,0.15 c-0.1,0.1-0.15,0.22-0.15,0.35c0,0.14,0.05,0.25,0.15,0.35C10.75,12.95,10.86,13,11,13C11.14,13,11.25,12.95,11.35,12.85z M13.35,12.85c0.1-0.1,0.15-0.22,0.15-0.35c0-0.14-0.05-0.25-0.15-0.35C13.25,12.05,13.14,12,13,12c-0.14,0-0.25,0.05-0.35,0.15 c-0.1,0.1-0.15,0.22-0.15,0.35c0,0.14,0.05,0.25,0.15,0.35C12.75,12.95,12.86,13,13,13C13.14,13,13.25,12.95,13.35,12.85z"
            />
        </svg>
    `);
}
function $5281f9bafc8b4846$export$81207e5cc4186890() {
    return $5281f9bafc8b4846$export$1ca1ec8b29a4ce27((0, $9UZF0.html)`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
            <path
                d="M10.85,4.9C10.95,5,11,5.11,11,5.25c0,0.14-0.05,0.25-0.15,0.35l-3.5,3.5C7.25,9.2,7.14,9.25,7,9.25 c-0.14,0-0.25-0.05-0.35-0.15l-3.5-3.5C3.05,5.5,3,5.39,3,5.25C3,5.11,3.05,5,3.15,4.9c0.1-0.1,0.22-0.15,0.35-0.15h7 C10.64,4.75,10.75,4.8,10.85,4.9z"
            />
        </svg>
    `);
}
function $5281f9bafc8b4846$export$e1a8e267487c59d1() {
    return $5281f9bafc8b4846$export$1ca1ec8b29a4ce27((0, $9UZF0.html)`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
            <path
                d="M7.58,3.17l3.25,3.25l-6.5,6.5H1.08V9.67L7.58,3.17z M3.92,11.92l0.71-0.71L2.79,9.37l-0.71,0.71v0.84h1v1 H3.92z M8,4.67C8,4.55,7.95,4.5,7.83,4.5c-0.05,0-0.1,0.02-0.13,0.05L3.46,8.79C3.43,8.82,3.41,8.87,3.41,8.92 c0,0.11,0.06,0.17,0.17,0.17c0.05,0,0.1-0.02,0.13-0.05L7.95,4.8C7.99,4.76,8,4.72,8,4.67z M12.92,3.92c0,0.28-0.1,0.51-0.29,0.7 l-1.3,1.3L8.08,2.67l1.3-1.29c0.19-0.2,0.42-0.3,0.7-0.3c0.28,0,0.51,0.1,0.71,0.3l1.84,1.83C12.82,3.41,12.92,3.65,12.92,3.92z"
            />
        </svg>
    `);
}
function $5281f9bafc8b4846$export$ae413195ea50c70e() {
    return $5281f9bafc8b4846$export$1ca1ec8b29a4ce27((0, $9UZF0.html)`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <path
                d="M5.44,16.84c0,0.42-0.34,0.76-0.76,0.76H1.26c-0.42,0-0.76-0.34-0.76-0.76v-7.6 c0-0.42,0.34-0.76,0.76-0.76h3.42c0.42,0,0.76,0.34,0.76,0.76V16.84z M2.78,14.56c-0.43,0-0.76,0.34-0.76,0.76 c0,0.43,0.33,0.76,0.76,0.76c0.42,0,0.76-0.33,0.76-0.76C3.54,14.9,3.2,14.56,2.78,14.56z M18.85,11.01 c0.13,0.38,0.18,0.74,0.18,0.9c0.02,0.59-0.15,1.15-0.51,1.63c0.13,0.44,0.13,0.91,0,1.39c-0.12,0.44-0.34,0.83-0.64,1.12 c0.07,0.89-0.13,1.62-0.58,2.15c-0.51,0.61-1.29,0.91-2.34,0.93c-0.05,0-0.21,0-0.43,0h-0.9h-0.2c-1.7,0-3.3-0.56-4.58-1 c-0.75-0.26-1.46-0.51-1.88-0.52c-0.4-0.01-0.76-0.34-0.76-0.76V9.23c0-0.39,0.33-0.72,0.72-0.76c0.44-0.04,1.58-1.45,2.1-2.14 c0.43-0.55,0.83-1.06,1.2-1.42c0.46-0.46,0.59-1.18,0.74-1.86c0.13-0.7,0.27-1.44,0.78-1.94c0.14-0.14,0.33-0.23,0.53-0.23 c2.66,0,2.66,2.13,2.66,3.04c0,0.97-0.34,1.66-0.66,2.28c-0.13,0.26-0.25,0.38-0.34,0.76h3.29c1.24,0,2.28,1.04,2.28,2.28 C19.5,9.87,19.25,10.55,18.85,11.01z"
            />
        </svg>
    `);
}
function $5281f9bafc8b4846$export$fbdecc684f217e03() {
    return $5281f9bafc8b4846$export$1ca1ec8b29a4ce27((0, $9UZF0.html)`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <g id="XMLID_442_">
                <path id="XMLID_445_" d="M0 2.5H20V5.5H0z" />
                <path id="XMLID_446_" class="st0" d="M0 8.5H20V11.5H0z" />
                <path id="XMLID_447_" class="st0" d="M0 14.5H20V17.5H0z" />
            </g>
        </svg>
    `);
}
function $5281f9bafc8b4846$export$a80b3bd66acc52ff() {
    return $5281f9bafc8b4846$export$1ca1ec8b29a4ce27((0, $9UZF0.html)`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
            <path
                d="M10.5,12v1c0,0.14-0.05,0.25-0.15,0.35c-0.1,0.1-0.22,0.15-0.35,0.15H6c-0.14,0-0.25-0.05-0.35-0.15 C5.55,13.25,5.5,13.14,5.5,13v-1c0-0.14,0.05-0.25,0.15-0.35c0.1-0.1,0.22-0.15,0.35-0.15h0.5v-3H6c-0.14,0-0.25-0.05-0.35-0.15 C5.55,8.25,5.5,8.14,5.5,8V7c0-0.14,0.05-0.25,0.15-0.35C5.75,6.55,5.86,6.5,6,6.5h3c0.14,0,0.25,0.05,0.35,0.15 C9.45,6.75,9.5,6.86,9.5,7v4.5H10c0.14,0,0.25,0.05,0.35,0.15C10.45,11.75,10.5,11.86,10.5,12z M9.5,3v1.5 c0,0.14-0.05,0.25-0.15,0.35C9.25,4.95,9.14,5,9,5H7C6.86,5,6.75,4.95,6.65,4.85C6.55,4.75,6.5,4.64,6.5,4.5V3 c0-0.14,0.05-0.25,0.15-0.35C6.75,2.55,6.86,2.5,7,2.5h2c0.14,0,0.25,0.05,0.35,0.15C9.45,2.75,9.5,2.86,9.5,3z"
            />
        </svg>
    `);
}
function $5281f9bafc8b4846$export$3551c0bbbe6b0dda() {
    return $5281f9bafc8b4846$export$1ca1ec8b29a4ce27((0, $9UZF0.html)`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <g>
                <path
                    fill="#FFEB33"
                    d="M10 0L9.81 0.6 9.17 0.6 9.69 0.96 9.5 1.54 10 1.19 10.5 1.54 10.31 0.96 10.83 0.6 10.19 0.6z"
                />
                <path
                    fill="#FFEB33"
                    d="M12.59 0.68L12.39 1.27 11.76 1.27 12.28 1.64 12.09 2.22 12.59 1.86 13.08 2.22 12.9 1.64 13.41 1.27 12.78 1.27z"
                />
                <path
                    fill="#FFEB33"
                    d="M6.92 2.22L7.41 1.86 7.91 2.22 7.72 1.64 8.24 1.27 7.61 1.27 7.41 0.68 7.22 1.27 6.59 1.27 7.1 1.64z"
                />
                <path
                    fill="#FFEB33"
                    d="M13.99 4.12L14.49 3.76 14.99 4.12 14.8 3.54 15.32 3.17 14.68 3.17 14.49 2.57 14.3 3.17 13.66 3.17 14.18 3.54z"
                />
                <path
                    fill="#FFEB33"
                    d="M5.51 2.57L5.32 3.17 4.68 3.17 5.2 3.54 5.01 4.12 5.51 3.76 6.01 4.12 5.82 3.54 6.34 3.17 5.7 3.17z"
                />
                <path
                    fill="#FFEB33"
                    d="M16 5.77L15.37 5.77 15.17 5.17 14.98 5.77 14.35 5.77 14.86 6.13 14.68 6.71 15.17 6.36 15.67 6.71 15.48 6.13z"
                />
                <path
                    fill="#FFEB33"
                    d="M4.83 6.36L5.32 6.71 5.14 6.13 5.65 5.77 5.02 5.77 4.83 5.17 4.63 5.77 4 5.77 4.52 6.13 4.33 6.71z"
                />
                <path
                    fill="#FFEB33"
                    d="M14.68 8.35L14.49 7.76 14.3 8.35 13.66 8.35 14.18 8.72 13.99 9.3 14.49 8.94 14.99 9.3 14.8 8.72 15.32 8.35z"
                />
                <path
                    fill="#FFEB33"
                    d="M5.7 8.35L5.51 7.76 5.32 8.35 4.68 8.35 5.2 8.72 5.01 9.3 5.51 8.94 6.01 9.3 5.82 8.72 6.34 8.35z"
                />
                <path
                    fill="#FFEB33"
                    d="M12.78 10.25L12.59 9.65 12.39 10.25 11.76 10.25 12.28 10.62 12.09 11.19 12.59 10.84 13.08 11.19 12.9 10.62 13.41 10.25z"
                />
                <path
                    fill="#FFEB33"
                    d="M7.61 10.25L7.41 9.65 7.22 10.25 6.59 10.25 7.1 10.62 6.92 11.19 7.41 10.84 7.91 11.19 7.72 10.62 8.24 10.25z"
                />
                <path
                    fill="#FFEB33"
                    d="M10.19 10.95L10 10.35 9.81 10.95 9.17 10.95 9.69 11.32 9.5 11.9 10 11.54 10.5 11.9 10.31 11.32 10.83 10.95z"
                />
            </g>
            <g>
                <path
                    d="M4.93,20v-6.04h1.19l2.47,4.04v-4.04h1.13V20H8.5l-2.44-3.94V20H4.93z"
                />
                <path d="M11.04,20v-5.99h1.22v4.98h3.03V20H11.04z" />
            </g>
        </svg>
    `);
}
function $5281f9bafc8b4846$export$ec6aea9c3df53a3c() {
    return $5281f9bafc8b4846$export$1ca1ec8b29a4ce27((0, $9UZF0.html)`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
            <path d="M2 1v14h1.6V9.24h4.48l.32 1.64H14V2.65H9.52L9.2 1z" />
        </svg>
    `);
}
function $5281f9bafc8b4846$export$a0973bcfe11b05c9() {
    return $5281f9bafc8b4846$export$1ca1ec8b29a4ce27((0, $9UZF0.html)`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
            <path d="M5.2 2l1.2 1.53h8.07v9.07H6.4L5.2 14H16V2z" />
            <path
                id="XMLID_152_"
                class="st0"
                d="M6.13 6.53H0v3h6.13v1.54l3.07-3-3.07-3.14z"
            />
        </svg>
    `);
}
function $5281f9bafc8b4846$export$f9ef67375ddc185() {
    return $5281f9bafc8b4846$export$1ca1ec8b29a4ce27((0, $9UZF0.html)`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
            <path
                d="M14.19,12.76l-2.67-2.65c0.6-0.88,0.96-1.95,0.96-3.1c0-3.04-2.45-5.5-5.48-5.5c-3.03,0-5.48,2.46-5.48,5.5 c0,3.04,2.45,5.5,5.48,5.5c1.16,0,2.23-0.36,3.12-0.98l2.66,2.67c0.18,0.19,0.44,0.3,0.72,0.3c0.56,0,1.01-0.45,1.01-1.01 C14.5,13.2,14.38,12.94,14.19,12.76z M6.99,10.51c-1.93,0-3.5-1.57-3.5-3.5s1.57-3.5,3.5-3.5c1.93,0,3.5,1.57,3.5,3.5 S8.93,10.51,6.99,10.51z"
            />
        </svg>
    `);
}
function $5281f9bafc8b4846$export$48cfd1e771a65c4f() {
    return $5281f9bafc8b4846$export$1ca1ec8b29a4ce27((0, $9UZF0.html)`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
            <path
                d="M10.9,7.35l-5.8,5.8C5,13.25,4.89,13.3,4.75,13.3c-0.14,0-0.25-0.05-0.35-0.15l-1.3-1.3 c-0.1-0.1-0.15-0.22-0.15-0.35c0-0.14,0.05-0.25,0.15-0.35L7.25,7L3.1,2.85C3,2.75,2.95,2.64,2.95,2.5C2.95,2.36,3,2.25,3.1,2.15 l1.3-1.3C4.5,0.75,4.61,0.7,4.75,0.7C4.89,0.7,5,0.75,5.1,0.85l5.8,5.8C11,6.75,11.05,6.86,11.05,7C11.05,7.14,11,7.25,10.9,7.35z"
            />
        </svg>
    `);
}
function $5281f9bafc8b4846$export$6f259e79976a58c8() {
    return $5281f9bafc8b4846$export$1ca1ec8b29a4ce27((0, $9UZF0.html)`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 42">
            <path
                fill="#FFEB33"
                d="M28.84,28.67c-5.99,5.99-15.69,5.99-21.68,0c-5.99-5.99-5.99-15.69,0-21.68 C13.15,1,22.85,1,28.84,6.99C34.83,12.97,34.83,22.68,28.84,28.67z"
            />
            <path
                fill="#0028D8"
                d="M27.58,14.98H26.5c-0.24,0-0.46,0.09-0.62,0.25c-0.59-1.32-1.37-3.36-1.82-4.16 c-0.2-0.36-0.6-0.79-1.04-0.79H12.98c-0.45,0-0.85,0.43-1.04,0.79c-0.44,0.8-1.22,2.84-1.82,4.16c-0.16-0.15-0.38-0.25-0.62-0.25 H8.42c-0.51,0-0.92,0.41-0.92,0.92c0,0.51,0.41,0.92,0.92,0.92h0.96c0,0,0,0.01,0,0.01v3.4c0,0.03,0,0.05,0,0.08 c0,0.03,0,0.05,0,0.08v0.04l0,0c0.04,1.08,0.58,1.95,1.25,1.95c0,0,0.01,0,0.01,0c0,0.04-0.01,0.09-0.01,0.14v1.8 c0,0.47,0.38,0.85,0.85,0.85h0.79c0.47,0,0.85-0.38,0.85-0.85v-1.8c0-0.05-0.01-0.1-0.01-0.15l0.14,0h9.55l0.13,0 c-0.01,0.05-0.01,0.1-0.01,0.15v1.8c0,0.47,0.38,0.85,0.85,0.85h0.79c0.47,0,0.85-0.38,0.85-0.85v-1.8c0-0.05-0.01-0.09-0.01-0.14h0 c0.69,0,1.25-0.92,1.25-2.06c0-0.01,0-0.02,0-0.03l0-3.44c0,0,0-0.01,0-0.01h0.96c0.51,0,0.92-0.41,0.92-0.92 C28.5,15.39,28.09,14.98,27.58,14.98 M12.94,20.25c-0.72,0-1.31-0.59-1.31-1.31c0-0.72,0.59-1.31,1.31-1.31 c0.72,0,1.31,0.59,1.31,1.31C14.26,19.66,13.67,20.25,12.94,20.25 M22.64,20.25c-0.72,0-1.31-0.59-1.31-1.31 c0-0.72,0.59-1.31,1.31-1.31c0.72,0,1.31,0.59,1.31,1.31C23.95,19.66,23.37,20.25,22.64,20.25 M11.23,16.03 c0.57-1.22,1.08-2.96,1.75-4.16c0.05-0.08,0.19-0.28,0.29-0.32h4.69h0.1h4.69c0.1,0.04,0.24,0.24,0.29,0.32 c0.66,1.2,1.17,2.94,1.75,4.16H11.23z"
            />
            <path
                fill="#FFEB33"
                d="M30.61,5.22c-6.96-6.96-18.25-6.96-25.21,0c-6.96,6.96-6.96,18.25,0,25.21l10.84,10.84 c0.97,0.97,2.56,0.97,3.53,0l10.84-10.84C37.57,23.47,37.57,12.18,30.61,5.22z M28.84,28.67c-5.99,5.99-15.69,5.99-21.68,0 c-5.99-5.99-5.99-15.69,0-21.68C13.15,1,22.85,1,28.84,6.99C34.83,12.97,34.83,22.68,28.84,28.67z"
            />
        </svg>
    `);
}
function $5281f9bafc8b4846$export$e4043f67d36cbb26() {
    return $5281f9bafc8b4846$export$1ca1ec8b29a4ce27((0, $9UZF0.html)`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 42">
            <path
                fill="#e3f6f8"
                d="M28.84,28.67c-5.99,5.99-15.69,5.99-21.68,0c-5.99-5.99-5.99-15.69,0-21.68 C13.15,1,22.85,1,28.84,6.99C34.83,12.97,34.83,22.68,28.84,28.67z"
            />
            <path
                fill="#0028D8"
                d="M27.58,14.98H26.5c-0.24,0-0.46,0.09-0.62,0.25c-0.59-1.32-1.37-3.36-1.82-4.16 c-0.2-0.36-0.6-0.79-1.04-0.79H12.98c-0.45,0-0.85,0.43-1.04,0.79c-0.44,0.8-1.22,2.84-1.82,4.16c-0.16-0.15-0.38-0.25-0.62-0.25 H8.42c-0.51,0-0.92,0.41-0.92,0.92c0,0.51,0.41,0.92,0.92,0.92h0.96c0,0,0,0.01,0,0.01v3.4c0,0.03,0,0.05,0,0.08 c0,0.03,0,0.05,0,0.08v0.04l0,0c0.04,1.08,0.58,1.95,1.25,1.95c0,0,0.01,0,0.01,0c0,0.04-0.01,0.09-0.01,0.14v1.8 c0,0.47,0.38,0.85,0.85,0.85h0.79c0.47,0,0.85-0.38,0.85-0.85v-1.8c0-0.05-0.01-0.1-0.01-0.15l0.14,0h9.55l0.13,0 c-0.01,0.05-0.01,0.1-0.01,0.15v1.8c0,0.47,0.38,0.85,0.85,0.85h0.79c0.47,0,0.85-0.38,0.85-0.85v-1.8c0-0.05-0.01-0.09-0.01-0.14h0 c0.69,0,1.25-0.92,1.25-2.06c0-0.01,0-0.02,0-0.03l0-3.44c0,0,0-0.01,0-0.01h0.96c0.51,0,0.92-0.41,0.92-0.92 C28.5,15.39,28.09,14.98,27.58,14.98 M12.94,20.25c-0.72,0-1.31-0.59-1.31-1.31c0-0.72,0.59-1.31,1.31-1.31 c0.72,0,1.31,0.59,1.31,1.31C14.26,19.66,13.67,20.25,12.94,20.25 M22.64,20.25c-0.72,0-1.31-0.59-1.31-1.31 c0-0.72,0.59-1.31,1.31-1.31c0.72,0,1.31,0.59,1.31,1.31C23.95,19.66,23.37,20.25,22.64,20.25 M11.23,16.03 c0.57-1.22,1.08-2.96,1.75-4.16c0.05-0.08,0.19-0.28,0.29-0.32h4.69h0.1h4.69c0.1,0.04,0.24,0.24,0.29,0.32 c0.66,1.2,1.17,2.94,1.75,4.16H11.23z"
            />
            <path
                fill="#e3f6f8"
                d="M30.61,5.22c-6.96-6.96-18.25-6.96-25.21,0c-6.96,6.96-6.96,18.25,0,25.21l10.84,10.84 c0.97,0.97,2.56,0.97,3.53,0l10.84-10.84C37.57,23.47,37.57,12.18,30.61,5.22z M28.84,28.67c-5.99,5.99-15.69,5.99-21.68,0 c-5.99-5.99-5.99-15.69,0-21.68C13.15,1,22.85,1,28.84,6.99C34.83,12.97,34.83,22.68,28.84,28.67z"
            />
        </svg>
    `);
}
function $5281f9bafc8b4846$export$b7fd2c2937973304() {
    return $5281f9bafc8b4846$export$1ca1ec8b29a4ce27((0, $9UZF0.html)`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
            <path
                d="M12.46 9.69c-.08.18-.26.31-.46.31H9.02l1.57 3.72c.11.26-.02.55-.27.66l-1.38.59c-.26.11-.55-.02-.66-.27l-1.49-3.53-2.44 2.43c-.09.09-.22.15-.35.15-.06 0-.13-.02-.19-.04-.19-.08-.31-.26-.31-.46V1.5c0-.2.12-.38.31-.46.06-.02.13-.04.19-.04.13 0 .26.05.35.15l8 8c.15.14.19.36.11.54z"
            />
        </svg>
    `);
}
function $5281f9bafc8b4846$export$232faf9add678146() {
    return $5281f9bafc8b4846$export$1ca1ec8b29a4ce27((0, $9UZF0.html)`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
            <path
                d="M10.9,2.85L6.75,7l4.15,4.15c0.1,0.1,0.15,0.22,0.15,0.35c0,0.14-0.05,0.25-0.15,0.35l-1.3,1.3 c-0.1,0.1-0.22,0.15-0.35,0.15c-0.14,0-0.25-0.05-0.35-0.15l-5.8-5.8C3,7.25,2.95,7.14,2.95,7C2.95,6.86,3,6.75,3.1,6.65l5.8-5.8 C9,0.75,9.11,0.7,9.25,0.7c0.14,0,0.25,0.05,0.35,0.15l1.3,1.3c0.1,0.1,0.15,0.22,0.15,0.35C11.05,2.64,11,2.75,10.9,2.85z"
            />
        </svg>
    `);
}
function $5281f9bafc8b4846$export$c2d084dc44961371() {
    return $5281f9bafc8b4846$export$1ca1ec8b29a4ce27((0, $9UZF0.html)`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
            <path
                d="M14.5,8.5v3.25c0,0.07-0.02,0.13-0.07,0.18C14.38,11.98,14.32,12,14.25,12H12.5v1.25 c0,0.21-0.07,0.39-0.22,0.53C12.14,13.93,11.96,14,11.75,14h-7.5c-0.21,0-0.39-0.07-0.53-0.22c-0.15-0.15-0.22-0.32-0.22-0.53V12 H1.75c-0.07,0-0.13-0.02-0.18-0.07c-0.05-0.05-0.07-0.11-0.07-0.18V8.5c0-0.41,0.15-0.76,0.44-1.06C2.24,7.15,2.59,7,3,7h0.5V2.75 c0-0.21,0.07-0.39,0.22-0.53C3.86,2.07,4.04,2,4.25,2H9.5c0.21,0,0.44,0.05,0.69,0.16c0.25,0.1,0.45,0.23,0.59,0.38l1.19,1.19 c0.15,0.15,0.27,0.34,0.38,0.59C12.45,4.56,12.5,4.79,12.5,5v2H13c0.41,0,0.76,0.15,1.06,0.44C14.35,7.74,14.5,8.09,14.5,8.5z M4.5,8h7V5h-1.25c-0.21,0-0.39-0.07-0.53-0.22C9.57,4.64,9.5,4.46,9.5,4.25V3h-5V8z M4.5,13h7v-2h-7V13z M13.35,8.85 c0.1-0.1,0.15-0.22,0.15-0.35c0-0.14-0.05-0.25-0.15-0.35C13.25,8.05,13.14,8,13,8c-0.14,0-0.25,0.05-0.35,0.15 c-0.1,0.1-0.15,0.22-0.15,0.35c0,0.14,0.05,0.25,0.15,0.35C12.75,8.95,12.86,9,13,9C13.14,9,13.25,8.95,13.35,8.85z"
            />
        </svg>
    `);
}
function $5281f9bafc8b4846$export$6be81e7acd49b103() {
    return $5281f9bafc8b4846$export$1ca1ec8b29a4ce27((0, $9UZF0.html)`
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 200.000000 200.000000"
            preserveAspectRatio="xMidYMid meet"
        >
            <g
                transform="translate(0.000000,200.000000) scale(0.100000,-0.100000)"
                stroke="none"
            >
                <path
                    d="M741 1685 c-80 -23 -129 -47 -196 -98 -137 -104 -210 -255 -208 -432
2 -207 113 -385 298 -476 158 -78 326 -79 475 -4 27 14 52 25 55 25 3 0 5 -17
5 -38 0 -35 12 -49 233 -270 l232 -232 60 60 60 60 -235 235 c-201 201 -239
235 -265 235 l-29 0 41 43 c161 166 194 417 82 628 -57 107 -175 207 -294 250
-79 28 -238 35 -314 14z m238 -80 c138 -33 246 -121 309 -252 36 -76 37 -81
37 -193 0 -109 -2 -119 -32 -182 -18 -38 -35 -68 -38 -68 -3 0 -16 10 -28 21
-30 29 -133 78 -179 85 -21 4 -38 8 -38 10 0 2 13 23 30 46 37 52 52 126 39
190 -12 64 -30 98 -78 141 -102 92 -244 63 -315 -63 -26 -47 -30 -64 -30 -125
0 -73 16 -118 57 -162 16 -18 17 -23 6 -27 -8 -2 -41 -12 -73 -22 -33 -10 -82
-33 -109 -51 -27 -18 -50 -33 -52 -33 -1 0 -15 28 -31 63 -27 57 -29 71 -29
177 0 112 1 117 36 190 64 133 163 216 298 252 82 21 138 22 220 3z m-43 -252
c34 -22 64 -84 64 -133 0 -56 -21 -101 -64 -137 -36 -29 -37 -31 -29 -79 8
-45 11 -49 38 -52 100 -11 223 -62 245 -102 8 -16 3 -24 -38 -54 -104 -76
-234 -108 -350 -87 -76 14 -170 57 -222 100 -29 25 -33 33 -24 48 17 29 117
74 196 87 l73 12 5 53 c5 48 4 54 -20 68 -43 26 -64 63 -68 125 -5 68 9 109
50 143 35 30 105 34 144 8z"
                />
            </g>
        </svg>
    `);
}
function $5281f9bafc8b4846$export$a5a6e0b888b2c992() {
    return $5281f9bafc8b4846$export$1ca1ec8b29a4ce27((0, $9UZF0.html)`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
            <path
                d="M14,7.15v1.73c0,0.06-0.02,0.12-0.06,0.18c-0.04,0.06-0.09,0.09-0.16,0.1l-1.45,0.22 c-0.1,0.28-0.2,0.52-0.3,0.71c0.18,0.26,0.46,0.62,0.84,1.08c0.05,0.06,0.08,0.13,0.08,0.2c0,0.07-0.02,0.13-0.07,0.18 c-0.14,0.19-0.4,0.47-0.77,0.84c-0.38,0.37-0.62,0.55-0.73,0.55c-0.06,0-0.13-0.02-0.2-0.07l-1.08-0.84 c-0.23,0.12-0.47,0.22-0.71,0.3c-0.08,0.71-0.16,1.19-0.23,1.45C9.11,13.93,9.02,14,8.87,14H7.13C7.06,14,7,13.98,6.94,13.93 c-0.05-0.04-0.08-0.1-0.09-0.17l-0.22-1.44c-0.26-0.08-0.49-0.18-0.7-0.29l-1.1,0.84c-0.05,0.05-0.12,0.07-0.2,0.07 c-0.07,0-0.14-0.03-0.2-0.09c-0.66-0.59-1.09-1.03-1.29-1.31c-0.04-0.05-0.05-0.11-0.05-0.18c0-0.06,0.02-0.12,0.06-0.18 c0.08-0.11,0.21-0.28,0.4-0.52c0.19-0.24,0.33-0.42,0.42-0.55C3.84,9.86,3.73,9.6,3.66,9.34L2.23,9.13C2.16,9.12,2.1,9.09,2.06,9.04 C2.02,8.98,2,8.92,2,8.85V7.12C2,7.05,2.02,7,2.06,6.94c0.04-0.06,0.09-0.09,0.15-0.1l1.45-0.22c0.07-0.24,0.17-0.48,0.3-0.72 C3.76,5.6,3.48,5.24,3.13,4.82C3.08,4.76,3.05,4.7,3.05,4.63c0-0.05,0.02-0.11,0.07-0.18c0.14-0.19,0.39-0.47,0.77-0.84 c0.38-0.37,0.62-0.56,0.74-0.56c0.07,0,0.14,0.03,0.2,0.08l1.08,0.84c0.23-0.12,0.47-0.22,0.71-0.3c0.08-0.71,0.16-1.19,0.23-1.45 C6.89,2.07,6.98,2,7.13,2h1.73C8.94,2,9,2.02,9.06,2.07c0.05,0.04,0.08,0.1,0.09,0.17l0.22,1.44c0.25,0.08,0.49,0.18,0.7,0.29 l1.11-0.84c0.05-0.05,0.11-0.07,0.19-0.07c0.07,0,0.13,0.03,0.2,0.08c0.67,0.62,1.1,1.06,1.29,1.33c0.04,0.04,0.05,0.1,0.05,0.17 c0,0.06-0.02,0.12-0.06,0.18c-0.08,0.11-0.21,0.28-0.4,0.52c-0.19,0.24-0.33,0.42-0.42,0.55c0.14,0.26,0.24,0.52,0.32,0.77 l1.43,0.22c0.07,0.01,0.12,0.04,0.16,0.1C13.98,7.02,14,7.08,14,7.15z M9.41,9.41C9.8,9.02,10,8.55,10,8c0-0.55-0.2-1.02-0.59-1.41 S8.55,6,8,6C7.45,6,6.98,6.2,6.59,6.59S6,7.45,6,8c0,0.55,0.2,1.02,0.59,1.41S7.45,10,8,10C8.55,10,9.02,9.8,9.41,9.41z"
            />
        </svg>
    `);
}
function $5281f9bafc8b4846$export$786fb34efcf0dd02() {
    return $5281f9bafc8b4846$export$1ca1ec8b29a4ce27((0, $9UZF0.html)`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
            <path
                d="M12.43,3.07C12.38,3.02,12.32,3,12.25,3H9.84L9.29,1.7C9.21,1.5,9.07,1.34,8.87,1.2C8.66,1.07,8.46,1,8.25,1 h-2.5C5.54,1,5.34,1.07,5.13,1.2C4.93,1.34,4.79,1.5,4.71,1.7L4.16,3H1.75C1.68,3,1.62,3.02,1.57,3.07S1.5,3.18,1.5,3.25v0.5 c0,0.07,0.02,0.13,0.07,0.18S1.68,4,1.75,4H2.5v7.6c0,0.77,0.63,1.4,1.4,1.4h6.2c0.77,0,1.4-0.63,1.4-1.4V4h0.75 c0.07,0,0.13-0.02,0.18-0.07s0.07-0.11,0.07-0.18v-0.5C12.5,3.18,12.48,3.12,12.43,3.07z M5.63,2.09C5.67,2.04,5.71,2.01,5.77,2 h2.48c0.05,0.01,0.1,0.04,0.13,0.09L8.75,3h-3.5L5.63,2.09z M5.5,10.75C5.5,10.89,5.39,11,5.25,11H4.75c-0.14,0-0.25-0.11-0.25-0.25 V5.25C4.5,5.11,4.61,5,4.75,5h0.49C5.39,5,5.5,5.11,5.5,5.25V10.75z M7.5,10.75C7.5,10.89,7.39,11,7.25,11H6.75 c-0.14,0-0.25-0.11-0.25-0.25V5.25C6.5,5.11,6.61,5,6.75,5h0.49C7.39,5,7.5,5.11,7.5,5.25V10.75z M9.5,10.75 C9.5,10.89,9.39,11,9.25,11H8.75c-0.14,0-0.25-0.11-0.25-0.25V5.25C8.5,5.11,8.61,5,8.75,5h0.49C9.39,5,9.5,5.11,9.5,5.25V10.75z"
            />
        </svg>
    `);
}
function $5281f9bafc8b4846$export$84ddb186c49f4e56() {
    return $5281f9bafc8b4846$export$1ca1ec8b29a4ce27((0, $9UZF0.html)`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
            <path
                d="M14.25,11.92c0,0.14-0.11,0.25-0.25,0.25H4.25v1.75c0,0.1-0.05,0.19-0.15,0.23s-0.2,0.02-0.27-0.04l-3-2.73
	c-0.05-0.05-0.08-0.11-0.08-0.18s0.03-0.14,0.08-0.19l3-2.77C3.91,8.17,4.01,8.16,4.1,8.2c0.09,0.04,0.15,0.12,0.15,0.23v1.75H14
	c0.14,0,0.25,0.11,0.25,0.25V11.92z"
            />
            <path
                d="M15.17,4.99l-3,2.77c-0.08,0.07-0.18,0.09-0.27,0.05c-0.09-0.04-0.15-0.12-0.15-0.23V5.83H2
	c-0.14,0-0.25-0.11-0.25-0.25v-1.5c0-0.14,0.11-0.25,0.25-0.25h9.75V2.08c0-0.1,0.05-0.19,0.15-0.23s0.2-0.02,0.27,0.04l3,2.73
	c0.05,0.05,0.08,0.11,0.08,0.18S15.22,4.95,15.17,4.99z"
            />
        </svg>
    `);
}
function $5281f9bafc8b4846$export$5f8d3589eb8441ca() {
    return $5281f9bafc8b4846$export$1ca1ec8b29a4ce27((0, $9UZF0.html)`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
            <path
                d="M13,10.64c0,0.17-0.11,0.33-0.26,0.4c-0.05,0.02-0.11,0.03-0.17,0.03c-0.11,0-0.22-0.04-0.3-0.13l-2.7-2.7 v1.11c0,1.06-0.86,1.93-1.93,1.93H2.93C1.86,11.29,1,10.42,1,9.36V4.64c0-1.06,0.86-1.93,1.93-1.93h4.72 c1.06,0,1.93,0.86,1.93,1.93v1.11l2.7-2.69c0.08-0.09,0.19-0.13,0.3-0.13c0.05,0,0.11,0.01,0.17,0.03C12.9,3.03,13,3.18,13,3.36 V10.64z"
            />
        </svg>
    `);
}
function $5281f9bafc8b4846$export$b1df4d220da062a2() {
    return $5281f9bafc8b4846$export$1ca1ec8b29a4ce27((0, $9UZF0.html)`
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
            <path
                d="M20.77,7.7h-0.85c-0.19,0-0.36,0.07-0.49,0.19c-0.47-1.04-1.16-2.83-1.51-3.47 c-0.16-0.28-0.47-0.62-0.82-0.62H9.31c-0.35,0-0.67,0.34-0.82,0.62c-0.14,0.26-0.34,0.7-0.55,1.21h1.1c0.09-0.2,0.18-0.4,0.28-0.57 C9.35,5,9.46,4.85,9.54,4.81h7.33c0.08,0.03,0.19,0.19,0.23,0.25c0.52,0.95,1.01,2.5,1.46,3.46h-3.42c0.02,0.04,0.04,0.09,0.05,0.13 c0.1,0.23,0.19,0.47,0.29,0.69c0.01,0,0.03,0,0.04,0h0.85c0.85,0,1.54,0.69,1.54,1.54c0,0.83-0.66,1.51-1.49,1.54l0,0.82h0.55 l0.11,0c-0.01,0.04-0.01,0.07-0.01,0.11v1.42c0,0.37,0.3,0.67,0.67,0.67h0.62c0.37,0,0.67-0.3,0.67-0.67v-1.42 c0-0.04,0-0.07-0.01-0.11h0c0.55,0,0.99-0.73,0.99-1.63c0-0.01,0-0.02,0-0.02l0-2.45c0,0,0-0.01,0-0.01h0.76 c0.4,0,0.73-0.32,0.73-0.73C21.5,8.02,21.17,7.7,20.77,7.7z"
            />
            <g>
                <path
                    d="M16.37,10.17h-0.85c-0.19,0-0.36,0.07-0.49,0.19c-0.47-1.04-1.09-2.66-1.44-3.29 c-0.16-0.28-0.47-0.62-0.82-0.62H4.83c-0.35,0-0.67,0.34-0.82,0.62c-0.35,0.63-0.97,2.25-1.44,3.29c-0.13-0.12-0.3-0.19-0.49-0.19 H1.23c-0.4,0-0.73,0.32-0.73,0.73c0,0.4,0.33,0.73,0.73,0.73h0.76c0,0,0,0,0,0.01v2.68c0,0.02,0,0.04,0,0.06c0,0.02,0,0.04,0,0.06 v0.03l0,0C2.01,15.32,2.44,16,2.97,16c0,0,0.01,0,0.01,0c0,0.04-0.01,0.07-0.01,0.11v1.42c0,0.37,0.3,0.67,0.67,0.67h0.62 c0.37,0,0.67-0.3,0.67-0.67v-1.42c0-0.04,0-0.08-0.01-0.11l0.11,0h7.55l0.11,0c-0.01,0.04-0.01,0.07-0.01,0.11v1.42 c0,0.37,0.3,0.67,0.67,0.67h0.62c0.37,0,0.67-0.3,0.67-0.67v-1.42c0-0.04,0-0.07-0.01-0.11h0c0.55,0,0.99-0.73,0.99-1.63 c0-0.01,0-0.02,0-0.02l0-2.72c0,0,0-0.01,0-0.01h0.76c0.4,0,0.73-0.32,0.73-0.73C17.1,10.49,16.77,10.17,16.37,10.17 M4.8,14.33 c-0.57,0-1.04-0.46-1.04-1.04c0-0.57,0.46-1.04,1.04-1.04c0.57,0,1.04,0.46,1.04,1.04C5.84,13.87,5.37,14.33,4.8,14.33z M12.47,14.33c-0.57,0-1.04-0.46-1.04-1.04c0-0.57,0.46-1.04,1.04-1.04c0.57,0,1.04,0.46,1.04,1.04 C13.5,13.87,13.04,14.33,12.47,14.33z M3.45,11c0.45-0.96,0.86-2.34,1.38-3.28c0.04-0.07,0.15-0.22,0.23-0.25h7.49 c0.08,0.03,0.19,0.19,0.23,0.25c0.52,0.95,0.93,2.32,1.38,3.28H3.45z"
                />
            </g>
        </svg>
    `);
}
function $5281f9bafc8b4846$export$1ca1ec8b29a4ce27(content) {
    return (0, $9UZF0.html)`<ata-icon>${content}</ata-icon>`;
}
class $5281f9bafc8b4846$export$225e0f1e0e6845d9 extends (0, $78EKQ.LitElement) {
    static styles = (0, $hOpwk.css)`
        :host {
            display: flex;
            place-items: center;
            aspect-ratio: 1;
            height: 100%;
        }
    `;
    render() {
        return (0, $9UZF0.html)`<slot></slot>`;
    }
}
$5281f9bafc8b4846$export$225e0f1e0e6845d9 = (0, $dGa5T.__decorate)([
    (0, $d92i1.customElement)("ata-icon")
], $5281f9bafc8b4846$export$225e0f1e0e6845d9);

});

parcelRegister("74J5l", function(module, exports) {

$parcel$export(module.exports, "link", () => $bf118709dbcfb8d8$export$9c30223ca0a664fb);
$parcel$export(module.exports, "externalLink", () => $bf118709dbcfb8d8$export$f9fba33f0a1f3295);
parcelRequire("MJPZu");
var $9UZF0 = parcelRequire("9UZF0");
function $bf118709dbcfb8d8$export$9c30223ca0a664fb(href, onClick, content) {
    return (0, $9UZF0.html)` <a
        href="${href}"
        @click=${(event)=>{
        event.preventDefault();
        onClick(href);
    }}
    >
        ${content}
    </a>`;
}
function $bf118709dbcfb8d8$export$f9fba33f0a1f3295(href, content) {
    return (0, $9UZF0.html)`<a href="${href}" target="_blank" rel="noopener noreferrer">
        ${content}
    </a>`;
}

});

parcelRegister("ez1dp", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce5d409cb7d8a5da$export$2e2bcd8739ae039);
$parcel$export(module.exports, "onChange", () => $ce5d409cb7d8a5da$export$bd913411069e59d3);
$parcel$export(module.exports, "onLinkClick", () => $ce5d409cb7d8a5da$export$dccc97e4cadc9724);
$parcel$export(module.exports, "onSubmit", () => $ce5d409cb7d8a5da$export$307d29742c654737);
var $ce5d409cb7d8a5da$export$2e2bcd8739ae039 = {
    onInput: $ce5d409cb7d8a5da$export$7fbc06d7c1beb512,
    onChange: $ce5d409cb7d8a5da$export$bd913411069e59d3,
    onCheck: $ce5d409cb7d8a5da$export$afc3672ac3452f6d,
    onDateRangeChange: $ce5d409cb7d8a5da$export$303638796bec860c,
    onLinkClick: $ce5d409cb7d8a5da$export$dccc97e4cadc9724
};
function $ce5d409cb7d8a5da$export$dccc97e4cadc9724(toMsg) {
    return (event)=>{
        event.preventDefault();
        const element = event.target instanceof HTMLAnchorElement ? event.target : event.target.closest("a");
        return toMsg(element?.getAttribute("href") ?? "");
    };
}
function $ce5d409cb7d8a5da$export$7fbc06d7c1beb512(toMsg) {
    return (event)=>{
        event.preventDefault();
        return toMsg(event.target.value);
    };
}
function $ce5d409cb7d8a5da$export$bd913411069e59d3(toMsg) {
    return (event)=>{
        event.preventDefault();
        return toMsg(event.target.value);
    };
}
function $ce5d409cb7d8a5da$export$afc3672ac3452f6d(toMsg) {
    return (event)=>{
        event.preventDefault();
        return toMsg(event.target.checked);
    };
}
function $ce5d409cb7d8a5da$export$303638796bec860c(toMsg) {
    return ([start, end])=>{
        return toMsg({
            startDate: start.toISOString().split("T")[0],
            endDate: end.toISOString().split("T")[0]
        });
    };
}
function $ce5d409cb7d8a5da$export$307d29742c654737(toMsg) {
    return (event)=>{
        event.preventDefault();
        return toMsg();
    };
}

});

parcelRegister("7yG78", function(module, exports) {

$parcel$export(module.exports, "button", () => $64897fe275dd6acd$export$2ba01fb71ed41cb6);
$parcel$export(module.exports, "denseButton", () => $64897fe275dd6acd$export$85c2019f786494c2);
$parcel$export(module.exports, "filledButton", () => $64897fe275dd6acd$export$f813fc8f4e55838d);
$parcel$export(module.exports, "denseFilledButton", () => $64897fe275dd6acd$export$a2248ded88cbd857);
$parcel$export(module.exports, "strokedButton", () => $64897fe275dd6acd$export$9759bc59c2c50d21);
$parcel$export(module.exports, "denseStrokedButton", () => $64897fe275dd6acd$export$3771d86707e2b44b);
parcelRequire("MJPZu");
var $9UZF0 = parcelRequire("9UZF0");
parcelRequire("kwGhh");
parcelRequire("1BCWb");
parcelRequire("4c7YL");
function $64897fe275dd6acd$export$2ba01fb71ed41cb6(config) {
    return $64897fe275dd6acd$var$internalButton({
        content: config.content,
        onClick: $64897fe275dd6acd$var$toOnClick(config),
        inProgress: config.inProgress,
        isDisabled: $64897fe275dd6acd$var$toDisabled(config),
        dense: false,
        appearance: "Text",
        theme: config.theme,
        type: $64897fe275dd6acd$var$toType(config),
        href: $64897fe275dd6acd$var$toHref(config)
    });
}
function $64897fe275dd6acd$export$85c2019f786494c2(config) {
    return $64897fe275dd6acd$var$internalButton({
        content: config.content,
        onClick: $64897fe275dd6acd$var$toOnClick(config),
        inProgress: config.inProgress,
        isDisabled: $64897fe275dd6acd$var$toDisabled(config),
        dense: true,
        appearance: "Text",
        theme: config.theme,
        type: $64897fe275dd6acd$var$toType(config),
        href: $64897fe275dd6acd$var$toHref(config)
    });
}
function $64897fe275dd6acd$export$f813fc8f4e55838d(config) {
    return $64897fe275dd6acd$var$internalButton({
        content: config.content,
        onClick: $64897fe275dd6acd$var$toOnClick(config),
        inProgress: config.inProgress,
        isDisabled: $64897fe275dd6acd$var$toDisabled(config),
        dense: false,
        appearance: "Filled",
        theme: config.theme,
        type: $64897fe275dd6acd$var$toType(config),
        href: $64897fe275dd6acd$var$toHref(config)
    });
}
function $64897fe275dd6acd$export$a2248ded88cbd857(config) {
    return $64897fe275dd6acd$var$internalButton({
        content: config.content,
        onClick: $64897fe275dd6acd$var$toOnClick(config),
        inProgress: config.inProgress,
        isDisabled: $64897fe275dd6acd$var$toDisabled(config),
        dense: true,
        appearance: "Filled",
        theme: config.theme,
        type: $64897fe275dd6acd$var$toType(config),
        href: $64897fe275dd6acd$var$toHref(config)
    });
}
function $64897fe275dd6acd$export$9759bc59c2c50d21(config) {
    return $64897fe275dd6acd$var$internalButton({
        content: config.content,
        onClick: $64897fe275dd6acd$var$toOnClick(config),
        inProgress: config.inProgress,
        isDisabled: $64897fe275dd6acd$var$toDisabled(config),
        dense: false,
        appearance: "Stroked",
        theme: config.theme,
        type: $64897fe275dd6acd$var$toType(config),
        href: $64897fe275dd6acd$var$toHref(config)
    });
}
function $64897fe275dd6acd$export$3771d86707e2b44b(config) {
    return $64897fe275dd6acd$var$internalButton({
        content: config.content,
        onClick: $64897fe275dd6acd$var$toOnClick(config),
        inProgress: config.inProgress,
        isDisabled: $64897fe275dd6acd$var$toDisabled(config),
        dense: true,
        appearance: "Stroked",
        theme: config.theme,
        type: $64897fe275dd6acd$var$toType(config),
        href: $64897fe275dd6acd$var$toHref(config)
    });
}
function $64897fe275dd6acd$var$internalButton(config) {
    const isProgress = config?.inProgress === true;
    const onClick = config.onClick ?? (()=>{});
    const themeClass = {
        Primary: "primary",
        Secondary: "secondary",
        Success: "success",
        Warning: "warning",
        Danger: "danger"
    }[config.theme];
    switch(config.appearance){
        case "Text":
            return (0, $9UZF0.html)`<ata-text-button
                theme="${themeClass}"
                ?disabled="${config.isDisabled}"
                ?dense="${config.dense}"
                ?progress="${isProgress}"
                href=${config.href ?? (0, $9UZF0.nothing)}
                type="${config.type ?? "button"}"
                @click="${(event)=>{
                if (config.href) {
                    event.preventDefault();
                    onClick(config.href);
                } else onClick();
            }}"
            >
                ${config.content}
            </ata-text-button>`;
        case "Stroked":
            return (0, $9UZF0.html)`<ata-stroked-button
                theme="${themeClass}"
                ?disabled="${config.isDisabled}"
                ?dense="${config.dense}"
                ?progress="${isProgress}"
                href=${config.href ?? (0, $9UZF0.nothing)}
                type="${config.type ?? "button"}"
                @click="${(event)=>{
                if (config.href) {
                    event.preventDefault();
                    onClick(config.href);
                } else onClick();
            }}"
            >
                ${config.content}
            </ata-stroked-button>`;
        case "Filled":
            return (0, $9UZF0.html)`<ata-filled-button
                theme="${themeClass}"
                ?disabled="${config.isDisabled}"
                ?dense="${config.dense}"
                ?progress="${isProgress}"
                href=${config.href ?? (0, $9UZF0.nothing)}
                type="${config.type ?? "button"}"
                @click="${(event)=>{
                if (config.href) {
                    event.preventDefault();
                    onClick(config.href);
                } else onClick();
            }}"
            >
                ${config.content}
            </ata-filled-button>`;
    }
}
function $64897fe275dd6acd$var$toOnClick(config) {
    return "onClick" in config ? config.onClick : undefined;
}
function $64897fe275dd6acd$var$toDisabled(config) {
    if ("type" in config && (config.type === "submit" || config.type === "reset")) return config.disabled === true;
    return "onClick" in config && config.onClick === undefined;
}
function $64897fe275dd6acd$var$toType(config) {
    if ("type" in config) return config.type ?? "button";
    return "button";
}
function $64897fe275dd6acd$var$toHref(config) {
    return "href" in config ? config.href : undefined;
}

});
parcelRegister("kwGhh", function(module, exports) {

var $dGa5T = parcelRequire("dGa5T");
parcelRequire("bFoC6");
var $d92i1 = parcelRequire("d92i1");
parcelRequire("MJPZu");
var $hOpwk = parcelRequire("hOpwk");

var $9Vlur = parcelRequire("9Vlur");
class $5233033e0e78908d$export$2e2bcd8739ae039 extends (0, $9Vlur.default) {
    static styles = [
        (0, $9Vlur.ataButtonStyles),
        (0, $hOpwk.css)`
            a,
            button {
                ---ataButton--backgroundColor: transparent;
                ---ataButton--foregroundColor: var(--ata--button--color);
                ---ataButton--borderColor: transparent;
            }
        `
    ];
}
$5233033e0e78908d$export$2e2bcd8739ae039 = (0, $dGa5T.__decorate)([
    (0, $d92i1.customElement)("ata-text-button")
], $5233033e0e78908d$export$2e2bcd8739ae039);

});
parcelRegister("9Vlur", function(module, exports) {

$parcel$export(module.exports, "ataButtonStyles", () => $f9f2c629074d45bc$export$f861574949fd546d);
$parcel$export(module.exports, "default", () => $f9f2c629074d45bc$export$2e2bcd8739ae039);

var $dGa5T = parcelRequire("dGa5T");
parcelRequire("MJPZu");
var $hOpwk = parcelRequire("hOpwk");
var $9UZF0 = parcelRequire("9UZF0");
var $78EKQ = parcelRequire("78EKQ");
parcelRequire("bFoC6");
var $4Kcgn = parcelRequire("4Kcgn");
const $f9f2c629074d45bc$export$f861574949fd546d = (0, $hOpwk.css)`
    :is(button, a) {
        ---ataButton--backgroundColor: transparent;
        ---ataButton--foregroundColor: currentColor;
        ---ataButton--borderColor: transparent;
        position: relative;
        display: inline-flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        border-radius: var(--ata--button--borderRadius);
        padding-inline: 1.5rem;
        gap: 0.5rem;
        block-size: var(--ata--button--blockSize);
        border: none;
        outline: 1px solid var(---ataButton--borderColor);
        outline-offset: -1px;
        font-size: 0.875em;
        font-weight: 700;
        line-height: calc(var(--ata--button--blockSize) / 2);
        text-decoration: none;
        cursor: pointer;
        color: var(---ataButton--foregroundColor);
        fill: var(---ataButton--foregroundColor);
        background: var(---ataButton--backgroundColor);
        inline-size: 100%;
        box-sizing: border-box;

        &:disabled {
            cursor: not-allowed;
        }
    }

    :host-context([dense]) :is(a, button) {
        block-size: var(--ata--button--blockSize--dense);
        line-height: calc(var(--ata--button--blockSize--dense) / 2);
    }

    :is(a, button)[aria-busy='true'] {
        &[disabled] {
            cursor: wait;
        }

        &::after {
            content: '';
            display: inline-block;
            margin-left: 0.5rem;
            aspect-ratio: 1;
            height: 1rem;
            width: 1rem;
            position: relative;
            animation: rotation 1s infinite linear;
            border: 0.25rem solid transparent;
            border-top-color: var(---ataButton--foregroundColor);
            border-left-color: var(---ataButton--foregroundColor);
            border-radius: 100%;
            vertical-align: middle;
        }
    }

    @keyframes rotation {
        to {
            transform: rotate(359deg);
        }
    }

    ::slotted(ata-icon) {
        height: 50%;
    }
`;
class $f9f2c629074d45bc$export$2e2bcd8739ae039 extends (0, $78EKQ.LitElement) {
    static formAssociated = true;
    static shadowRootOptions = {
        ...(0, $78EKQ.LitElement).shadowRootOptions,
        delegatesFocus: true
    };
    #internals = this.attachInternals();
    disabled = false;
    progress = false;
    href = undefined;
    type = "button";
    attributeChangedCallback(name, _old, value) {
        switch(name){
            case "type":
            case "disabled":
            case "href":
            case "progress":
                this.requestUpdate(name, _old);
        }
        super.attributeChangedCallback(name, _old, value);
    }
    render() {
        return this.href === undefined || this.disabled ? this.renderButton() : this.renderLink();
    }
    renderButton() {
        return (0, $9UZF0.html)`
            <button
                ?disabled="${this.disabled}"
                aria-busy="${this.progress ? "true" : "false"}"
                @click=${this.onClick}
            >
                <slot></slot>
            </button>
        `;
    }
    renderLink() {
        return (0, $9UZF0.html)`
            <a href=${this.href} aria-busy="${this.progress}">
                <slot></slot>
            </a>
        `;
    }
    onClick() {
        switch(this.type){
            case "submit":
                this.#internals.form?.requestSubmit(null);
                return;
            case "reset":
                this.#internals.form?.reset();
                return;
        }
    }
}
(0, $dGa5T.__decorate)([
    (0, $4Kcgn.property)({
        type: Boolean,
        reflect: true
    })
], $f9f2c629074d45bc$export$2e2bcd8739ae039.prototype, "disabled", void 0);
(0, $dGa5T.__decorate)([
    (0, $4Kcgn.property)({
        type: Boolean,
        reflect: true
    })
], $f9f2c629074d45bc$export$2e2bcd8739ae039.prototype, "progress", void 0);
(0, $dGa5T.__decorate)([
    (0, $4Kcgn.property)({
        type: String
    })
], $f9f2c629074d45bc$export$2e2bcd8739ae039.prototype, "href", void 0);
(0, $dGa5T.__decorate)([
    (0, $4Kcgn.property)({
        type: String,
        converter: {
            fromAttribute (value) {
                switch(value.toLowerCase()){
                    case "submit":
                        return "submit";
                    case "reset":
                        return "reset";
                    default:
                        return "button";
                }
            }
        }
    })
], $f9f2c629074d45bc$export$2e2bcd8739ae039.prototype, "type", void 0);

});


parcelRegister("1BCWb", function(module, exports) {

var $dGa5T = parcelRequire("dGa5T");
parcelRequire("bFoC6");
var $d92i1 = parcelRequire("d92i1");
parcelRequire("MJPZu");
var $hOpwk = parcelRequire("hOpwk");

var $9Vlur = parcelRequire("9Vlur");
class $0574eb0a3b5be724$export$2e2bcd8739ae039 extends (0, $9Vlur.default) {
    static styles = [
        (0, $9Vlur.ataButtonStyles),
        (0, $hOpwk.css)`
            a,
            button {
                ---ataButton--backgroundColor: transparent;
                ---ataButton--foregroundColor: var(--ata--button--color);
                ---ataButton--borderColor: var(--ata--button--borderColor);
            }
        `
    ];
}
$0574eb0a3b5be724$export$2e2bcd8739ae039 = (0, $dGa5T.__decorate)([
    (0, $d92i1.customElement)("ata-stroked-button")
], $0574eb0a3b5be724$export$2e2bcd8739ae039);

});

parcelRegister("4c7YL", function(module, exports) {

var $dGa5T = parcelRequire("dGa5T");
parcelRequire("bFoC6");
var $d92i1 = parcelRequire("d92i1");
parcelRequire("MJPZu");
var $hOpwk = parcelRequire("hOpwk");

var $9Vlur = parcelRequire("9Vlur");
class $c6cdcf52e633a143$export$2e2bcd8739ae039 extends (0, $9Vlur.default) {
    static styles = [
        (0, $9Vlur.ataButtonStyles),
        (0, $hOpwk.css)`
            a,
            button {
                ---ataButton--backgroundColor: var(--ata--button--color);
                ---ataButton--foregroundColor: var(--ata--button--onColor);
                ---ataButton--borderColor: var(--ata--button--color);
            }
        `
    ];
}
$c6cdcf52e633a143$export$2e2bcd8739ae039 = (0, $dGa5T.__decorate)([
    (0, $d92i1.customElement)("ata-filled-button")
], $c6cdcf52e633a143$export$2e2bcd8739ae039);

});


parcelRegister("eziMm", function(module, exports) {

$parcel$export(module.exports, "default", () => $f16bb9a52138f890$export$2e2bcd8739ae039);
parcelRequire("MJPZu");
var $9UZF0 = parcelRequire("9UZF0");
parcelRequire("j1ycV");
function $f16bb9a52138f890$export$2e2bcd8739ae039(config) {
    const isDisabled = config.isDisabled === true;
    const isReadonly = config.onChange === undefined && config.debounce === undefined && !isDisabled;
    const onChange = config.onChange !== undefined ? (event)=>{
        config.onChange(event.target.value);
    } : ()=>{};
    const onDebouncedChange = config.debounce !== undefined ? (event)=>{
        config.debounce.onChange(event.target.value);
    } : ()=>{};
    return (0, $9UZF0.html)`<ata-number-input
        name="${config.name}"
        value="${config.value}"
        autocomplete="${config.autocomplete ?? "off"}"
        placeholder="${config.placeholder}"
        error-message="${config.errorMessage}"
        debounce-duration=${config.debounce?.duration}
        ?disabled="${isDisabled}"
        ?readonly="${isReadonly}"
        @input=${onChange}
        @blur=${onChange}
        @debouncedInput=${onDebouncedChange}
    ></ata-number-input>`;
}

});
parcelRegister("j1ycV", function(module, exports) {

var $dGa5T = parcelRequire("dGa5T");
parcelRequire("MJPZu");
var $9UZF0 = parcelRequire("9UZF0");
var $78EKQ = parcelRequire("78EKQ");
parcelRequire("bFoC6");
var $d92i1 = parcelRequire("d92i1");
var $4Kcgn = parcelRequire("4Kcgn");

var $TQ7d2 = parcelRequire("TQ7d2");

var $fZ8Ts = parcelRequire("fZ8Ts");
const $859e669cff6bbe76$var$VALUE = Symbol("VALUE");
class $859e669cff6bbe76$export$2e2bcd8739ae039 extends (0, $fZ8Ts.mixinDebouncedInput)((0, $TQ7d2.AtaInput)) {
    static formAssociated = true;
    static shadowRootOptions = {
        ...(0, $78EKQ.LitElement).shadowRootOptions,
        delegatesFocus: true
    };
    static styles = [
        (0, $TQ7d2.inputCss)
    ];
    disabled = false;
    readonly = false;
    required = false;
    step = 1;
    min = undefined;
    max = undefined;
    placeholder = "";
    errorMessage = "";
    autocomplete = "off";
    tabIndex = 0;
    [$859e669cff6bbe76$var$VALUE] = "";
    get value() {
        return this[$859e669cff6bbe76$var$VALUE];
    }
    set value(value) {
        this[$859e669cff6bbe76$var$VALUE] = value;
    }
    get valueAsNumber() {
        const value = Number(this.value);
        return isNaN(value) ? null : value;
    }
    set valueAsNumber(value) {
        this.value = String(value);
    }
    get name() {
        return this.getAttribute("name") ?? "";
    }
    set name(name) {
        this.setAttribute("name", name);
    }
    get form() {
        return this.internals.form;
    }
    get input() {
        return this.renderRoot.querySelector("input");
    }
    internals;
    constructor(){
        super();
        this.internals = this.attachInternals();
        this.internals.role = "textbox";
        this.addEventListener("focus", this.onFocusEvent.bind(this));
        this.addEventListener("blur", this.onBlurEvent.bind(this));
        this.addEventListener("keypress", this.onKeyPressEvent.bind(this));
    }
    attributeChangedCallback(name, oldValue, value) {
        if (name === "name") {
            this.requestUpdate("name", oldValue);
            return;
        }
        if (name === "error-message") {
            this.errorMessage = value ?? "";
            this.requestUpdate("errorMessage", oldValue);
            return;
        }
        super.attributeChangedCallback(name, oldValue, value);
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has("value")) this.internals.setFormValue(this.value, this.value);
        this.updateValidity();
    }
    formStateRestoreCallback(state) {
        this.value = state;
    }
    formDisabledCallback(disabled) {
        this.disabled = disabled;
    }
    formResetCallback() {
        this[$859e669cff6bbe76$var$VALUE] = "";
    }
    setCustomValidity(message) {
        const previousMessage = this.errorMessage;
        this.errorMessage = message;
        this.requestUpdate("errorMessage", previousMessage);
    }
    updateValidity() {
        if (!this.internals) return;
        const inputEl = this.input;
        if (!inputEl) return;
        this.internals.setValidity({
            badInput: inputEl.validity.badInput,
            customError: this.errorMessage !== "" || inputEl.validity.customError,
            patternMismatch: inputEl.validity.patternMismatch,
            rangeOverflow: inputEl.validity.rangeOverflow,
            rangeUnderflow: inputEl.validity.rangeUnderflow,
            stepMismatch: inputEl.validity.stepMismatch,
            tooLong: inputEl.validity.tooLong,
            tooShort: inputEl.validity.tooShort,
            typeMismatch: inputEl.validity.typeMismatch,
            valueMissing: inputEl.validity.valueMissing
        }, this.errorMessage || this.input.validationMessage, this.input);
    }
    onFocusEvent() {
        this.input?.focus();
    }
    onBlurEvent() {
        this.input?.blur();
    }
    onKeyPressEvent(event) {
        switch(event.key){
            case "Enter":
                this.internals.form?.requestSubmit();
                break;
        }
    }
    render() {
        return (0, $9UZF0.html)`
            <input
                type="number"
                ?disabled=${this.disabled}
                ?readonly=${this.readonly}
                ?required=${this.required}
                autocomplete=${this.autocomplete}
                ?min=${this.min}
                ?max=${this.max}
                step=${this.step}
                placeholder=${this.placeholder}
                .value="${this.value}"
                @input=${this.onInput}
            />
        `;
    }
    onInput(event) {
        const previousValue = this.value;
        this.value = event.target.value;
        this.requestUpdate("value", previousValue);
    }
}
(0, $dGa5T.__decorate)([
    (0, $4Kcgn.property)({
        type: Boolean,
        reflect: true
    })
], $859e669cff6bbe76$export$2e2bcd8739ae039.prototype, "disabled", void 0);
(0, $dGa5T.__decorate)([
    (0, $4Kcgn.property)({
        type: Boolean,
        reflect: true
    })
], $859e669cff6bbe76$export$2e2bcd8739ae039.prototype, "readonly", void 0);
(0, $dGa5T.__decorate)([
    (0, $4Kcgn.property)({
        type: Boolean,
        reflect: true
    })
], $859e669cff6bbe76$export$2e2bcd8739ae039.prototype, "required", void 0);
(0, $dGa5T.__decorate)([
    (0, $4Kcgn.property)({
        type: Number
    })
], $859e669cff6bbe76$export$2e2bcd8739ae039.prototype, "step", void 0);
(0, $dGa5T.__decorate)([
    (0, $4Kcgn.property)({
        type: Number
    })
], $859e669cff6bbe76$export$2e2bcd8739ae039.prototype, "min", void 0);
(0, $dGa5T.__decorate)([
    (0, $4Kcgn.property)({
        type: Number
    })
], $859e669cff6bbe76$export$2e2bcd8739ae039.prototype, "max", void 0);
(0, $dGa5T.__decorate)([
    (0, $4Kcgn.property)({
        type: String
    })
], $859e669cff6bbe76$export$2e2bcd8739ae039.prototype, "placeholder", void 0);
(0, $dGa5T.__decorate)([
    (0, $4Kcgn.property)({
        type: String,
        attribute: "error-message",
        noAccessor: true
    })
], $859e669cff6bbe76$export$2e2bcd8739ae039.prototype, "errorMessage", void 0);
(0, $dGa5T.__decorate)([
    (0, $4Kcgn.property)({
        type: String
    })
], $859e669cff6bbe76$export$2e2bcd8739ae039.prototype, "autocomplete", void 0);
(0, $dGa5T.__decorate)([
    (0, $4Kcgn.property)({
        type: Number,
        reflect: true,
        attribute: "tabindex"
    })
], $859e669cff6bbe76$export$2e2bcd8739ae039.prototype, "tabIndex", void 0);
(0, $dGa5T.__decorate)([
    (0, $4Kcgn.property)({
        type: String
    })
], $859e669cff6bbe76$export$2e2bcd8739ae039.prototype, "value", null);
(0, $dGa5T.__decorate)([
    (0, $4Kcgn.property)({
        type: Number,
        attribute: undefined
    })
], $859e669cff6bbe76$export$2e2bcd8739ae039.prototype, "valueAsNumber", null);
(0, $dGa5T.__decorate)([
    (0, $4Kcgn.property)({
        type: String,
        noAccessor: true
    })
], $859e669cff6bbe76$export$2e2bcd8739ae039.prototype, "name", null);
$859e669cff6bbe76$export$2e2bcd8739ae039 = (0, $dGa5T.__decorate)([
    (0, $d92i1.customElement)("ata-number-input")
], $859e669cff6bbe76$export$2e2bcd8739ae039);

});
parcelRegister("TQ7d2", function(module, exports) {

$parcel$export(module.exports, "AtaInput", () => $e2269a37f3e9ba1b$export$ab36753eed0ef0);
$parcel$export(module.exports, "inputCss", () => $e2269a37f3e9ba1b$export$a74b3567ba3d397a);
$parcel$export(module.exports, "inputArrowCss", () => $e2269a37f3e9ba1b$export$678557f2a5a358ee);
parcelRequire("MJPZu");
var $hOpwk = parcelRequire("hOpwk");
var $78EKQ = parcelRequire("78EKQ");
class $e2269a37f3e9ba1b$export$ab36753eed0ef0 extends (0, $78EKQ.LitElement) {
}
const $e2269a37f3e9ba1b$export$a74b3567ba3d397a = (0, $hOpwk.css)`
    :is(input, select, textarea, button) {
        inline-size: 100%;
        block-size: 100%;
        box-sizing: border-box;
        padding: 0 1rem;
        min-block-size: var(--ata--input--blockSize);
        border-radius: var(--ata--input--borderRadius);
        border: 1px solid var(--ata--input--borderColor);
        background: var(--ata--input--backgroundColor);
        color: var(--ata--input--foregroundColor);
        fill: var(--ata--input--foregroundColor);
        transition: outline-color var(--motion--duration--short) linear;
        outline: 1px solid transparent;
        font-family: inherit;
        font-size: inherit;
        text-overflow: ellipsis;
    }

    textarea {
        padding: 1rem;
    }

    :is(input, select, textarea, button):is(:hover, :focus) {
        outline: 1px solid var(--color--neutral-3);
    }

    :is(input, select, textarea, button):is(
            [readonly],
            [aria-readonly='true'],
            :disabled
        ) {
        cursor: default;
        outline: 1px solid transparent;
    }

    :is(input, select, textarea, button):disabled {
        cursor: not-allowed;
        color: #aaa;
        background-color: #eee;
    }

    :is(input, select, textarea, button):has(~ .arrow) {
        padding-inline-end: 3rem;
    }
`;
const $e2269a37f3e9ba1b$export$678557f2a5a358ee = (0, $hOpwk.css)`
    :host {
        position: relative;
    }

    .arrow {
        position: absolute;
        right: 1rem;
        block-size: 2rem;
        aspect-ratio: 1;
        top: 50%;
        translate: 0 -50%;
        pointer-events: none;
    }

    [popover]:popover-open ~ .arrow,
    .arrow:has(~ [popover]:popover-open) {
        rotate: -180deg;
    }

    :host(:is(:disabled, [readonly])) .arrow {
        opacity: 0;
    }
`;

});

parcelRegister("fZ8Ts", function(module, exports) {

$parcel$export(module.exports, "mixinDebouncedInput", () => $9373748d83cbd624$export$b7b7d5d0280c1346);

var $dGa5T = parcelRequire("dGa5T");
parcelRequire("bFoC6");
var $4Kcgn = parcelRequire("4Kcgn");
function $9373748d83cbd624$export$b7b7d5d0280c1346(base) {
    class WithDebouncedInputElement extends base {
        debounceDuration = 0;
        #debounceTimeoutId = 0;
        connectedCallback() {
            super.connectedCallback();
            this.addEventListener("input", this.onInputForDebounce.bind(this));
        }
        disconnectedCallback() {
            this.removeEventListener("input", this.onInputForDebounce.bind(this));
            super.disconnectedCallback();
        }
        onInputForDebounce(event) {
            if (!(event instanceof InputEvent)) return;
            clearTimeout(this.#debounceTimeoutId);
            this.#debounceTimeoutId = setTimeout(()=>{
                this.dispatchEvent(new CustomEvent("debouncedInput", event));
            }, this.debounceDuration);
        }
    }
    (0, $dGa5T.__decorate)([
        (0, $4Kcgn.property)({
            type: Number,
            attribute: "debounce-duration"
        })
    ], WithDebouncedInputElement.prototype, "debounceDuration", void 0);
    return WithDebouncedInputElement;
}

});



parcelRegister("80ixM", function(module, exports) {

$parcel$export(module.exports, "bigHeading", () => $d1ab6aa95c59d8fc$export$7896487bcf2600a);
$parcel$export(module.exports, "mediumHeading", () => $d1ab6aa95c59d8fc$export$de5ce002c4d3829a);
$parcel$export(module.exports, "smallHeading", () => $d1ab6aa95c59d8fc$export$51b0d7d7ffb46db2);
parcelRequire("9TU71");
parcelRequire("9zfjy");
parcelRequire("1itKR");
parcelRequire("MJPZu");
var $9UZF0 = parcelRequire("9UZF0");
function $d1ab6aa95c59d8fc$export$7896487bcf2600a(content) {
    return (0, $9UZF0.html)`<ata-big-heading>${content}</ata-big-heading>`;
}
function $d1ab6aa95c59d8fc$export$de5ce002c4d3829a(content) {
    return (0, $9UZF0.html)`<ata-medium-heading>${content}</ata-medium-heading>`;
}
function $d1ab6aa95c59d8fc$export$51b0d7d7ffb46db2(content) {
    return (0, $9UZF0.html)`<ata-small-heading>${content}</ata-small-heading>`;
}

});
parcelRegister("9TU71", function(module, exports) {

var $dGa5T = parcelRequire("dGa5T");
parcelRequire("bFoC6");
var $d92i1 = parcelRequire("d92i1");
parcelRequire("MJPZu");
var $hOpwk = parcelRequire("hOpwk");
var $9UZF0 = parcelRequire("9UZF0");
var $78EKQ = parcelRequire("78EKQ");
class $69dd69336a644af7$export$2e2bcd8739ae039 extends (0, $78EKQ.LitElement) {
    static styles = (0, $hOpwk.css)`
        :host {
            font-size: 1.5em;
            line-height: 1.5em;
            margin: 0;
        }
    `;
    render() {
        return (0, $9UZF0.html)`<slot></slot>`;
    }
}
$69dd69336a644af7$export$2e2bcd8739ae039 = (0, $dGa5T.__decorate)([
    (0, $d92i1.customElement)("ata-big-heading")
], $69dd69336a644af7$export$2e2bcd8739ae039);

});

parcelRegister("9zfjy", function(module, exports) {

var $dGa5T = parcelRequire("dGa5T");
parcelRequire("bFoC6");
var $d92i1 = parcelRequire("d92i1");
parcelRequire("MJPZu");
var $hOpwk = parcelRequire("hOpwk");
var $9UZF0 = parcelRequire("9UZF0");
var $78EKQ = parcelRequire("78EKQ");
class $b587e33d23ad0f89$export$2e2bcd8739ae039 extends (0, $78EKQ.LitElement) {
    static styles = (0, $hOpwk.css)`
        :host {
            font-size: 1.25em;
            line-height: 1.25em;
            margin: 0;
        }
    `;
    render() {
        return (0, $9UZF0.html)`<slot></slot>`;
    }
}
$b587e33d23ad0f89$export$2e2bcd8739ae039 = (0, $dGa5T.__decorate)([
    (0, $d92i1.customElement)("ata-medium-heading")
], $b587e33d23ad0f89$export$2e2bcd8739ae039);

});

parcelRegister("1itKR", function(module, exports) {

var $dGa5T = parcelRequire("dGa5T");
parcelRequire("bFoC6");
var $d92i1 = parcelRequire("d92i1");
parcelRequire("MJPZu");
var $hOpwk = parcelRequire("hOpwk");
var $9UZF0 = parcelRequire("9UZF0");
var $78EKQ = parcelRequire("78EKQ");
class $cc56652cde0f6cc3$export$2e2bcd8739ae039 extends (0, $78EKQ.LitElement) {
    static styles = (0, $hOpwk.css)`
        :host {
            font-size: 1em;
            line-height: 1.1em;
            letter-spacing: 1px;
            margin: 0;
            text-transform: uppercase;
            font-weight: bold;
        }
    `;
    render() {
        return (0, $9UZF0.html)`<slot></slot>`;
    }
}
$cc56652cde0f6cc3$export$2e2bcd8739ae039 = (0, $dGa5T.__decorate)([
    (0, $d92i1.customElement)("ata-small-heading")
], $cc56652cde0f6cc3$export$2e2bcd8739ae039);

});


parcelRegister("hsSvT", function(module, exports) {

var $dGa5T = parcelRequire("dGa5T");
parcelRequire("MJPZu");
var $hOpwk = parcelRequire("hOpwk");
var $9UZF0 = parcelRequire("9UZF0");
var $78EKQ = parcelRequire("78EKQ");
parcelRequire("bFoC6");
var $d92i1 = parcelRequire("d92i1");
var $4Kcgn = parcelRequire("4Kcgn");

var $TQ7d2 = parcelRequire("TQ7d2");

var $fZ8Ts = parcelRequire("fZ8Ts");
const $52625f40eeb1a02f$var$VALUE = Symbol("VALUE");
class $52625f40eeb1a02f$export$2e2bcd8739ae039 extends (0, $fZ8Ts.mixinDebouncedInput)((0, $TQ7d2.AtaInput)) {
    static formAssociated = true;
    static shadowRootOptions = {
        ...(0, $78EKQ.LitElement).shadowRootOptions,
        delegatesFocus: true
    };
    static styles = [
        (0, $TQ7d2.inputCss),
        (0, $hOpwk.css)`
            textarea {
                resize: vertical;
            }
        `
    ];
    multiLine = false;
    disabled = false;
    readonly = false;
    required = false;
    minLength = undefined;
    maxLength = undefined;
    placeholder = "";
    errorMessage = "";
    autocomplete = "off";
    tabIndex = 0;
    [$52625f40eeb1a02f$var$VALUE] = "";
    get value() {
        return this[$52625f40eeb1a02f$var$VALUE];
    }
    set value(value) {
        this[$52625f40eeb1a02f$var$VALUE] = value;
    }
    get name() {
        return this.getAttribute("name") ?? "";
    }
    set name(name) {
        this.setAttribute("name", name);
    }
    get form() {
        return this.internals.form;
    }
    get input() {
        return this.renderRoot.querySelector("input, textarea");
    }
    internals;
    constructor(){
        super();
        this.internals = this.attachInternals();
        this.internals.role = "textbox";
        this.addEventListener("focus", this.onFocusEvent.bind(this));
        this.addEventListener("blur", this.onBlurEvent.bind(this));
        this.addEventListener("keypress", this.onKeyPressEvent.bind(this));
    }
    attributeChangedCallback(name, oldValue, value) {
        if (name === "name") {
            this.requestUpdate("name", oldValue);
            return;
        }
        if (name === "error-message") {
            this.errorMessage = value ?? "";
            this.requestUpdate("errorMessage", oldValue);
            return;
        }
        super.attributeChangedCallback(name, oldValue, value);
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has("value")) this.internals.setFormValue(this.value, this.value);
        this.updateValidity();
    }
    formStateRestoreCallback(state) {
        this.value = state;
    }
    formDisabledCallback(disabled) {
        this.disabled = disabled;
    }
    formResetCallback() {
        this.value = "";
    }
    setCustomValidity(message) {
        const previousMessage = this.errorMessage;
        this.errorMessage = message;
        this.requestUpdate("errorMessage", previousMessage);
    }
    updateValidity() {
        if (!this.internals) return;
        const inputEl = this.input;
        if (!inputEl) return;
        this.internals.setValidity({
            badInput: inputEl.validity.badInput,
            customError: this.errorMessage !== "" || inputEl.validity.customError,
            patternMismatch: inputEl.validity.patternMismatch,
            rangeOverflow: inputEl.validity.rangeOverflow,
            rangeUnderflow: inputEl.validity.rangeUnderflow,
            stepMismatch: inputEl.validity.stepMismatch,
            tooLong: inputEl.validity.tooLong,
            tooShort: inputEl.validity.tooShort,
            typeMismatch: inputEl.validity.typeMismatch,
            valueMissing: inputEl.validity.valueMissing
        }, this.errorMessage || this.input.validationMessage, this.input);
    }
    onFocusEvent() {
        this.input?.focus();
    }
    onBlurEvent() {
        this.input?.blur();
    }
    onKeyPressEvent(event) {
        switch(event.key){
            case "Enter":
                this.internals.form?.requestSubmit();
                break;
        }
    }
    render() {
        return this.multiLine ? this.renderTextarea() : this.renderInput();
    }
    renderInput() {
        return (0, $9UZF0.html)`
            <input
                part="input"
                type="text"
                ?disabled=${this.disabled}
                ?readonly=${this.readonly}
                ?required=${this.required}
                autocomplete=${this.autocomplete}
                ?minlength=${this.minLength}
                ?maxlength=${this.maxLength}
                placeholder=${this.placeholder}
                .value="${this.value}"
                @input=${this.onInput}
            />
        `;
    }
    renderTextarea() {
        return (0, $9UZF0.html)`
            <textarea
                part="input"
                ?disabled=${this.disabled}
                ?readonly=${this.readonly}
                ?required=${this.required}
                autocomplete=${this.autocomplete}
                ?minlength=${this.minLength}
                ?maxlength=${this.maxLength}
                placeholder=${this.placeholder}
                .value="${this.value}"
                @input=${this.onInput}
            ></textarea>
        `;
    }
    onInput(event) {
        const previousValue = this.value;
        this.value = event.target.value;
        this.requestUpdate("value", previousValue);
    }
}
(0, $dGa5T.__decorate)([
    (0, $4Kcgn.property)({
        type: Boolean,
        attribute: "multiline"
    })
], $52625f40eeb1a02f$export$2e2bcd8739ae039.prototype, "multiLine", void 0);
(0, $dGa5T.__decorate)([
    (0, $4Kcgn.property)({
        type: Boolean,
        reflect: true
    })
], $52625f40eeb1a02f$export$2e2bcd8739ae039.prototype, "disabled", void 0);
(0, $dGa5T.__decorate)([
    (0, $4Kcgn.property)({
        type: Boolean,
        reflect: true
    })
], $52625f40eeb1a02f$export$2e2bcd8739ae039.prototype, "readonly", void 0);
(0, $dGa5T.__decorate)([
    (0, $4Kcgn.property)({
        type: Boolean,
        reflect: true
    })
], $52625f40eeb1a02f$export$2e2bcd8739ae039.prototype, "required", void 0);
(0, $dGa5T.__decorate)([
    (0, $4Kcgn.property)({
        type: Number
    })
], $52625f40eeb1a02f$export$2e2bcd8739ae039.prototype, "minLength", void 0);
(0, $dGa5T.__decorate)([
    (0, $4Kcgn.property)({
        type: Number
    })
], $52625f40eeb1a02f$export$2e2bcd8739ae039.prototype, "maxLength", void 0);
(0, $dGa5T.__decorate)([
    (0, $4Kcgn.property)({
        type: String
    })
], $52625f40eeb1a02f$export$2e2bcd8739ae039.prototype, "placeholder", void 0);
(0, $dGa5T.__decorate)([
    (0, $4Kcgn.property)({
        type: String,
        attribute: "error-message",
        noAccessor: true
    })
], $52625f40eeb1a02f$export$2e2bcd8739ae039.prototype, "errorMessage", void 0);
(0, $dGa5T.__decorate)([
    (0, $4Kcgn.property)({
        type: String
    })
], $52625f40eeb1a02f$export$2e2bcd8739ae039.prototype, "autocomplete", void 0);
(0, $dGa5T.__decorate)([
    (0, $4Kcgn.property)({
        type: Number,
        reflect: true,
        attribute: "tabindex"
    })
], $52625f40eeb1a02f$export$2e2bcd8739ae039.prototype, "tabIndex", void 0);
(0, $dGa5T.__decorate)([
    (0, $4Kcgn.property)({
        type: String
    })
], $52625f40eeb1a02f$export$2e2bcd8739ae039.prototype, "value", null);
(0, $dGa5T.__decorate)([
    (0, $4Kcgn.property)({
        type: String,
        noAccessor: true
    })
], $52625f40eeb1a02f$export$2e2bcd8739ae039.prototype, "name", null);
$52625f40eeb1a02f$export$2e2bcd8739ae039 = (0, $dGa5T.__decorate)([
    (0, $d92i1.customElement)("ata-text-input")
], $52625f40eeb1a02f$export$2e2bcd8739ae039);

});

parcelRegister("5IE5z", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff338057b4ddf91c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "toName", () => $ff338057b4ddf91c$export$aa4004ea78d69481);
$parcel$export(module.exports, "toSummary", () => $ff338057b4ddf91c$export$49bbceafad3380f5);
$parcel$export(module.exports, "toTaxationSummary", () => $ff338057b4ddf91c$export$81aa464756a7e2f5);
$parcel$export(module.exports, "toShortName", () => $ff338057b4ddf91c$export$fcc5bb54a09bc58d);
var $ff338057b4ddf91c$export$2e2bcd8739ae039 = {
    toName: $ff338057b4ddf91c$export$aa4004ea78d69481,
    toSummary: $ff338057b4ddf91c$export$49bbceafad3380f5,
    toTaxationSummary: $ff338057b4ddf91c$export$81aa464756a7e2f5
};
function $ff338057b4ddf91c$export$fcc5bb54a09bc58d(vehicle) {
    return [
        vehicle.make.humanvalue,
        vehicle.model.humanvalue
    ].join(" ");
}
function $ff338057b4ddf91c$export$aa4004ea78d69481(vehicle) {
    return [
        vehicle.make.humanvalue,
        vehicle.model.humanvalue,
        vehicle.trimpackage.humanvalue
    ].join(" ");
}
function $ff338057b4ddf91c$export$49bbceafad3380f5(vehicle) {
    return [
        vehicle.licenseplate?.humanvalue,
        vehicle.mileage?.humanvalue,
        [
            vehicle.manufacture.month?.humanvalue,
            vehicle.manufacture.year?.humanvalue
        ].join(" ")
    ].filter((x)=>x !== undefined).join(" \u2022 ");
}
function $ff338057b4ddf91c$export$81aa464756a7e2f5(vehicle) {
    return [
        vehicle.licenseplate?.humanvalue,
        vehicle.mileage?.humanvalue
    ].filter((x)=>x !== undefined).join(" \u2022 ");
}

});

parcelRegister("aY56T", function(module, exports) {

$parcel$export(module.exports, "create", () => $3ced43c3e8e9e459$export$185802fd694ee1f5);
$parcel$export(module.exports, "setName", () => $3ced43c3e8e9e459$export$6cf3d710d3a367e5);
$parcel$export(module.exports, "addCluster", () => $3ced43c3e8e9e459$export$8db39ba11dc04681);
$parcel$export(module.exports, "updateCluster", () => $3ced43c3e8e9e459$export$9f1cde0b985eeb43);
$parcel$export(module.exports, "removeCluster", () => $3ced43c3e8e9e459$export$43dfc67f4ef337dd);
$parcel$export(module.exports, "setClusterName", () => $3ced43c3e8e9e459$export$13a9756569e32323);
$parcel$export(module.exports, "addDealerToCluster", () => $3ced43c3e8e9e459$export$2c68ebc2bd2835b4);
$parcel$export(module.exports, "removeDealerFromCluster", () => $3ced43c3e8e9e459$export$e2379b61256889d3);
$parcel$export(module.exports, "getAllDealers", () => $3ced43c3e8e9e459$export$be09cc4e17584f8d);
function $3ced43c3e8e9e459$export$185802fd694ee1f5() {
    return {
        name: "",
        clusters: [
            $3ced43c3e8e9e459$var$createCluster()
        ]
    };
}
function $3ced43c3e8e9e459$var$createCluster() {
    return {
        name: "",
        dealers: []
    };
}
function $3ced43c3e8e9e459$export$6cf3d710d3a367e5(scenario, title) {
    const nextScenario = structuredClone(scenario);
    nextScenario["name"] = title;
    return nextScenario;
}
function $3ced43c3e8e9e459$export$8db39ba11dc04681(scenario) {
    const nextScenario = structuredClone(scenario);
    nextScenario["clusters"].push($3ced43c3e8e9e459$var$createCluster());
    return nextScenario;
}
function $3ced43c3e8e9e459$export$9f1cde0b985eeb43(scenario, index, fn) {
    const nextScenario = structuredClone(scenario);
    if (index in nextScenario.clusters) nextScenario.clusters[index] = fn(nextScenario.clusters[index]);
    return nextScenario;
}
function $3ced43c3e8e9e459$export$43dfc67f4ef337dd(scenario, index) {
    const nextScenario = structuredClone(scenario);
    if (index in nextScenario.clusters) nextScenario.clusters.splice(index, 1);
    return nextScenario;
}
function $3ced43c3e8e9e459$export$13a9756569e32323(cluster, name) {
    const nextCluster = structuredClone(cluster);
    nextCluster.name = name;
    return nextCluster;
}
function $3ced43c3e8e9e459$export$2c68ebc2bd2835b4(cluster, dealerId) {
    const nextCluster = structuredClone(cluster);
    nextCluster.dealers.push(dealerId);
    return nextCluster;
}
function $3ced43c3e8e9e459$export$e2379b61256889d3(cluster, dealerId) {
    const nextCluster = structuredClone(cluster);
    nextCluster.dealers = nextCluster.dealers.filter((id)=>id !== dealerId);
    return nextCluster;
}
function $3ced43c3e8e9e459$export$be09cc4e17584f8d(scenario) {
    return scenario.clusters.flatMap((cluster)=>cluster.dealers);
}

});

parcelRegister("5yZNA", function(module, exports) {

$parcel$export(module.exports, "create", () => $96f1922c9acef0d0$export$185802fd694ee1f5);
function $96f1922c9acef0d0$export$185802fd694ee1f5() {
    return {
        name: "",
        dealers: []
    };
}
function $96f1922c9acef0d0$export$6cf3d710d3a367e5(profile, name) {
    const nextProfile = structuredClone(profile);
    nextProfile["name"] = name;
    return nextProfile;
}
function $96f1922c9acef0d0$export$7d45f75284daebea(profile, dealer) {
    const nextProfile = structuredClone(profile);
    nextProfile["dealers"].push(dealer);
    return nextProfile;
}
function $96f1922c9acef0d0$export$e5a6b3d8c9fc9ac2(profile, dealer) {
    const nextProfile = structuredClone(profile);
    nextProfile.dealers = nextProfile.dealers.filter((theDealer)=>theDealer.id === dealer.id);
    return nextProfile;
}

});

parcelRegister("210eY", function(module, exports) {

$parcel$export(module.exports, "toForm", () => $222a54f5183d2354$export$fe0bd842ca892f4d);
$parcel$export(module.exports, "fromForm", () => $222a54f5183d2354$export$3f9ea17eb94ede0a);
function $222a54f5183d2354$export$fe0bd842ca892f4d(original, changes) {
    return {
        ...$222a54f5183d2354$var$fromOriginal(original),
        ...changes
    };
}
function $222a54f5183d2354$export$3f9ea17eb94ede0a(form) {
    return {
        excludedvehicleids: Array.from(form.excludedvehicleids.values()),
        mileagemax: form.mileagemax === "" ? null : Number(form.mileagemax),
        mileagemin: form.mileagemin === "" ? null : Number(form.mileagemin),
        reachfiltered: form.reachfiltered,
        vehicleimported: form.vehicleimported,
        vehiclenew: form.vehiclenew,
        vehiclenotimported: form.vehiclenotimported
    };
}
function $222a54f5183d2354$var$fromOriginal(original) {
    return {
        excludedvehicleids: new Set(original.excludedvehicleids),
        mileagemax: original.mileagemax ? String(original.mileagemax) : "",
        mileagemin: original.mileagemin ? String(original.mileagemin) : "",
        reachfiltered: original.reachfiltered,
        vehicleimported: original.vehicleimported,
        vehiclenew: original.vehiclenew,
        vehiclenotimported: original.vehiclenotimported
    };
}

});

parcelRegister("gUdlQ", function(module, exports) {

$parcel$export(module.exports, "init", () => $f94fc72eaa69b990$export$2cd8252107eb640b);
$parcel$export(module.exports, "hasChanges", () => $f94fc72eaa69b990$export$8c5c7c88e6e06c0e);
$parcel$export(module.exports, "add", () => $f94fc72eaa69b990$export$e16d8520af44a096);
$parcel$export(module.exports, "remove", () => $f94fc72eaa69b990$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "applyTo", () => $f94fc72eaa69b990$export$dd72867b1231e7f9);
function $f94fc72eaa69b990$export$2cd8252107eb640b() {
    return {
        additions: new Map(),
        deletions: new Map()
    };
}
function $f94fc72eaa69b990$export$8c5c7c88e6e06c0e(changes) {
    return changes.additions.size > 0 || changes.deletions.size > 0;
}
function $f94fc72eaa69b990$export$e16d8520af44a096(changes, toHash, item) {
    const nextChanges = structuredClone(changes);
    const hash = toHash(item);
    nextChanges.additions.set(hash, item);
    nextChanges.deletions.delete(hash);
    return nextChanges;
}
function $f94fc72eaa69b990$export$cd7f480d6b8286c3(changes, toHash, item) {
    const nextChanges = structuredClone(changes);
    const hash = toHash(item);
    nextChanges.deletions.set(hash, item);
    nextChanges.additions.delete(hash);
    return nextChanges;
}
function $f94fc72eaa69b990$export$dd72867b1231e7f9(list, toHash, changes) {
    const listHashes = list.map(toHash);
    const deletionHashes = Array.from(changes.deletions.keys());
    const nextList = list.filter((item)=>!deletionHashes.includes(toHash(item)));
    changes.additions.forEach((item)=>{
        if (!listHashes.includes(toHash(item))) nextList.push(item);
    });
    return nextList;
}

});

parcelRegister("ls5dD", function(module, exports) {

$parcel$export(module.exports, "toISODateString", () => $bf4bbd44ccae7a93$export$c0335d436cc2228b);
$parcel$export(module.exports, "yesterday", () => $bf4bbd44ccae7a93$export$b251037d0939765d);
$parcel$export(module.exports, "hasOverlappingRange", () => $bf4bbd44ccae7a93$export$d5d1715f5bfd8732);
$parcel$export(module.exports, "clampEndDate", () => $bf4bbd44ccae7a93$export$80ea4af602ceba11);
$parcel$export(module.exports, "thisWeek", () => $bf4bbd44ccae7a93$export$3b6878065a4a08e8);
$parcel$export(module.exports, "lastWeek", () => $bf4bbd44ccae7a93$export$2a75184383374920);
$parcel$export(module.exports, "last7Days", () => $bf4bbd44ccae7a93$export$817a223dda4e7620);
$parcel$export(module.exports, "thisMonth", () => $bf4bbd44ccae7a93$export$e6026af96c763fd7);
$parcel$export(module.exports, "lastMonth", () => $bf4bbd44ccae7a93$export$f2ca499a9c94f6c3);
$parcel$export(module.exports, "last30Days", () => $bf4bbd44ccae7a93$export$f639d176566284cd);
$parcel$export(module.exports, "thisQuarter", () => $bf4bbd44ccae7a93$export$3a92df77a756c497);
$parcel$export(module.exports, "lastQuarter", () => $bf4bbd44ccae7a93$export$7c2670f7accfd8ec);
$parcel$export(module.exports, "last90Days", () => $bf4bbd44ccae7a93$export$5b6a8a3e487f89f8);
$parcel$export(module.exports, "thisYear", () => $bf4bbd44ccae7a93$export$e4d391170489133b);
$parcel$export(module.exports, "lastYear", () => $bf4bbd44ccae7a93$export$99abb60bf66c0e13);
$parcel$export(module.exports, "last365Days", () => $bf4bbd44ccae7a93$export$6e8f7660978c9d92);

var $g0oow = parcelRequire("g0oow");
var $9SWF2 = parcelRequire("9SWF2");
var $7eaJs = parcelRequire("7eaJs");
var $7NJnK = parcelRequire("7NJnK");
var $66FNB = parcelRequire("66FNB");
var $fJ1ra = parcelRequire("fJ1ra");
var $g8yRt = parcelRequire("g8yRt");
var $3EsOc = parcelRequire("3EsOc");
var $6zPBd = parcelRequire("6zPBd");
var $d2D14 = parcelRequire("d2D14");
var $HfHA2 = parcelRequire("HfHA2");
var $dZ7b9 = parcelRequire("dZ7b9");
var $6vyOy = parcelRequire("6vyOy");
var $k0h9F = parcelRequire("k0h9F");
function $bf4bbd44ccae7a93$export$c0335d436cc2228b(date) {
    return (0, $66FNB.formatISO)(date, {
        representation: "date"
    });
}
const $bf4bbd44ccae7a93$export$b251037d0939765d = (currentDate)=>(0, $d2D14.subDays)(currentDate, 1);
const $bf4bbd44ccae7a93$var$weekStartsOnMonday = {
    weekStartsOn: 1
};
function $bf4bbd44ccae7a93$export$d5d1715f5bfd8732(range1, range2) {
    const [start1, end1] = range1;
    const [start2, end2] = range2;
    return start1 <= end2 && start2 <= end1;
}
function $bf4bbd44ccae7a93$export$80ea4af602ceba11(range, maxDate) {
    const [startDate, endDate] = range;
    if (endDate > maxDate) return [
        startDate,
        maxDate
    ];
    return range;
}
const $bf4bbd44ccae7a93$export$3b6878065a4a08e8 = (currentDate)=>{
    const startDate = (0, $3EsOc.startOfWeek)(currentDate, $bf4bbd44ccae7a93$var$weekStartsOnMonday);
    const endDate = (0, $7eaJs.endOfWeek)(currentDate, $bf4bbd44ccae7a93$var$weekStartsOnMonday);
    return [
        startDate,
        endDate
    ];
};
const $bf4bbd44ccae7a93$export$2a75184383374920 = (currentDate)=>{
    const startDate = (0, $3EsOc.startOfWeek)((0, $6vyOy.subWeeks)(currentDate, 1), $bf4bbd44ccae7a93$var$weekStartsOnMonday);
    const endDate = (0, $7eaJs.endOfWeek)((0, $6vyOy.subWeeks)(currentDate, 1), $bf4bbd44ccae7a93$var$weekStartsOnMonday);
    return [
        startDate,
        endDate
    ];
};
const $bf4bbd44ccae7a93$export$817a223dda4e7620 = (currentDate)=>{
    const startDate = (0, $d2D14.subDays)(currentDate, 6);
    const endDate = currentDate;
    return [
        startDate,
        endDate
    ];
};
const $bf4bbd44ccae7a93$export$e6026af96c763fd7 = (currentDate)=>{
    const startDate = (0, $fJ1ra.startOfMonth)(currentDate);
    const endDate = (0, $g0oow.endOfMonth)(currentDate);
    return [
        startDate,
        endDate
    ];
};
const $bf4bbd44ccae7a93$export$f2ca499a9c94f6c3 = (currentDate)=>{
    const startDate = (0, $fJ1ra.startOfMonth)((0, $HfHA2.subMonths)(currentDate, 1));
    const endDate = (0, $g0oow.endOfMonth)((0, $HfHA2.subMonths)(currentDate, 1));
    return [
        startDate,
        endDate
    ];
};
const $bf4bbd44ccae7a93$export$f639d176566284cd = (currentDate)=>{
    const startDate = (0, $d2D14.subDays)(currentDate, 29);
    const endDate = currentDate;
    return [
        startDate,
        endDate
    ];
};
const $bf4bbd44ccae7a93$export$3a92df77a756c497 = (currentDate)=>{
    const startDate = (0, $g8yRt.startOfQuarter)(currentDate);
    const endDate = (0, $9SWF2.endOfQuarter)(currentDate);
    return [
        startDate,
        endDate
    ];
};
const $bf4bbd44ccae7a93$export$7c2670f7accfd8ec = (currentDate)=>{
    const startDate = (0, $g8yRt.startOfQuarter)((0, $dZ7b9.subQuarters)(currentDate, 1));
    const endDate = (0, $9SWF2.endOfQuarter)((0, $dZ7b9.subQuarters)(currentDate, 1));
    return [
        startDate,
        endDate
    ];
};
const $bf4bbd44ccae7a93$export$5b6a8a3e487f89f8 = (currentDate)=>{
    const startDate = (0, $d2D14.subDays)(currentDate, 89);
    const endDate = currentDate;
    return [
        startDate,
        endDate
    ];
};
const $bf4bbd44ccae7a93$export$e4d391170489133b = (currentDate)=>{
    const startDate = (0, $6zPBd.startOfYear)(currentDate);
    const endDate = (0, $7NJnK.endOfYear)(currentDate);
    return [
        startDate,
        endDate
    ];
};
const $bf4bbd44ccae7a93$export$99abb60bf66c0e13 = (currentDate)=>{
    const startDate = (0, $6zPBd.startOfYear)((0, $k0h9F.subYears)(currentDate, 1));
    const endDate = (0, $7NJnK.endOfYear)((0, $k0h9F.subYears)(currentDate, 1));
    return [
        startDate,
        endDate
    ];
};
const $bf4bbd44ccae7a93$export$6e8f7660978c9d92 = (currentDate)=>{
    const startDate = (0, $d2D14.subDays)(currentDate, 364);
    const endDate = currentDate;
    return [
        startDate,
        endDate
    ];
};

});
parcelRegister("g0oow", function(module, exports) {

$parcel$export(module.exports, "endOfMonth", () => $84ca9198102a25b8$export$a2258d9c4118825c);

var $a2Z2s = parcelRequire("a2Z2s");
function $84ca9198102a25b8$export$a2258d9c4118825c(date) {
    const _date = (0, $a2Z2s.toDate)(date);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$84ca9198102a25b8$export$2e2bcd8739ae039 = $84ca9198102a25b8$export$a2258d9c4118825c;

});
parcelRegister("a2Z2s", function(module, exports) {

$parcel$export(module.exports, "toDate", () => $8874ecf588d83cc9$export$e67a095c620b86fe);
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $8874ecf588d83cc9$export$e67a095c620b86fe(argument) {
    const argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new argument.constructor(+argument);
    else if (typeof argument === "number" || argStr === "[object Number]" || typeof argument === "string" || argStr === "[object String]") // TODO: Can we get rid of as?
    return new Date(argument);
    else // TODO: Can we get rid of as?
    return new Date(NaN);
}
var // Fallback for modularized imports:
$8874ecf588d83cc9$export$2e2bcd8739ae039 = $8874ecf588d83cc9$export$e67a095c620b86fe;

});


parcelRegister("9SWF2", function(module, exports) {

$parcel$export(module.exports, "endOfQuarter", () => $ad0007cd80836a81$export$5f53493861eef879);

var $a2Z2s = parcelRequire("a2Z2s");
function $ad0007cd80836a81$export$5f53493861eef879(date) {
    const _date = (0, $a2Z2s.toDate)(date);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3 + 3;
    _date.setMonth(month, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$ad0007cd80836a81$export$2e2bcd8739ae039 = $ad0007cd80836a81$export$5f53493861eef879;

});

parcelRegister("7eaJs", function(module, exports) {

$parcel$export(module.exports, "endOfWeek", () => $bf27da01a0326ed8$export$ef8b6d9133084f4e);

var $a2Z2s = parcelRequire("a2Z2s");

var $jWfkp = parcelRequire("jWfkp");
function $bf27da01a0326ed8$export$ef8b6d9133084f4e(date, options) {
    const defaultOptions = (0, $jWfkp.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $a2Z2s.toDate)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setDate(_date.getDate() + diff);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$bf27da01a0326ed8$export$2e2bcd8739ae039 = $bf27da01a0326ed8$export$ef8b6d9133084f4e;

});
parcelRegister("jWfkp", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", () => $bbeae459ccb92d69$export$430a3269e24b912e);
let $bbeae459ccb92d69$var$defaultOptions = {};
function $bbeae459ccb92d69$export$430a3269e24b912e() {
    return $bbeae459ccb92d69$var$defaultOptions;
}
function $bbeae459ccb92d69$export$95365be1b0704abc(newOptions) {
    $bbeae459ccb92d69$var$defaultOptions = newOptions;
}

});


parcelRegister("7NJnK", function(module, exports) {

$parcel$export(module.exports, "endOfYear", () => $9ee757637bb2962b$export$8b7aa55c66d5569e);

var $a2Z2s = parcelRequire("a2Z2s");
function $9ee757637bb2962b$export$8b7aa55c66d5569e(date) {
    const _date = (0, $a2Z2s.toDate)(date);
    const year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$9ee757637bb2962b$export$2e2bcd8739ae039 = $9ee757637bb2962b$export$8b7aa55c66d5569e;

});

parcelRegister("66FNB", function(module, exports) {

$parcel$export(module.exports, "formatISO", () => $f0a3a527d05ba667$export$3c826ac3ab9da76c);

var $a2Z2s = parcelRequire("a2Z2s");

var $3nZOn = parcelRequire("3nZOn");
function $f0a3a527d05ba667$export$3c826ac3ab9da76c(date, options) {
    const _date = (0, $a2Z2s.toDate)(date);
    if (isNaN(_date.getTime())) throw new RangeError("Invalid time value");
    const format = options?.format ?? "extended";
    const representation = options?.representation ?? "complete";
    let result = "";
    let tzOffset = "";
    const dateDelimiter = format === "extended" ? "-" : "";
    const timeDelimiter = format === "extended" ? ":" : "";
    // Representation is either 'date' or 'complete'
    if (representation !== "time") {
        const day = (0, $3nZOn.addLeadingZeros)(_date.getDate(), 2);
        const month = (0, $3nZOn.addLeadingZeros)(_date.getMonth() + 1, 2);
        const year = (0, $3nZOn.addLeadingZeros)(_date.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = `${year}${dateDelimiter}${month}${dateDelimiter}${day}`;
    }
    // Representation is either 'time' or 'complete'
    if (representation !== "date") {
        // Add the timezone.
        const offset = _date.getTimezoneOffset();
        if (offset !== 0) {
            const absoluteOffset = Math.abs(offset);
            const hourOffset = (0, $3nZOn.addLeadingZeros)(Math.trunc(absoluteOffset / 60), 2);
            const minuteOffset = (0, $3nZOn.addLeadingZeros)(absoluteOffset % 60, 2);
            // If less than 0, the sign is +, because it is ahead of time.
            const sign = offset < 0 ? "+" : "-";
            tzOffset = `${sign}${hourOffset}:${minuteOffset}`;
        } else tzOffset = "Z";
        const hour = (0, $3nZOn.addLeadingZeros)(_date.getHours(), 2);
        const minute = (0, $3nZOn.addLeadingZeros)(_date.getMinutes(), 2);
        const second = (0, $3nZOn.addLeadingZeros)(_date.getSeconds(), 2);
        // If there's also date, separate it with time with 'T'
        const separator = result === "" ? "" : "T";
        // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
        const time = [
            hour,
            minute,
            second
        ].join(timeDelimiter);
        // HHmmss or HH:mm:ss.
        result = `${result}${separator}${time}${tzOffset}`;
    }
    return result;
}
var // Fallback for modularized imports:
$f0a3a527d05ba667$export$2e2bcd8739ae039 = $f0a3a527d05ba667$export$3c826ac3ab9da76c;

});
parcelRegister("3nZOn", function(module, exports) {

$parcel$export(module.exports, "addLeadingZeros", () => $72226580d7c4cb5b$export$c8306e720e213c0f);
function $72226580d7c4cb5b$export$c8306e720e213c0f(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}

});


parcelRegister("fJ1ra", function(module, exports) {

$parcel$export(module.exports, "startOfMonth", () => $2fac52d4e4291979$export$a5a3b454ada2268e);

var $a2Z2s = parcelRequire("a2Z2s");
function $2fac52d4e4291979$export$a5a3b454ada2268e(date) {
    const _date = (0, $a2Z2s.toDate)(date);
    _date.setDate(1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$2fac52d4e4291979$export$2e2bcd8739ae039 = $2fac52d4e4291979$export$a5a3b454ada2268e;

});

parcelRegister("g8yRt", function(module, exports) {

$parcel$export(module.exports, "startOfQuarter", () => $dd0c9541a0cddd37$export$69be7267a042ecb3);

var $a2Z2s = parcelRequire("a2Z2s");
function $dd0c9541a0cddd37$export$69be7267a042ecb3(date) {
    const _date = (0, $a2Z2s.toDate)(date);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3;
    _date.setMonth(month, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$dd0c9541a0cddd37$export$2e2bcd8739ae039 = $dd0c9541a0cddd37$export$69be7267a042ecb3;

});

parcelRegister("3EsOc", function(module, exports) {

$parcel$export(module.exports, "startOfWeek", () => $01d27203ea4f59c6$export$42c81a444fbfb5d4);

var $a2Z2s = parcelRequire("a2Z2s");

var $jWfkp = parcelRequire("jWfkp");
function $01d27203ea4f59c6$export$42c81a444fbfb5d4(date, options) {
    const defaultOptions = (0, $jWfkp.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $a2Z2s.toDate)(date);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$01d27203ea4f59c6$export$2e2bcd8739ae039 = $01d27203ea4f59c6$export$42c81a444fbfb5d4;

});

parcelRegister("6zPBd", function(module, exports) {

$parcel$export(module.exports, "startOfYear", () => $c9ed7ea013a998b2$export$f91e89d3d0406102);

var $a2Z2s = parcelRequire("a2Z2s");

var $41rRi = parcelRequire("41rRi");
function $c9ed7ea013a998b2$export$f91e89d3d0406102(date) {
    const cleanDate = (0, $a2Z2s.toDate)(date);
    const _date = (0, $41rRi.constructFrom)(date, 0);
    _date.setFullYear(cleanDate.getFullYear(), 0, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$c9ed7ea013a998b2$export$2e2bcd8739ae039 = $c9ed7ea013a998b2$export$f91e89d3d0406102;

});
parcelRegister("41rRi", function(module, exports) {

$parcel$export(module.exports, "constructFrom", () => $de14ec15169bb865$export$ead8a1812b171991);
/**
 * @name constructFrom
 * @category Generic Helpers
 * @summary Constructs a date using the reference date and the value
 *
 * @description
 * The function constructs a new date using the constructor from the reference
 * date and the given value. It helps to build generic functions that accept
 * date extensions.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 * @param value - The value to create the date
 *
 * @returns Date initialized using the given date and value
 *
 * @example
 * import { constructFrom } from 'date-fns'
 *
 * // A function that clones a date preserving the original type
 * function cloneDate<DateType extends Date(date: DateType): DateType {
 *   return constructFrom(
 *     date, // Use contrustor from the given date
 *     date.getTime() // Use the date value to create a new date
 *   )
 * }
 */ function $de14ec15169bb865$export$ead8a1812b171991(date, value) {
    if (date instanceof Date) return new date.constructor(value);
    else return new Date(value);
}
var // Fallback for modularized imports:
$de14ec15169bb865$export$2e2bcd8739ae039 = $de14ec15169bb865$export$ead8a1812b171991;

});


parcelRegister("d2D14", function(module, exports) {

$parcel$export(module.exports, "subDays", () => $7542b49f8c9742b1$export$70823084e2deb1ea);

var $9iVfc = parcelRequire("9iVfc");
function $7542b49f8c9742b1$export$70823084e2deb1ea(date, amount) {
    return (0, $9iVfc.addDays)(date, -amount);
}
var // Fallback for modularized imports:
$7542b49f8c9742b1$export$2e2bcd8739ae039 = $7542b49f8c9742b1$export$70823084e2deb1ea;

});
parcelRegister("9iVfc", function(module, exports) {

$parcel$export(module.exports, "addDays", () => $acdecb9c8d27c63e$export$dd412b56f1e4d8aa);

var $a2Z2s = parcelRequire("a2Z2s");

var $41rRi = parcelRequire("41rRi");
function $acdecb9c8d27c63e$export$dd412b56f1e4d8aa(date, amount) {
    const _date = (0, $a2Z2s.toDate)(date);
    if (isNaN(amount)) return (0, $41rRi.constructFrom)(date, NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}
var // Fallback for modularized imports:
$acdecb9c8d27c63e$export$2e2bcd8739ae039 = $acdecb9c8d27c63e$export$dd412b56f1e4d8aa;

});


parcelRegister("HfHA2", function(module, exports) {

$parcel$export(module.exports, "subMonths", () => $a53d1d62a90bfdfe$export$73d1c15a21f9fae5);

var $bWOwL = parcelRequire("bWOwL");
function $a53d1d62a90bfdfe$export$73d1c15a21f9fae5(date, amount) {
    return (0, $bWOwL.addMonths)(date, -amount);
}
var // Fallback for modularized imports:
$a53d1d62a90bfdfe$export$2e2bcd8739ae039 = $a53d1d62a90bfdfe$export$73d1c15a21f9fae5;

});
parcelRegister("bWOwL", function(module, exports) {

$parcel$export(module.exports, "addMonths", () => $ac4cf5133dfd55ff$export$17c93e242b2d3a22);

var $a2Z2s = parcelRequire("a2Z2s");

var $41rRi = parcelRequire("41rRi");
function $ac4cf5133dfd55ff$export$17c93e242b2d3a22(date, amount) {
    const _date = (0, $a2Z2s.toDate)(date);
    if (isNaN(amount)) return (0, $41rRi.constructFrom)(date, NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
    const dayOfMonth = _date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    const endOfDesiredMonth = (0, $41rRi.constructFrom)(date, _date.getTime());
    endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
    const daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        _date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return _date;
    }
}
var // Fallback for modularized imports:
$ac4cf5133dfd55ff$export$2e2bcd8739ae039 = $ac4cf5133dfd55ff$export$17c93e242b2d3a22;

});


parcelRegister("dZ7b9", function(module, exports) {

$parcel$export(module.exports, "subQuarters", () => $f741ef4907e75b25$export$a31bfeeeee80cce6);

var $gqyRP = parcelRequire("gqyRP");
function $f741ef4907e75b25$export$a31bfeeeee80cce6(date, amount) {
    return (0, $gqyRP.addQuarters)(date, -amount);
}
var // Fallback for modularized imports:
$f741ef4907e75b25$export$2e2bcd8739ae039 = $f741ef4907e75b25$export$a31bfeeeee80cce6;

});
parcelRegister("gqyRP", function(module, exports) {

$parcel$export(module.exports, "addQuarters", () => $0ac9f5a7d0b5ff77$export$c252a41d0fbed2ce);

var $bWOwL = parcelRequire("bWOwL");
function $0ac9f5a7d0b5ff77$export$c252a41d0fbed2ce(date, amount) {
    const months = amount * 3;
    return (0, $bWOwL.addMonths)(date, months);
}
var // Fallback for modularized imports:
$0ac9f5a7d0b5ff77$export$2e2bcd8739ae039 = $0ac9f5a7d0b5ff77$export$c252a41d0fbed2ce;

});


parcelRegister("6vyOy", function(module, exports) {

$parcel$export(module.exports, "subWeeks", () => $05cfedfcddbe9925$export$b4d8ae6376193efb);

var $lb6Rx = parcelRequire("lb6Rx");
function $05cfedfcddbe9925$export$b4d8ae6376193efb(date, amount) {
    return (0, $lb6Rx.addWeeks)(date, -amount);
}
var // Fallback for modularized imports:
$05cfedfcddbe9925$export$2e2bcd8739ae039 = $05cfedfcddbe9925$export$b4d8ae6376193efb;

});
parcelRegister("lb6Rx", function(module, exports) {

$parcel$export(module.exports, "addWeeks", () => $5d55845d7ad69eb1$export$ef501a2bb4f3ee6b);

var $9iVfc = parcelRequire("9iVfc");
function $5d55845d7ad69eb1$export$ef501a2bb4f3ee6b(date, amount) {
    const days = amount * 7;
    return (0, $9iVfc.addDays)(date, days);
}
var // Fallback for modularized imports:
$5d55845d7ad69eb1$export$2e2bcd8739ae039 = $5d55845d7ad69eb1$export$ef501a2bb4f3ee6b;

});


parcelRegister("k0h9F", function(module, exports) {

$parcel$export(module.exports, "subYears", () => $0f724b2a5e5ed356$export$14867687ff6c92e2);

var $jnAPs = parcelRequire("jnAPs");
function $0f724b2a5e5ed356$export$14867687ff6c92e2(date, amount) {
    return (0, $jnAPs.addYears)(date, -amount);
}
var // Fallback for modularized imports:
$0f724b2a5e5ed356$export$2e2bcd8739ae039 = $0f724b2a5e5ed356$export$14867687ff6c92e2;

});
parcelRegister("jnAPs", function(module, exports) {

$parcel$export(module.exports, "addYears", () => $4bbb172c0573b9aa$export$3d83eec43f4ea476);

var $bWOwL = parcelRequire("bWOwL");
function $4bbb172c0573b9aa$export$3d83eec43f4ea476(date, amount) {
    return (0, $bWOwL.addMonths)(date, amount * 12);
}
var // Fallback for modularized imports:
$4bbb172c0573b9aa$export$2e2bcd8739ae039 = $4bbb172c0573b9aa$export$3d83eec43f4ea476;

});



parcelRegister("kmtkw", function(module, exports) {

$parcel$export(module.exports, "loadingPage", () => $178ee8f97570ba73$export$f5f2b7216332d86e);
$parcel$export(module.exports, "loadingLogo", () => $178ee8f97570ba73$export$d200836e285bb0bb);
parcelRequire("MJPZu");
var $hOpwk = parcelRequire("hOpwk");
var $9UZF0 = parcelRequire("9UZF0");
parcelRequire("9TU71");
parcelRequire("4CCe6");

var $2dbqg = parcelRequire("2dbqg");
(0, $2dbqg.declareStyle)((0, $hOpwk.css)`
    ata-loading-page {
        inset: 0;
        display: grid;
        place-items: center;
        place-content: center;
        background: white;
        z-index: 1000;
        block-size: 20dvb;

        img {
            block-size: 15rem;
            margin-block: var(--dimensions--spacing--medium);
        }
    }

    ata-loading-logo {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
        row-gap: var(--dimensions--spacing--large);
        padding: var(--dimensions--spacing--large);

        &[fullscreen] {
            position: fixed;
            inset: 0;
            z-index: 1;
            background: white;
            block-size: 100dvb;
            inline-size: 100dvi;
        }

        #loading-logo {
            width: 50rem;
            max-width: 100%;
            height: auto;
            padding: 0 2rem;
        }

        #loading-loader {
            position: relative;
            display: flex;
            flex-direction: row;
            align-items: center;
            column-gap: var(--dimensions--spacing--medium);
        }

        #loading-loader > span {
            display: block;
            border-radius: 50%;
            width: 2.5rem;
            height: 2.5rem;
            animation-fill-mode: both;
            animation: ata-loading-three-dots 1.8s infinite ease-in-out;
            background-color: var(--color--secondary);
            scale: 0;
        }

        #loading-loader > span:nth-child(1) {
            animation-delay: -0.32s;
        }

        #loading-loader > span:nth-child(3) {
            animation-delay: 0.32s;
        }
    }

    @keyframes ata-loading-three-dots {
        0%,
        80%,
        100% {
            scale: 0;
        }
        40% {
            scale: 1;
        }
    }
`);
function $178ee8f97570ba73$export$f5f2b7216332d86e(description = (0, $9UZF0.nothing)) {
    return (0, $9UZF0.html)`
        <ata-loading-page>
            <img src="/assets/images/loading.gif" alt="Loading" />
            ${description}
        </ata-loading-page>
    `;
}
function $178ee8f97570ba73$export$d200836e285bb0bb() {
    return (0, $9UZF0.html)`
        <ata-loading-logo>
            <img
                id="loading-logo"
                loading="eager"
                src="/assets/images/autotrack-analytics.png"
            />
            <div id="loading-loader">
                <span></span>
                <span></span>
                <span></span>
            </div>
        </ata-loading-logo>
    `;
}

});

parcelRegister("j1PQF", function(module, exports) {

var $eFxl3 = parcelRequire("eFxl3");
module.exports = $eFxl3("ini7e").then(()=>parcelRequire("julnL"));

});
parcelRegister("eFxl3", function(module, exports) {
"use strict";

function $aadec161df629fff$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("fPNBh")).resolve(id));
}
module.exports = $aadec161df629fff$var$load;

});


parcelRegister("2E1HU", function(module, exports) {

var $eFxl3 = parcelRequire("eFxl3");
module.exports = Promise.all([
    $eFxl3("cq9ft"),
    $eFxl3("aMfsf"),
    $eFxl3("j4dVA")
]).then(()=>parcelRequire("8Br7s"));

});

parcelRegister("8xC7l", function(module, exports) {

var $eFxl3 = parcelRequire("eFxl3");
module.exports = $eFxl3("lPfvc").then(()=>parcelRequire("6jHFV"));

});

parcelRegister("5IKMw", function(module, exports) {

var $eFxl3 = parcelRequire("eFxl3");
module.exports = Promise.all([
    $eFxl3("cq9ft"),
    $eFxl3("dmRj2")
]).then(()=>parcelRequire("ieivr"));

});

parcelRegister("aJvFJ", function(module, exports) {

var $eFxl3 = parcelRequire("eFxl3");
module.exports = Promise.all([
    $eFxl3("NfCYv"),
    $eFxl3("cq9ft"),
    $eFxl3("4ihoG")
]).then(()=>parcelRequire("caPhS"));

});

parcelRegister("3ULcl", function(module, exports) {

var $eFxl3 = parcelRequire("eFxl3");
module.exports = Promise.all([
    $eFxl3("NfCYv"),
    $eFxl3("cq9ft"),
    $eFxl3("1H0so")
]).then(()=>parcelRequire("eD1RO"));

});

parcelRegister("8tjeS", function(module, exports) {

var $eFxl3 = parcelRequire("eFxl3");
module.exports = Promise.all([
    $eFxl3("cq9ft"),
    $eFxl3("hQ1mH")
]).then(()=>parcelRequire("klBHa"));

});

parcelRegister("cL75j", function(module, exports) {

var $eFxl3 = parcelRequire("eFxl3");
module.exports = $eFxl3("adEbd").then(()=>parcelRequire("dMeEs"));

});

parcelRegister("cCBiV", function(module, exports) {

var $eFxl3 = parcelRequire("eFxl3");
module.exports = Promise.all([
    $eFxl3("cq9ft"),
    $eFxl3("8hnRJ")
]).then(()=>parcelRequire("fMfHv"));

});

parcelRegister("iH2eH", function(module, exports) {

var $eFxl3 = parcelRequire("eFxl3");
module.exports = Promise.all([
    $eFxl3("cq9ft"),
    $eFxl3("aMfsf"),
    $eFxl3("4KZCT")
]).then(()=>parcelRequire("fGWE0"));

});

parcelRegister("6QKk0", function(module, exports) {

var $eFxl3 = parcelRequire("eFxl3");
module.exports = $eFxl3("4jXuY").then(()=>parcelRequire("gJa9r"));

});

parcelRegister("hAogL", function(module, exports) {

var $eFxl3 = parcelRequire("eFxl3");
module.exports = Promise.all([
    $eFxl3("cq9ft"),
    $eFxl3("aMfsf"),
    $eFxl3("lKe1Z")
]).then(()=>parcelRequire("i0W93"));

});

parcelRegister("QWgYr", function(module, exports) {

var $eFxl3 = parcelRequire("eFxl3");
module.exports = Promise.all([
    $eFxl3("dTli4"),
    $eFxl3("cq9ft"),
    $eFxl3("aMfsf"),
    $eFxl3("3Ud5H")
]).then(()=>parcelRequire("avtbG"));

});

parcelRegister("i7zGK", function(module, exports) {

var $eFxl3 = parcelRequire("eFxl3");
module.exports = Promise.all([
    $eFxl3("cq9ft"),
    $eFxl3("atT7n")
]).then(()=>parcelRequire("lQ2S4"));

});

parcelRegister("lc2yH", function(module, exports) {

var $eFxl3 = parcelRequire("eFxl3");
module.exports = Promise.all([
    $eFxl3("NfCYv"),
    $eFxl3("cq9ft"),
    $eFxl3("c4i6H")
]).then(()=>parcelRequire("lkqDQ"));

});

parcelRegister("lNnx6", function(module, exports) {

var $eFxl3 = parcelRequire("eFxl3");
module.exports = $eFxl3("04Z5x").then(()=>parcelRequire("9Nt1x"));

});

parcelRegister("kOFyh", function(module, exports) {

var $eFxl3 = parcelRequire("eFxl3");
module.exports = Promise.all([
    $eFxl3("cq9ft"),
    $eFxl3("cMvnx")
]).then(()=>parcelRequire("lrUtm"));

});

parcelRegister("84DKp", function(module, exports) {

var $eFxl3 = parcelRequire("eFxl3");
module.exports = Promise.all([
    $eFxl3("cq9ft"),
    $eFxl3("3x22W")
]).then(()=>parcelRequire("hjr9n"));

});

parcelRegister("lKDOU", function(module, exports) {

var $eFxl3 = parcelRequire("eFxl3");
module.exports = Promise.all([
    $eFxl3("cq9ft"),
    $eFxl3("9sHID")
]).then(()=>parcelRequire("dcgaF"));

});

parcelRegister("76Uws", function(module, exports) {

var $eFxl3 = parcelRequire("eFxl3");
module.exports = Promise.all([
    $eFxl3("dTli4"),
    $eFxl3("cq9ft"),
    $eFxl3("aX4Kq")
]).then(()=>parcelRequire("d2xDu"));

});

parcelRegister("cOYGu", function(module, exports) {

var $eFxl3 = parcelRequire("eFxl3");
module.exports = $eFxl3("7WZ9o").then(()=>parcelRequire("a5C3P"));

});

parcelRegister("3VpVp", function(module, exports) {

var $eFxl3 = parcelRequire("eFxl3");
module.exports = $eFxl3("aVRRC").then(()=>parcelRequire("5hogq"));

});

parcelRegister("iVS8k", function(module, exports) {

var $eFxl3 = parcelRequire("eFxl3");
module.exports = $eFxl3("kW62R").then(()=>parcelRequire("7VeC8"));

});

parcelRegister("jznq5", function(module, exports) {

var $eFxl3 = parcelRequire("eFxl3");
module.exports = Promise.all([
    $eFxl3("cq9ft"),
    $eFxl3("ibWi4")
]).then(()=>parcelRequire("f4GiI"));

});

parcelRegister("2IY3S", function(module, exports) {

var $eFxl3 = parcelRequire("eFxl3");
module.exports = $eFxl3("1PHkg").then(()=>parcelRequire("3YqC6"));

});

parcelRegister("amerX", function(module, exports) {

var $eFxl3 = parcelRequire("eFxl3");
module.exports = $eFxl3("lhtPF").then(()=>parcelRequire("9QWfQ"));

});

parcelRegister("4WmQS", function(module, exports) {

var $eFxl3 = parcelRequire("eFxl3");
module.exports = $eFxl3("58Mpr").then(()=>parcelRequire("BxJPt"));

});

parcelRegister("hGqWR", function(module, exports) {

var $eFxl3 = parcelRequire("eFxl3");
module.exports = $eFxl3("2mVMZ").then(()=>parcelRequire("5NrAS"));

});

parcelRegister("iMRUf", function(module, exports) {

var $eFxl3 = parcelRequire("eFxl3");
module.exports = Promise.all([
    $eFxl3("cq9ft"),
    $eFxl3("iUFBH")
]).then(()=>parcelRequire("2IyV6"));

});

parcelRegister("4yh2M", function(module, exports) {

var $eFxl3 = parcelRequire("eFxl3");
module.exports = $eFxl3("58V6v").then(()=>parcelRequire("hHUd8"));

});

parcelRegister("2zbVW", function(module, exports) {

var $eFxl3 = parcelRequire("eFxl3");
module.exports = $eFxl3("b88yI").then(()=>parcelRequire("kj1N6"));

});

parcelRegister("2MvY1", function(module, exports) {

var $eFxl3 = parcelRequire("eFxl3");
module.exports = $eFxl3("4FVcK").then(()=>parcelRequire("1Bzpx"));

});

parcelRegister("dNvYy", function(module, exports) {

var $eFxl3 = parcelRequire("eFxl3");
module.exports = $eFxl3("c7mp2").then(()=>parcelRequire("9IyGB"));

});

parcelRegister("4cRLa", function(module, exports) {

var $eFxl3 = parcelRequire("eFxl3");
module.exports = $eFxl3("k8k6B").then(()=>parcelRequire("jxiYR"));

});

parcelRegister("ilEas", function(module, exports) {

var $eFxl3 = parcelRequire("eFxl3");
module.exports = $eFxl3("ig5IW").then(()=>parcelRequire("4e37f"));

});

parcelRequire("MJPZu");
var $9UZF0 = parcelRequire("9UZF0");
var $3b0857feb50ad5c5$exports = {};
"use strict";
// do not edit .js files directly - edit src/index.jst
var $3b0857feb50ad5c5$var$envHasBigInt64Array = typeof BigInt64Array !== "undefined";
$3b0857feb50ad5c5$exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            for (i of a.entries())if (!b.has(i[0])) return false;
            for (i of a.entries())if (!equal(i[1], b.get(i[0]))) return false;
            return true;
        }
        if (a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            for (i of a.entries())if (!b.has(i[0])) return false;
            return true;
        }
        if (ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};


class $918a58a0e5e8453f$export$8210dfe1863c478 {
    internalValue;
    listeners = [];
    constructor(initialValue){
        this.internalValue = initialValue;
    }
    get value() {
        return this.internalValue;
    }
    set(newValue) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($3b0857feb50ad5c5$exports)))(this.internalValue, newValue)) return;
        this.internalValue = newValue;
        this.listeners.forEach((listener)=>listener(newValue));
    }
    subscribe(listener) {
        this.listeners.push(listener);
    }
}



var $fb0eT = parcelRequire("fb0eT");
function $1a3eaec0c4e3e22a$export$8d516e055d924071(config) {
    const state = new (0, $918a58a0e5e8453f$export$8210dfe1863c478)(config.init[0]);
    const msgQueue = [];
    let isProcessing = false;
    handleCmd(config.init[1]);
    async function processQueue() {
        if (isProcessing || msgQueue.length === 0) return;
        isProcessing = true;
        const msg = msgQueue.shift();
        const [newModel, cmd] = handleUpdate(msg);
        state.set(newModel);
        if (cmd) handleCmd(cmd);
        isProcessing = false;
        performance.mark("Processed");
        if (msgQueue.length > 0) processQueue();
    }
    function handleUpdate(msg) {
        try {
            return config.update(msg, structuredClone(state.value));
        } catch (error) {
            config.onFatalError(error);
            return [
                state.value,
                []
            ];
        }
    }
    function handleCmd(cmd) {
        for (const task of cmd)task.then(dispatch);
    }
    function dispatch(msg) {
        msgQueue.push(msg);
        processQueue();
    }
    function renderView(theState) {
        const execRender = ()=>{
            try {
                const theDocument = config.view((toMsg)=>(...args)=>dispatch(toMsg(...args)), theState);
                (0, $9UZF0.render)(theDocument.body, config.root);
                document.title = theDocument.title;
            } catch (error) {
                const errorMessage = error instanceof Error ? error.stack : error;
                (0, $9UZF0.render)($fb0eT.debug ? (0, $9UZF0.html)`<style>
                                  body {
                                      background: black !important;
                                      font-size: 2em !important;
                                      padding: 4rem !important;
                                  }
                              </style>
                              <pre style="color: #FF2222">
                                  ${errorMessage}
                              </pre
                              > ` : (0, $9UZF0.html)``, config.root);
                if ($fb0eT.debug) console.error(error);
            }
        };
        if (!("startViewTransition" in document)) {
            execRender();
            return;
        }
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        document.startViewTransition(()=>execRender());
    }
    state.subscribe(renderView);
    renderView(state.value);
    return {
        subscribe: (fn)=>state.subscribe(fn),
        send: (msg)=>dispatch(msg)
    };
}


parcelRequire("MJPZu");
var $9UZF0 = parcelRequire("9UZF0");

var $dErh8 = parcelRequire("dErh8");
var $e3dd86d6587fafa3$export$8695620d48fe67d;
(function(RequestMethod) {
    RequestMethod["Get"] = "GET";
    RequestMethod["Post"] = "POST";
    RequestMethod["Put"] = "PUT";
    RequestMethod["Patch"] = "PATCH";
    RequestMethod["Delete"] = "DELETE";
})($e3dd86d6587fafa3$export$8695620d48fe67d || ($e3dd86d6587fafa3$export$8695620d48fe67d = {}));
function $e3dd86d6587fafa3$export$b5fe3f66a567bec0(request) {
    const abortController = new AbortController();
    const promise = fetch($e3dd86d6587fafa3$var$createRequest(request), {
        signal: abortController.signal
    }).then(request.expect);
    promise["cancelled"] = false;
    promise["cancel"] = function() {
        abortController.abort();
        this.cancelled = true;
    };
    return promise;
}
function $e3dd86d6587fafa3$var$createRequest(config) {
    const url = $e3dd86d6587fafa3$var$toUrl(config.path, config.query ?? {});
    return new Request(url, {
        headers: config.headers,
        method: config.method,
        body: config.body === undefined ? undefined : JSON.stringify(config.body)
    });
}
function $e3dd86d6587fafa3$var$toUrl(path, query) {
    const thePath = Array.isArray(path) ? path.join("/") : path;
    if (Object.keys(query)[0] === undefined) return thePath;
    return thePath + "?" + new URLSearchParams(query).toString();
}


const $73731a0695accb65$export$efbc88c27b0be04 = (originalError)=>({
        type: "UnexpectedError",
        originalError: originalError
    });
const $73731a0695accb65$export$8c3da4ee41db947e = (originalError)=>({
        type: "UnexpectedBody",
        originalError: originalError
    });
const $73731a0695accb65$export$480071e217f8ed37 = ()=>({
        type: "LoginWithCredentialsFailed"
    });
const $73731a0695accb65$export$24bd8ee57d4be76f = ()=>({
        type: "CaptchaRequired"
    });
const $73731a0695accb65$export$22888f5e2c523c92 = ()=>({
        type: "TaxationNotFound"
    });
const $73731a0695accb65$export$5c773811ae1e141b = ()=>({
        type: "AuthenticationError"
    });
const $73731a0695accb65$export$e322fa85f938c513 = (location)=>({
        type: "RedirectError",
        location: location
    });



var $jqoka = parcelRequire("jqoka");

var $fb0eT = parcelRequire("fb0eT");
function $ab6eb75b24f42828$export$9094b7742a87955e(value) {
    return ()=>value;
}
function $ab6eb75b24f42828$export$c8ec6e1ec9fefcb0(literal) {
    return (json, path = [])=>{
        if (json !== literal) throw new Error(`Expected ${literal}, got ${json} at ${path.join(".")}`);
        return json;
    };
}
const $ab6eb75b24f42828$export$22b082955e083ec3 = (json, path = [])=>{
    if (typeof json !== "string") throw new Error(`Expected string, got ${typeof json} at ${path.join(".")}`);
    return json;
};
const $ab6eb75b24f42828$export$98e628dec113755e = (json, path = [])=>{
    if (typeof json !== "number") throw new Error(`Expected number, got ${typeof json} at ${path.join(".")}`);
    return json;
};
const $ab6eb75b24f42828$export$87b259aa03e3d267 = (json, path = [])=>{
    if (typeof json !== "boolean") throw new Error(`Expected boolean, got ${typeof json} at ${path.join(".")}`);
    return json;
};
function $ab6eb75b24f42828$export$133fc36489ac9add(decoder) {
    return (json)=>{
        if (json === null) return null;
        return decoder(json);
    };
}
function $ab6eb75b24f42828$export$2f23118c22fb2630(decoder) {
    return (json, path = [])=>{
        if (!Array.isArray(json)) throw new Error(`Expected array, got ${typeof json} at ${path.join(".")}`);
        return json.map((value, index)=>decoder(value, [
                ...path,
                String(index)
            ]));
    };
}
function $ab6eb75b24f42828$export$a6b37472941cc417(decoder) {
    return (json, path = [])=>{
        if (typeof json !== "object" || json === null) throw new Error(`Expected object, got ${typeof json} at ${path.join(".")}`);
        const result = {};
        for(const key in json){
            if (!$ab6eb75b24f42828$var$hasKey(key, json)) throw new Error(`Expected key \`${key}\` in object at ${path.join(".")}`);
            result[key] = decoder(json[key], [
                ...path,
                key
            ]);
        }
        return result;
    };
}
function $ab6eb75b24f42828$export$e5185e241753e543(decoders) {
    return (json, path = [])=>{
        if (typeof json !== "object" || json === null) throw new Error(`Expected an object for record decoding  at ${path.join(".")}`);
        const result = {};
        for(const key in decoders){
            const fieldValue = json[key];
            const decoder = decoders[key];
            result[key] = decoder(fieldValue, [
                ...path,
                key
            ]);
        }
        return result;
    };
}
function $ab6eb75b24f42828$export$e0f35d825088c098(key, decoder) {
    return (json, path = [])=>{
        if (typeof json !== "object" || json === null) throw new Error(`Expected object, got ${typeof json} at ${path.join(".")}`);
        if (!(key in json)) throw new Error(`Expected key ${key} in object at ${path.join(".")}`);
        return decoder(json[key], [
            ...path,
            key
        ]);
    };
}
function $ab6eb75b24f42828$export$493d36ec626b6698(key, decoder) {
    return (json, path = [])=>{
        const [head, ...tail] = key;
        if (tail.length === 0) return $ab6eb75b24f42828$export$e0f35d825088c098(head, decoder)(json, path);
        if (!(typeof json === "object" && json !== null)) throw new Error(`Expected object, got ${typeof json} at ${path.join(".")}`);
        if (!$ab6eb75b24f42828$var$hasKey(head, json)) throw new Error(`Expected key ${head} in object at ${path.join(".")}`);
        return $ab6eb75b24f42828$export$493d36ec626b6698(tail, decoder)(json[head], [
            ...path,
            head
        ]);
    };
}
function $ab6eb75b24f42828$export$b610b8812bbcded9(i, decoder) {
    return (json, path = [])=>{
        if (!Array.isArray(json)) throw new Error(`Expected array, got ${typeof json} at ${path.join(".")}`);
        if (i >= json.length) throw new Error(`Expected array of length ${i + 1}, got ${json.length} at ${path.join(".")}`);
        return decoder(json[i], [
            ...path,
            String(i)
        ]);
    };
}
function $ab6eb75b24f42828$export$a9a18ae5ba42aeab(decoders) {
    return (json, path = [])=>{
        const errors = [];
        for (const decoder of decoders)try {
            return decoder(json, path);
        } catch (error) {
            errors.push(error.message);
        }
        throw new Error(`All decoders failed at ${path.join(".")}:\n\n\t${errors.join("\n\n	")} `);
    };
}
function $ab6eb75b24f42828$export$871de8747c9eaa88(decoders, fn) {
    return (json, path = [])=>fn(...decoders.map((d)=>d(json, path)));
}
/**
 * Checks if a key is in an object. This is a type guard.
 */ function $ab6eb75b24f42828$var$hasKey(key, json) {
    return key in json;
}


//---- Fetch ----//
const $0b52e672722f75d2$var$defaultHeaders = (locale)=>new Headers({
        "Content-Type": "application/json",
        Accept: "application/json",
        "Accept-Language": locale
    });
const $0b52e672722f75d2$var$authorizedHeaders = (locale, token)=>{
    const headers = $0b52e672722f75d2$var$defaultHeaders(locale);
    headers.append("Authorization", `Bearer ${token}`);
    return headers;
};
function $0b52e672722f75d2$var$removeUndefinedFromRecord(record) {
    const clonedRecord = structuredClone(record);
    Object.keys(clonedRecord).forEach((key)=>clonedRecord[key] === undefined && delete clonedRecord[key]);
    return clonedRecord;
}
function $0b52e672722f75d2$var$getHttpStatusErrors(response) {
    if (response.ok) return null;
    if (response.status === 401) return $jqoka.err($73731a0695accb65$export$5c773811ae1e141b());
    if (response.status >= 300 && response.status < 400) return $jqoka.err($73731a0695accb65$export$e322fa85f938c513(response.headers.get("Location") ?? undefined));
    return null;
}
//---- Requests ----//
const $0b52e672722f75d2$var$AtaApiEndpoints = {
    session: ()=>(0, $fb0eT.apiDomain) + "/info",
    authenticate: ()=>(0, $fb0eT.apiDomain) + "/oauth/access_token",
    authenticateSHA: ()=>(0, $fb0eT.apiDomain) + `/login`,
    settingsStock: ()=>(0, $fb0eT.apiDomain) + "/settings_stock/0",
    settingsCompetingVehicles: (id)=>(0, $fb0eT.apiDomain) + `/settings_competingvehicles/${id}`,
    settingsNotifications: ()=>(0, $fb0eT.apiDomain) + "/settings_notifications/0",
    settingsDealerProfiles: ()=>(0, $fb0eT.apiDomain) + "/settings_competingdealers",
    settingsDealerProfile: (id)=>(0, $fb0eT.apiDomain) + `/settings_competingdealers/${id}`,
    settingsDealerFilter: ()=>(0, $fb0eT.apiDomain) + "/settings_dealerfilter/0",
    settingsDealerFilterScenario: (id)=>(0, $fb0eT.apiDomain) + `/settings_dealerfilter/${id}`,
    settingsScenarioDealers: ()=>(0, $fb0eT.apiDomain) + `/settings_dealers`,
    settingsScenarios: ()=>(0, $fb0eT.apiDomain) + `/settings_scenarios`,
    settingsScenario: (id)=>(0, $fb0eT.apiDomain) + `/settings_scenarios/${id}`,
    settingsTestMail: ()=>(0, $fb0eT.apiDomain) + "/settings_notificationsmail/0",
    dealerSearch: ()=>(0, $fb0eT.apiDomain) + "/settings_competingdealers_search",
    dealerVehicles: ()=>(0, $fb0eT.apiDomain) + "/stock",
    dealerCompetition: ()=>(0, $fb0eT.apiDomain) + "/competition",
    dealerDashboard: ()=>(0, $fb0eT.apiDomain) + "/dashboard",
    dealerReach: ()=>(0, $fb0eT.apiDomain) + "/reach",
    dealerLeads: ()=>(0, $fb0eT.apiDomain) + "/leads",
    dealerAnalysisCostBenefit: ()=>(0, $fb0eT.apiDomain) + "/costbenefits",
    dealerAnalysisStock: ()=>(0, $fb0eT.apiDomain) + "/analysisstock",
    dealerAnalysisMakeModel: ()=>(0, $fb0eT.apiDomain) + "/analysismakemodel",
    dealerAnalysisLeadsPerformance: ()=>(0, $fb0eT.apiDomain) + "/analysisperformance",
    dealerProspects: ()=>(0, $fb0eT.apiDomain) + "/prospects",
    vehicle: (id)=>(0, $fb0eT.apiDomain) + `/vehicle/${id}`,
    vehicleDashboard: (id)=>(0, $fb0eT.apiDomain) + `/vehicle/${id}/dashboard`,
    vehicleReach: (id)=>(0, $fb0eT.apiDomain) + `/vehicle/${id}/reach`,
    vehicleCompetition: (id)=>(0, $fb0eT.apiDomain) + `/vehicle/${id}/competingvehicles`,
    vehiclePriceEffect: (id)=>(0, $fb0eT.apiDomain) + `/vehicle/${id}/priceeffect`,
    vehiclePriceHistory: (id)=>(0, $fb0eT.apiDomain) + `/vehicle/${id}/pricehistory`,
    vehicleGeography: (id)=>(0, $fb0eT.apiDomain) + `/vehicle/${id}/geography`,
    taxation: (id)=>(0, $fb0eT.apiDomain) + (id ? `/taxation/${id}` : "/taxation"),
    taxationDashboard: (id)=>(0, $fb0eT.apiDomain) + `/taxation/${id}/dashboard`,
    taxationReach: (id)=>(0, $fb0eT.apiDomain) + `/taxation/${id}/reach`,
    taxationCompetition: (id)=>(0, $fb0eT.apiDomain) + `/taxation/${id}/competingvehicles`,
    taxationPriceHistory: (id)=>(0, $fb0eT.apiDomain) + `/taxation/${id}/pricehistory`,
    taxationGeography: (id)=>(0, $fb0eT.apiDomain) + `/taxation/${id}/geography`,
    taxationSettings: (id)=>(0, $fb0eT.apiDomain) + `/settings_taxations/${id}`,
    vehicleMakes: ()=>(0, $fb0eT.apiDomain) + "/vehiclemake",
    vehicleModels: ()=>(0, $fb0eT.apiDomain) + "/vehiclemodel",
    settingsDealerProfileFilters: ()=>(0, $fb0eT.apiDomain) + "/settings_competingdealers_ui",
    // TODO: remove when competition arrives in one call
    dealerCompetitionPrice: ()=>(0, $fb0eT.apiDomain) + "/comparedealerprofiles",
    dealerCompetitionGeo: ()=>(0, $fb0eT.apiDomain) + "/comparedealerprofilesgeography"
};
const $0b52e672722f75d2$var$dateDecoder = $ab6eb75b24f42828$export$871de8747c9eaa88([
    $ab6eb75b24f42828$export$a9a18ae5ba42aeab([
        $ab6eb75b24f42828$export$98e628dec113755e,
        $ab6eb75b24f42828$export$22b082955e083ec3
    ])
], (a)=>new Date(a));
const $0b52e672722f75d2$var$valueDecoder = (decoder)=>$ab6eb75b24f42828$export$e5185e241753e543({
        value: decoder,
        humanvalue: $ab6eb75b24f42828$export$22b082955e083ec3
    });
const $0b52e672722f75d2$var$extractValueDecoder = (decoder)=>$ab6eb75b24f42828$export$e0f35d825088c098("value", decoder);
const $0b52e672722f75d2$var$vehicleDecoder = $ab6eb75b24f42828$export$e5185e241753e543({
    advertisementquality: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
    advertisementqualityitems: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$e5185e241753e543({
        accuracy: $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$22b082955e083ec3),
        nap: $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$22b082955e083ec3),
        photo: $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$22b082955e083ec3),
        warranty: $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$22b082955e083ec3)
    })),
    alerts: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$a9a18ae5ba42aeab([
        $ab6eb75b24f42828$export$871de8747c9eaa88([
            $ab6eb75b24f42828$export$c8ec6e1ec9fefcb0("Prijs gewijzigd")
        ], (_)=>"lastupdate"),
        $ab6eb75b24f42828$export$871de8747c9eaa88([
            $ab6eb75b24f42828$export$c8ec6e1ec9fefcb0("Statijd")
        ], (_)=>"daysinstock"),
        $ab6eb75b24f42828$export$871de8747c9eaa88([
            $ab6eb75b24f42828$export$c8ec6e1ec9fefcb0("Bekeken per dag")
        ], (_)=>"viewed")
    ]))),
    aturl: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$22b082955e083ec3),
    body: $ab6eb75b24f42828$export$e5185e241753e543({
        value: $ab6eb75b24f42828$export$22b082955e083ec3,
        humanvalue: $ab6eb75b24f42828$export$22b082955e083ec3,
        label: $ab6eb75b24f42828$export$22b082955e083ec3
    }),
    btwmarge: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$22b082955e083ec3),
    clicks: $ab6eb75b24f42828$export$e5185e241753e543({
        daily: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
        total: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
        total15: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e)
    }),
    daysinstock: $ab6eb75b24f42828$export$e5185e241753e543({
        amount: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
        benchmarkaverage: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e)
    }),
    dealer: $ab6eb75b24f42828$export$e5185e241753e543({
        name: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$22b082955e083ec3)
    }),
    enginecapacity: $ab6eb75b24f42828$export$e5185e241753e543({
        value: $ab6eb75b24f42828$export$22b082955e083ec3,
        humanvalue: $ab6eb75b24f42828$export$22b082955e083ec3,
        label: $ab6eb75b24f42828$export$22b082955e083ec3
    }),
    enginepowerhp: $ab6eb75b24f42828$export$e5185e241753e543({
        value: $ab6eb75b24f42828$export$22b082955e083ec3,
        humanvalue: $ab6eb75b24f42828$export$22b082955e083ec3,
        label: $ab6eb75b24f42828$export$22b082955e083ec3
    }),
    found: $ab6eb75b24f42828$export$e5185e241753e543({
        amount: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
        amount15: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
        daily: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e)
    }),
    fueltype: $ab6eb75b24f42828$export$e5185e241753e543({
        value: $ab6eb75b24f42828$export$22b082955e083ec3,
        humanvalue: $ab6eb75b24f42828$export$22b082955e083ec3,
        label: $ab6eb75b24f42828$export$22b082955e083ec3
    }),
    id: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$22b082955e083ec3),
    isnew: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$87b259aa03e3d267),
    lastdateofownership: $ab6eb75b24f42828$export$e5185e241753e543({
        value: $ab6eb75b24f42828$export$22b082955e083ec3,
        humanvalue: $ab6eb75b24f42828$export$22b082955e083ec3,
        label: $ab6eb75b24f42828$export$22b082955e083ec3
    }),
    licenseplate: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$22b082955e083ec3),
    licenseplateformatted: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$22b082955e083ec3),
    maintenancebooklet: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$87b259aa03e3d267),
    make: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$22b082955e083ec3),
    manufacture: $ab6eb75b24f42828$export$e5185e241753e543({
        bouwjaar: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$22b082955e083ec3),
        month: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$22b082955e083ec3),
        year: $ab6eb75b24f42828$export$e5185e241753e543({
            value: $ab6eb75b24f42828$export$22b082955e083ec3,
            humanvalue: $ab6eb75b24f42828$export$22b082955e083ec3,
            label: $ab6eb75b24f42828$export$22b082955e083ec3
        })
    }),
    mileage: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
    model: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$22b082955e083ec3),
    nap: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$87b259aa03e3d267),
    numberofdoors: $ab6eb75b24f42828$export$e5185e241753e543({
        value: $ab6eb75b24f42828$export$22b082955e083ec3,
        humanvalue: $ab6eb75b24f42828$export$22b082955e083ec3,
        label: $ab6eb75b24f42828$export$22b082955e083ec3
    }),
    occasiontype: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$a9a18ae5ba42aeab([
        $ab6eb75b24f42828$export$22b082955e083ec3,
        $ab6eb75b24f42828$export$9094b7742a87955e(null)
    ])),
    paintcolor: $ab6eb75b24f42828$export$e5185e241753e543({
        value: $ab6eb75b24f42828$export$22b082955e083ec3,
        humanvalue: $ab6eb75b24f42828$export$22b082955e083ec3,
        label: $ab6eb75b24f42828$export$22b082955e083ec3
    }),
    photo15askingprice: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
    photo15date: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$22b082955e083ec3),
    photo: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$22b082955e083ec3),
    photocount: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
    price: $ab6eb75b24f42828$export$e5185e241753e543({
        asking: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
        changes: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
        lastupdate: $ab6eb75b24f42828$export$e5185e241753e543({
            days: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e)
        }),
        lowest: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
        lowestdealer: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$22b082955e083ec3),
        recommended: $ab6eb75b24f42828$export$e5185e241753e543({
            difference: $ab6eb75b24f42828$export$e5185e241753e543({
                amount: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                percentage: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e)
            }),
            amount: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e)
        })
    }),
    pricedetails: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$a9a18ae5ba42aeab([
        $ab6eb75b24f42828$export$e5185e241753e543({
            info: $ab6eb75b24f42828$export$22b082955e083ec3,
            options: $ab6eb75b24f42828$export$133fc36489ac9add($ab6eb75b24f42828$export$e5185e241753e543({
                total: $ab6eb75b24f42828$export$e5185e241753e543({
                    label: $ab6eb75b24f42828$export$22b082955e083ec3,
                    humanvalue: $ab6eb75b24f42828$export$22b082955e083ec3
                }),
                residualvalue: $ab6eb75b24f42828$export$e5185e241753e543({
                    label: $ab6eb75b24f42828$export$22b082955e083ec3,
                    humanvalue: $ab6eb75b24f42828$export$22b082955e083ec3
                })
            })),
            price: $ab6eb75b24f42828$export$e5185e241753e543({
                residualvalue: $ab6eb75b24f42828$export$e5185e241753e543({
                    label: $ab6eb75b24f42828$export$22b082955e083ec3,
                    humanvalue: $ab6eb75b24f42828$export$22b082955e083ec3
                }),
                total: $ab6eb75b24f42828$export$e5185e241753e543({
                    label: $ab6eb75b24f42828$export$22b082955e083ec3,
                    humanvalue: $ab6eb75b24f42828$export$22b082955e083ec3
                })
            }),
            recommendedprice: $ab6eb75b24f42828$export$e5185e241753e543({
                label: $ab6eb75b24f42828$export$22b082955e083ec3,
                humanvalue: $ab6eb75b24f42828$export$22b082955e083ec3
            })
        }),
        $ab6eb75b24f42828$export$9094b7742a87955e(null)
    ])),
    qpq_sold: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
    recalc: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$87b259aa03e3d267),
    similarvehicles: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
    similarvehiclesissetting: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$87b259aa03e3d267),
    transmission: $ab6eb75b24f42828$export$e5185e241753e543({
        value: $ab6eb75b24f42828$export$22b082955e083ec3,
        humanvalue: $ab6eb75b24f42828$export$22b082955e083ec3,
        label: $ab6eb75b24f42828$export$22b082955e083ec3
    }),
    trimpackage: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$22b082955e083ec3),
    video: $ab6eb75b24f42828$export$e5185e241753e543({
        value: $ab6eb75b24f42828$export$22b082955e083ec3,
        humanvalue: $ab6eb75b24f42828$export$22b082955e083ec3,
        label: $ab6eb75b24f42828$export$22b082955e083ec3
    }),
    viewed: $ab6eb75b24f42828$export$e5185e241753e543({
        amount: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
        amount15: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
        daily: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e)
    }),
    warranties: $ab6eb75b24f42828$export$e5185e241753e543({
        count: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
        items: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$22b082955e083ec3))
    })
});
const $0b52e672722f75d2$var$competingVehicleDecoder = $ab6eb75b24f42828$export$e5185e241753e543({
    aturl: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$22b082955e083ec3),
    clicks: $ab6eb75b24f42828$export$e5185e241753e543({
        daily: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
        total: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
        total15: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e)
    }),
    daysinstock: $ab6eb75b24f42828$export$e5185e241753e543({
        amount: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
        benchmarkaverage: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e)
    }),
    dealer: $ab6eb75b24f42828$export$e5185e241753e543({
        name: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$22b082955e083ec3)
    }),
    found: $ab6eb75b24f42828$export$e5185e241753e543({
        amount: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
        amount15: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
        daily: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e)
    }),
    id: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$22b082955e083ec3),
    licenseplate: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$22b082955e083ec3),
    make: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$22b082955e083ec3),
    manufacture: $ab6eb75b24f42828$export$e5185e241753e543({
        bouwjaar: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$22b082955e083ec3),
        month: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$22b082955e083ec3),
        year: $ab6eb75b24f42828$export$e5185e241753e543({
            value: $ab6eb75b24f42828$export$22b082955e083ec3,
            humanvalue: $ab6eb75b24f42828$export$22b082955e083ec3,
            label: $ab6eb75b24f42828$export$22b082955e083ec3
        })
    }),
    mileage: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
    model: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$22b082955e083ec3),
    nap: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$87b259aa03e3d267),
    occasiontype: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$22b082955e083ec3),
    photo: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$22b082955e083ec3),
    photocount: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
    price: $ab6eb75b24f42828$export$e5185e241753e543({
        asking: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
        changes: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
        lastupdate: $ab6eb75b24f42828$export$e5185e241753e543({
            days: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e)
        }),
        lowest: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
        lowestdealer: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$22b082955e083ec3),
        recommended: $ab6eb75b24f42828$export$e5185e241753e543({
            difference: $ab6eb75b24f42828$export$e5185e241753e543({
                amount: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                percentage: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e)
            }),
            amount: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e)
        })
    }),
    trimpackage: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$22b082955e083ec3),
    viewed: $ab6eb75b24f42828$export$e5185e241753e543({
        amount: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
        amount15: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
        daily: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e)
    }),
    warranties: $ab6eb75b24f42828$export$e5185e241753e543({
        count: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
        items: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$22b082955e083ec3))
    })
});
function $0b52e672722f75d2$export$e6dad8e485f60ef8(payload, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        headers: $0b52e672722f75d2$var$defaultHeaders("nl-NL"),
        path: $0b52e672722f75d2$var$AtaApiEndpoints.authenticateSHA(),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Get,
        query: $0b52e672722f75d2$var$removeUndefinedFromRecord({
            SHA: payload.token,
            d: payload.dealer,
            ma: payload.ma,
            sessie: payload.session,
            rf: payload.reference,
            t: payload.type,
            master: payload.master ? "1" : "0"
        }),
        expect: async (response)=>{
            const data = (await response.json())?.data.data;
            return toMsg({
                accountName: data["accountname"],
                accountType: (()=>{
                    switch(data["accounttype"]){
                        case 1:
                            return "Dealer";
                        case 2:
                            return "Holding";
                        case 3:
                            return "Group";
                        default:
                            throw new Error("Unknown account type");
                    }
                })(),
                accessToken: data["access_token"],
                isMasterAccount: data["ismaster"]
            });
        }
    });
}
function $0b52e672722f75d2$export$2225eabe1ff0179d(username, password, captcha, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        headers: $0b52e672722f75d2$var$defaultHeaders("nl-NL"),
        path: $0b52e672722f75d2$var$AtaApiEndpoints.authenticate(),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Post,
        query: {},
        body: $0b52e672722f75d2$var$removeUndefinedFromRecord({
            grant_type: "password",
            client_id: "autotrack-web",
            client_secret: "JBDy7q#LkphkT@F28XDtG=2-8Fx%HBN!^szzhQ7vgA",
            scope: "web",
            username: username,
            password: password,
            "g-recaptcha-response": captcha ?? undefined
        }),
        expect: async (response)=>{
            if (!response.ok) {
                if (response.status >= 400 && response.status < 500) try {
                    const json = await response.json();
                    const errors = $ab6eb75b24f42828$export$e0f35d825088c098("errors", $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$e5185e241753e543({
                        error: $ab6eb75b24f42828$export$98e628dec113755e,
                        error_description: $ab6eb75b24f42828$export$22b082955e083ec3
                    })))(json);
                    if (errors.find((error)=>error.error === 901) !== undefined) return toMsg($jqoka.err($73731a0695accb65$export$24bd8ee57d4be76f()));
                    return toMsg($jqoka.err($73731a0695accb65$export$480071e217f8ed37()));
                } catch  {
                    return toMsg($jqoka.err($73731a0695accb65$export$480071e217f8ed37()));
                }
                else return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04()));
            }
            const json = await response.json();
            const data = json?.data;
            return toMsg($jqoka.ok({
                accessToken: data["access_token"],
                expiration: new Date(Date.now() + data["expires_in"] * 1000)
            }));
        }
    });
}
function $0b52e672722f75d2$export$aceb985d559ad4(authentication, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        path: $0b52e672722f75d2$var$AtaApiEndpoints.session(),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Get,
        query: {},
        expect: async (response)=>{
            if (!response.ok) {
                const httpStatusError = $0b52e672722f75d2$var$getHttpStatusErrors(response);
                if (httpStatusError) return toMsg(httpStatusError);
            }
            const data = (await response.json())?.data;
            return toMsg($jqoka.ok({
                accountId: String(data["accountid"]),
                accountName: String(data["accountname"]),
                accountType: (()=>{
                    switch(data["accounttype"]){
                        case 1:
                            return "Dealer";
                        case 2:
                            return "Holding";
                        case 3:
                            return "Group";
                        default:
                            throw new Error("Unknown account type");
                    }
                })(),
                // autotracksession: null
                isPremiumAccount: Boolean(data["premium"]),
                isReachFiltered: Boolean(data["reachfiltered"]),
                totalStock: Number(data["stock"]["total"]),
                filteredStock: Number(data["stock"]["filtered"]),
                hasTaxation: Boolean(data["taxation"]),
                lastUpdate: new Date(data["lastupdate"] * 1000)
            }));
        }
    });
}
function $0b52e672722f75d2$export$226b0e9bbfe4903b(authentication, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        path: $0b52e672722f75d2$var$AtaApiEndpoints.authenticate(),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Delete,
        query: {},
        expect: async (response)=>{
            return toMsg(response.ok);
        }
    });
}
function $0b52e672722f75d2$export$c7c0f888375d50cc(authentication, query, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.dealerVehicles(),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Get,
        query: {
            limit: String(10),
            search: query
        },
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        expect: async ()=>toMsg()
    });
}
function $0b52e672722f75d2$export$7438a52d2ce5eaac(authentication, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.vehicleMakes(),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Get,
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        query: {},
        expect: async ()=>toMsg()
    });
}
function $0b52e672722f75d2$export$a4009d164ad78027(authentication, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.vehicleModels(),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Get,
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        query: {},
        expect: async ()=>toMsg()
    });
}
function $0b52e672722f75d2$export$5dc3064b6db5b9c(authentication, options, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.dealerVehicles(),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Get,
        query: $0b52e672722f75d2$var$removeUndefinedFromRecord({
            crr_page: String(options.page),
            limit: String(options.amountPerPage),
            col: options.sort,
            sort: options.sortDirection ?? "ASC",
            search: options?.search,
            filter: options?.onlyWithWarnings ? "alerts" : undefined
        }),
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        expect: async (response)=>{
            if (!response.ok) {
                const httpStatusError = $0b52e672722f75d2$var$getHttpStatusErrors(response);
                if (httpStatusError) return toMsg(httpStatusError);
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04()));
            }
            const data = (await response.json())?.data;
            const decoder = $ab6eb75b24f42828$export$871de8747c9eaa88([
                $ab6eb75b24f42828$export$a9a18ae5ba42aeab([
                    $ab6eb75b24f42828$export$e0f35d825088c098("vehicle", $ab6eb75b24f42828$export$2f23118c22fb2630($0b52e672722f75d2$var$vehicleDecoder)),
                    $ab6eb75b24f42828$export$9094b7742a87955e([])
                ]),
                $ab6eb75b24f42828$export$e0f35d825088c098("vehicle_count", $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e))
            ], (vehicles, totalVehicles)=>({
                    vehicles: vehicles,
                    totalVehicles: totalVehicles
                }));
            try {
                return toMsg($jqoka.ok(decoder(data)));
            } catch  {
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04()));
            }
        }
    });
}
function $0b52e672722f75d2$export$95f8a3d197872fd8(authentication, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.dealerDashboard(),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Get,
        query: {
            period: "30d"
        },
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        expect: async (response)=>{
            if (!response.ok) {
                const httpStatusError = $0b52e672722f75d2$var$getHttpStatusErrors(response);
                if (httpStatusError) return toMsg(httpStatusError);
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04()));
            }
            const data = (await response.json())?.data;
            const decoder = $ab6eb75b24f42828$export$e5185e241753e543({
                competition: $ab6eb75b24f42828$export$9094b7742a87955e([]),
                contact: $ab6eb75b24f42828$export$e5185e241753e543({
                    total: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    graph: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$871de8747c9eaa88([
                        $ab6eb75b24f42828$export$b610b8812bbcded9(0, $ab6eb75b24f42828$export$98e628dec113755e),
                        $ab6eb75b24f42828$export$b610b8812bbcded9(1, $ab6eb75b24f42828$export$98e628dec113755e)
                    ], (x, y)=>[
                            x,
                            y
                        ])))
                }),
                found: $ab6eb75b24f42828$export$e5185e241753e543({
                    total: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    graph: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$871de8747c9eaa88([
                        $ab6eb75b24f42828$export$b610b8812bbcded9(0, $ab6eb75b24f42828$export$98e628dec113755e),
                        $ab6eb75b24f42828$export$b610b8812bbcded9(1, $ab6eb75b24f42828$export$98e628dec113755e)
                    ], (x, y)=>[
                            x,
                            y
                        ])))
                }),
                viewed: $ab6eb75b24f42828$export$e5185e241753e543({
                    total: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    graph: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$871de8747c9eaa88([
                        $ab6eb75b24f42828$export$b610b8812bbcded9(0, $ab6eb75b24f42828$export$98e628dec113755e),
                        $ab6eb75b24f42828$export$b610b8812bbcded9(1, $ab6eb75b24f42828$export$98e628dec113755e)
                    ], (x, y)=>[
                            x,
                            y
                        ])))
                }),
                performance: $ab6eb75b24f42828$export$e5185e241753e543({
                    advertisementquality: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    askingprice: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    daysinstock: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e)
                }),
                pricehistory: $ab6eb75b24f42828$export$9094b7742a87955e([]),
                stock: $ab6eb75b24f42828$export$a9a18ae5ba42aeab([
                    $ab6eb75b24f42828$export$e5185e241753e543({
                        vehicle: $ab6eb75b24f42828$export$2f23118c22fb2630($0b52e672722f75d2$var$vehicleDecoder),
                        vehicle_count: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                        vehicle_hasrecalc: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$87b259aa03e3d267)
                    }),
                    $ab6eb75b24f42828$export$9094b7742a87955e(null)
                ]),
                stocksummary: $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$e5185e241753e543({
                    advertisementquality: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    askingpricedifferencepercentage: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    askingpricetoohigh: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    askingpricetotal: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    daysinstockaverage: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    daysinstockdistribution: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$a9a18ae5ba42aeab([
                        $ab6eb75b24f42828$export$22b082955e083ec3,
                        $ab6eb75b24f42828$export$98e628dec113755e
                    ])))),
                    found: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    id: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$22b082955e083ec3),
                    name: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$22b082955e083ec3),
                    place: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$22b082955e083ec3),
                    turnoveraveragedaysinstock: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    vehiclecount: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    viewed: $0b52e672722f75d2$var$valueDecoder($ab6eb75b24f42828$export$98e628dec113755e)
                }))
            });
            try {
                return toMsg($jqoka.ok(decoder(data)));
            } catch (error) {
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04(error)));
            }
        }
    });
}
function $0b52e672722f75d2$export$56de87f170f2f151(authentication, period, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        path: $0b52e672722f75d2$var$AtaApiEndpoints.dealerReach(),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Get,
        query: {
            startdate: period.startDate,
            enddate: period.endDate
        },
        expect: async (response)=>{
            if (!response.ok) {
                const httpStatusError = $0b52e672722f75d2$var$getHttpStatusErrors(response);
                if (httpStatusError) return toMsg(httpStatusError);
            }
            const data = (await response.json())?.data;
            const decoder = $ab6eb75b24f42828$export$e5185e241753e543({
                dealerviews: $ab6eb75b24f42828$export$e5185e241753e543({
                    total: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    graph: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$98e628dec113755e)))
                }),
                found: $ab6eb75b24f42828$export$e5185e241753e543({
                    total: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    graph: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$98e628dec113755e)))
                }),
                clicks: $ab6eb75b24f42828$export$e5185e241753e543({
                    total: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    graph: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$98e628dec113755e)))
                }),
                viewed: $ab6eb75b24f42828$export$e5185e241753e543({
                    total: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    graph: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$98e628dec113755e)))
                }),
                stockviews: $ab6eb75b24f42828$export$e5185e241753e543({
                    total: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    graph: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$98e628dec113755e)))
                }),
                reviewviews: $ab6eb75b24f42828$export$e5185e241753e543({
                    total: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    graph: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$98e628dec113755e)))
                }),
                contact: $ab6eb75b24f42828$export$e5185e241753e543({
                    total: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    graph: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$98e628dec113755e))),
                    distribution: $ab6eb75b24f42828$export$a6b37472941cc417($ab6eb75b24f42828$export$e0f35d825088c098("total", $ab6eb75b24f42828$export$871de8747c9eaa88([
                        $ab6eb75b24f42828$export$e5185e241753e543({
                            value: $ab6eb75b24f42828$export$98e628dec113755e,
                            label: $ab6eb75b24f42828$export$22b082955e083ec3
                        })
                    ], ({ value: total, label: label })=>({
                            total: total,
                            label: label
                        }))))
                }),
                share: $ab6eb75b24f42828$export$e5185e241753e543({
                    total: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    graph: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$98e628dec113755e))),
                    distribution: $ab6eb75b24f42828$export$a6b37472941cc417($ab6eb75b24f42828$export$e0f35d825088c098("total", $ab6eb75b24f42828$export$871de8747c9eaa88([
                        $ab6eb75b24f42828$export$e5185e241753e543({
                            value: $ab6eb75b24f42828$export$98e628dec113755e,
                            label: $ab6eb75b24f42828$export$22b082955e083ec3
                        })
                    ], ({ value: total, label: label })=>({
                            total: total,
                            label: label
                        }))))
                })
            });
            try {
                return toMsg($jqoka.ok(decoder(data)));
            } catch (error) {
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04(error)));
            }
        }
    });
}
function $0b52e672722f75d2$export$80dce8f245200185(authentication, config, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.dealerLeads(),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Get,
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        query: $0b52e672722f75d2$var$removeUndefinedFromRecord({
            col: config.sort,
            sort: "DESC",
            startdate: config.period.startDate,
            enddate: config.period.endDate,
            limit: String(config.amountPerPage),
            crr_page: String(config.page),
            search: config.search === "" ? undefined : config.search,
            type: config.filter.size === 0 ? undefined : Array.from(config.filter).join(",")
        }),
        expect: async (response)=>{
            if (!response.ok) {
                const httpStatusError = $0b52e672722f75d2$var$getHttpStatusErrors(response);
                if (httpStatusError) return toMsg(httpStatusError);
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04()));
            }
            const decoder = $ab6eb75b24f42828$export$e5185e241753e543({
                records: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$e5185e241753e543({
                    type: $ab6eb75b24f42828$export$22b082955e083ec3,
                    date: $0b52e672722f75d2$var$dateDecoder,
                    source: $ab6eb75b24f42828$export$22b082955e083ec3,
                    sourceid: $ab6eb75b24f42828$export$133fc36489ac9add($ab6eb75b24f42828$export$22b082955e083ec3),
                    amount: $ab6eb75b24f42828$export$98e628dec113755e,
                    label: $ab6eb75b24f42828$export$22b082955e083ec3
                }))),
                total: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                graph: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$98e628dec113755e))),
                distribution: $ab6eb75b24f42828$export$a6b37472941cc417($ab6eb75b24f42828$export$a9a18ae5ba42aeab([
                    $ab6eb75b24f42828$export$871de8747c9eaa88([
                        $ab6eb75b24f42828$export$493d36ec626b6698([
                            "total",
                            "label"
                        ], $ab6eb75b24f42828$export$22b082955e083ec3),
                        $ab6eb75b24f42828$export$493d36ec626b6698([
                            "total",
                            "value"
                        ], $ab6eb75b24f42828$export$98e628dec113755e),
                        $ab6eb75b24f42828$export$493d36ec626b6698([
                            "sub"
                        ], $ab6eb75b24f42828$export$a6b37472941cc417($ab6eb75b24f42828$export$871de8747c9eaa88([
                            $ab6eb75b24f42828$export$493d36ec626b6698([
                                "total",
                                "label"
                            ], $ab6eb75b24f42828$export$22b082955e083ec3),
                            $ab6eb75b24f42828$export$493d36ec626b6698([
                                "total",
                                "value"
                            ], $ab6eb75b24f42828$export$98e628dec113755e)
                        ], (label, total)=>({
                                label: label,
                                total: total
                            }))))
                    ], (label, total, sub)=>({
                            label: label,
                            total: total,
                            children: sub
                        })),
                    $ab6eb75b24f42828$export$871de8747c9eaa88([
                        $ab6eb75b24f42828$export$493d36ec626b6698([
                            "total",
                            "label"
                        ], $ab6eb75b24f42828$export$22b082955e083ec3),
                        $ab6eb75b24f42828$export$493d36ec626b6698([
                            "total",
                            "value"
                        ], $ab6eb75b24f42828$export$98e628dec113755e)
                    ], (label, total)=>({
                            label: label,
                            total: total
                        }))
                ])),
                totalrecords: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e)
            });
            try {
                const data = (await response.json())?.data;
                return toMsg($jqoka.ok(decoder(data)));
            } catch (error) {
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04(error)));
            }
        }
    });
}
function $0b52e672722f75d2$export$3918dddb3fcdd1e2(authentication, profile, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.dealerAnalysisStock(),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Get,
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        query: {
            benchmark: profile
        },
        expect: async (response)=>{
            if (!response.ok) {
                const httpStatusError = $0b52e672722f75d2$var$getHttpStatusErrors(response);
                if (httpStatusError) return toMsg(httpStatusError);
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04()));
            }
            const benchmarkDecoder = $ab6eb75b24f42828$export$e5185e241753e543({
                own: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                benchmark: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e)
            });
            const decoder = $ab6eb75b24f42828$export$e5185e241753e543({
                stock: benchmarkDecoder,
                askingprice: benchmarkDecoder,
                daysinstock: benchmarkDecoder,
                foundperday: benchmarkDecoder,
                viewedperday: benchmarkDecoder,
                averageaskingprice: benchmarkDecoder,
                daysinstockdistribution: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$871de8747c9eaa88([
                    $ab6eb75b24f42828$export$b610b8812bbcded9(0, $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$22b082955e083ec3)),
                    $ab6eb75b24f42828$export$b610b8812bbcded9(1, $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$a9a18ae5ba42aeab([
                        $ab6eb75b24f42828$export$22b082955e083ec3,
                        $ab6eb75b24f42828$export$98e628dec113755e
                    ]))),
                    $ab6eb75b24f42828$export$b610b8812bbcded9(2, $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$a9a18ae5ba42aeab([
                        $ab6eb75b24f42828$export$22b082955e083ec3,
                        $ab6eb75b24f42828$export$98e628dec113755e
                    ]))),
                    $ab6eb75b24f42828$export$b610b8812bbcded9(3, $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$a9a18ae5ba42aeab([
                        $ab6eb75b24f42828$export$22b082955e083ec3,
                        $ab6eb75b24f42828$export$98e628dec113755e
                    ]))),
                    $ab6eb75b24f42828$export$b610b8812bbcded9(4, $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$a9a18ae5ba42aeab([
                        $ab6eb75b24f42828$export$22b082955e083ec3,
                        $ab6eb75b24f42828$export$98e628dec113755e
                    ])))
                ], (top, ...rows)=>{
                    return top.slice(1).reduce((acc, header, index)=>{
                        acc[header] = {
                            label: header,
                            children: rows.map((row)=>({
                                    label: String(row[0]),
                                    total: Number(row[index + 1])
                                }))
                        };
                        return acc;
                    }, {});
                })),
                askingpricedistribution: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$871de8747c9eaa88([
                    $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$871de8747c9eaa88([
                        $ab6eb75b24f42828$export$b610b8812bbcded9(0, $ab6eb75b24f42828$export$22b082955e083ec3),
                        $ab6eb75b24f42828$export$b610b8812bbcded9(1, $ab6eb75b24f42828$export$98e628dec113755e)
                    ], (label, total)=>({
                            label: label,
                            total: total
                        })))
                ], (items)=>items.reduce((acc, item)=>{
                        acc[item.label] = item;
                        return acc;
                    }, {}))),
                profiles: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$e5185e241753e543({
                    label: $ab6eb75b24f42828$export$22b082955e083ec3,
                    value: $ab6eb75b24f42828$export$22b082955e083ec3
                })))
            });
            try {
                const data = (await response.json())?.data;
                return toMsg($jqoka.ok(decoder(data)));
            } catch (error) {
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04(error)));
            }
        }
    });
}
function $0b52e672722f75d2$export$6f2cf8dc2683e0aa(authentication, period, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.dealerAnalysisLeadsPerformance(),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Get,
        query: {
            startdate: period.startDate,
            enddate: period.endDate
        },
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        expect: async (response)=>{
            if (!response.ok) {
                const httpStatusError = $0b52e672722f75d2$var$getHttpStatusErrors(response);
                if (httpStatusError) return toMsg(httpStatusError);
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04()));
            }
            const decoder = $ab6eb75b24f42828$export$e5185e241753e543({
                dealerData: $ab6eb75b24f42828$export$a6b37472941cc417($ab6eb75b24f42828$export$e5185e241753e543({
                    id: $ab6eb75b24f42828$export$22b082955e083ec3,
                    name: $ab6eb75b24f42828$export$22b082955e083ec3
                })),
                table: $ab6eb75b24f42828$export$e5185e241753e543({
                    totals: $ab6eb75b24f42828$export$a6b37472941cc417($ab6eb75b24f42828$export$e5185e241753e543({
                        found: $ab6eb75b24f42828$export$98e628dec113755e,
                        seenAdverts: $ab6eb75b24f42828$export$98e628dec113755e,
                        hardLeads: $ab6eb75b24f42828$export$98e628dec113755e,
                        vehicleCount: $ab6eb75b24f42828$export$98e628dec113755e,
                        avgFound: $ab6eb75b24f42828$export$98e628dec113755e,
                        avgSeenAdverts: $ab6eb75b24f42828$export$98e628dec113755e
                    }))
                }),
                graph: $ab6eb75b24f42828$export$e5185e241753e543({
                    foundSeries: $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$a9a18ae5ba42aeab([
                        $ab6eb75b24f42828$export$98e628dec113755e,
                        $ab6eb75b24f42828$export$22b082955e083ec3
                    ]))),
                    seenAdvertsSeries: $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$a9a18ae5ba42aeab([
                        $ab6eb75b24f42828$export$98e628dec113755e,
                        $ab6eb75b24f42828$export$22b082955e083ec3
                    ]))),
                    hardLeadsSeries: $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$a9a18ae5ba42aeab([
                        $ab6eb75b24f42828$export$98e628dec113755e,
                        $ab6eb75b24f42828$export$22b082955e083ec3
                    ]))),
                    vehicleCountSeries: $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$a9a18ae5ba42aeab([
                        $ab6eb75b24f42828$export$98e628dec113755e,
                        $ab6eb75b24f42828$export$22b082955e083ec3
                    ])))
                })
            });
            try {
                const data = (await response.json())?.data;
                return toMsg($jqoka.ok(decoder(data)));
            } catch (error) {
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04(error)));
            }
        }
    });
}
function $0b52e672722f75d2$export$b3d015ef61bf89b9(authentication, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.dealerAnalysisMakeModel(),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Get,
        query: {},
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        expect: async (response)=>{
            if (!response.ok) {
                const httpStatusError = $0b52e672722f75d2$var$getHttpStatusErrors(response);
                if (httpStatusError) return toMsg(httpStatusError);
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04()));
            }
            const data = (await response.json())?.data;
            const decoder = $ab6eb75b24f42828$export$e5185e241753e543({
                askingprice: $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$a9a18ae5ba42aeab([
                    $ab6eb75b24f42828$export$22b082955e083ec3,
                    $ab6eb75b24f42828$export$98e628dec113755e
                ]))),
                daysinstock: $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$a9a18ae5ba42aeab([
                    $ab6eb75b24f42828$export$22b082955e083ec3,
                    $ab6eb75b24f42828$export$98e628dec113755e
                ]))),
                found: $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$a9a18ae5ba42aeab([
                    $ab6eb75b24f42828$export$22b082955e083ec3,
                    $ab6eb75b24f42828$export$98e628dec113755e
                ]))),
                viewed: $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$a9a18ae5ba42aeab([
                    $ab6eb75b24f42828$export$22b082955e083ec3,
                    $ab6eb75b24f42828$export$98e628dec113755e
                ])))
            });
            try {
                return toMsg($jqoka.ok(decoder(data)));
            } catch (error) {
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04(error)));
            }
        }
    });
}
function $0b52e672722f75d2$export$bb7ee46c8e4b6b24(authentication, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.dealerAnalysisCostBenefit(),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Get,
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        query: {},
        expect: async (response)=>{
            if (!response.ok) {
                const httpStatusError = $0b52e672722f75d2$var$getHttpStatusErrors(response);
                if (httpStatusError) return toMsg(httpStatusError);
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04()));
            }
            const decoder = $ab6eb75b24f42828$export$e5185e241753e543({
                totalvehicles: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                totalaskingprice: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                averagedaysinstock: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                goaldaysinstock: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                costaveragedaysinstock: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                costgoaldaysinstock: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                costsaving: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                grossmargin: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                benefitsgoaldaysinstock: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                turnoveraveragedaysinstock: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                turnovergoaldaysinstock: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                turnoverimprovement: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                morevehiclesgoaldaysinstock: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                interestrate: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                interestperday: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                writeoffrate: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                writeoffperday: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                costperday: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                graph: $ab6eb75b24f42828$export$e5185e241753e543({
                    cost: $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$a9a18ae5ba42aeab([
                        $ab6eb75b24f42828$export$98e628dec113755e,
                        $ab6eb75b24f42828$export$22b082955e083ec3
                    ]))),
                    benefits: $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$a9a18ae5ba42aeab([
                        $ab6eb75b24f42828$export$98e628dec113755e,
                        $ab6eb75b24f42828$export$22b082955e083ec3
                    ])))
                })
            });
            try {
                const data = (await response.json())?.data;
                return toMsg($jqoka.ok(decoder(data)));
            } catch (error) {
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04(error)));
            }
        }
    });
}
function $0b52e672722f75d2$export$12f64674bb7bf6e4(authentication, id, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.vehicle(id),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Get,
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        query: {},
        expect: async (response)=>{
            if (!response.ok) {
                const httpStatusError = $0b52e672722f75d2$var$getHttpStatusErrors(response);
                if (httpStatusError) return toMsg(httpStatusError);
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04()));
            }
            const decoder = $ab6eb75b24f42828$export$493d36ec626b6698([
                "vehicle",
                "0"
            ], $0b52e672722f75d2$var$vehicleDecoder);
            try {
                const data = (await response.json())?.data;
                return toMsg($jqoka.ok(decoder(data)));
            } catch (error) {
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04(error)));
            }
        }
    });
}
function $0b52e672722f75d2$export$d7b53e6d119ad4b4(authentication, vehicle, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.vehicleDashboard(vehicle),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Get,
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        query: {},
        expect: async (response)=>{
            if (!response.ok) {
                const httpStatusError = $0b52e672722f75d2$var$getHttpStatusErrors(response);
                if (httpStatusError) return toMsg(httpStatusError);
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04()));
            }
            const decoder = $ab6eb75b24f42828$export$e5185e241753e543({
                competition: $ab6eb75b24f42828$export$e5185e241753e543({
                    amount: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    highest: $ab6eb75b24f42828$export$e5185e241753e543({
                        askingprice: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                        name: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$22b082955e083ec3)
                    }),
                    lowest: $ab6eb75b24f42828$export$e5185e241753e543({
                        askingprice: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                        name: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$22b082955e083ec3)
                    })
                }),
                contact: $ab6eb75b24f42828$export$e5185e241753e543({
                    total: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    graph: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$871de8747c9eaa88([
                        $ab6eb75b24f42828$export$b610b8812bbcded9(0, $ab6eb75b24f42828$export$98e628dec113755e),
                        $ab6eb75b24f42828$export$b610b8812bbcded9(1, $ab6eb75b24f42828$export$98e628dec113755e)
                    ], (x, y)=>[
                            x,
                            y
                        ])))
                }),
                found: $ab6eb75b24f42828$export$e5185e241753e543({
                    total: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    graph: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$871de8747c9eaa88([
                        $ab6eb75b24f42828$export$b610b8812bbcded9(0, $ab6eb75b24f42828$export$98e628dec113755e),
                        $ab6eb75b24f42828$export$b610b8812bbcded9(1, $ab6eb75b24f42828$export$98e628dec113755e)
                    ], (x, y)=>[
                            x,
                            y
                        ])))
                }),
                viewed: $ab6eb75b24f42828$export$e5185e241753e543({
                    total: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    graph: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$871de8747c9eaa88([
                        $ab6eb75b24f42828$export$b610b8812bbcded9(0, $ab6eb75b24f42828$export$98e628dec113755e),
                        $ab6eb75b24f42828$export$b610b8812bbcded9(1, $ab6eb75b24f42828$export$98e628dec113755e)
                    ], (x, y)=>[
                            x,
                            y
                        ])))
                }),
                performance: $ab6eb75b24f42828$export$e5185e241753e543({
                    advertisementquality: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    askingprice: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    daysinstock: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e)
                }),
                pricehistory: $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$e5185e241753e543({
                    currentaskingprice: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    date: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    previousaskingprice: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e)
                })),
                stock: $ab6eb75b24f42828$export$a9a18ae5ba42aeab([
                    $ab6eb75b24f42828$export$e5185e241753e543({
                        vehicle: $ab6eb75b24f42828$export$2f23118c22fb2630($0b52e672722f75d2$var$vehicleDecoder),
                        vehicle_count: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                        vehicle_hasrecalc: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$87b259aa03e3d267)
                    }),
                    $ab6eb75b24f42828$export$9094b7742a87955e(null)
                ]),
                stocksummary: $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$e5185e241753e543({
                    advertisementquality: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    askingpricedifferencepercentage: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    askingpricetoohigh: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    askingpricetotal: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    daysinstockaverage: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    daysinstockdistribution: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$a9a18ae5ba42aeab([
                        $ab6eb75b24f42828$export$22b082955e083ec3,
                        $ab6eb75b24f42828$export$98e628dec113755e
                    ])))),
                    found: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    id: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$22b082955e083ec3),
                    name: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$22b082955e083ec3),
                    place: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$22b082955e083ec3),
                    turnoveraveragedaysinstock: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    vehiclecount: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    viewed: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e)
                }))
            });
            try {
                const data = (await response.json())?.data;
                return toMsg($jqoka.ok(decoder(data)));
            } catch (error) {
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04(error)));
            }
        }
    });
}
function $0b52e672722f75d2$export$e06b153790910c7a(authentication, vehicle, type, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.vehiclePriceEffect(vehicle),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Get,
        query: {
            type: type
        },
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        expect: async (response)=>{
            if (!response.ok) {
                const httpStatusError = $0b52e672722f75d2$var$getHttpStatusErrors(response);
                if (httpStatusError) return toMsg(httpStatusError);
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04()));
            }
            const decoder = $ab6eb75b24f42828$export$e5185e241753e543({
                graph: $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$a9a18ae5ba42aeab([
                    $ab6eb75b24f42828$export$22b082955e083ec3,
                    $ab6eb75b24f42828$export$98e628dec113755e
                ]))),
                total: $ab6eb75b24f42828$export$98e628dec113755e
            });
            try {
                const data = (await response.json())?.data;
                return toMsg($jqoka.ok(decoder(data)));
            } catch (error) {
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04(error)));
            }
        }
    });
}
function $0b52e672722f75d2$export$fbbc9cbc96cb2f25(authentication, vehicle, isSold, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.vehicleCompetition(vehicle),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Get,
        query: {
            sold: isSold ? "1" : "0"
        },
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        expect: async (response)=>{
            if (!response.ok) {
                const httpStatusError = $0b52e672722f75d2$var$getHttpStatusErrors(response);
                if (httpStatusError) return toMsg(httpStatusError);
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04()));
            }
            const decoder = $ab6eb75b24f42828$export$871de8747c9eaa88([
                $ab6eb75b24f42828$export$e0f35d825088c098("vehicle", $ab6eb75b24f42828$export$2f23118c22fb2630($0b52e672722f75d2$var$competingVehicleDecoder)),
                $ab6eb75b24f42828$export$e0f35d825088c098("vehicle_count", $ab6eb75b24f42828$export$98e628dec113755e)
            ], (vehicles, amountOfVehicles)=>({
                    vehicles: vehicles,
                    amountOfVehicles: amountOfVehicles
                }));
            try {
                const data = (await response.json())?.data;
                return toMsg($jqoka.ok(decoder(data)));
            } catch (error) {
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04(error)));
            }
        }
    });
}
function $0b52e672722f75d2$export$a26d195ae78841ad(authentication, vehicle, isSold, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.vehiclePriceHistory(vehicle),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Get,
        query: {
            sold: isSold ? "1" : "0"
        },
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        expect: async (response)=>{
            if (!response.ok) {
                const httpStatusError = $0b52e672722f75d2$var$getHttpStatusErrors(response);
                if (httpStatusError) return toMsg(httpStatusError);
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04()));
            }
            const decoder = $ab6eb75b24f42828$export$871de8747c9eaa88([
                $ab6eb75b24f42828$export$e0f35d825088c098("graph", $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$a9a18ae5ba42aeab([
                    $ab6eb75b24f42828$export$133fc36489ac9add($ab6eb75b24f42828$export$22b082955e083ec3),
                    $ab6eb75b24f42828$export$133fc36489ac9add($ab6eb75b24f42828$export$98e628dec113755e)
                ])))),
                $ab6eb75b24f42828$export$e0f35d825088c098("vehicle", $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$e5185e241753e543({
                    id: $ab6eb75b24f42828$export$98e628dec113755e,
                    pricehistory: $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$e5185e241753e543({
                        date: $ab6eb75b24f42828$export$98e628dec113755e,
                        price: $ab6eb75b24f42828$export$98e628dec113755e
                    }))
                })))
            ], (graph, vehicles)=>({
                    graph: graph,
                    vehicleHistory: new Map(vehicles.map(({ id: id, pricehistory: pricehistory })=>[
                            id,
                            pricehistory
                        ]))
                }));
            try {
                const data = (await response.json())?.data;
                return toMsg($jqoka.ok(decoder(data)));
            } catch (error) {
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04(error)));
            }
        }
    });
}
function $0b52e672722f75d2$export$b003f91e5f568c3f(authentication, vehicle, isSold, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.vehicleGeography(vehicle),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Get,
        query: {
            sold: isSold ? "1" : "0"
        },
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        expect: async (response)=>{
            if (!response.ok) {
                const httpStatusError = $0b52e672722f75d2$var$getHttpStatusErrors(response);
                if (httpStatusError) return toMsg(httpStatusError);
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04()));
            }
            const decoder = $ab6eb75b24f42828$export$871de8747c9eaa88([
                $ab6eb75b24f42828$export$e0f35d825088c098("graph", $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$a9a18ae5ba42aeab([
                    $ab6eb75b24f42828$export$133fc36489ac9add($ab6eb75b24f42828$export$22b082955e083ec3),
                    $ab6eb75b24f42828$export$133fc36489ac9add($ab6eb75b24f42828$export$98e628dec113755e)
                ])))),
                $ab6eb75b24f42828$export$e0f35d825088c098("vehicle", $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$e5185e241753e543({
                    id: $ab6eb75b24f42828$export$22b082955e083ec3,
                    latitude: $ab6eb75b24f42828$export$98e628dec113755e,
                    longitude: $ab6eb75b24f42828$export$98e628dec113755e
                })))
            ], (graph, vehicles)=>({
                    graph: graph,
                    vehicleLocations: new Map(vehicles.map(({ id: id, latitude: latitude, longitude: longitude })=>[
                            id,
                            {
                                latitude: latitude,
                                longitude: longitude
                            }
                        ]))
                }));
            try {
                const data = (await response.json())?.data;
                return toMsg($jqoka.ok(decoder(data)));
            } catch (error) {
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04(error)));
            }
        }
    });
}
function $0b52e672722f75d2$export$2503cc23c03a566(authentication, vehicle, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.vehicleReach(vehicle),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Get,
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        query: {},
        expect: async (response)=>{
            if (!response.ok) {
                const httpStatusError = $0b52e672722f75d2$var$getHttpStatusErrors(response);
                if (httpStatusError) return toMsg(httpStatusError);
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04()));
            }
            const decoder = $ab6eb75b24f42828$export$e5185e241753e543({
                dealerviews: $ab6eb75b24f42828$export$e5185e241753e543({
                    total: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    graph: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$98e628dec113755e)))
                }),
                found: $ab6eb75b24f42828$export$e5185e241753e543({
                    total: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    graph: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$98e628dec113755e)))
                }),
                clicks: $ab6eb75b24f42828$export$e5185e241753e543({
                    total: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    graph: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$98e628dec113755e)))
                }),
                viewed: $ab6eb75b24f42828$export$e5185e241753e543({
                    total: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    graph: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$98e628dec113755e)))
                }),
                stockviews: $ab6eb75b24f42828$export$e5185e241753e543({
                    total: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    graph: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$98e628dec113755e)))
                }),
                reviewviews: $ab6eb75b24f42828$export$e5185e241753e543({
                    total: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    graph: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$98e628dec113755e)))
                }),
                contact: $ab6eb75b24f42828$export$e5185e241753e543({
                    total: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    graph: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$98e628dec113755e))),
                    distribution: $ab6eb75b24f42828$export$a6b37472941cc417($ab6eb75b24f42828$export$e0f35d825088c098("total", $ab6eb75b24f42828$export$871de8747c9eaa88([
                        $ab6eb75b24f42828$export$e5185e241753e543({
                            value: $ab6eb75b24f42828$export$98e628dec113755e,
                            label: $ab6eb75b24f42828$export$22b082955e083ec3
                        })
                    ], ({ value: total, label: label })=>({
                            total: total,
                            label: label
                        }))))
                }),
                share: $ab6eb75b24f42828$export$e5185e241753e543({
                    total: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    graph: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$98e628dec113755e))),
                    distribution: $ab6eb75b24f42828$export$a6b37472941cc417($ab6eb75b24f42828$export$e0f35d825088c098("total", $ab6eb75b24f42828$export$871de8747c9eaa88([
                        $ab6eb75b24f42828$export$e5185e241753e543({
                            value: $ab6eb75b24f42828$export$98e628dec113755e,
                            label: $ab6eb75b24f42828$export$22b082955e083ec3
                        })
                    ], ({ value: total, label: label })=>({
                            total: total,
                            label: label
                        }))))
                })
            });
            try {
                const data = (await response.json())?.data;
                return toMsg($jqoka.ok(decoder(data)));
            } catch (error) {
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04(error)));
            }
        }
    });
}
function $0b52e672722f75d2$export$5a37493df37ee35c() {
    // toMsg: () => msg, // options?, // dealer,
    throw new Error("Not implemented");
// const priceRequestOptions: RequestOptionsArgs = {
//     path: AtaApiEndpoints.dealerCompetitionPrice(),
//     method: Http.RequestMethod.Post,
//     query: {
//         type: 'price',
//     },
//     body: {
//         data: options,
//     },
// };
//
// const geoRequestOptions: RequestOptionsArgs = {
//     path: AtaApiEndpoints.dealerCompetitionGeo(),
//     method: Http.RequestMethod.Post,
//     body: {
//         data: options,
//     },
// };
//
// const priceResponse$ = Observable.of(constructRequest(priceRequestOptions))
//     .switchMap((request) => this.http.request(request))
//     .catch(AtaApiService.convertErrorResponse)
//     .map(AtaApiService.convertResponse);
//
// const geoResponse$ = Observable.of(constructRequest(geoRequestOptions))
//     .switchMap((request) => this.http.request(request))
//     .catch(AtaApiService.convertErrorResponse)
//     .map(AtaApiService.convertResponse);
//
// return Observable.combineLatest(priceResponse$, geoResponse$)
//     .catch((error) => [])
//     .map(([price, geo]) => {
//         const result = {
//             data: {
//                 vehicleMakes: [],
//                 vehicleModels: [],
//                 dealers: [],
//             },
//         };
//
//         if (price && price.data) {
//             if (price.data.graph && geo && geo.data && geo.data.graph) {
//                 result.data.dealers = price.data.graph.reduce(
//                     (mResult, priceRow, index) => {
//                         const geoRow =
//                             geo.data.graph.find(
//                                 (data) =>
//                                     data['dealerid'] ===
//                                     priceRow['AANBIEDER_ID']
//                             ) || {};
//
//                         return [
//                             ...mResult,
//                             {
//                                 id: priceRow['AANBIEDER_ID'],
//                                 isOwn: priceRow['zichzelf'],
//                                 name: priceRow['d_naam'],
//                                 place: priceRow['d_plaats'],
//                                 latitude: geoRow['latitude'],
//                                 longitude: geoRow['longitude'],
//                                 countOfVehicles: Number.parseInt(
//                                     priceRow['aantal']
//                                 ),
//                                 averageDifference:
//                                     Number.parseFloat(
//                                         priceRow['verschil']
//                                     ) / 100,
//                                 averageDifferenceString:
//                                     priceRow['verschil'],
//                                 averageDaysInStock: Number.parseInt(
//                                     priceRow['statijd']
//                                 ),
//                                 averageViewed: geoRow[
//                                     'avgofviewed'
//                                 ] as number,
//                                 averageFound: geoRow[
//                                     'avgoffound'
//                                 ] as number,
//                             },
//                         ];
//                     },
//                     []
//                 );
//             }
//
//             if (price.data.makes) {
//                 result.data.vehicleMakes = [
//                     ...result.data.vehicleMakes,
//                     ...price.data.makes.map((make) => ({
//                         key: make,
//                         value: make,
//                         isPopular: false,
//                     })),
//                 ];
//             }
//
//             if (price.data.makes) {
//                 result.data.vehicleMakes = [
//                     ...result.data.vehicleMakes,
//                     ...price.data.makespopular.map((make) => ({
//                         key: make,
//                         value: make,
//                         isPopular: true,
//                     })),
//                 ];
//             }
//
//             if (price.data.models) {
//                 result.data.vehicleModels = price.data.models.map(
//                     (model) => ({
//                         key: model.model,
//                         value: model.model,
//                         vehicleMake: model.make,
//                     })
//                 );
//             }
//         }
//
//         return result;
//     })
//     .catch((error) => {
//         return Observable.of([]);
//     });
}
function $0b52e672722f75d2$export$c409007959eb9b2f(authentication, path, dateRange, toMsg) {
    const [startdate, enddate] = dateRange ?? [];
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: `${(0, $fb0eT.apiDomain)}/${path}`,
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Get,
        headers: {
            "Content-Type": "text/csv; charset=utf-8",
            ...$0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication)
        },
        query: {
            _F: "csv",
            token: authentication,
            ...startdate && enddate ? {
                startdate: startdate,
                enddate: enddate
            } : {}
        },
        expect: async (response)=>{
            const data = await response.blob();
            const csv = window.URL.createObjectURL(data);
            window.location.assign(csv);
            return toMsg(response.ok);
        }
    });
}
function $0b52e672722f75d2$export$be6367adeb077076(authentication, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.settingsStock(),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Get,
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        query: {},
        expect: async (response)=>{
            if (!response.ok) {
                const httpStatusError = $0b52e672722f75d2$var$getHttpStatusErrors(response);
                if (httpStatusError) return toMsg(httpStatusError);
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04()));
            }
            const decoder = $ab6eb75b24f42828$export$e5185e241753e543({
                excludedvehicleids: $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$22b082955e083ec3),
                mileagemax: $ab6eb75b24f42828$export$133fc36489ac9add($ab6eb75b24f42828$export$98e628dec113755e),
                mileagemin: $ab6eb75b24f42828$export$133fc36489ac9add($ab6eb75b24f42828$export$98e628dec113755e),
                reachfiltered: $ab6eb75b24f42828$export$87b259aa03e3d267,
                vehicleimported: $ab6eb75b24f42828$export$87b259aa03e3d267,
                vehiclenew: $ab6eb75b24f42828$export$87b259aa03e3d267,
                vehiclenotimported: $ab6eb75b24f42828$export$87b259aa03e3d267
            });
            try {
                const data = (await response.json())?.data?.stock;
                return toMsg($jqoka.ok(decoder(data)));
            } catch (error) {
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04(error)));
            }
        }
    });
}
function $0b52e672722f75d2$export$528313ee297bca90(authentication, data, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.settingsStock(),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Patch,
        body: {
            data: data
        },
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        query: {},
        expect: async (response)=>{
            if (!response.ok) {
                const httpStatusError = $0b52e672722f75d2$var$getHttpStatusErrors(response);
                if (httpStatusError) return toMsg(httpStatusError);
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04()));
            }
            const decoder = $ab6eb75b24f42828$export$e5185e241753e543({
                id: $ab6eb75b24f42828$export$a9a18ae5ba42aeab([
                    $ab6eb75b24f42828$export$22b082955e083ec3,
                    $ab6eb75b24f42828$export$871de8747c9eaa88([
                        $ab6eb75b24f42828$export$98e628dec113755e
                    ], String)
                ])
            });
            try {
                const data = (await response.json())?.data;
                return toMsg($jqoka.ok(decoder(data)));
            } catch (error) {
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04(error)));
            }
        }
    });
}
function $0b52e672722f75d2$export$d39fb861e07ce4f0(authentication, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.settingsStock(),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Delete,
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        query: {},
        expect: async (response)=>toMsg(response.ok)
    });
}
function $0b52e672722f75d2$export$f85c8b69eed70986(authentication, id, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.settingsCompetingVehicles(id),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Get,
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        query: {},
        expect: async (response)=>{
            if (!response.ok) {
                const httpStatusError = $0b52e672722f75d2$var$getHttpStatusErrors(response);
                if (httpStatusError) return toMsg(httpStatusError);
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04()));
            }
            const decoder = $ab6eb75b24f42828$export$e5185e241753e543({
                agedifference: $ab6eb75b24f42828$export$98e628dec113755e,
                agesameyear: $ab6eb75b24f42828$export$87b259aa03e3d267,
                aircon: $ab6eb75b24f42828$export$87b259aa03e3d267,
                bovagmember: $ab6eb75b24f42828$export$87b259aa03e3d267,
                climatecontrol: $ab6eb75b24f42828$export$87b259aa03e3d267,
                leather: $ab6eb75b24f42828$export$87b259aa03e3d267,
                maintenancebooklet: $ab6eb75b24f42828$export$87b259aa03e3d267,
                makedealer: $ab6eb75b24f42828$export$87b259aa03e3d267,
                mileagedifference: $ab6eb75b24f42828$export$98e628dec113755e,
                navigation: $ab6eb75b24f42828$export$87b259aa03e3d267,
                universaldealer: $ab6eb75b24f42828$export$87b259aa03e3d267,
                vehiclecolor: $ab6eb75b24f42828$export$87b259aa03e3d267,
                vehicledoors: $ab6eb75b24f42828$export$87b259aa03e3d267,
                vehicleenginecapacity: $ab6eb75b24f42828$export$87b259aa03e3d267,
                vehiclefuel: $ab6eb75b24f42828$export$87b259aa03e3d267,
                vehiclemake: $ab6eb75b24f42828$export$87b259aa03e3d267,
                vehiclemodel: $ab6eb75b24f42828$export$87b259aa03e3d267,
                vehiclepower: $ab6eb75b24f42828$export$87b259aa03e3d267,
                vehicletransmission: $ab6eb75b24f42828$export$87b259aa03e3d267,
                vehicletrimpackage: $ab6eb75b24f42828$export$87b259aa03e3d267,
                vehicleweight: $ab6eb75b24f42828$export$87b259aa03e3d267,
                warrantyautopas: $ab6eb75b24f42828$export$87b259aa03e3d267,
                warrantybovag: $ab6eb75b24f42828$export$87b259aa03e3d267,
                warrantybrand: $ab6eb75b24f42828$export$87b259aa03e3d267,
                warrantycarfax: $ab6eb75b24f42828$export$87b259aa03e3d267,
                warrantyhome: $ab6eb75b24f42828$export$87b259aa03e3d267,
                towbar: $ab6eb75b24f42828$export$87b259aa03e3d267,
                rearviewcamera: $ab6eb75b24f42828$export$87b259aa03e3d267,
                seatheating: $ab6eb75b24f42828$export$87b259aa03e3d267,
                panoramicroof: $ab6eb75b24f42828$export$87b259aa03e3d267,
                cruisecontrol: $ab6eb75b24f42828$export$87b259aa03e3d267,
                adaptivecruisecontrol: $ab6eb75b24f42828$export$87b259aa03e3d267,
                parkingsensors: $ab6eb75b24f42828$export$87b259aa03e3d267,
                applecarplay: $ab6eb75b24f42828$export$87b259aa03e3d267
            });
            try {
                const data = (await response.json())?.data?.competingvehicles;
                return toMsg($jqoka.ok(decoder(data)));
            } catch (error) {
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04(error)));
            }
        }
    });
}
function $0b52e672722f75d2$export$de4a167f7c9d1b43(authentication, id, data, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.settingsCompetingVehicles(id),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Patch,
        body: {
            data: data
        },
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        query: {},
        expect: async (response)=>{
            if (!response.ok) {
                const httpStatusError = $0b52e672722f75d2$var$getHttpStatusErrors(response);
                if (httpStatusError) return toMsg(httpStatusError);
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04()));
            }
            const decoder = $ab6eb75b24f42828$export$e5185e241753e543({
                id: $ab6eb75b24f42828$export$22b082955e083ec3
            });
            try {
                const data = (await response.json())?.data;
                return toMsg($jqoka.ok(decoder(data)));
            } catch (error) {
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04(error)));
            }
        }
    });
}
function $0b52e672722f75d2$export$f30d7d3a2dd4715(authentication, id, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.settingsCompetingVehicles(id),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Delete,
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        query: {},
        expect: async (response)=>toMsg(response.ok)
    });
}
function $0b52e672722f75d2$export$b0a0681fc38b10d1(authentication, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.settingsNotifications(),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Get,
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        query: {},
        expect: async (response)=>{
            if (!response.ok) {
                const httpStatusError = $0b52e672722f75d2$var$getHttpStatusErrors(response);
                if (httpStatusError) return toMsg(httpStatusError);
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04()));
            }
            const decoder = $ab6eb75b24f42828$export$e5185e241753e543({
                alertadvertisementseen: $ab6eb75b24f42828$export$98e628dec113755e,
                alertdaysinstock: $ab6eb75b24f42828$export$98e628dec113755e,
                alertpricechange: $ab6eb75b24f42828$export$98e628dec113755e,
                emailclicks: $ab6eb75b24f42828$export$87b259aa03e3d267,
                emaildaysinstock: $ab6eb75b24f42828$export$87b259aa03e3d267,
                emailfrequency: $ab6eb75b24f42828$export$22b082955e083ec3,
                emailpricechange: $ab6eb75b24f42828$export$87b259aa03e3d267,
                emailrecipients: $ab6eb75b24f42828$export$22b082955e083ec3,
                goaldaysinstock: $ab6eb75b24f42828$export$98e628dec113755e
            });
            try {
                const data = (await response.json())?.data?.notifications;
                return toMsg($jqoka.ok(decoder(data)));
            } catch (error) {
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04(error)));
            }
        }
    });
}
function $0b52e672722f75d2$export$521c0d1ccb71a481(authentication, data, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.settingsNotifications(),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Patch,
        body: {
            data: data
        },
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        query: {},
        expect: async (response)=>{
            if (!response.ok) {
                const httpStatusError = $0b52e672722f75d2$var$getHttpStatusErrors(response);
                if (httpStatusError) return toMsg(httpStatusError);
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04()));
            }
            const decoder = $ab6eb75b24f42828$export$e5185e241753e543({
                id: $ab6eb75b24f42828$export$a9a18ae5ba42aeab([
                    $ab6eb75b24f42828$export$871de8747c9eaa88([
                        $ab6eb75b24f42828$export$98e628dec113755e
                    ], String),
                    $ab6eb75b24f42828$export$22b082955e083ec3
                ])
            });
            try {
                const data = (await response.json())?.data;
                return toMsg($jqoka.ok(decoder(data)));
            } catch (error) {
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04(error)));
            }
        }
    });
}
function $0b52e672722f75d2$export$688471111d91c7fb(authentication, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.settingsNotifications(),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Delete,
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        query: {},
        expect: async (response)=>toMsg(response.ok)
    });
}
function $0b52e672722f75d2$export$5204726068cfc3f1(authentication, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.settingsDealerProfiles(),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Get,
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        query: {},
        expect: async (response)=>{
            if (!response.ok) {
                const httpStatusError = $0b52e672722f75d2$var$getHttpStatusErrors(response);
                if (httpStatusError) return toMsg(httpStatusError);
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04()));
            }
            const decoder = $ab6eb75b24f42828$export$a9a18ae5ba42aeab([
                $ab6eb75b24f42828$export$e0f35d825088c098("competingdealers", $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$871de8747c9eaa88([
                    $ab6eb75b24f42828$export$e5185e241753e543({
                        name: $ab6eb75b24f42828$export$22b082955e083ec3,
                        id: $ab6eb75b24f42828$export$22b082955e083ec3,
                        dealerlist: $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$e5185e241753e543({
                            id: $ab6eb75b24f42828$export$22b082955e083ec3,
                            name: $ab6eb75b24f42828$export$22b082955e083ec3
                        }))
                    })
                ], ({ id: id, name: name, dealerlist: dealers })=>({
                        id: id,
                        name: name,
                        dealers: dealers
                    })))),
                $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$9094b7742a87955e(null))
            ]);
            try {
                const data = (await response.json())?.data;
                return toMsg($jqoka.ok(decoder(data)));
            } catch (error) {
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04(error)));
            }
        }
    });
}
function $0b52e672722f75d2$export$11d1cfca7e1cc010(authentication, profile, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: profile?.id ? $0b52e672722f75d2$var$AtaApiEndpoints.settingsDealerProfile(profile?.id) : $0b52e672722f75d2$var$AtaApiEndpoints.settingsDealerProfiles(),
        method: profile?.id ? $e3dd86d6587fafa3$export$8695620d48fe67d.Patch : $e3dd86d6587fafa3$export$8695620d48fe67d.Post,
        body: {
            data: {
                id: profile?.id ?? null,
                name: profile.name,
                dealerlist: profile.dealers.map((dealer)=>({
                        id: dealer.id,
                        name: dealer.name
                    })),
                dealerids: profile.dealers.map((dealer)=>dealer.id)
            }
        },
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        query: {},
        expect: async (response)=>{
            if (!response.ok) {
                const httpStatusError = $0b52e672722f75d2$var$getHttpStatusErrors(response);
                if (httpStatusError) return toMsg(httpStatusError);
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04()));
            }
            const decoder = $ab6eb75b24f42828$export$e5185e241753e543({
                id: $ab6eb75b24f42828$export$22b082955e083ec3
            });
            try {
                const data = (await response.json())?.data;
                return toMsg($jqoka.ok(decoder(data)));
            } catch (error) {
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04(error)));
            }
        }
    });
}
function $0b52e672722f75d2$export$a372f3ec5b6effb0(authentication, profile, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.settingsDealerProfile(profile?.id),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Delete,
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        query: {},
        expect: async (response)=>toMsg(response.ok)
    });
}
function $0b52e672722f75d2$export$87e53aa8c3bba037(authentication, scenario, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.settingsScenario(scenario.id),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Delete,
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        query: {},
        expect: async (response)=>toMsg(response.ok)
    });
}
function $0b52e672722f75d2$export$e76d47496ef8fe27(authentication, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.settingsTestMail(),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Get,
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        query: {},
        expect: async (response)=>{
            if (!response.ok) {
                const httpStatusError = $0b52e672722f75d2$var$getHttpStatusErrors(response);
                if (httpStatusError) return toMsg(httpStatusError);
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04()));
            }
            const decoder = $ab6eb75b24f42828$export$e5185e241753e543({
                error: $ab6eb75b24f42828$export$87b259aa03e3d267
            });
            try {
                const data = (await response.json())?.data;
                return toMsg($jqoka.ok(decoder(data)));
            } catch (error) {
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04(error)));
            }
        }
    });
}
function $0b52e672722f75d2$export$5c0f379364891dee(authentication, filters, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.dealerSearch(),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Post,
        body: {
            data: {
                dealernaam: filters.search ?? "",
                regio: Array.from(filters.provinces?.values() ?? []),
                soortaanbieder: Array.from(filters.dealerTypes?.values() ?? []),
                dealermerk: Array.from(filters.dealerMakes?.values() ?? []),
                merk: Array.from(filters.stockMakes?.values() ?? [])
            }
        },
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        query: {},
        expect: async (response)=>{
            if (!response.ok) {
                const httpStatusError = $0b52e672722f75d2$var$getHttpStatusErrors(response);
                if (httpStatusError) return toMsg(httpStatusError);
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04()));
            }
            const decoder = $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$871de8747c9eaa88([
                $ab6eb75b24f42828$export$e5185e241753e543({
                    key: $ab6eb75b24f42828$export$22b082955e083ec3,
                    value: $ab6eb75b24f42828$export$22b082955e083ec3
                })
            ], (item)=>({
                    id: item.key,
                    name: item.value
                })));
            try {
                const data = (await response.json())?.data;
                return toMsg($jqoka.ok(decoder(data)));
            } catch (error) {
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04(error)));
            }
        }
    });
}
function $0b52e672722f75d2$export$249d34085d7c95ed(authentication, scenario, toMsg) {
    const createScenarioRequest = $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.settingsScenarios(),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Post,
        body: {
            name: scenario.name
        },
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        query: {},
        expect: async (response)=>{
            if (!response.ok) {
                if (response.status === 401) return $jqoka.err($73731a0695accb65$export$5c773811ae1e141b());
                return $jqoka.err($73731a0695accb65$export$efbc88c27b0be04());
            }
            const decoder = $ab6eb75b24f42828$export$e0f35d825088c098("id", $ab6eb75b24f42828$export$22b082955e083ec3);
            try {
                const data = (await response.json())?.data;
                return $jqoka.ok(decoder(data));
            } catch (error) {
                return $jqoka.err($73731a0695accb65$export$efbc88c27b0be04(error));
            }
        }
    });
    return (async ()=>$jqoka.match(await createScenarioRequest, {
            Err: (error)=>Promise.resolve(toMsg($jqoka.err(error))),
            Ok: (scenarioId)=>$0b52e672722f75d2$export$cd857b2e3fb3b50(authentication, {
                    ...scenario,
                    id: scenarioId
                }, toMsg)
        }))();
}
function $0b52e672722f75d2$export$cd857b2e3fb3b50(authentication, scenario, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: scenario.id ? $0b52e672722f75d2$var$AtaApiEndpoints.settingsScenario(scenario.id) : $0b52e672722f75d2$var$AtaApiEndpoints.settingsScenarios(),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Patch,
        body: {
            data: scenario
        },
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        query: {},
        expect: async (response)=>{
            if (!response.ok) {
                const httpStatusError = $0b52e672722f75d2$var$getHttpStatusErrors(response);
                if (httpStatusError) return toMsg(httpStatusError);
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04()));
            }
            const decoder = $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$e5185e241753e543({
                id: $ab6eb75b24f42828$export$22b082955e083ec3,
                name: $ab6eb75b24f42828$export$22b082955e083ec3,
                dealers: $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$22b082955e083ec3)
            }));
            try {
                const data = (await response.json())?.data?.clusters;
                const decodedData = decoder(data);
                const updatedScenario = {
                    ...scenario,
                    clusters: decodedData
                };
                return toMsg($jqoka.ok(updatedScenario));
            } catch (error) {
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04(error)));
            }
        }
    });
}
function $0b52e672722f75d2$export$6006eb61c8267e5d(authentication, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.settingsDealerProfileFilters(),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Get,
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        query: {},
        expect: async (response)=>{
            if (!response.ok) {
                const httpStatusError = $0b52e672722f75d2$var$getHttpStatusErrors(response);
                if (httpStatusError) return toMsg(httpStatusError);
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04()));
            }
            const itemDecoder = $ab6eb75b24f42828$export$e5185e241753e543({
                key: $ab6eb75b24f42828$export$22b082955e083ec3,
                value: $ab6eb75b24f42828$export$22b082955e083ec3
            });
            const decoder = $ab6eb75b24f42828$export$871de8747c9eaa88([
                $ab6eb75b24f42828$export$e0f35d825088c098("merken", $ab6eb75b24f42828$export$2f23118c22fb2630(itemDecoder)),
                $ab6eb75b24f42828$export$e0f35d825088c098("provincies", $ab6eb75b24f42828$export$2f23118c22fb2630(itemDecoder)),
                $ab6eb75b24f42828$export$e0f35d825088c098("soortaanbieders", $ab6eb75b24f42828$export$2f23118c22fb2630(itemDecoder))
            ], (makes, provinces, dealerTypes)=>({
                    makes: makes,
                    provinces: provinces,
                    dealerTypes: dealerTypes
                }));
            try {
                const json = (await response.json())?.data;
                return toMsg($jqoka.ok(decoder(json)));
            } catch (error) {
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04(error)));
            }
        }
    });
}
function $0b52e672722f75d2$export$d941a330948d4ba8(authentication, licenseplate, mileage, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.taxation(),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Post,
        body: {
            data: {
                licenseplate: licenseplate,
                mileage: mileage
            }
        },
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        query: {},
        expect: async (response)=>{
            if (!response.ok) {
                const httpStatusError = $0b52e672722f75d2$var$getHttpStatusErrors(response);
                if (httpStatusError) return toMsg(httpStatusError);
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04()));
            }
            if (response.status === 204) return toMsg($jqoka.err($73731a0695accb65$export$22888f5e2c523c92()));
            const decoder = $ab6eb75b24f42828$export$e5185e241753e543({
                id: $ab6eb75b24f42828$export$22b082955e083ec3
            });
            try {
                const data = (await response.json())?.data;
                return toMsg($jqoka.ok(decoder(data)));
            } catch (error) {
                return toMsg($jqoka.err($73731a0695accb65$export$8c3da4ee41db947e(error)));
            }
        }
    });
}
function $0b52e672722f75d2$export$f0c25d078d304456(authentication, id, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.taxation(id),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Get,
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        query: {},
        expect: async (response)=>{
            if (!response.ok) {
                const httpStatusError = $0b52e672722f75d2$var$getHttpStatusErrors(response);
                if (httpStatusError) return toMsg(httpStatusError);
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04()));
            }
            const decoder = $ab6eb75b24f42828$export$e5185e241753e543({
                id: $ab6eb75b24f42828$export$22b082955e083ec3,
                vehicle: $ab6eb75b24f42828$export$2f23118c22fb2630($0b52e672722f75d2$var$vehicleDecoder)
            });
            try {
                const json = await response.json();
                return toMsg($jqoka.ok(decoder({
                    ...json?.data,
                    id: json?.id
                })?.vehicle[0]));
            } catch (error) {
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04(error)));
            }
        }
    });
}
function $0b52e672722f75d2$export$f8f090d64e3c787a(authentication, vehicle, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.taxationDashboard(vehicle),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Get,
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        query: {},
        expect: async (response)=>{
            if (!response.ok) {
                const httpStatusError = $0b52e672722f75d2$var$getHttpStatusErrors(response);
                if (httpStatusError) return toMsg(httpStatusError);
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04()));
            }
            const decoder = $ab6eb75b24f42828$export$e5185e241753e543({
                competition: $ab6eb75b24f42828$export$e5185e241753e543({
                    amount: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    highest: $ab6eb75b24f42828$export$e5185e241753e543({
                        askingprice: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                        name: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$22b082955e083ec3)
                    }),
                    lowest: $ab6eb75b24f42828$export$e5185e241753e543({
                        askingprice: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                        name: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$22b082955e083ec3)
                    })
                }),
                contact: $ab6eb75b24f42828$export$e5185e241753e543({
                    total: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    graph: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$871de8747c9eaa88([
                        $ab6eb75b24f42828$export$b610b8812bbcded9(0, $ab6eb75b24f42828$export$98e628dec113755e),
                        $ab6eb75b24f42828$export$b610b8812bbcded9(1, $ab6eb75b24f42828$export$98e628dec113755e)
                    ], (x, y)=>[
                            x,
                            y
                        ])))
                }),
                found: $ab6eb75b24f42828$export$e5185e241753e543({
                    total: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    graph: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$871de8747c9eaa88([
                        $ab6eb75b24f42828$export$b610b8812bbcded9(0, $ab6eb75b24f42828$export$98e628dec113755e),
                        $ab6eb75b24f42828$export$b610b8812bbcded9(1, $ab6eb75b24f42828$export$98e628dec113755e)
                    ], (x, y)=>[
                            x,
                            y
                        ])))
                }),
                viewed: $ab6eb75b24f42828$export$e5185e241753e543({
                    total: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    graph: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$871de8747c9eaa88([
                        $ab6eb75b24f42828$export$b610b8812bbcded9(0, $ab6eb75b24f42828$export$98e628dec113755e),
                        $ab6eb75b24f42828$export$b610b8812bbcded9(1, $ab6eb75b24f42828$export$98e628dec113755e)
                    ], (x, y)=>[
                            x,
                            y
                        ])))
                }),
                performance: $ab6eb75b24f42828$export$a9a18ae5ba42aeab([
                    $ab6eb75b24f42828$export$e5185e241753e543({
                        advertisementquality: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                        askingprice: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                        daysinstock: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e)
                    }),
                    $ab6eb75b24f42828$export$9094b7742a87955e([])
                ]),
                pricehistory: $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$e5185e241753e543({
                    currentaskingprice: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    date: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                    previousaskingprice: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e)
                })),
                stock: $ab6eb75b24f42828$export$a9a18ae5ba42aeab([
                    $ab6eb75b24f42828$export$e5185e241753e543({
                        vehicle: $ab6eb75b24f42828$export$2f23118c22fb2630($0b52e672722f75d2$var$vehicleDecoder),
                        vehicle_count: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                        vehicle_hasrecalc: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$87b259aa03e3d267)
                    }),
                    $ab6eb75b24f42828$export$9094b7742a87955e(null)
                ]),
                stocksummary: $ab6eb75b24f42828$export$a9a18ae5ba42aeab([
                    $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$e5185e241753e543({
                        advertisementquality: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                        askingpricedifferencepercentage: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                        askingpricetoohigh: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                        askingpricetotal: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                        daysinstockaverage: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                        daysinstockdistribution: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$a9a18ae5ba42aeab([
                            $ab6eb75b24f42828$export$22b082955e083ec3,
                            $ab6eb75b24f42828$export$98e628dec113755e
                        ])))),
                        found: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                        id: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$22b082955e083ec3),
                        name: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$22b082955e083ec3),
                        place: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$22b082955e083ec3),
                        turnoveraveragedaysinstock: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                        vehiclecount: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e),
                        viewed: $0b52e672722f75d2$var$extractValueDecoder($ab6eb75b24f42828$export$98e628dec113755e)
                    })),
                    $ab6eb75b24f42828$export$9094b7742a87955e([])
                ])
            });
            try {
                const data = (await response.json())?.data;
                return toMsg($jqoka.ok(decoder(data)));
            } catch (error) {
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04(error)));
            }
        }
    });
}
function $0b52e672722f75d2$export$ae36f7dda251b6f1(authentication, vehicle, isSold, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.taxationCompetition(vehicle),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Get,
        query: {
            sold: isSold ? "1" : "0"
        },
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        expect: async (response)=>{
            if (!response.ok) {
                const httpStatusError = $0b52e672722f75d2$var$getHttpStatusErrors(response);
                if (httpStatusError) return toMsg(httpStatusError);
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04()));
            }
            const decoder = $ab6eb75b24f42828$export$871de8747c9eaa88([
                $ab6eb75b24f42828$export$e0f35d825088c098("vehicle", $ab6eb75b24f42828$export$2f23118c22fb2630($0b52e672722f75d2$var$competingVehicleDecoder)),
                $ab6eb75b24f42828$export$e0f35d825088c098("vehicle_count", $ab6eb75b24f42828$export$98e628dec113755e)
            ], (vehicles, amountOfVehicles)=>({
                    vehicles: vehicles,
                    amountOfVehicles: amountOfVehicles
                }));
            try {
                const data = (await response.json())?.data;
                return toMsg($jqoka.ok(decoder(data)));
            } catch (error) {
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04(error)));
            }
        }
    });
}
function $0b52e672722f75d2$export$84de2582e4881aa3(authentication, vehicle, isSold, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.taxationPriceHistory(vehicle),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Get,
        query: {
            sold: isSold ? "1" : "0"
        },
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        expect: async (response)=>{
            if (!response.ok) {
                const httpStatusError = $0b52e672722f75d2$var$getHttpStatusErrors(response);
                if (httpStatusError) return toMsg(httpStatusError);
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04()));
            }
            const decoder = $ab6eb75b24f42828$export$871de8747c9eaa88([
                $ab6eb75b24f42828$export$e0f35d825088c098("graph", $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$a9a18ae5ba42aeab([
                    $ab6eb75b24f42828$export$133fc36489ac9add($ab6eb75b24f42828$export$22b082955e083ec3),
                    $ab6eb75b24f42828$export$133fc36489ac9add($ab6eb75b24f42828$export$98e628dec113755e)
                ])))),
                $ab6eb75b24f42828$export$e0f35d825088c098("vehicle", $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$e5185e241753e543({
                    id: $ab6eb75b24f42828$export$98e628dec113755e,
                    pricehistory: $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$e5185e241753e543({
                        date: $ab6eb75b24f42828$export$98e628dec113755e,
                        price: $ab6eb75b24f42828$export$98e628dec113755e
                    }))
                })))
            ], (graph, vehicles)=>({
                    graph: graph,
                    vehicleHistory: new Map(vehicles.map(({ id: id, pricehistory: pricehistory })=>[
                            id,
                            pricehistory
                        ]))
                }));
            try {
                const data = (await response.json())?.data;
                return toMsg($jqoka.ok(decoder(data)));
            } catch (error) {
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04(error)));
            }
        }
    });
}
function $0b52e672722f75d2$export$e2ea3d25324bff83(authentication, vehicle, isSold, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.taxationGeography(vehicle),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Get,
        query: {
            sold: isSold ? "1" : "0"
        },
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        expect: async (response)=>{
            if (!response.ok) {
                const httpStatusError = $0b52e672722f75d2$var$getHttpStatusErrors(response);
                if (httpStatusError) return toMsg(httpStatusError);
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04()));
            }
            const decoder = $ab6eb75b24f42828$export$871de8747c9eaa88([
                $ab6eb75b24f42828$export$e0f35d825088c098("graph", $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$a9a18ae5ba42aeab([
                    $ab6eb75b24f42828$export$133fc36489ac9add($ab6eb75b24f42828$export$22b082955e083ec3),
                    $ab6eb75b24f42828$export$133fc36489ac9add($ab6eb75b24f42828$export$98e628dec113755e)
                ])))),
                $ab6eb75b24f42828$export$e0f35d825088c098("vehicle", $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$e5185e241753e543({
                    id: $ab6eb75b24f42828$export$22b082955e083ec3,
                    latitude: $ab6eb75b24f42828$export$98e628dec113755e,
                    longitude: $ab6eb75b24f42828$export$98e628dec113755e
                })))
            ], (graph, vehicles)=>({
                    graph: graph,
                    vehicleLocations: new Map(vehicles.map(({ id: id, latitude: latitude, longitude: longitude })=>[
                            id,
                            {
                                latitude: latitude,
                                longitude: longitude
                            }
                        ]))
                }));
            try {
                const data = (await response.json())?.data;
                return toMsg($jqoka.ok(decoder(data)));
            } catch (error) {
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04(error)));
            }
        }
    });
}
function $0b52e672722f75d2$export$c2ad421229fe9f15(authentication, id, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.taxationSettings(id),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Get,
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        query: {},
        expect: async (response)=>{
            if (!response.ok) {
                const httpStatusError = $0b52e672722f75d2$var$getHttpStatusErrors(response);
                if (httpStatusError) return toMsg(httpStatusError);
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04()));
            }
            const decoder = $ab6eb75b24f42828$export$e5185e241753e543({
                agedifference: $ab6eb75b24f42828$export$98e628dec113755e,
                agesameyear: $ab6eb75b24f42828$export$87b259aa03e3d267,
                aircon: $ab6eb75b24f42828$export$87b259aa03e3d267,
                bovagmember: $ab6eb75b24f42828$export$87b259aa03e3d267,
                climatecontrol: $ab6eb75b24f42828$export$87b259aa03e3d267,
                leather: $ab6eb75b24f42828$export$87b259aa03e3d267,
                maintenancebooklet: $ab6eb75b24f42828$export$87b259aa03e3d267,
                makedealer: $ab6eb75b24f42828$export$87b259aa03e3d267,
                mileagedifference: $ab6eb75b24f42828$export$98e628dec113755e,
                navigation: $ab6eb75b24f42828$export$87b259aa03e3d267,
                universaldealer: $ab6eb75b24f42828$export$87b259aa03e3d267,
                vehiclecolor: $ab6eb75b24f42828$export$87b259aa03e3d267,
                vehicledoors: $ab6eb75b24f42828$export$87b259aa03e3d267,
                vehicleenginecapacity: $ab6eb75b24f42828$export$87b259aa03e3d267,
                vehiclefuel: $ab6eb75b24f42828$export$87b259aa03e3d267,
                vehiclemake: $ab6eb75b24f42828$export$87b259aa03e3d267,
                vehiclemodel: $ab6eb75b24f42828$export$87b259aa03e3d267,
                vehiclepower: $ab6eb75b24f42828$export$87b259aa03e3d267,
                vehicletransmission: $ab6eb75b24f42828$export$87b259aa03e3d267,
                vehicletrimpackage: $ab6eb75b24f42828$export$87b259aa03e3d267,
                vehicleweight: $ab6eb75b24f42828$export$87b259aa03e3d267,
                warrantyautopas: $ab6eb75b24f42828$export$87b259aa03e3d267,
                warrantybovag: $ab6eb75b24f42828$export$87b259aa03e3d267,
                warrantybrand: $ab6eb75b24f42828$export$87b259aa03e3d267,
                warrantycarfax: $ab6eb75b24f42828$export$87b259aa03e3d267,
                warrantyhome: $ab6eb75b24f42828$export$87b259aa03e3d267,
                towbar: $ab6eb75b24f42828$export$87b259aa03e3d267,
                rearviewcamera: $ab6eb75b24f42828$export$87b259aa03e3d267,
                seatheating: $ab6eb75b24f42828$export$87b259aa03e3d267,
                panoramicroof: $ab6eb75b24f42828$export$87b259aa03e3d267,
                cruisecontrol: $ab6eb75b24f42828$export$87b259aa03e3d267,
                adaptivecruisecontrol: $ab6eb75b24f42828$export$87b259aa03e3d267,
                parkingsensors: $ab6eb75b24f42828$export$87b259aa03e3d267,
                applecarplay: $ab6eb75b24f42828$export$87b259aa03e3d267
            });
            try {
                const data = (await response.json())?.data?.competingvehicles;
                return toMsg($jqoka.ok(decoder(data)));
            } catch (error) {
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04(error)));
            }
        }
    });
}
function $0b52e672722f75d2$export$f266afe8beaa0c7e(authentication, id, data, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.taxationSettings(id),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Patch,
        body: {
            data: data
        },
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        query: {},
        expect: async (response)=>{
            if (!response.ok) {
                const httpStatusError = $0b52e672722f75d2$var$getHttpStatusErrors(response);
                if (httpStatusError) return toMsg(httpStatusError);
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04()));
            }
            const decoder = $ab6eb75b24f42828$export$e5185e241753e543({
                id: $ab6eb75b24f42828$export$22b082955e083ec3
            });
            try {
                const data = (await response.json())?.data;
                return toMsg($jqoka.ok(decoder(data)));
            } catch (error) {
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04(error)));
            }
        }
    });
}
function $0b52e672722f75d2$export$d3a3464fecdcf9d2(authentication, id, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.taxationSettings(id),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Delete,
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        query: {},
        expect: async (response)=>toMsg(response.ok)
    });
}
function $0b52e672722f75d2$export$95f519620f38a864(authentication, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.settingsScenarioDealers(),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Get,
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        query: {},
        expect: async (response)=>{
            if (!response.ok) {
                const httpStatusError = $0b52e672722f75d2$var$getHttpStatusErrors(response);
                if (httpStatusError) return toMsg(httpStatusError);
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04()));
            }
            const decoder = $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$e5185e241753e543({
                id: $ab6eb75b24f42828$export$22b082955e083ec3,
                name: $ab6eb75b24f42828$export$22b082955e083ec3,
                place: $ab6eb75b24f42828$export$22b082955e083ec3
            }));
            try {
                const data = (await response.json())?.data;
                return toMsg($jqoka.ok(decoder(data)));
            } catch (error) {
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04(error)));
            }
        }
    });
}
function $0b52e672722f75d2$export$f99ffec57e6e1e1f(authentication, config, toMsg) {
    const geoRequest = $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.dealerCompetitionGeo(),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Post,
        query: {},
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        body: {
            data: {
                profile: config.profile,
                make: Array.from(config.makes),
                model: Array.from(config.models)
            }
        },
        expect: async (response)=>{
            if (!response.ok) {
                if (response.status === 401) return $jqoka.err($73731a0695accb65$export$5c773811ae1e141b());
                return $jqoka.err($73731a0695accb65$export$efbc88c27b0be04());
            }
            const decoder = $ab6eb75b24f42828$export$e0f35d825088c098("graph", $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$871de8747c9eaa88([
                $ab6eb75b24f42828$export$e5185e241753e543({
                    avgoffound: $ab6eb75b24f42828$export$98e628dec113755e,
                    avgofviewed: $ab6eb75b24f42828$export$98e628dec113755e,
                    dealerid: $ab6eb75b24f42828$export$22b082955e083ec3,
                    latitude: $ab6eb75b24f42828$export$98e628dec113755e,
                    longitude: $ab6eb75b24f42828$export$98e628dec113755e
                })
            ], (record)=>({
                    dealerId: record.dealerid,
                    averageFound: record.avgoffound,
                    averageViewed: record.avgofviewed,
                    latitude: record.latitude,
                    longitude: record.longitude
                }))));
            try {
                const data = (await response.json()).data;
                return $jqoka.ok(decoder(data));
            } catch (error) {
                return $jqoka.err($73731a0695accb65$export$efbc88c27b0be04(error));
            }
        }
    });
    const priceRequest = $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.dealerCompetitionPrice(),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Post,
        query: {
            type: "price"
        },
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        body: {
            data: {
                profile: config.profile,
                make: Array.from(config.makes),
                model: Array.from(config.models)
            }
        },
        expect: async (response)=>{
            if (!response.ok) {
                if (response.status === 401) return $jqoka.err($73731a0695accb65$export$5c773811ae1e141b());
                return $jqoka.err($73731a0695accb65$export$efbc88c27b0be04());
            }
            const stringToNumberDecoder = $ab6eb75b24f42828$export$871de8747c9eaa88([
                $ab6eb75b24f42828$export$22b082955e083ec3
            ], (value)=>Number(value));
            const decoder = $ab6eb75b24f42828$export$e5185e241753e543({
                goaldaysinstock: stringToNumberDecoder,
                graph: $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$871de8747c9eaa88([
                    $ab6eb75b24f42828$export$e5185e241753e543({
                        AANBIEDER_ID: $ab6eb75b24f42828$export$22b082955e083ec3,
                        d_naam: $ab6eb75b24f42828$export$22b082955e083ec3,
                        d_plaats: $ab6eb75b24f42828$export$22b082955e083ec3,
                        aantal: stringToNumberDecoder,
                        statijd: stringToNumberDecoder,
                        verschil: stringToNumberDecoder,
                        zichzelf: stringToNumberDecoder
                    })
                ], (record)=>({
                        dealerId: record.AANBIEDER_ID,
                        dealerName: record.d_naam,
                        dealerPlace: record.d_plaats,
                        vehicleCount: record.aantal,
                        averageDaysInStock: record.statijd,
                        averageDifference: record.verschil,
                        isOwn: record.zichzelf
                    }))),
                makes: $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$22b082955e083ec3),
                makespopular: $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$22b082955e083ec3),
                models: $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$e5185e241753e543({
                    make: $ab6eb75b24f42828$export$22b082955e083ec3,
                    model: $ab6eb75b24f42828$export$22b082955e083ec3
                })),
                profiles: $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$e5185e241753e543({
                    id: $ab6eb75b24f42828$export$22b082955e083ec3,
                    name: $ab6eb75b24f42828$export$22b082955e083ec3
                }))
            });
            try {
                const data = (await response.json()).data;
                return $jqoka.ok(decoder(data));
            } catch (error) {
                return $jqoka.err($73731a0695accb65$export$efbc88c27b0be04(error));
            }
        }
    });
    return Promise.all([
        geoRequest,
        priceRequest
    ]).then(([geoResult, priceResult])=>{
        const result = $jqoka.andThen(geoResult, (geo)=>{
            const dealerMap = new Map(geo.map((x)=>[
                    x.dealerId,
                    x
                ]));
            return $jqoka.map(priceResult, (price)=>{
                const dealers = price.graph.reduce((acc, dealer)=>{
                    const foundDealer = dealerMap.get(dealer.dealerId);
                    acc.push({
                        ...dealer,
                        ...foundDealer ?? {}
                    });
                    return acc;
                }, []);
                return {
                    ...price,
                    graph: dealers
                };
            });
        });
        return toMsg(result);
    });
}
function $0b52e672722f75d2$export$d8d0b85dee5e278(authentication, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.settingsScenarios(),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Get,
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        query: {},
        expect: async (response)=>{
            if (!response.ok) {
                const httpStatusError = $0b52e672722f75d2$var$getHttpStatusErrors(response);
                if (httpStatusError) return toMsg(httpStatusError);
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04()));
            }
            const decoder = $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$e5185e241753e543({
                id: $ab6eb75b24f42828$export$22b082955e083ec3,
                name: $ab6eb75b24f42828$export$22b082955e083ec3
            }));
            try {
                const data = (await response.json())?.data;
                return toMsg($jqoka.ok(decoder(data)));
            } catch (error) {
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04(error)));
            }
        }
    });
}
function $0b52e672722f75d2$export$b2c8da529da96bfc(authentication, id, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.settingsScenario(id),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Get,
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        query: {},
        expect: async (response)=>{
            if (!response.ok) {
                const httpStatusError = $0b52e672722f75d2$var$getHttpStatusErrors(response);
                if (httpStatusError) return toMsg(httpStatusError);
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04()));
            }
            const decoder = $ab6eb75b24f42828$export$e5185e241753e543({
                id: $ab6eb75b24f42828$export$22b082955e083ec3,
                name: $ab6eb75b24f42828$export$22b082955e083ec3,
                clusters: $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$e5185e241753e543({
                    id: $ab6eb75b24f42828$export$22b082955e083ec3,
                    name: $ab6eb75b24f42828$export$22b082955e083ec3,
                    dealers: $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$22b082955e083ec3)
                }))
            });
            try {
                const json = await response.json();
                return toMsg($jqoka.ok(decoder({
                    ...json?.data,
                    id: json?.id,
                    name: json?.name
                })));
            } catch (error) {
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04(error)));
            }
        }
    });
}
function $0b52e672722f75d2$export$9760cea95b8456a5(authentication, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.settingsDealerFilter(),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Get,
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        query: {},
        expect: async (response)=>{
            if (!response.ok) {
                const httpStatusError = $0b52e672722f75d2$var$getHttpStatusErrors(response);
                if (httpStatusError) return toMsg(httpStatusError);
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04()));
            }
            const dealersDecoder = $ab6eb75b24f42828$export$e0f35d825088c098("data", $ab6eb75b24f42828$export$b610b8812bbcded9(0, $ab6eb75b24f42828$export$e0f35d825088c098("dealers", $ab6eb75b24f42828$export$871de8747c9eaa88([
                $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$e5185e241753e543({
                    dealerid: $ab6eb75b24f42828$export$22b082955e083ec3,
                    checked: $ab6eb75b24f42828$export$87b259aa03e3d267
                }))
            ], (items)=>items.reduce((acc, item)=>({
                        ...acc,
                        [item.dealerid]: item.checked
                    }), {})))));
            const decoder = $ab6eb75b24f42828$export$871de8747c9eaa88([
                $ab6eb75b24f42828$export$e0f35d825088c098("id", $ab6eb75b24f42828$export$22b082955e083ec3),
                dealersDecoder
            ], (scenario, dealers)=>({
                    scenario: scenario,
                    dealers: dealers
                }));
            try {
                const data = await response.json();
                return toMsg($jqoka.ok(decoder(data)));
            } catch (error) {
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04(error)));
            }
        }
    });
}
function $0b52e672722f75d2$export$3719284900695305(authentication, dealersChecked, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.settingsDealerFilter(),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Patch,
        body: {
            data: {
                dealerfilter: Object.entries(dealersChecked).map(([dealerId, checked])=>({
                        dealerid: dealerId,
                        checked: checked
                    }), {})
            }
        },
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        query: {},
        expect: async (response)=>{
            if (!response.ok) {
                const httpStatusError = $0b52e672722f75d2$var$getHttpStatusErrors(response);
                if (httpStatusError) return toMsg(httpStatusError);
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04()));
            }
            const decoder = $ab6eb75b24f42828$export$871de8747c9eaa88([
                $ab6eb75b24f42828$export$e0f35d825088c098("data", $ab6eb75b24f42828$export$b610b8812bbcded9(0, $ab6eb75b24f42828$export$e0f35d825088c098("dealers", $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$e5185e241753e543({
                    dealerid: $ab6eb75b24f42828$export$22b082955e083ec3,
                    checked: $ab6eb75b24f42828$export$87b259aa03e3d267
                })))))
            ], (dealers)=>dealers.reduce((acc, dealer)=>({
                        ...acc,
                        [dealer.dealerid]: dealer.checked
                    }), {}));
            try {
                const json = await response.json();
                return toMsg($jqoka.ok(decoder(json)));
            } catch (error) {
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04(error)));
            }
        }
    });
}
function $0b52e672722f75d2$export$1478c0c5a627cf4d(authentication, config, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.dealerProspects(),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Get,
        query: {
            startdate: config.period.startDate,
            enddate: config.period.endDate
        },
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        expect: async (response)=>{
            if (!response.ok) {
                const httpStatusError = $0b52e672722f75d2$var$getHttpStatusErrors(response);
                if (httpStatusError) return toMsg(httpStatusError);
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04()));
            }
            const data = (await response.json())?.data;
            const decoder = $ab6eb75b24f42828$export$e5185e241753e543({
                records: $ab6eb75b24f42828$export$2f23118c22fb2630($ab6eb75b24f42828$export$e5185e241753e543({
                    telefoon: $ab6eb75b24f42828$export$22b082955e083ec3,
                    email: $ab6eb75b24f42828$export$22b082955e083ec3,
                    datum: $ab6eb75b24f42828$export$871de8747c9eaa88([
                        $ab6eb75b24f42828$export$22b082955e083ec3
                    ], (value)=>{
                        const formatted = value.match(/([0-9]{2})-([0-9]{2})-([0-9]{4})/);
                        const [, day, month, year] = formatted ?? [];
                        return new Date(`${year}-${month}-${day}`);
                    }),
                    leads: $ab6eb75b24f42828$export$22b082955e083ec3,
                    aantal: $ab6eb75b24f42828$export$22b082955e083ec3,
                    kenteken: $ab6eb75b24f42828$export$22b082955e083ec3,
                    merk: $ab6eb75b24f42828$export$22b082955e083ec3,
                    status: $ab6eb75b24f42828$export$22b082955e083ec3,
                    dealerNaam: $ab6eb75b24f42828$export$22b082955e083ec3
                })),
                totals: $ab6eb75b24f42828$export$e5185e241753e543({
                    totalNrOfProspects: $ab6eb75b24f42828$export$98e628dec113755e,
                    totalNrOfHardLead: $ab6eb75b24f42828$export$e5185e241753e543({
                        phone: $ab6eb75b24f42828$export$98e628dec113755e,
                        email: $ab6eb75b24f42828$export$98e628dec113755e,
                        chatWhatsapp: $ab6eb75b24f42828$export$98e628dec113755e
                    })
                }),
                totalrecords: $ab6eb75b24f42828$export$98e628dec113755e
            });
            try {
                return toMsg($jqoka.ok(decoder(data)));
            } catch (error) {
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04(error)));
            }
        }
    });
}
function $0b52e672722f75d2$export$691258cc176f24b7(authentication, profile, toMsg) {
    if (profile.id !== undefined) return Promise.resolve(toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04())));
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.settingsDealerProfiles(),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Post,
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        query: {},
        body: {
            data: {
                dealerids: profile.dealers.map((dealer)=>dealer.id),
                dealerlist: profile.dealers,
                id: null,
                name: profile.name
            }
        },
        expect: async (response)=>{
            if (!response.ok) {
                const httpStatusError = $0b52e672722f75d2$var$getHttpStatusErrors(response);
                if (httpStatusError) return toMsg(httpStatusError);
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04()));
            }
            const decoder = $ab6eb75b24f42828$export$e0f35d825088c098("id", $ab6eb75b24f42828$export$22b082955e083ec3);
            try {
                const data = (await response.json()).data;
                return toMsg($jqoka.ok(decoder(data)));
            } catch (error) {
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04(error)));
            }
        }
    });
}
function $0b52e672722f75d2$export$3ff10d26a93adf19(authentication, profile, toMsg) {
    return $e3dd86d6587fafa3$export$b5fe3f66a567bec0({
        path: $0b52e672722f75d2$var$AtaApiEndpoints.settingsDealerProfile(profile.id),
        method: $e3dd86d6587fafa3$export$8695620d48fe67d.Patch,
        headers: $0b52e672722f75d2$var$authorizedHeaders("nl-NL", authentication),
        query: {},
        body: {
            data: {
                dealerids: profile.dealers.map((dealer)=>dealer.id),
                dealerlist: profile.dealers,
                id: profile.id,
                name: profile.name
            }
        },
        expect: async (response)=>{
            if (!response.ok) {
                const httpStatusError = $0b52e672722f75d2$var$getHttpStatusErrors(response);
                if (httpStatusError) return toMsg(httpStatusError);
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04()));
            }
            const decoder = $ab6eb75b24f42828$export$e0f35d825088c098("id", $ab6eb75b24f42828$export$22b082955e083ec3);
            try {
                const data = (await response.json()).data;
                return toMsg($jqoka.ok(decoder(data)));
            } catch (error) {
                return toMsg($jqoka.err($73731a0695accb65$export$efbc88c27b0be04(error)));
            }
        }
    });
}


var $a08deb550261a13e$exports = {};
!function(t, n) {
    $a08deb550261a13e$exports = n();
}("undefined" != typeof self ? self : $a08deb550261a13e$exports, function() {
    return function() {
        "use strict";
        var t = {
            407: function(t, n, e) {
                e.d(n, {
                    default: function() {
                        return N;
                    }
                });
                var o = /([:*])(\w+)/g, r = /\*/g, i = /\/\?/g;
                function a(t) {
                    return void 0 === t && (t = "/"), v() ? location.pathname + location.search + location.hash : t;
                }
                function s(t) {
                    return t.replace(/\/+$/, "").replace(/^\/+/, "");
                }
                function c(t) {
                    return "string" == typeof t;
                }
                function u(t) {
                    return t && t.indexOf("#") >= 0 && t.split("#").pop() || "";
                }
                function h(t) {
                    var n = s(t).split(/\?(.*)?$/);
                    return [
                        s(n[0]),
                        n.slice(1).join("")
                    ];
                }
                function f(t) {
                    for(var n = {}, e = t.split("&"), o = 0; o < e.length; o++){
                        var r = e[o].split("=");
                        if ("" !== r[0]) {
                            var i = decodeURIComponent(r[0]);
                            n[i] ? (Array.isArray(n[i]) || (n[i] = [
                                n[i]
                            ]), n[i].push(decodeURIComponent(r[1] || ""))) : n[i] = decodeURIComponent(r[1] || "");
                        }
                    }
                    return n;
                }
                function l(t, n) {
                    var e, a = h(s(t.currentLocationPath)), l = a[0], p = a[1], d = "" === p ? null : f(p), v = [];
                    if (c(n.path)) {
                        if (e = "(?:/^|^)" + s(n.path).replace(o, function(t, n, e) {
                            return v.push(e), "([^/]+)";
                        }).replace(r, "?(?:.*)").replace(i, "/?([^/]+|)") + "$", "" === s(n.path) && "" === s(l)) return {
                            url: l,
                            queryString: p,
                            hashString: u(t.to),
                            route: n,
                            data: null,
                            params: d
                        };
                    } else e = n.path;
                    var g = new RegExp(e, ""), m = l.match(g);
                    if (m) {
                        var y = c(n.path) ? function(t, n) {
                            return 0 === n.length ? null : t ? t.slice(1, t.length).reduce(function(t, e, o) {
                                return null === t && (t = {}), t[n[o]] = decodeURIComponent(e), t;
                            }, null) : null;
                        }(m, v) : m.groups ? m.groups : m.slice(1);
                        return {
                            url: s(l.replace(new RegExp("^" + t.instance.root), "")),
                            queryString: p,
                            hashString: u(t.to),
                            route: n,
                            data: y,
                            params: d
                        };
                    }
                    return !1;
                }
                function p() {
                    return !("undefined" == typeof window || !window.history || !window.history.pushState);
                }
                function d(t, n) {
                    return void 0 === t[n] || !0 === t[n];
                }
                function v() {
                    return "undefined" != typeof window;
                }
                function g(t, n) {
                    return void 0 === t && (t = []), void 0 === n && (n = {}), t.filter(function(t) {
                        return t;
                    }).forEach(function(t) {
                        [
                            "before",
                            "after",
                            "already",
                            "leave"
                        ].forEach(function(e) {
                            t[e] && (n[e] || (n[e] = []), n[e].push(t[e]));
                        });
                    }), n;
                }
                function m(t, n, e) {
                    var o = n || {}, r = 0;
                    !function n() {
                        t[r] ? Array.isArray(t[r]) ? (t.splice.apply(t, [
                            r,
                            1
                        ].concat(t[r][0](o) ? t[r][1] : t[r][2])), n()) : t[r](o, function(t) {
                            void 0 === t || !0 === t ? (r += 1, n()) : e && e(o);
                        }) : e && e(o);
                    }();
                }
                function y(t, n) {
                    void 0 === t.currentLocationPath && (t.currentLocationPath = t.to = a(t.instance.root)), t.currentLocationPath = t.instance._checkForAHash(t.currentLocationPath), n();
                }
                function _(t, n) {
                    for(var e = 0; e < t.instance.routes.length; e++){
                        var o = l(t, t.instance.routes[e]);
                        if (o && (t.matches || (t.matches = []), t.matches.push(o), "ONE" === t.resolveOptions.strategy)) return void n();
                    }
                    n();
                }
                function k(t, n) {
                    t.navigateOptions && (void 0 !== t.navigateOptions.shouldResolve && console.warn('"shouldResolve" is deprecated. Please check the documentation.'), void 0 !== t.navigateOptions.silent && console.warn('"silent" is deprecated. Please check the documentation.')), n();
                }
                function O(t, n) {
                    !0 === t.navigateOptions.force ? (t.instance._setCurrent([
                        t.instance._pathToMatchObject(t.to)
                    ]), n(!1)) : n();
                }
                m.if = function(t, n, e) {
                    return Array.isArray(n) || (n = [
                        n
                    ]), Array.isArray(e) || (e = [
                        e
                    ]), [
                        t,
                        n,
                        e
                    ];
                };
                var w = v(), L = p();
                function b(t, n) {
                    if (d(t.navigateOptions, "updateBrowserURL")) {
                        var e = ("/" + t.to).replace(/\/\//g, "/"), o = w && t.resolveOptions && !0 === t.resolveOptions.hash;
                        L ? (history[t.navigateOptions.historyAPIMethod || "pushState"](t.navigateOptions.stateObj || {}, t.navigateOptions.title || "", o ? "#" + e : e), location && location.hash && (t.instance.__freezeListening = !0, setTimeout(function() {
                            if (!o) {
                                var n = location.hash;
                                location.hash = "", location.hash = n;
                            }
                            t.instance.__freezeListening = !1;
                        }, 1))) : w && (window.location.href = t.to);
                    }
                    n();
                }
                function A(t, n) {
                    var e = t.instance;
                    e.lastResolved() ? m(e.lastResolved().map(function(n) {
                        return function(e, o) {
                            if (n.route.hooks && n.route.hooks.leave) {
                                var r = !1, i = t.instance.matchLocation(n.route.path, t.currentLocationPath, !1);
                                r = "*" !== n.route.path ? !i : !(t.matches && t.matches.find(function(t) {
                                    return n.route.path === t.route.path;
                                })), d(t.navigateOptions, "callHooks") && r ? m(n.route.hooks.leave.map(function(n) {
                                    return function(e, o) {
                                        return n(function(n) {
                                            !1 === n ? t.instance.__markAsClean(t) : o();
                                        }, t.matches && t.matches.length > 0 ? 1 === t.matches.length ? t.matches[0] : t.matches : void 0);
                                    };
                                }).concat([
                                    function() {
                                        return o();
                                    }
                                ])) : o();
                            } else o();
                        };
                    }), {}, function() {
                        return n();
                    }) : n();
                }
                function P(t, n) {
                    d(t.navigateOptions, "updateState") && t.instance._setCurrent(t.matches), n();
                }
                var R = [
                    function(t, n) {
                        var e = t.instance.lastResolved();
                        if (e && e[0] && e[0].route === t.match.route && e[0].url === t.match.url && e[0].queryString === t.match.queryString) return e.forEach(function(n) {
                            n.route.hooks && n.route.hooks.already && d(t.navigateOptions, "callHooks") && n.route.hooks.already.forEach(function(n) {
                                return n(t.match);
                            });
                        }), void n(!1);
                        n();
                    },
                    function(t, n) {
                        t.match.route.hooks && t.match.route.hooks.before && d(t.navigateOptions, "callHooks") ? m(t.match.route.hooks.before.map(function(n) {
                            return function(e, o) {
                                return n(function(n) {
                                    !1 === n ? t.instance.__markAsClean(t) : o();
                                }, t.match);
                            };
                        }).concat([
                            function() {
                                return n();
                            }
                        ])) : n();
                    },
                    function(t, n) {
                        d(t.navigateOptions, "callHandler") && t.match.route.handler(t.match), t.instance.updatePageLinks(), n();
                    },
                    function(t, n) {
                        t.match.route.hooks && t.match.route.hooks.after && d(t.navigateOptions, "callHooks") && t.match.route.hooks.after.forEach(function(n) {
                            return n(t.match);
                        }), n();
                    }
                ], S = [
                    A,
                    function(t, n) {
                        var e = t.instance._notFoundRoute;
                        if (e) {
                            t.notFoundHandled = !0;
                            var o = h(t.currentLocationPath), r = o[0], i = o[1], a = u(t.to);
                            e.path = s(r);
                            var c = {
                                url: e.path,
                                queryString: i,
                                hashString: a,
                                data: null,
                                route: e,
                                params: "" !== i ? f(i) : null
                            };
                            t.matches = [
                                c
                            ], t.match = c;
                        }
                        n();
                    },
                    m.if(function(t) {
                        return t.notFoundHandled;
                    }, R.concat([
                        P
                    ]), [
                        function(t, n) {
                            t.resolveOptions && !1 !== t.resolveOptions.noMatchWarning && void 0 !== t.resolveOptions.noMatchWarning || console.warn('Navigo: "' + t.currentLocationPath + "\" didn't match any of the registered routes."), n();
                        },
                        function(t, n) {
                            t.instance._setCurrent(null), n();
                        }
                    ])
                ];
                function E() {
                    return (E = Object.assign || function(t) {
                        for(var n = 1; n < arguments.length; n++){
                            var e = arguments[n];
                            for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                        }
                        return t;
                    }).apply(this, arguments);
                }
                function x(t, n) {
                    var e = 0;
                    A(t, function o() {
                        e !== t.matches.length ? m(R, E({}, t, {
                            match: t.matches[e]
                        }), function() {
                            e += 1, o();
                        }) : P(t, n);
                    });
                }
                function H(t) {
                    t.instance.__markAsClean(t);
                }
                function j() {
                    return (j = Object.assign || function(t) {
                        for(var n = 1; n < arguments.length; n++){
                            var e = arguments[n];
                            for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                        }
                        return t;
                    }).apply(this, arguments);
                }
                var C = "[data-navigo]";
                function N(t, n) {
                    var e, o = n || {
                        strategy: "ONE",
                        hash: !1,
                        noMatchWarning: !1,
                        linksSelector: C
                    }, r = this, i = "/", d = null, w = [], L = !1, A = p(), P = v();
                    function R(t) {
                        return t.indexOf("#") >= 0 && (t = !0 === o.hash ? t.split("#")[1] || "/" : t.split("#")[0]), t;
                    }
                    function E(t) {
                        return s(i + "/" + s(t));
                    }
                    function N(t, n, e, o) {
                        return t = c(t) ? E(t) : t, {
                            name: o || s(String(t)),
                            path: t,
                            handler: n,
                            hooks: g(e)
                        };
                    }
                    function U(t, n) {
                        if (!r.__dirty) {
                            r.__dirty = !0, t = t ? s(i) + "/" + s(t) : void 0;
                            var e = {
                                instance: r,
                                to: t,
                                currentLocationPath: t,
                                navigateOptions: {},
                                resolveOptions: j({}, o, n)
                            };
                            return m([
                                y,
                                _,
                                m.if(function(t) {
                                    var n = t.matches;
                                    return n && n.length > 0;
                                }, x, S)
                            ], e, H), !!e.matches && e.matches;
                        }
                        r.__waiting.push(function() {
                            return r.resolve(t, n);
                        });
                    }
                    function q(t, n) {
                        if (r.__dirty) r.__waiting.push(function() {
                            return r.navigate(t, n);
                        });
                        else {
                            r.__dirty = !0, t = s(i) + "/" + s(t);
                            var e = {
                                instance: r,
                                to: t,
                                navigateOptions: n || {},
                                resolveOptions: n && n.resolveOptions ? n.resolveOptions : o,
                                currentLocationPath: R(t)
                            };
                            m([
                                k,
                                O,
                                _,
                                m.if(function(t) {
                                    var n = t.matches;
                                    return n && n.length > 0;
                                }, x, S),
                                b,
                                H
                            ], e, H);
                        }
                    }
                    function F() {
                        if (P) return (P ? [].slice.call(document.querySelectorAll(o.linksSelector || C)) : []).forEach(function(t) {
                            "false" !== t.getAttribute("data-navigo") && "_blank" !== t.getAttribute("target") ? t.hasListenerAttached || (t.hasListenerAttached = !0, t.navigoHandler = function(n) {
                                if ((n.ctrlKey || n.metaKey) && "a" === n.target.tagName.toLowerCase()) return !1;
                                var e = t.getAttribute("href");
                                if (null == e) return !1;
                                if (e.match(/^(http|https)/) && "undefined" != typeof URL) try {
                                    var o = new URL(e);
                                    e = o.pathname + o.search;
                                } catch (t) {}
                                var i = function(t) {
                                    if (!t) return {};
                                    var n, e = t.split(","), o = {};
                                    return e.forEach(function(t) {
                                        var e = t.split(":").map(function(t) {
                                            return t.replace(/(^ +| +$)/g, "");
                                        });
                                        switch(e[0]){
                                            case "historyAPIMethod":
                                                o.historyAPIMethod = e[1];
                                                break;
                                            case "resolveOptionsStrategy":
                                                n || (n = {}), n.strategy = e[1];
                                                break;
                                            case "resolveOptionsHash":
                                                n || (n = {}), n.hash = "true" === e[1];
                                                break;
                                            case "updateBrowserURL":
                                            case "callHandler":
                                            case "updateState":
                                            case "force":
                                                o[e[0]] = "true" === e[1];
                                        }
                                    }), n && (o.resolveOptions = n), o;
                                }(t.getAttribute("data-navigo-options"));
                                L || (n.preventDefault(), n.stopPropagation(), r.navigate(s(e), i));
                            }, t.addEventListener("click", t.navigoHandler)) : t.hasListenerAttached && t.removeEventListener("click", t.navigoHandler);
                        }), r;
                    }
                    function I(t, n, e) {
                        var o = w.find(function(n) {
                            return n.name === t;
                        }), r = null;
                        if (o) {
                            if (r = o.path, n) for(var a in n)r = r.replace(":" + a, n[a]);
                            r = r.match(/^\//) ? r : "/" + r;
                        }
                        return r && e && !e.includeRoot && (r = r.replace(new RegExp("^/" + i), "")), r;
                    }
                    function M(t) {
                        var n = h(s(t)), o = n[0], r = n[1], i = "" === r ? null : f(r);
                        return {
                            url: o,
                            queryString: r,
                            hashString: u(t),
                            route: N(o, function() {}, [
                                e
                            ], o),
                            data: null,
                            params: i
                        };
                    }
                    function T(t, n, e) {
                        return "string" == typeof n && (n = z(n)), n ? (n.hooks[t] || (n.hooks[t] = []), n.hooks[t].push(e), function() {
                            n.hooks[t] = n.hooks[t].filter(function(t) {
                                return t !== e;
                            });
                        }) : (console.warn("Route doesn't exists: " + n), function() {});
                    }
                    function z(t) {
                        return "string" == typeof t ? w.find(function(n) {
                            return n.name === E(t);
                        }) : w.find(function(n) {
                            return n.handler === t;
                        });
                    }
                    t ? i = s(t) : console.warn('Navigo requires a root path in its constructor. If not provided will use "/" as default.'), this.root = i, this.routes = w, this.destroyed = L, this.current = d, this.__freezeListening = !1, this.__waiting = [], this.__dirty = !1, this.__markAsClean = function(t) {
                        t.instance.__dirty = !1, t.instance.__waiting.length > 0 && t.instance.__waiting.shift()();
                    }, this.on = function(t, n, o) {
                        var r = this;
                        return "object" != typeof t || t instanceof RegExp ? ("function" == typeof t && (o = n, n = t, t = i), w.push(N(t, n, [
                            e,
                            o
                        ])), this) : (Object.keys(t).forEach(function(n) {
                            if ("function" == typeof t[n]) r.on(n, t[n]);
                            else {
                                var o = t[n], i = o.uses, a = o.as, s = o.hooks;
                                w.push(N(n, i, [
                                    e,
                                    s
                                ], a));
                            }
                        }), this);
                    }, this.off = function(t) {
                        return this.routes = w = w.filter(function(n) {
                            return c(t) ? s(n.path) !== s(t) : "function" == typeof t ? t !== n.handler : String(n.path) !== String(t);
                        }), this;
                    }, this.resolve = U, this.navigate = q, this.navigateByName = function(t, n, e) {
                        var o = I(t, n);
                        return null !== o && (q(o.replace(new RegExp("^/?" + i), ""), e), !0);
                    }, this.destroy = function() {
                        this.routes = w = [], A && window.removeEventListener("popstate", this.__popstateListener), this.destroyed = L = !0;
                    }, this.notFound = function(t, n) {
                        return r._notFoundRoute = N("*", t, [
                            e,
                            n
                        ], "__NOT_FOUND__"), this;
                    }, this.updatePageLinks = F, this.link = function(t) {
                        return "/" + i + "/" + s(t);
                    }, this.hooks = function(t) {
                        return e = t, this;
                    }, this.extractGETParameters = function(t) {
                        return h(R(t));
                    }, this.lastResolved = function() {
                        return d;
                    }, this.generate = I, this.getLinkPath = function(t) {
                        return t.getAttribute("href");
                    }, this.match = function(t) {
                        var n = {
                            instance: r,
                            currentLocationPath: t,
                            to: t,
                            navigateOptions: {},
                            resolveOptions: o
                        };
                        return _(n, function() {}), !!n.matches && n.matches;
                    }, this.matchLocation = function(t, n, e) {
                        void 0 === n || void 0 !== e && !e || (n = E(n));
                        var o = {
                            instance: r,
                            to: n,
                            currentLocationPath: n
                        };
                        return y(o, function() {}), "string" == typeof t && (t = void 0 === e || e ? E(t) : t), l(o, {
                            name: String(t),
                            path: t,
                            handler: function() {},
                            hooks: {}
                        }) || !1;
                    }, this.getCurrentLocation = function() {
                        return M(s(a(i)).replace(new RegExp("^" + i), ""));
                    }, this.addBeforeHook = T.bind(this, "before"), this.addAfterHook = T.bind(this, "after"), this.addAlreadyHook = T.bind(this, "already"), this.addLeaveHook = T.bind(this, "leave"), this.getRoute = z, this._pathToMatchObject = M, this._clean = s, this._checkForAHash = R, this._setCurrent = function(t) {
                        return d = r.current = t;
                    }, (function() {
                        A && (this.__popstateListener = function() {
                            r.__freezeListening || U();
                        }, window.addEventListener("popstate", this.__popstateListener));
                    }).call(this), F.call(this);
                }
            }
        }, n = {};
        function e(o) {
            if (n[o]) return n[o].exports;
            var r = n[o] = {
                exports: {}
            };
            return t[o](r, r.exports, e), r.exports;
        }
        return e.d = function(t, n) {
            for(var o in n)e.o(n, o) && !e.o(t, o) && Object.defineProperty(t, o, {
                enumerable: !0,
                get: n[o]
            });
        }, e.o = function(t, n) {
            return Object.prototype.hasOwnProperty.call(t, n);
        }, e(407);
    }().default;
});


const $6de9763b9e556850$export$e7b0ac011bb776c6 = {
    NotFound: ()=>({
            id: "NotFound"
        }),
    AnalysisCostBenefit: ()=>({
            id: "AnalysisCostBenefit"
        }),
    AnalysisLeadPerformance: ()=>({
            id: "AnalysisLeadPerformance"
        }),
    AnalysisMakeModel: ()=>({
            id: "AnalysisMakeModel"
        }),
    AnalysisOverview: ()=>({
            id: "AnalysisOverview"
        }),
    ComparisonAdvicePrice: ()=>({
            id: "ComparisonAdvicePrice"
        }),
    ComparisonDaysInStock: ()=>({
            id: "ComparisonDaysInStock"
        }),
    ComparisonGeographic: ()=>({
            id: "ComparisonGeographic"
        }),
    ComparisonOverview: ()=>({
            id: "ComparisonOverview"
        }),
    Dashboard: ()=>({
            id: "Dashboard"
        }),
    Leads: ()=>({
            id: "Leads"
        }),
    Login: ()=>({
            id: "Login"
        }),
    Logout: ()=>({
            id: "Logout"
        }),
    Prospects: ()=>({
            id: "Prospects"
        }),
    Reach: ()=>({
            id: "Reach"
        }),
    SettingsBranches: ()=>({
            id: "SettingsBranches"
        }),
    SettingsCompetingCompanies: ()=>({
            id: "SettingsCompetingCompanies"
        }),
    SettingsCompetingCompaniesProfile: (params)=>({
            id: "SettingsCompetingCompaniesProfile",
            params: params
        }),
    SettingsCompetingVehicles: ()=>({
            id: "SettingsCompetingVehicles"
        }),
    SettingsNotifications: ()=>({
            id: "SettingsNotifications"
        }),
    SettingsScenarios: ()=>({
            id: "SettingsScenarios"
        }),
    SettingsScenario: (params)=>({
            id: "SettingsScenario",
            params: params
        }),
    SettingsStock: ()=>({
            id: "SettingsStock"
        }),
    Stock: ()=>({
            id: "Stock"
        }),
    TaxationDashboard: (params)=>({
            id: "TaxationDashboard",
            params: params
        }),
    TaxationComparisonGeographic: (params)=>({
            id: "TaxationComparisonGeographic",
            params: params
        }),
    TaxationComparisonOverview: (params)=>({
            id: "TaxationComparisonOverview",
            params: params
        }),
    TaxationComparisonPriceAnalysis: (params)=>({
            id: "TaxationComparisonPriceAnalysis",
            params: params
        }),
    TaxationComparisonPriceHistory: (params)=>({
            id: "TaxationComparisonPriceHistory",
            params: params
        }),
    TaxationSettings: (params)=>({
            id: "TaxationSettings",
            params: params
        }),
    TaxationSearch: ()=>({
            id: "TaxationSearch"
        }),
    VehicleComparisonGeographic: (params)=>({
            id: "VehicleComparisonGeographic",
            params: params
        }),
    VehicleComparisonOverview: (params)=>({
            id: "VehicleComparisonOverview",
            params: params
        }),
    VehicleComparisonPriceAnalysis: (params)=>({
            id: "VehicleComparisonPriceAnalysis",
            params: params
        }),
    VehicleComparisonPriceHistory: (params)=>({
            id: "VehicleComparisonPriceHistory",
            params: params
        }),
    VehicleDashboard: (params)=>({
            id: "VehicleDashboard",
            params: params
        }),
    VehicleReachOverview: (params)=>({
            id: "VehicleReachOverview",
            params: params
        }),
    VehicleReachPriceEffect: (params)=>({
            id: "VehicleReachPriceEffect",
            params: params
        }),
    VehicleSettings: (params)=>({
            id: "VehicleSettings",
            params: params
        })
};



var $bKIDm = parcelRequire("bKIDm");

var $jqoka = parcelRequire("jqoka");

var $1ubKN = parcelRequire("1ubKN");
parcelRequire("MJPZu");
var $9UZF0 = parcelRequire("9UZF0");

var $dGa5T = parcelRequire("dGa5T");
parcelRequire("bFoC6");
var $d92i1 = parcelRequire("d92i1");
parcelRequire("MJPZu");
var $hOpwk = parcelRequire("hOpwk");
var $9UZF0 = parcelRequire("9UZF0");
var $78EKQ = parcelRequire("78EKQ");
class $481a3b5887684b26$export$2e2bcd8739ae039 extends (0, $78EKQ.LitElement) {
    static styles = (0, $hOpwk.css)`
        :host {
            ---header-height: 7rem;
            ---navigation-width: 40rem;

            display: grid;
            grid-template-columns: 100cqi var(---navigation-width, auto);
            grid-template-rows: var(---header-height, 0) minmax(
                    calc(100cqb - var(---header-height)),
                    max-content
                );
            grid-template-areas: 'header navigation' 'content navigation';
            grid-gap: 0;
            transition: translate var(--motion--duration--long, 0s) ease-in-out;
        }

        :host([navigation-visible]) {
            translate: calc(-1 * var(---navigation-width, 0));
        }

        .shell__header {
            grid-area: header;
            position: sticky;
            top: 0;
            z-index: 1;
        }

        .shell__navigation {
            grid-area: navigation;
            position: sticky;
            top: 0;
            block-size: 100cqb;
            overflow: auto;
        }

        .shell__content {
            grid-area: content;
            position: relative;
        }

        @container (min-width: 1000px) {
            :host {
                grid-template-columns: var(---navigation-width, auto) 1fr;
                grid-template-rows: 7rem minmax(calc(100cqb - 7rem), 1fr);
                grid-template-areas: 'header header' 'navigation content';
                grid-gap: 0;
            }

            :host([navigation-visible]) {
                translate: 0;
            }

            .shell__navigation {
                top: var(---header-height, 0);
                block-size: calc(100cqb - var(---header-height, 0));
            }
        }
    `;
    render() {
        return (0, $9UZF0.html)`
            <div class="shell__header">
                <slot name="header"></slot>
            </div>

            <div class="shell__navigation">
                <slot name="navigation"></slot>
            </div>

            <div class="shell__content">
                <slot></slot>
            </div>
        `;
    }
}
$481a3b5887684b26$export$2e2bcd8739ae039 = (0, $dGa5T.__decorate)([
    (0, $d92i1.customElement)("ata-layout-shell")
], $481a3b5887684b26$export$2e2bcd8739ae039);



var $kjhzP = parcelRequire("kjhzP");

var $ksfXA = parcelRequire("ksfXA");

var $fjcCR = parcelRequire("fjcCR");
parcelRequire("MJPZu");
var $9UZF0 = parcelRequire("9UZF0");

var $ksfXA = parcelRequire("ksfXA");

var $5jpwE = parcelRequire("5jpwE");
function $d33980c98f883187$export$2e2bcd8739ae039(lastUpdate) {
    return (0, $9UZF0.html)`<small class="color--neutral--light">
        ${(0, $ksfXA.padding)("large", (0, $fjcCR.horizontalLayout)([
        "center",
        "center"
    ], "small", $d33980c98f883187$var$intersperse([
        (0, $9UZF0.html)`<span
                            >Copyright&nbsp;${new Date().getFullYear()}</span
                        >`,
        ...lastUpdate !== undefined ? [
            (0, $9UZF0.html)`<span>
                                      Laatste update:
                                      ${(0, $5jpwE.default).datetime(lastUpdate)}
                                  </span>`
        ] : [],
        (0, $9UZF0.html)`<a href="//zakelijk.autotrack.nl" target="_blank">
                            AutoTrack&nbsp;Zakelijk
                        </a>`,
        (0, $9UZF0.html)`<a href="mailto:info@autotrack.nl" target="_blank">
                            Contact
                        </a>`
    ], (0, $9UZF0.html)`|`)))}
    </small>`;
}
function $d33980c98f883187$var$intersperse(arr, sep) {
    if (arr.length === 0) return [];
    return arr.slice(1).reduce((xs, x)=>xs.concat([
            sep,
            x
        ]), [
        arr[0]
    ]);
}



var $fb0eT = parcelRequire("fb0eT");
function $9cca11e6920deac5$export$2e2bcd8739ae039(deviceLayout, content) {
    return (0, $9UZF0.html)`
        <div slot="header"> ${$9cca11e6920deac5$var$viewAppBar(deviceLayout)} </div>

        ${content}

        <hr />

        ${(0, $d33980c98f883187$export$2e2bcd8739ae039)()}
    `;
}
function $9cca11e6920deac5$var$viewAppBar(deviceLayout) {
    switch(deviceLayout){
        case "Desktop":
            return (0, $kjhzP.default)({
                start: (0, $ksfXA.paddingBlockInline)({
                    block: "none",
                    inline: "medium"
                }, (0, $9UZF0.html)`<img
                        loading="lazy"
                        src="https://analytics.autotrack.nl/assets/images/autotrack-analytics.png"
                        style="block-size: 3rem"
                        title="AutoTrack Analytics v${(0, $fb0eT.version)}"
                    />`)
            });
        case "Mobile":
            return (0, $kjhzP.default)({
                center: (0, $ksfXA.paddingBlockInline)({
                    block: "none",
                    inline: "medium"
                }, (0, $9UZF0.html)`<img
                        loading="lazy"
                        src="https://analytics.autotrack.nl/assets/images/autotrack-analytics.png"
                        style="block-size: 3rem"
                        title="AutoTrack Analytics v${(0, $fb0eT.version)}"
                    />`)
            });
    }
}


parcelRequire("MJPZu");
var $9UZF0 = parcelRequire("9UZF0");
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function* $10f45a76726b5bfb$export$f7e2c8231c57a8bd(o, t) {
    const f = "function" == typeof t;
    if (void 0 !== o) {
        let i = -1;
        for (const n of o)i > -1 && (yield f ? t(i) : t), i++, yield n;
    }
}






var $dGa5T = parcelRequire("dGa5T");
parcelRequire("bFoC6");
var $d92i1 = parcelRequire("d92i1");
parcelRequire("MJPZu");
var $hOpwk = parcelRequire("hOpwk");
var $9UZF0 = parcelRequire("9UZF0");
var $78EKQ = parcelRequire("78EKQ");
class $6d4e32188254fdcf$export$2e2bcd8739ae039 extends (0, $78EKQ.LitElement) {
    static styles = (0, $hOpwk.css)`
        :host {
            display: flex;
            flex-direction: column;
            block-size: 100%;
            background: var(--ata--app--navigation--backgroundColor);
            container-name: navigation;
            container-type: inline-size;
        }

        ::slotted(ata-navigation-item),
        ::slotted(ata-navigation-item-with-sub) {
            border-top: 1px solid black;
            transition: opacity 200ms linear;
        }

        @container navigation (max-width: 20rem) {
            ::slotted(ata-navigation-item),
            ::slotted(ata-navigation-item-with-sub) {
                opacity: 0;
                pointer-events: none;
            }
        }
    `;
    render() {
        return (0, $9UZF0.html)`
            <slot name="header"></slot>

            <slot></slot>
        `;
    }
}
$6d4e32188254fdcf$export$2e2bcd8739ae039 = (0, $dGa5T.__decorate)([
    (0, $d92i1.customElement)("ata-navigation")
], $6d4e32188254fdcf$export$2e2bcd8739ae039);



var $dGa5T = parcelRequire("dGa5T");
parcelRequire("bFoC6");
var $d92i1 = parcelRequire("d92i1");
parcelRequire("MJPZu");
var $hOpwk = parcelRequire("hOpwk");
var $9UZF0 = parcelRequire("9UZF0");
var $78EKQ = parcelRequire("78EKQ");

class $66eb136110d64386$export$2e2bcd8739ae039 extends (0, $78EKQ.LitElement) {
    static styles = (0, $hOpwk.css)`
        :host {
            display: flex;
            flex-direction: row;
            block-size: 100%;
        }

        ::slotted(ata-navigation) {
            flex: 0 0 7rem;
            min-inline-size: 7rem;
            transition: flex var(--motion--duration--long)
                var(--motion--easing--inOut);
            white-space: nowrap;
            overflow-x: hidden;
        }

        ::slotted(ata-navigation:not(:first-child)) {
            border-inline-start: 1px solid black;
        }

        ::slotted(ata-navigation:not([aria-expanded='true'])) {
            cursor: pointer;
        }

        ::slotted(ata-navigation[aria-expanded='true']) {
            flex: 1;
        }
    `;
    navigations = [];
    render() {
        return (0, $9UZF0.html)` <slot @slotchange="${this.onSlotChange}"></slot> `;
    }
    onSlotChange() {
        this.setNavigationListeners();
    }
    firstUpdated() {
        this.setNavigationListeners();
    }
    setNavigationListeners() {
        for (const navigation of this.navigations)navigation.removeEventListener("click", expandNavigation);
        this.navigations = [];
        const navigations = this.shadowRoot?.querySelector("slot")?.assignedElements() ?? [];
        for (const navigation of navigations)if (navigation instanceof (0, $6d4e32188254fdcf$export$2e2bcd8739ae039)) {
            navigation.addEventListener("click", expandNavigation);
            this.navigations.push(navigation);
        }
        function expandNavigation() {
            if (this.getAttribute("aria-expanded") === "true") return;
            for (const navigation of navigations)navigation.removeAttribute("aria-expanded");
            this.setAttribute("aria-expanded", "true");
        }
    }
}
$66eb136110d64386$export$2e2bcd8739ae039 = (0, $dGa5T.__decorate)([
    (0, $d92i1.customElement)("ata-navigation-group")
], $66eb136110d64386$export$2e2bcd8739ae039);


parcelRequire("9TU71");
parcelRequire("4c7YL");

var $dGa5T = parcelRequire("dGa5T");
parcelRequire("MJPZu");
var $hOpwk = parcelRequire("hOpwk");
var $9UZF0 = parcelRequire("9UZF0");
var $78EKQ = parcelRequire("78EKQ");
parcelRequire("bFoC6");
var $d92i1 = parcelRequire("d92i1");
class $3dcffd53154b9bbc$export$2e2bcd8739ae039 extends (0, $78EKQ.LitElement) {
    static styles = (0, $hOpwk.css)`
        :host {
            display: grid;
            grid-template-columns: 1fr auto;
            grid-template-areas:
                'title actions'
                'subtitle subtitle';
            gap: var(--dimensions--spacing--small)
                var(--dimensions--spacing--medium);
            padding: var(--dimensions--spacing--large)
                var(--dimensions--spacing--large);
        }

        .pageHeader__title {
            grid-area: title;
        }

        .pageHeader__subtitle {
            grid-area: subtitle;
        }

        .pageHeader__actions {
            grid-area: actions;
            align-self: center;
        }
    `;
    render() {
        return (0, $9UZF0.html)`
            <div class="pageHeader__title">
                <slot name="title"></slot>
            </div>

            <div class="pageHeader__subtitle">
                <slot name="subtitle"></slot>
            </div>

            <div class="pageHeader__actions">
                <slot name="actions"></slot>
            </div>
        `;
    }
}
$3dcffd53154b9bbc$export$2e2bcd8739ae039 = (0, $dGa5T.__decorate)([
    (0, $d92i1.customElement)("ata-page-header")
], $3dcffd53154b9bbc$export$2e2bcd8739ae039);


parcelRequire("4CCe6");
parcelRequire("MJPZu");
var $9UZF0 = parcelRequire("9UZF0");

var $ac4D8 = parcelRequire("ac4D8");

var $dGa5T = parcelRequire("dGa5T");
parcelRequire("MJPZu");
var $hOpwk = parcelRequire("hOpwk");
var $9UZF0 = parcelRequire("9UZF0");
var $78EKQ = parcelRequire("78EKQ");
parcelRequire("bFoC6");
var $d92i1 = parcelRequire("d92i1");
class $a658dfc04d8551c5$export$2e2bcd8739ae039 extends (0, $78EKQ.LitElement) {
    static styles = (0, $hOpwk.css)`
        :host {
            display: grid;
            grid-template-columns: 3rem 1fr;
            align-items: center;
            gap: 2rem;
            padding: 3rem 2rem;
            text-decoration: none;
            color: currentColor;
        }
    `;
    render() {
        return (0, $9UZF0.html)`
            <slot name="icon"></slot>
            <slot name="title">No text</slot>
        `;
    }
}
$a658dfc04d8551c5$export$2e2bcd8739ae039 = (0, $dGa5T.__decorate)([
    (0, $d92i1.customElement)("ata-navigation-header")
], $a658dfc04d8551c5$export$2e2bcd8739ae039);



var $dGa5T = parcelRequire("dGa5T");
parcelRequire("MJPZu");
var $hOpwk = parcelRequire("hOpwk");
var $9UZF0 = parcelRequire("9UZF0");
var $78EKQ = parcelRequire("78EKQ");
parcelRequire("bFoC6");
var $d92i1 = parcelRequire("d92i1");
var $4Kcgn = parcelRequire("4Kcgn");
class $93b8eda7d42386ec$export$2e2bcd8739ae039 extends (0, $78EKQ.LitElement) {
    static styles = (0, $hOpwk.css)`
        a {
            display: grid;
            grid-template-columns: 2rem 1fr;
            align-items: center;
            gap: 3rem;
            padding: 2rem;
            text-decoration: none;
            color: currentColor;
        }

        :host([active]) a {
            background-color: var(
                --ata--app--navigation--backgroundColor--active
            );
            color: var(--ata--app--navigation--foregroundColor--active);
            fill: var(--ata--app--navigation--foregroundColor--active);
        }
    `;
    href = "#";
    render() {
        return (0, $9UZF0.html)`
            <a href="${this.href}">
                <slot name="icon"></slot>
                <slot name="title">No text</slot>
            </a>
        `;
    }
}
(0, $dGa5T.__decorate)([
    (0, $4Kcgn.property)({
        type: String
    })
], $93b8eda7d42386ec$export$2e2bcd8739ae039.prototype, "href", void 0);
$93b8eda7d42386ec$export$2e2bcd8739ae039 = (0, $dGa5T.__decorate)([
    (0, $d92i1.customElement)("ata-navigation-item")
], $93b8eda7d42386ec$export$2e2bcd8739ae039);



var $dGa5T = parcelRequire("dGa5T");
parcelRequire("MJPZu");
var $hOpwk = parcelRequire("hOpwk");
var $9UZF0 = parcelRequire("9UZF0");
var $78EKQ = parcelRequire("78EKQ");
parcelRequire("bFoC6");
var $d92i1 = parcelRequire("d92i1");
var $4Kcgn = parcelRequire("4Kcgn");
class $b76c250efc2cbf34$export$2e2bcd8739ae039 extends (0, $78EKQ.LitElement) {
    static styles = (0, $hOpwk.css)`
        summary {
            display: grid;
            grid-template-columns: 2rem 1fr;
            align-items: center;
            gap: 3rem;
            padding: 2rem;
            text-decoration: none;
            color: currentColor;
        }

        :host([active]) details {
            background-color: var(
                --ata--app--navigation--backgroundColor--active
            );
            color: var(--ata--app--navigation--foregroundColor--active);
            fill: var(--ata--app--navigation--foregroundColor--active);
        }

        .navigationItem__sub {
            display: flex;
            flex-direction: column;
            padding-block-end: 1rem;
        }

        .navigationItem__sub ::slotted(a) {
            display: block;
            padding: 2rem 2rem 2rem 7rem;
            text-decoration: none !important;
            color: currentColor !important;
        }
    `;
    active = false;
    attributeChangedCallback(name, _old, value) {
        super.attributeChangedCallback(name, _old, value);
        if (name === "active") this.requestUpdate(name, _old);
    }
    render() {
        const isActive = this.getAttribute("active") !== null;
        return (0, $9UZF0.html)`
            <details ?open="${isActive}">
                <summary>
                    <slot name="icon"></slot>
                    <slot name="title">No text</slot>
                </summary>

                <div class="navigationItem__sub">
                    <slot></slot>
                </div>
            </details>
        `;
    }
}
(0, $dGa5T.__decorate)([
    (0, $4Kcgn.property)({
        type: Boolean
    })
], $b76c250efc2cbf34$export$2e2bcd8739ae039.prototype, "active", void 0);
$b76c250efc2cbf34$export$2e2bcd8739ae039 = (0, $dGa5T.__decorate)([
    (0, $d92i1.customElement)("ata-navigation-item-with-sub")
], $b76c250efc2cbf34$export$2e2bcd8739ae039);



var $74J5l = parcelRequire("74J5l");
parcelRequire("MJPZu");
var $9UZF0 = parcelRequire("9UZF0");

var $ez1dp = parcelRequire("ez1dp");
function $9ad3139a15a0aab3$export$428e7c787d57587d(config) {
    return (0, $9UZF0.html)`
        <ata-navigation aria-expanded="${config.isExpanded ? "true" : "false"}">
            ${config.header}
            ${config.items.map($9ad3139a15a0aab3$var$toNavigationItem.bind(null, config.activeRoute, config.onNavigate))}
        </ata-navigation>
    `;
}
function $9ad3139a15a0aab3$var$toNavigationItem(activeRoute, onNavigate, item) {
    if ("items" in item) return (0, $9UZF0.html)`
            <ata-navigation-item-with-sub
                ?active="${$9ad3139a15a0aab3$var$isNavigationItemActive(item, activeRoute)}"
            >
                <span slot="icon">${item.icon}</span>
                <span slot="title" style="text-transform: uppercase">
                    ${item.label}
                </span>

                ${item.items.map((subItem)=>(0, $9UZF0.html)`<a
                            href="${subItem.href}"
                            @click="${(0, $ez1dp.default).onLinkClick(onNavigate)}"
                        >
                            ${$9ad3139a15a0aab3$var$isNavigationItemActive(subItem, activeRoute) ? (0, $9UZF0.html)`<strong>${subItem.label}</strong>` : (0, $9UZF0.html)`<span>${subItem.label}</span>`}
                        </a>`)}
            </ata-navigation-item-with-sub>
        `;
    return (0, $9UZF0.html)`
        <ata-navigation-item
            href="${item.href}"
            ?active="${$9ad3139a15a0aab3$var$isNavigationItemActive(item, activeRoute)}"
            @click="${(event)=>{
        event.preventDefault();
        onNavigate(item.href);
    }}"
        >
            <span slot="icon">${item.icon}</span>
            <span slot="title" style="text-transform: uppercase;">
                ${item.label}
            </span>
        </ata-navigation-item>
    `;
}
function $9ad3139a15a0aab3$var$isNavigationItemActive(item, currentRoute) {
    if ("items" in item) return item.items.some((subItem)=>$9ad3139a15a0aab3$var$isNavigationItemActive(subItem, currentRoute));
    switch(currentRoute.id){
        case "SettingsCompetingCompaniesProfile":
            return "id" in item && item.id === "SettingsCompetingCompanies";
        case "SettingsScenario":
            return "id" in item && item.id === "SettingsScenarios";
        default:
            return item.id === currentRoute.id;
    }
}


function $70d723e9d5a15174$export$2e2bcd8739ae039(account, activeRoute, isExpanded, onNavigate) {
    return (0, $9ad3139a15a0aab3$export$428e7c787d57587d)({
        activeRoute: activeRoute,
        onNavigate: onNavigate,
        isExpanded: isExpanded,
        header: (0, $9UZF0.html)` <ata-navigation-header>
            <span slot="icon">${(0, $ac4D8.default).dealer()}</span>
            <ata-vertical-layout slot="title">
                <span>${account.name}</span>
                ${account.type !== "Dealer" ? (0, $74J5l.link)("/instellingen/vestigingen", onNavigate, (0, $9UZF0.html)`Rapportage aanpassen`) : (0, $9UZF0.nothing)}
            </ata-vertical-layout>
        </ata-navigation-header>`,
        items: $70d723e9d5a15174$var$navigationItems(account)
    });
}
function $70d723e9d5a15174$var$navigationItems(account) {
    return [
        {
            id: "Dashboard",
            label: "Dashboard",
            href: "/dashboard",
            icon: (0, $ac4D8.default).dashboard()
        },
        {
            id: "Stock",
            label: "Voorraad",
            href: "/voorraad",
            icon: (0, $ac4D8.default).voorraad()
        },
        {
            id: "Reach",
            label: "Bereik",
            href: "/bereik",
            icon: (0, $ac4D8.default).bereik()
        },
        {
            id: "Leads",
            label: "Leads",
            href: "/leads",
            icon: (0, $ac4D8.default).leads()
        },
        account.isMaster && {
            id: "Prospects",
            label: "Prospects",
            href: "/prospects",
            icon: (0, $ac4D8.default).prospects()
        },
        {
            label: "Analyse",
            icon: (0, $ac4D8.default).analyse(),
            items: [
                {
                    id: "AnalysisOverview",
                    label: "Overzicht",
                    href: "/analyse/overzicht"
                },
                {
                    id: "AnalysisLeadPerformance",
                    label: "Leads prestatie",
                    href: "/analyse/leadsprestatie"
                },
                {
                    id: "AnalysisMakeModel",
                    label: "Merk/model",
                    href: "/analyse/merkmodel"
                },
                {
                    id: "AnalysisCostBenefit",
                    label: "Kosten en baten",
                    href: "/analyse/kostenbaten"
                }
            ]
        },
        {
            label: "Bedrijven Vergelijken",
            icon: (0, $ac4D8.default).vergelijken(),
            items: [
                {
                    id: "ComparisonAdvicePrice",
                    label: "Adviesprijs",
                    href: "/vergelijk/adviesprijs"
                },
                {
                    id: "ComparisonDaysInStock",
                    label: "Statijd",
                    href: "/vergelijk/statijd"
                },
                {
                    id: "ComparisonGeographic",
                    label: "Geografisch",
                    href: "/vergelijk/geografisch"
                }
            ]
        },
        {
            label: "Instellingen",
            icon: (0, $ac4D8.default).settings(),
            items: [
                account.type !== "Dealer" && {
                    id: "SettingsScenarios",
                    label: "Clusters aanpassen",
                    href: "/instellingen/scenarios"
                },
                account.type !== "Dealer" && {
                    id: "SettingsBranches",
                    label: "Rapportage aanpassen",
                    href: "/instellingen/vestigingen"
                },
                {
                    id: "SettingsStock",
                    label: "Voorraad",
                    href: "/instellingen/voorraad"
                },
                {
                    id: "SettingsCompetingVehicles",
                    label: "Vergelijkbare auto's",
                    href: "/instellingen/concurrentievoertuigen"
                },
                {
                    id: "SettingsCompetingCompanies",
                    label: "Profielen vergelijkbare bedrijven",
                    href: "/instellingen/concurrentiebedrijven"
                },
                {
                    id: "SettingsNotifications",
                    label: "Doel en meldingen",
                    href: "/instellingen/doelenmeldingen"
                }
            ].filter(Boolean)
        },
        {
            id: "NotFound",
            label: "Uitloggen",
            href: "/logout",
            icon: (0, $ac4D8.default).logout()
        }
    ].filter(Boolean);
}



var $9oMz1 = parcelRequire("9oMz1");
parcelRequire("MJPZu");
var $9UZF0 = parcelRequire("9UZF0");
function $2fb54ea62a481d99$export$2e2bcd8739ae039({ previous: previous, next: next }, onNavigate) {
    return (0, $9UZF0.html)`<ata-horizontal-layout align="fill center">
        ${previous === undefined ? (0, $9UZF0.html)`<span></span>` : $2fb54ea62a481d99$var$viewButton(()=>onNavigate(previous.href), "Vorige", previous)}
        ${next === undefined ? (0, $9UZF0.html)`<span></span>` : $2fb54ea62a481d99$var$viewButton(()=>onNavigate(next.href), "Volgende", next)}
    </ata-horizontal-layout>`;
}
function $2fb54ea62a481d99$var$viewButton(onNavigate, prefix, config) {
    return (0, $9UZF0.html)` <ata-filled-button
        theme="primary"
        href="${config.href}"
        @click="${(event)=>{
        event.preventDefault();
        onNavigate();
    }}"
    >
        ${prefix}: ${config.label}
    </ata-filled-button>`;
}



var $ksfXA = parcelRequire("ksfXA");

var $kjhzP = parcelRequire("kjhzP");

var $7yG78 = parcelRequire("7yG78");

var $ac4D8 = parcelRequire("ac4D8");

var $ksfXA = parcelRequire("ksfXA");

var $fjcCR = parcelRequire("fjcCR");

var $eziMm = parcelRequire("eziMm");

var $7yG78 = parcelRequire("7yG78");

var $ac4D8 = parcelRequire("ac4D8");

var $80ixM = parcelRequire("80ixM");
parcelRequire("MJPZu");
var $hOpwk = parcelRequire("hOpwk");
var $9UZF0 = parcelRequire("9UZF0");

var $2dbqg = parcelRequire("2dbqg");
parcelRequire("hsSvT");
parcelRequire("MJPZu");
var $hOpwk = parcelRequire("hOpwk");
var $9UZF0 = parcelRequire("9UZF0");

var $2dbqg = parcelRequire("2dbqg");
(0, $2dbqg.declareStyle)((0, $hOpwk.css)`
    ata-license-plate-input {
        display: flex;
        flex-direction: row;
        --ata--input--backgroundColor: #f7c033;
        --ata--input--borderColor: #f7c033;
    }

    ata-license-plate-input > div {
        background: #0028d8;
        display: flex;
        align-items: center;
        justify-content: center;
        border-start-start-radius: var(--ata--input--borderRadius);
        border-end-start-radius: var(--ata--input--borderRadius);
    }

    ata-license-plate-input ::part(input) {
        text-transform: uppercase;
        border-start-start-radius: 0;
        border-end-start-radius: 0;
    }
`);
function $1cf311d8b77ef616$export$2e2bcd8739ae039(config) {
    const isDisabled = config.isDisabled === true;
    const isReadonly = config.onChange === undefined && config.debounce === undefined && !isDisabled;
    const onChange = config.onChange !== undefined ? (event)=>{
        config.onChange(event.target.value);
    } : ()=>{};
    const onDebouncedChange = config.debounce !== undefined ? (event)=>{
        config.debounce.onChange(event.target.value);
    } : ()=>{};
    return (0, $9UZF0.html)` <ata-license-plate-input>
        <div>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
            >
                <g>
                    <path
                        fill="#FFEB33"
                        d="M10 0L9.81 0.6 9.17 0.6 9.69 0.96 9.5 1.54 10 1.19 10.5 1.54 10.31 0.96 10.83 0.6 10.19 0.6z"
                    />
                    <path
                        fill="#FFEB33"
                        d="M12.59 0.68L12.39 1.27 11.76 1.27 12.28 1.64 12.09 2.22 12.59 1.86 13.08 2.22 12.9 1.64 13.41 1.27 12.78 1.27z"
                    />
                    <path
                        fill="#FFEB33"
                        d="M6.92 2.22L7.41 1.86 7.91 2.22 7.72 1.64 8.24 1.27 7.61 1.27 7.41 0.68 7.22 1.27 6.59 1.27 7.1 1.64z"
                    />
                    <path
                        fill="#FFEB33"
                        d="M13.99 4.12L14.49 3.76 14.99 4.12 14.8 3.54 15.32 3.17 14.68 3.17 14.49 2.57 14.3 3.17 13.66 3.17 14.18 3.54z"
                    />
                    <path
                        fill="#FFEB33"
                        d="M5.51 2.57L5.32 3.17 4.68 3.17 5.2 3.54 5.01 4.12 5.51 3.76 6.01 4.12 5.82 3.54 6.34 3.17 5.7 3.17z"
                    />
                    <path
                        fill="#FFEB33"
                        d="M16 5.77L15.37 5.77 15.17 5.17 14.98 5.77 14.35 5.77 14.86 6.13 14.68 6.71 15.17 6.36 15.67 6.71 15.48 6.13z"
                    />
                    <path
                        fill="#FFEB33"
                        d="M4.83 6.36L5.32 6.71 5.14 6.13 5.65 5.77 5.02 5.77 4.83 5.17 4.63 5.77 4 5.77 4.52 6.13 4.33 6.71z"
                    />
                    <path
                        fill="#FFEB33"
                        d="M14.68 8.35L14.49 7.76 14.3 8.35 13.66 8.35 14.18 8.72 13.99 9.3 14.49 8.94 14.99 9.3 14.8 8.72 15.32 8.35z"
                    />
                    <path
                        fill="#FFEB33"
                        d="M5.7 8.35L5.51 7.76 5.32 8.35 4.68 8.35 5.2 8.72 5.01 9.3 5.51 8.94 6.01 9.3 5.82 8.72 6.34 8.35z"
                    />
                    <path
                        fill="#FFEB33"
                        d="M12.78 10.25L12.59 9.65 12.39 10.25 11.76 10.25 12.28 10.62 12.09 11.19 12.59 10.84 13.08 11.19 12.9 10.62 13.41 10.25z"
                    />
                    <path
                        fill="#FFEB33"
                        d="M7.61 10.25L7.41 9.65 7.22 10.25 6.59 10.25 7.1 10.62 6.92 11.19 7.41 10.84 7.91 11.19 7.72 10.62 8.24 10.25z"
                    />
                    <path
                        fill="#FFEB33"
                        d="M10.19 10.95L10 10.35 9.81 10.95 9.17 10.95 9.69 11.32 9.5 11.9 10 11.54 10.5 11.9 10.31 11.32 10.83 10.95z"
                    />
                </g>
                <g>
                    <path
                        d="M4.93,20v-6.04h1.19l2.47,4.04v-4.04h1.13V20H8.5l-2.44-3.94V20H4.93z"
                    />
                    <path d="M11.04,20v-5.99h1.22v4.98h3.03V20H11.04z" />
                </g>
            </svg>
        </div>
        <ata-text-input
            name=${config.name}
            value=${config.value}
            placeholder=${config.placeholder}
            autocomplete=${config.autocomplete ?? "off"}
            error-message=${config.errorMessage}
            debounce-duration=${config.debounce?.duration}
            ?disabled=${isDisabled}
            ?readonly=${isReadonly}
            @input=${onChange}
            @blur=${onChange}
            @debouncedInput=${onDebouncedChange}
        ></ata-text-input>
    </ata-license-plate-input>`;
}


(0, $2dbqg.declareStyle)((0, $hOpwk.css)`
    ata-taxation-widget {
        display: block;
        background: var(--color--neutral-3);
        color: var(--color--neutral-10);
        fill: var(--color--neutral-10);
        border-radius: var(--dimensions--borderRadius--small);
    }
`);
function $cbca03c442564b77$export$2e2bcd8739ae039(config) {
    const onSubmit = (event)=>{
        event.preventDefault();
        config.onSubmit();
    };
    return (0, $9UZF0.html)`<ata-taxation-widget>
        <form @submit=${onSubmit}>
        ${(0, $ksfXA.padding)("medium", (0, $fjcCR.verticalLayout)([
        "fill",
        "start"
    ], "medium", [
        (0, $fjcCR.horizontalLayout)([
            "start",
            "start"
        ], "medium", [
            (0, $9UZF0.html)`<div style="inline-size: 2rem; aspect-ratio: 1">
                        ${(0, $ac4D8.default).calc()}
                    </div>`,
            (0, $fjcCR.verticalLayout)([
                "start",
                "center"
            ], "small", [
                (0, $80ixM.smallHeading)((0, $9UZF0.html)`Taxatie`),
                (0, $9UZF0.html)`<small>Vul kenteken en km-stand in</small>`
            ])
        ]),
        (0, $fjcCR.horizontalLayout)([
            "fill",
            "center"
        ], "small", [
            (0, $fjcCR.fillContainer)((0, $1cf311d8b77ef616$export$2e2bcd8739ae039)({
                value: config.licensePlate,
                name: "taxation-licenseplate",
                placeholder: "Kenteken",
                onChange: config.onLicensePlateChange,
                errorMessage: config.licensePlate === "" ? "Vul kenteken in" : undefined
            })),
            (0, $fjcCR.fillContainer)((0, $eziMm.default)({
                value: config.mileage,
                name: "taxation-mileage",
                placeholder: "Km-stand",
                onChange: config.onMileageChange,
                errorMessage: config.mileage === "Vul km-stand in" ? "Required" : undefined
            })),
            (0, $7yG78.denseFilledButton)({
                type: "submit",
                theme: "Primary",
                content: (0, $ac4D8.default).loop()
            })
        ]),
        config.errorMessage ? (0, $9UZF0.html)`<div
                          style="
                            background: var(--color--danger); 
                            color: var(--color--neutral-10); 
                            padding: var(--dimensions--spacing--medium); 
                            border-radius: var(--dimensions--borderRadius--small)
                          "
                      >
                          <span>${config.errorMessage}</span>
                      </div>` : (0, $9UZF0.nothing)
    ]))}
        </form>
    </div>`;
}




var $74J5l = parcelRequire("74J5l");

var $fb0eT = parcelRequire("fb0eT");
function $7a662f5db96b23da$export$2e2bcd8739ae039(config) {
    return (0, $9UZF0.html)`
        <ata-layout-shell ?navigation-visible="${config.isNavigationVisible}">
            <div slot="header">
                ${$7a662f5db96b23da$var$viewAppBar(config.deviceLayout, config.onToggleNavigation)}
            </div>

            <div
                slot="navigation"
                style="block-size: 100%; background: var(--ata--app--navigation--backgroundColor); display: flex; flex-direction: column; overflow: hidden;"
            >
                <ata-navigation-group style="flex: 1; overflow: hidden;">
                    ${(0, $70d723e9d5a15174$export$2e2bcd8739ae039)(config.account, config.activeRoute, true, config.onNavigate)}
                </ata-navigation-group>

                ${config.taxationWidget !== undefined ? (0, $9UZF0.html)`
                          <div
                              style="flex: 0; position: sticky; inset: auto 0 0 0; padding: var(--dimensions--spacing--medium); box-sizing: border-box;"
                          >
                              ${(0, $cbca03c442564b77$export$2e2bcd8739ae039)(config.taxationWidget)}
                          </div>
                      ` : (0, $9UZF0.nothing)}
            </div>

            ${$7a662f5db96b23da$export$4cf1388ef83aed25({
        onNavigate: config.onNavigate,
        title: (0, $9UZF0.html)`${config.pageTitle}`,
        account: config.account,
        actions: config.pageActions,
        ...config.hasSettings === true ? {
            stockCount: null,
            dealerCount: null
        } : {
            stockCount: config.stockCount,
            dealerCount: config.dealerCount
        }
    })}

            <main style="position: relative"> ${config.content} </main>

            ${config.pageNavigations ? (0, $ksfXA.paddingEach)({
        blockStart: "large",
        blockEnd: "none",
        inlineStart: "none",
        inlineEnd: "none"
    }, (0, $9UZF0.html)`<hr />`) : (0, $9UZF0.nothing)}
            ${(0, $ksfXA.padding)("large", (0, $2fb54ea62a481d99$export$2e2bcd8739ae039)({
        previous: config.pageNavigations?.previous,
        next: config.pageNavigations?.next
    }, config.onNavigate))}
            ${(0, $d33980c98f883187$export$2e2bcd8739ae039)(config.account.lastUpdate)}
        </ata-layout-shell>
    `;
}
function $7a662f5db96b23da$var$viewAppBar(deviceLayout, onToggleNavigation) {
    switch(deviceLayout){
        case "Desktop":
            return (0, $kjhzP.default)({
                start: (0, $ksfXA.paddingBlockInline)({
                    block: "none",
                    inline: "medium"
                }, (0, $9UZF0.html)`<img
                        loading="lazy"
                        src="https://analytics.autotrack.nl/assets/images/autotrack-analytics.png"
                        style="block-size: 3rem"
                        title="AutoTrack Analytics v${(0, $fb0eT.version)}"
                    />`)
            });
        case "Mobile":
            return (0, $kjhzP.default)({
                center: (0, $ksfXA.paddingBlockInline)({
                    block: "none",
                    inline: "medium"
                }, (0, $9UZF0.html)`<img
                        loading="lazy"
                        src="https://analytics.autotrack.nl/assets/images/autotrack-analytics.png"
                        style="block-size: 3rem"
                        title="AutoTrack Analytics v${(0, $fb0eT.version)}"
                    />`),
                end: (0, $7yG78.button)({
                    theme: "Secondary",
                    content: (0, $ac4D8.default).hamburger(),
                    onClick: onToggleNavigation
                })
            });
    }
}
function $7a662f5db96b23da$export$4cf1388ef83aed25(config) {
    return (0, $9UZF0.html)`
        <ata-page-header>
            <ata-big-heading slot="title">${config.title}</ata-big-heading>
            <span slot="subtitle"
                >${$7a662f5db96b23da$var$toPageHeaderSubtitle(config.onNavigate, config.account, config.stockCount, config.dealerCount)}</span
            >
            <ata-horizontal-layout gap="small" slot="actions">
                ${config.actions}
            </ata-horizontal-layout>
        </ata-page-header>
    `;
}
function $7a662f5db96b23da$var$toPageHeaderSubtitle(onNavigate, account, stockCount, dealerCount) {
    switch(account.type){
        case "Dealer":
            if (stockCount === null) return 0, $9UZF0.nothing;
            return $7a662f5db96b23da$var$toPageHeaderStockCount(onNavigate, stockCount);
        case "Holding":
        case "Group":
            {
                const sections = [
                    stockCount !== null ? $7a662f5db96b23da$var$toPageHeaderStockCount(onNavigate, stockCount) : null,
                    dealerCount !== null ? $7a662f5db96b23da$var$toPageHeaderDealerCount(onNavigate, dealerCount) : null
                ];
                return (0, $9UZF0.html)`${(0, $10f45a76726b5bfb$export$f7e2c8231c57a8bd)(sections.filter(Boolean), (0, $9UZF0.html)` | `)}`;
            }
    }
}
function $7a662f5db96b23da$var$toPageHeaderStockCount(onNavigate, data) {
    const selectionText = (0, $9oMz1.intlText)("Selectie: {selected} van {total, plural, =1 {{total} auto} other {{total} auto's}}", {
        total: data.total,
        selected: data.selected
    });
    return (0, $9UZF0.html)`
        <span style="white-space: nowrap;">
            <span> ${selectionText} </span>
            - ${(0, $74J5l.link)("/instellingen/voorraad", onNavigate, (0, $9UZF0.html)`Aanpassen`)}
        </span>
    `;
}
function $7a662f5db96b23da$var$toPageHeaderDealerCount(onNavigate, data) {
    const selectionText = (0, $9oMz1.intlText)("Selectie vestigingen: {selected} van {total}", {
        total: data.total,
        selected: data.selected
    });
    return (0, $9UZF0.html)`
        <span style="white-space: nowrap;">
            <span> ${selectionText} </span>
            -
            ${(0, $74J5l.link)("/instellingen/vestigingen", onNavigate, (0, $9UZF0.html)`Samenstelling aanpassen`)}
        </span>
    `;
}


parcelRequire("MJPZu");
var $9UZF0 = parcelRequire("9UZF0");





var $dGa5T = parcelRequire("dGa5T");
parcelRequire("bFoC6");
var $d92i1 = parcelRequire("d92i1");
parcelRequire("MJPZu");
var $hOpwk = parcelRequire("hOpwk");
var $9UZF0 = parcelRequire("9UZF0");
var $78EKQ = parcelRequire("78EKQ");
class $9c6a6a8ebe7644a3$export$2e2bcd8739ae039 extends (0, $78EKQ.LitElement) {
    static styles = (0, $hOpwk.css)`
        :host {
            display: grid;
            grid-template-columns: auto 1fr;
            background: #ddd;
        }

        .pageHeader__vehicleImage:has(:not(slot:empty)) {
            block-size: 18rem;
        }

        .pageHeader__vehicleDetails {
            padding: 2rem;
        }
    `;
    render() {
        return (0, $9UZF0.html)`
            <div class="pageHeader__vehicleImage">
                <slot name="image"></slot>
            </div>

            <div class="pageHeader__vehicleDetails">
                <slot></slot>
            </div>
        `;
    }
}
$9c6a6a8ebe7644a3$export$2e2bcd8739ae039 = (0, $dGa5T.__decorate)([
    (0, $d92i1.customElement)("ata-vehicle-page-header")
], $9c6a6a8ebe7644a3$export$2e2bcd8739ae039);


parcelRequire("4CCe6");
parcelRequire("6yjXZ");
parcelRequire("9TU71");
parcelRequire("9zfjy");

var $dGa5T = parcelRequire("dGa5T");
parcelRequire("bFoC6");
var $d92i1 = parcelRequire("d92i1");
var $4Kcgn = parcelRequire("4Kcgn");
parcelRequire("MJPZu");
var $hOpwk = parcelRequire("hOpwk");
var $9UZF0 = parcelRequire("9UZF0");
var $78EKQ = parcelRequire("78EKQ");
class $9505f08bfa72773d$export$2e2bcd8739ae039 extends (0, $78EKQ.LitElement) {
    static styles = (0, $hOpwk.css)`
        :host {
            display: block;
            position: relative;
            aspect-ratio: 4 / 3;
            height: 100%;
        }

        img {
            display: block;
            max-block-size: 100%;
            max-inline-size: 100%;
        }

        ::slotted([slot='photoCount']:not(:empty)) {
            position: absolute;
            inset: auto 1rem 1rem auto;
            background: white;
            padding: 0.5rem;
            border-radius: 4px;
        }
    `;
    src = "";
    render() {
        return (0, $9UZF0.html)`
            <img src="${this.src}" />
            <slot name="photoCount"></slot>
        `;
    }
}
(0, $dGa5T.__decorate)([
    (0, $4Kcgn.property)({
        type: String
    })
], $9505f08bfa72773d$export$2e2bcd8739ae039.prototype, "src", void 0);
$9505f08bfa72773d$export$2e2bcd8739ae039 = (0, $dGa5T.__decorate)([
    (0, $d92i1.customElement)("ata-vehicle-image")
], $9505f08bfa72773d$export$2e2bcd8739ae039);



parcelRequire("MJPZu");
var $9UZF0 = parcelRequire("9UZF0");

var $ac4D8 = parcelRequire("ac4D8");



var $5IE5z = parcelRequire("5IE5z");
function $eb62fdb30add7b60$export$2e2bcd8739ae039(isExpanded, activeRoute, vehicle, onNavigate) {
    return (0, $9ad3139a15a0aab3$export$428e7c787d57587d)({
        isExpanded: isExpanded,
        activeRoute: activeRoute,
        onNavigate: onNavigate,
        header: (0, $9UZF0.html)` <ata-navigation-header>
            <span slot="icon">${(0, $ac4D8.default).auto()}</span>
            <span slot="title">${(0, $5IE5z.toShortName)(vehicle)}</span>
        </ata-navigation-header>`,
        items: $eb62fdb30add7b60$var$navigationItems(vehicle.id.value)
    });
}
function $eb62fdb30add7b60$var$navigationItems(vehicleId) {
    return [
        {
            id: "VehicleDashboard",
            label: "Dashboard Auto",
            href: `/voertuig/${vehicleId}/dashboard`,
            icon: (0, $ac4D8.default).dashboard()
        },
        {
            label: "Auto's vergelijken",
            icon: (0, $ac4D8.default).concurrentie(),
            items: [
                {
                    id: "VehicleComparisonOverview",
                    label: "Overzicht",
                    href: `/voertuig/${vehicleId}/vergelijk/overzicht`
                },
                {
                    id: "VehicleComparisonPriceAnalysis",
                    label: "Prijsanalyse",
                    href: `/voertuig/${vehicleId}/vergelijk/prijsanalyse`
                },
                {
                    id: "VehicleComparisonPriceHistory",
                    label: "Prijshistorie",
                    href: `/voertuig/${vehicleId}/vergelijk/prijshistorie`
                },
                {
                    id: "VehicleComparisonGeographic",
                    label: "Geografisch",
                    href: `/voertuig/${vehicleId}/vergelijk/geografisch`
                }
            ]
        },
        {
            label: "Bereik",
            icon: (0, $ac4D8.default).bereik(),
            items: [
                {
                    id: "VehicleReachOverview",
                    label: "Overzicht",
                    href: `/voertuig/${vehicleId}/bereik/overzicht`
                },
                {
                    id: "VehicleReachPriceEffect",
                    label: "Prijseffect",
                    href: `/voertuig/${vehicleId}/bereik/prijseffect`
                }
            ]
        },
        {
            id: "VehicleSettings",
            label: "Eigenschappen",
            href: `/voertuig/${vehicleId}/settings`,
            icon: (0, $ac4D8.default).settings()
        },
        {
            id: "NotFound",
            label: "Terug naar voorraadlijst",
            href: "/voorraad",
            icon: (0, $ac4D8.default).prev()
        }
    ];
}



var $5jpwE = parcelRequire("5jpwE");

var $9oMz1 = parcelRequire("9oMz1");

var $5IE5z = parcelRequire("5IE5z");

var $ac4D8 = parcelRequire("ac4D8");


var $ksfXA = parcelRequire("ksfXA");

var $kjhzP = parcelRequire("kjhzP");

var $7yG78 = parcelRequire("7yG78");



var $fb0eT = parcelRequire("fb0eT");
function $933280e87f824615$export$2e2bcd8739ae039(config) {
    return (0, $9UZF0.html)`
        <ata-layout-shell ?navigation-visible="${config.isNavigationVisible}">
            <div slot="header">
                ${$933280e87f824615$var$viewAppBar(config.deviceLayout, config.onToggleNavigation)}
            </div>

            <div
                slot="navigation"
                style="block-size: 100%; background: var(--ata--app--navigation--backgroundColor); display: flex; flex-direction: column; overflow: hidden;"
            >
                <ata-navigation-group style="flex: 1; overflow: hidden;">
                    ${(0, $70d723e9d5a15174$export$2e2bcd8739ae039)(config.account, config.activeRoute, false, config.onNavigate)}
                    ${(0, $eb62fdb30add7b60$export$2e2bcd8739ae039)(true, config.activeRoute, config.vehicle, config.onNavigate)}
                </ata-navigation-group>

                ${config.taxationWidget !== undefined ? (0, $9UZF0.html)`
                          <div
                              style="flex: 0; position: sticky; inset: auto 0 0 0; padding: var(--dimensions--spacing--medium); box-sizing: border-box;"
                          >
                              ${(0, $cbca03c442564b77$export$2e2bcd8739ae039)(config.taxationWidget)}
                          </div>
                      ` : (0, $9UZF0.nothing)}
            </div>

            ${$933280e87f824615$var$vehiclePageHeader({
        title: (0, $9UZF0.html)`${config.pageTitle}`,
        pageActions: config.pageActions,
        vehicle: config.vehicle
    })}

            <main style="position: relative"> ${config.content} </main>

            ${config.pageNavigations ? (0, $ksfXA.paddingEach)({
        blockStart: "large",
        blockEnd: "none",
        inlineStart: "none",
        inlineEnd: "none"
    }, (0, $9UZF0.html)`<hr />`) : (0, $9UZF0.nothing)}
            ${(0, $ksfXA.padding)("large", (0, $2fb54ea62a481d99$export$2e2bcd8739ae039)({
        previous: config.pageNavigations?.previous,
        next: config.pageNavigations?.next
    }, config.onNavigate))}
            ${(0, $d33980c98f883187$export$2e2bcd8739ae039)(config.account.lastUpdate)}
        </ata-layout-shell>
    `;
}
function $933280e87f824615$var$viewAppBar(deviceLayout, onToggleNavigation) {
    switch(deviceLayout){
        case "Desktop":
            return (0, $kjhzP.default)({
                start: (0, $ksfXA.paddingBlockInline)({
                    block: "none",
                    inline: "medium"
                }, (0, $9UZF0.html)`<img
                        loading="lazy"
                        src="https://analytics.autotrack.nl/assets/images/autotrack-analytics.png"
                        style="block-size: 3rem"
                        title="AutoTrack Analytics v${(0, $fb0eT.version)}"
                    />`)
            });
        case "Mobile":
            return (0, $kjhzP.default)({
                center: (0, $ksfXA.paddingBlockInline)({
                    block: "none",
                    inline: "medium"
                }, (0, $9UZF0.html)`<img
                        loading="lazy"
                        src="https://analytics.autotrack.nl/assets/images/autotrack-analytics.png"
                        style="block-size: 3rem"
                        title="AutoTrack Analytics v${(0, $fb0eT.version)}"
                    />`),
                end: (0, $7yG78.button)({
                    theme: "Secondary",
                    content: (0, $ac4D8.default).hamburger(),
                    onClick: onToggleNavigation
                })
            });
    }
}
function $933280e87f824615$var$vehiclePageHeader(config) {
    const vehiclePhotoCount = config.vehicle.photocount.value;
    const vehiclePhoto = config.vehicle.photo.value;
    const vehicleName = $5IE5z.toName(config.vehicle);
    const vehicleSummary = $5IE5z.toSummary(config.vehicle);
    const vehiclePrice = config.vehicle.price.asking.value;
    const vehicleDaysInStock = config.vehicle.daysinstock.amount.value;
    const vehicleDealer = config.vehicle.dealer.name.value;
    const vehicleAutoTrackLink = config.vehicle.aturl.value;
    const vehicleVideo = config.vehicle.video.value;
    return (0, $9UZF0.html)`
        <ata-vehicle-page-header>
            <ata-vertial-layout slot="image">
                <ata-vehicle-image src="${vehiclePhoto}">
                    <ata-horizontal-layout slot="photoCount" gap="small">
                        ${vehicleVideo.length > 0 ? (0, $9UZF0.html)`<span style="width: 2rem;"
                                  >${(0, $ac4D8.default).video()}</span
                              >` : (0, $9UZF0.nothing)}
                        <span style="width: 2rem;">${(0, $ac4D8.default).camera()}</span>
                        ${vehiclePhotoCount}
                    </ata-horizontal-layout>
                </ata-vehicle-image>
            </ata-vertial-layout>

            <ata-horizontal-layout align="fill" gap="medium">
                <ata-vertical-layout gap="medium">
                    <ata-big-heading>${vehicleName}</ata-big-heading>
                    <p>${vehicleSummary}</p>

                    <ata-vertical-layout>
                        <p>${vehicleDealer}</p>
                        <a href="${vehicleAutoTrackLink}" target="_blank">
                            Bekijk advertentie op AutoTrack
                        </a>
                    </ata-vertical-layout>
                </ata-vertical-layout>

                <ata-vertical-layout gap="medium" align="end start">
                    <ata-big-heading>
                        ${(0, $5jpwE.default).currency(Number(vehiclePrice))}
                    </ata-big-heading>
                    <p>
                        ${(0, $9oMz1.intlText)(`Statijd: {value, plural, =1 {1 dag} other {# dagen}}`, {
        value: Number(vehicleDaysInStock)
    })}
                    </p>
                </ata-vertical-layout>
            </ata-horizontal-layout>
        </ata-vehicle-page-header>

        <ata-page-header>
            <ata-big-heading slot="title">${config.title}</ata-big-heading>

            <ata-horizontal-layout gap="small" slot="actions">
                ${config.pageActions}
            </ata-horizontal-layout>
        </ata-page-header>
    `;
}



var $7yG78 = parcelRequire("7yG78");

var $ac4D8 = parcelRequire("ac4D8");
function $3b66fc74e6759da7$export$7212e0e3e3b6e766(value) {
    throw new Error(`Unhandled member of a union type.
        
You need to account for the following values:
        
    ${JSON.stringify(value, null, 2).replace(/\n/g, "\n	")}


Tip: This error often occurs if a new variant was recently added to a union type but hasn't been handled everywhere it's used.
`);
}


var $c9d0f3356cb93170$export$2e2bcd8739ae039 = {
    getValue: $c9d0f3356cb93170$export$bf7199a9ebcb84a9,
    set: $c9d0f3356cb93170$export$adaa4cf7ef1b65be,
    clearExpired: $c9d0f3356cb93170$export$9a3525c663730601
};
function $c9d0f3356cb93170$export$bf7199a9ebcb84a9(key, map) {
    return map.get(key)?.[0];
}
function $c9d0f3356cb93170$export$adaa4cf7ef1b65be(key, value, createdOn, map) {
    map.set(key, [
        value,
        createdOn
    ]);
    return map;
}
function $c9d0f3356cb93170$export$9a3525c663730601(expirationPredicate, map) {
    for (const [key, [value, createdOn]] of map.entries())if (expirationPredicate(value, createdOn)) map.delete(key);
    return map;
}



var $aY56T = parcelRequire("aY56T");

var $5yZNA = parcelRequire("5yZNA");

var $210eY = parcelRequire("210eY");

var $gUdlQ = parcelRequire("gUdlQ");

var $02YGq = parcelRequire("02YGq");

var $ls5dD = parcelRequire("ls5dD");
parcelRequire("MJPZu");
var $9UZF0 = parcelRequire("9UZF0");





parcelRequire("4CCe6");
parcelRequire("6yjXZ");
parcelRequire("9TU71");
parcelRequire("9zfjy");

var $kjhzP = parcelRequire("kjhzP");

var $ksfXA = parcelRequire("ksfXA");

var $7yG78 = parcelRequire("7yG78");

var $ac4D8 = parcelRequire("ac4D8");

var $5IE5z = parcelRequire("5IE5z");

parcelRequire("MJPZu");
var $9UZF0 = parcelRequire("9UZF0");


var $ac4D8 = parcelRequire("ac4D8");

function $79f586d32695369f$export$2e2bcd8739ae039(isExpanded, activeRoute, vehicleId, licensePlate, onNavigate) {
    return (0, $9ad3139a15a0aab3$export$428e7c787d57587d)({
        activeRoute: activeRoute,
        onNavigate: onNavigate,
        isExpanded: isExpanded,
        header: (0, $9UZF0.html)`<ata-navigation-header>
            <span slot="icon">${(0, $ac4D8.default).calc()}</span>
            <span slot="title">Taxatie: ${licensePlate}</span>
        </ata-navigation-header>`,
        items: $79f586d32695369f$var$navigationItems(vehicleId)
    });
}
function $79f586d32695369f$var$navigationItems(vehicleId) {
    return [
        {
            id: "TaxationDashboard",
            label: "Dashboard",
            href: `/taxatie/${vehicleId}/dashboard`,
            icon: (0, $ac4D8.default).dashboard()
        },
        {
            label: "Auto's vergelijken",
            icon: (0, $ac4D8.default).concurrentie(),
            items: [
                {
                    id: "TaxationComparisonOverview",
                    label: "Overzicht",
                    href: `/taxatie/${vehicleId}/vergelijk/overzicht`
                },
                {
                    id: "TaxationComparisonPriceAnalysis",
                    label: "Prijsanalyse",
                    href: `/taxatie/${vehicleId}/vergelijk/prijsanalyse`
                },
                {
                    id: "TaxationComparisonPriceHistory",
                    label: "Prijshistorie",
                    href: `/taxatie/${vehicleId}/vergelijk/prijshistorie`
                },
                {
                    id: "TaxationComparisonGeographic",
                    label: "Geografisch",
                    href: `/taxatie/${vehicleId}/vergelijk/geografisch`
                }
            ]
        },
        {
            id: "TaxationSettings",
            label: "Eigenschappen",
            href: `/taxatie/${vehicleId}/settings`,
            icon: (0, $ac4D8.default).settings()
        }
    ];
}






var $fb0eT = parcelRequire("fb0eT");
function $a7ab0f96a9239fab$export$2e2bcd8739ae039(config) {
    return (0, $9UZF0.html)`
        <ata-layout-shell ?navigation-visible="${config.isNavigationVisible}">
            <div slot="header">
                ${$a7ab0f96a9239fab$var$viewAppBar(config.deviceLayout, config.onToggleNavigation)}
            </div>

            <div
                slot="navigation"
                style="block-size: 100%; background: var(--ata--app--navigation--backgroundColor); display: flex; flex-direction: column; overflow: hidden;"
            >
                <ata-navigation-group style="flex: 1; overflow: hidden;">
                    ${(0, $70d723e9d5a15174$export$2e2bcd8739ae039)(config.account, config.activeRoute, false, config.onNavigate)}
                    ${(0, $79f586d32695369f$export$2e2bcd8739ae039)(true, config.activeRoute, config.vehicle.id.value, config.vehicle.licenseplate.humanvalue, config.onNavigate)}
                </ata-navigation-group>

                ${config.taxationWidget !== undefined ? (0, $9UZF0.html)`
                          <div
                              style="flex: 0; position: sticky; inset: auto 0 0 0; padding: var(--dimensions--spacing--medium); box-sizing: border-box;"
                          >
                              ${(0, $cbca03c442564b77$export$2e2bcd8739ae039)(config.taxationWidget)}
                          </div>
                      ` : (0, $9UZF0.nothing)}
            </div>

            ${$a7ab0f96a9239fab$var$vehiclePageHeader({
        title: (0, $9UZF0.html)`${config.pageTitle}`,
        pageActions: config.pageActions,
        vehicle: config.vehicle
    })}

            <main style="position: relative"> ${config.content} </main>

            ${config.pageNavigations ? (0, $ksfXA.paddingEach)({
        blockStart: "large",
        blockEnd: "none",
        inlineStart: "none",
        inlineEnd: "none"
    }, (0, $9UZF0.html)`<hr />`) : (0, $9UZF0.nothing)}
            ${(0, $ksfXA.padding)("large", (0, $2fb54ea62a481d99$export$2e2bcd8739ae039)({
        previous: config.pageNavigations?.previous,
        next: config.pageNavigations?.next
    }, config.onNavigate))}
            ${(0, $d33980c98f883187$export$2e2bcd8739ae039)(config.account.lastUpdate)}
        </ata-layout-shell>
    `;
}
function $a7ab0f96a9239fab$var$viewAppBar(deviceLayout, onToggleNavigation) {
    switch(deviceLayout){
        case "Desktop":
            return (0, $kjhzP.default)({
                start: (0, $ksfXA.paddingBlockInline)({
                    block: "none",
                    inline: "medium"
                }, (0, $9UZF0.html)`<img
                        loading="lazy"
                        src="https://analytics.autotrack.nl/assets/images/autotrack-analytics.png"
                        style="block-size: 3rem"
                        title="AutoTrack Analytics v${(0, $fb0eT.version)}"
                    />`)
            });
        case "Mobile":
            return (0, $kjhzP.default)({
                center: (0, $ksfXA.paddingBlockInline)({
                    block: "none",
                    inline: "medium"
                }, (0, $9UZF0.html)`<img
                        loading="lazy"
                        src="https://analytics.autotrack.nl/assets/images/autotrack-analytics.png"
                        style="block-size: 3rem"
                        title="AutoTrack Analytics v${(0, $fb0eT.version)}"
                    />`),
                end: (0, $7yG78.button)({
                    theme: "Secondary",
                    content: (0, $ac4D8.default).hamburger(),
                    onClick: onToggleNavigation
                })
            });
    }
}
function $a7ab0f96a9239fab$var$vehiclePageHeader(config) {
    const vehicleName = $5IE5z.toName(config.vehicle);
    const vehicleSummary = $5IE5z.toTaxationSummary(config.vehicle);
    return (0, $9UZF0.html)`
        <ata-vehicle-page-header>
            <ata-vertical-layout align="fill" gap="medium">
                <ata-big-heading>Taxatie: ${vehicleName}</ata-big-heading>
                <p> ${vehicleSummary} </p>
            </ata-vertical-layout>
        </ata-vehicle-page-header>

        <ata-page-header>
            <ata-big-heading slot="title">${config.title}</ata-big-heading>

            <ata-horizontal-layout gap="small" slot="actions">
                ${config.pageActions}
            </ata-horizontal-layout>
        </ata-page-header>
    `;
}


parcelRequire("MJPZu");
var $hOpwk = parcelRequire("hOpwk");
var $9UZF0 = parcelRequire("9UZF0");

var $2dbqg = parcelRequire("2dbqg");

var $fjcCR = parcelRequire("fjcCR");

var $80ixM = parcelRequire("80ixM");
(0, $2dbqg.declareStyle)((0, $hOpwk.css)`
    ata-premium-peak {
        display: block;
        max-block-size: 500px;
        overflow: hidden;
        position: relative;

        [content] {
            pointer-events: none;
        }

        [explanation] {
            position: absolute;
            inset: 0;
            background: linear-gradient(
                to top,
                rgba(256, 256, 256, 1) 30%,
                rgba(256, 256, 256, 0) 60%
            );
            display: flex;
            flex-direction: column;
            justify-content: end;
            align-items: center;
            padding-block-end: 2.5%;
        }
    }
`);
function $6cd550bbc3c7490c$export$a4111085dcbe77df(title, content) {
    return (0, $9UZF0.html)`
        <ata-premium-peak>
            <div content>${content}</div>
            <div explanation>
                ${(0, $fjcCR.verticalLayout)([
        "center",
        "start"
    ], "small", [
        (0, $80ixM.bigHeading)((0, $9UZF0.html)`${title}`),
        (0, $9UZF0.html)`<p>
                        Upgrade naar een premium account, bel
                        <a href="tel:+31887300100">
                            +31 88 7300 100
                        </a>
                    </p>`
    ])}
            </div>
        </ata-premium-peak>
    `;
}


parcelRequire("MJPZu");
var $9UZF0 = parcelRequire("9UZF0");

var $fjcCR = parcelRequire("fjcCR");

var $80ixM = parcelRequire("80ixM");

var $7yG78 = parcelRequire("7yG78");

var $ksfXA = parcelRequire("ksfXA");
function $04112eb0724539bf$export$2e2bcd8739ae039(config) {
    return (0, $ksfXA.padding)("large", (0, $fjcCR.verticalLayout)([
        "center",
        "start"
    ], "large", [
        (0, $fjcCR.verticalLayout)([
            "center",
            "start"
        ], "small", [
            (0, $80ixM.bigHeading)((0, $9UZF0.html)`Pagina niet gevonden`),
            (0, $9UZF0.html)`<p>
                    De door jou opgevraagde pagina bestaat niet (meer).
                </p>`
        ]),
        (0, $fjcCR.horizontalLayout)([
            "center",
            "center"
        ], "medium", [
            (0, $7yG78.strokedButton)({
                type: "button",
                content: (0, $9UZF0.html)`Ga terug`,
                theme: "Primary",
                onClick: config.onNavigateBack
            }),
            (0, $9UZF0.html)`of`,
            (0, $7yG78.strokedButton)({
                content: (0, $9UZF0.html)`Bekijk het dashboard`,
                href: "/dashboard",
                theme: "Secondary",
                onClick: config.onNavigate
            })
        ])
    ]));
}



var $kmtkw = parcelRequire("kmtkw");
function $1eae9a5514e9fcfb$export$a1544dad697b423d(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
}
function $1eae9a5514e9fcfb$export$11e63f7b0f3d9900(key) {
    const value = localStorage.getItem(key);
    if (value === null) return undefined;
    try {
        return JSON.parse(value);
    } catch  {
        return undefined;
    }
}



var $fb0eT = parcelRequire("fb0eT");



































const $fd60965d4b27bd3f$var$modules = {
    AnalysisCostBenefit: ()=>(parcelRequire("j1PQF")),
    AnalysisLeadPerformance: ()=>(parcelRequire("2E1HU")),
    AnalysisMakeModel: ()=>(parcelRequire("8xC7l")),
    AnalysisOverview: ()=>(parcelRequire("5IKMw")),
    ComparisonAdvicePrice: ()=>(parcelRequire("aJvFJ")),
    ComparisonDaysInStock: ()=>(parcelRequire("3ULcl")),
    ComparisonGeographic: ()=>(parcelRequire("8tjeS")),
    ComparisonOverview: ()=>(parcelRequire("cL75j")),
    Dashboard: ()=>(parcelRequire("cCBiV")),
    Leads: ()=>(parcelRequire("iH2eH")),
    Login: ()=>(parcelRequire("6QKk0")),
    Prospects: ()=>(parcelRequire("hAogL")),
    Reach: ()=>(parcelRequire("QWgYr")),
    SettingsBranches: ()=>(parcelRequire("i7zGK")),
    SettingsCompetingCompanies: ()=>(parcelRequire("lc2yH")),
    SettingsCompetingVehicles: ()=>(parcelRequire("lNnx6")),
    SettingsNotifications: ()=>(parcelRequire("kOFyh")),
    SettingsScenarios: ()=>(parcelRequire("84DKp")),
    SettingsStock: ()=>(parcelRequire("lKDOU")),
    Stock: ()=>(parcelRequire("76Uws")),
    TaxationDashboard: ()=>(parcelRequire("cOYGu")),
    TaxationSearch: ()=>(parcelRequire("3VpVp")),
    TaxationSettings: ()=>(parcelRequire("iVS8k")),
    TaxationComparisonOverview: ()=>(parcelRequire("jznq5")),
    TaxationComparisonGeographic: ()=>(parcelRequire("2IY3S")),
    TaxationComparisonPriceAnalysis: ()=>(parcelRequire("amerX")),
    TaxationComparisonPriceHistory: ()=>(parcelRequire("4WmQS")),
    VehicleComparisonGeographic: ()=>(parcelRequire("hGqWR")),
    VehicleComparisonOverview: ()=>(parcelRequire("iMRUf")),
    VehicleComparisonPriceAnalysis: ()=>(parcelRequire("4yh2M")),
    VehicleComparisonPriceHistory: ()=>(parcelRequire("2zbVW")),
    VehicleDashboard: ()=>(parcelRequire("2MvY1")),
    VehicleReachOverview: ()=>(parcelRequire("dNvYy")),
    VehicleReachPriceEffect: ()=>(parcelRequire("4cRLa")),
    VehicleSettings: ()=>(parcelRequire("ilEas"))
};
const $fd60965d4b27bd3f$var$loadedModules = {};
const $fd60965d4b27bd3f$var$app = (0, $1a3eaec0c4e3e22a$export$8d516e055d924071)({
    root: document.querySelector("[app]"),
    init: $fd60965d4b27bd3f$var$init({
        authentication: (()=>{
            const item = sessionStorage.getItem("authentication");
            return item === null ? null : JSON.parse(item);
        })(),
        deviceLayout: window.matchMedia("(min-width: 1200px)").matches ? "Desktop" : "Mobile",
        permanentSettings: {
            stockAmountPerPage: $1eae9a5514e9fcfb$export$11e63f7b0f3d9900("stockAmountPerPage"),
            leadsAmountPerPage: $1eae9a5514e9fcfb$export$11e63f7b0f3d9900("leadsAmountPerPage"),
            prospectsAmountPerPage: $1eae9a5514e9fcfb$export$11e63f7b0f3d9900("prospectsAmountPerPage")
        }
    }),
    view: $fd60965d4b27bd3f$var$view,
    update: $fd60965d4b27bd3f$var$update,
    onFatalError: (error)=>{
        if ($fb0eT.debug) {
            console.error(error);
            return;
        }
        ga("send", "exception", {
            exDescription: error instanceof Error ? error.message : String(error),
            exFatal: true
        });
    }
});
const $fd60965d4b27bd3f$var$router = $fd60965d4b27bd3f$var$setUpRoutingSubscription();
$fd60965d4b27bd3f$var$setUpDeviceLayoutSubscription();
//---- Router ----//
function $fd60965d4b27bd3f$var$setUpRoutingSubscription() {
    const router = new (0, (/*@__PURE__*/$parcel$interopDefault($a08deb550261a13e$exports)))("/", {
        strategy: "ONE"
    }).hooks({
        before: (done, match)=>{
            if (match.params && "SHA" in match.params) {
                $fd60965d4b27bd3f$var$app.send((0, $dErh8.Msg).Application_LoginWithToken({
                    token: match.params["SHA"],
                    dealer: match.params["d"],
                    ma: match.params["ma"],
                    session: match.params["sessie"],
                    reference: match.params["rf"],
                    type: match.params["t"],
                    master: match.params["master"] === "true"
                }));
                const queryParams = new URLSearchParams(match.params);
                queryParams.delete("SHA");
                queryParams.delete("d");
                queryParams.delete("ma");
                queryParams.delete("sessie");
                queryParams.delete("rf");
                queryParams.delete("t");
                queryParams.delete("master");
                router.navigate(match.url + (queryParams.toString().length > 0 ? "?" + queryParams.toString() : "") + (match.hashString ? "#" + match.hashString : ""), {
                    historyAPIMethod: "replaceState"
                });
            }
            done();
        }
    }).on({
        "/": {
            uses: async ()=>{
                router.navigate("/dashboard", {
                    historyAPIMethod: "replaceState"
                });
            }
        },
        "/login": {
            as: "Login",
            uses: async ()=>{
                $fd60965d4b27bd3f$var$loadedModules["Login"] = await $fd60965d4b27bd3f$var$modules.Login();
                $fd60965d4b27bd3f$var$app.send((0, $dErh8.Msg).OnRoute((0, $6de9763b9e556850$export$e7b0ac011bb776c6).Login()));
            }
        },
        "/logout": {
            as: "Logout",
            uses: ()=>{
                $fd60965d4b27bd3f$var$app.send((0, $dErh8.Msg).OnRoute((0, $6de9763b9e556850$export$e7b0ac011bb776c6).Logout()));
            }
        },
        "/dashboard": {
            as: "Dashboard",
            uses: async ()=>{
                $fd60965d4b27bd3f$var$loadedModules["Dashboard"] = await $fd60965d4b27bd3f$var$modules.Dashboard();
                $fd60965d4b27bd3f$var$app.send((0, $dErh8.Msg).OnRoute((0, $6de9763b9e556850$export$e7b0ac011bb776c6).Dashboard()));
            }
        },
        "/voorraad": {
            as: "Stock",
            uses: async ()=>{
                $fd60965d4b27bd3f$var$loadedModules["Stock"] = await $fd60965d4b27bd3f$var$modules.Stock();
                $fd60965d4b27bd3f$var$app.send((0, $dErh8.Msg).OnRoute((0, $6de9763b9e556850$export$e7b0ac011bb776c6).Stock()));
            }
        },
        "/bereik": {
            as: "Reach",
            uses: async ()=>{
                $fd60965d4b27bd3f$var$loadedModules["Reach"] = await $fd60965d4b27bd3f$var$modules.Reach();
                $fd60965d4b27bd3f$var$app.send((0, $dErh8.Msg).OnRoute((0, $6de9763b9e556850$export$e7b0ac011bb776c6).Reach()));
            }
        },
        "/leads": {
            as: "Leads",
            uses: async ()=>{
                $fd60965d4b27bd3f$var$loadedModules["Leads"] = await $fd60965d4b27bd3f$var$modules.Leads();
                $fd60965d4b27bd3f$var$app.send((0, $dErh8.Msg).OnRoute((0, $6de9763b9e556850$export$e7b0ac011bb776c6).Leads()));
            }
        },
        "/analyse/overzicht": {
            as: "AnalysisOverview",
            uses: async ()=>{
                $fd60965d4b27bd3f$var$loadedModules["AnalysisOverview"] = await $fd60965d4b27bd3f$var$modules.AnalysisOverview();
                $fd60965d4b27bd3f$var$app.send((0, $dErh8.Msg).OnRoute((0, $6de9763b9e556850$export$e7b0ac011bb776c6).AnalysisOverview()));
            }
        },
        "/analyse/leadsprestatie": {
            as: "AnalysisLeadPerformance",
            uses: async ()=>{
                $fd60965d4b27bd3f$var$loadedModules["AnalysisLeadPerformance"] = await $fd60965d4b27bd3f$var$modules.AnalysisLeadPerformance();
                $fd60965d4b27bd3f$var$app.send((0, $dErh8.Msg).OnRoute((0, $6de9763b9e556850$export$e7b0ac011bb776c6).AnalysisLeadPerformance()));
            }
        },
        "/analyse/merkmodel": {
            as: "AnalysisMakeModel",
            uses: async ()=>{
                $fd60965d4b27bd3f$var$loadedModules["AnalysisMakeModel"] = await $fd60965d4b27bd3f$var$modules.AnalysisMakeModel();
                $fd60965d4b27bd3f$var$app.send((0, $dErh8.Msg).OnRoute((0, $6de9763b9e556850$export$e7b0ac011bb776c6).AnalysisMakeModel()));
            }
        },
        "/analyse/kostenbaten": {
            as: "AnalysisCostBenefit",
            uses: async ()=>{
                $fd60965d4b27bd3f$var$loadedModules["AnalysisCostBenefit"] = await $fd60965d4b27bd3f$var$modules.AnalysisCostBenefit();
                $fd60965d4b27bd3f$var$app.send((0, $dErh8.Msg).OnRoute((0, $6de9763b9e556850$export$e7b0ac011bb776c6).AnalysisCostBenefit()));
            }
        },
        "/prospects": {
            as: "Prospects",
            uses: async ()=>{
                $fd60965d4b27bd3f$var$loadedModules["Prospects"] = await $fd60965d4b27bd3f$var$modules.Prospects();
                $fd60965d4b27bd3f$var$app.send((0, $dErh8.Msg).OnRoute((0, $6de9763b9e556850$export$e7b0ac011bb776c6).Prospects()));
            }
        },
        "/vergelijk/overzicht": {
            as: "ComparisonOverview",
            uses: async ()=>{
                $fd60965d4b27bd3f$var$loadedModules["ComparisonOverview"] = await $fd60965d4b27bd3f$var$modules.ComparisonOverview();
                $fd60965d4b27bd3f$var$app.send((0, $dErh8.Msg).OnRoute((0, $6de9763b9e556850$export$e7b0ac011bb776c6).ComparisonOverview()));
            }
        },
        "/vergelijk/adviesprijs": {
            as: "ComparisonAdvicePrice",
            uses: async ()=>{
                $fd60965d4b27bd3f$var$loadedModules["ComparisonAdvicePrice"] = await $fd60965d4b27bd3f$var$modules.ComparisonAdvicePrice();
                $fd60965d4b27bd3f$var$app.send((0, $dErh8.Msg).OnRoute((0, $6de9763b9e556850$export$e7b0ac011bb776c6).ComparisonAdvicePrice()));
            }
        },
        "/vergelijk/statijd": {
            as: "ComparisonDaysInStock",
            uses: async ()=>{
                $fd60965d4b27bd3f$var$loadedModules["ComparisonDaysInStock"] = await $fd60965d4b27bd3f$var$modules.ComparisonDaysInStock();
                $fd60965d4b27bd3f$var$app.send((0, $dErh8.Msg).OnRoute((0, $6de9763b9e556850$export$e7b0ac011bb776c6).ComparisonDaysInStock()));
            }
        },
        "/vergelijk/geografisch": {
            as: "ComparisonGeographic",
            uses: async ()=>{
                $fd60965d4b27bd3f$var$loadedModules["ComparisonGeographic"] = await $fd60965d4b27bd3f$var$modules.ComparisonGeographic();
                $fd60965d4b27bd3f$var$app.send((0, $dErh8.Msg).OnRoute((0, $6de9763b9e556850$export$e7b0ac011bb776c6).ComparisonGeographic()));
            }
        },
        "/voertuig/:vehicle": {
            uses: async ({ data: data })=>{
                router.navigate(`/voertuig/${data.vehicle}/dashboard`, {
                    historyAPIMethod: "replaceState"
                });
            }
        },
        "/voertuig/:vehicle/dashboard": {
            as: "VehicleDashboard",
            uses: async ({ data: data })=>{
                $fd60965d4b27bd3f$var$loadedModules["VehicleDashboard"] = await $fd60965d4b27bd3f$var$modules.VehicleDashboard();
                $fd60965d4b27bd3f$var$app.send((0, $dErh8.Msg).OnRoute((0, $6de9763b9e556850$export$e7b0ac011bb776c6).VehicleDashboard({
                    vehicleId: data.vehicle
                })));
            }
        },
        "/voertuig/:vehicle/bereik/overzicht": {
            as: "VehicleReachOverview",
            uses: async ({ data: data })=>{
                $fd60965d4b27bd3f$var$loadedModules["VehicleReachOverview"] = await $fd60965d4b27bd3f$var$modules.VehicleReachOverview();
                $fd60965d4b27bd3f$var$app.send((0, $dErh8.Msg).OnRoute((0, $6de9763b9e556850$export$e7b0ac011bb776c6).VehicleReachOverview({
                    vehicleId: data.vehicle
                })));
            }
        },
        "/voertuig/:vehicle/bereik/prijseffect": {
            as: "VehicleReachPriceEffect",
            uses: async ({ data: data })=>{
                $fd60965d4b27bd3f$var$loadedModules["VehicleReachPriceEffect"] = await $fd60965d4b27bd3f$var$modules.VehicleReachPriceEffect();
                $fd60965d4b27bd3f$var$app.send((0, $dErh8.Msg).OnRoute((0, $6de9763b9e556850$export$e7b0ac011bb776c6).VehicleReachPriceEffect({
                    vehicleId: data.vehicle
                })));
            }
        },
        "/voertuig/:vehicle/vergelijk/overzicht": {
            as: "VehicleComparisonOverview",
            uses: async ({ data: data })=>{
                $fd60965d4b27bd3f$var$loadedModules["VehicleComparisonOverview"] = await $fd60965d4b27bd3f$var$modules.VehicleComparisonOverview();
                $fd60965d4b27bd3f$var$app.send((0, $dErh8.Msg).OnRoute((0, $6de9763b9e556850$export$e7b0ac011bb776c6).VehicleComparisonOverview({
                    vehicleId: data.vehicle
                })));
            }
        },
        "/voertuig/:vehicle/vergelijk/prijsanalyse": {
            as: "VehicleComparisonPriceAnalysis",
            uses: async ({ data: data })=>{
                $fd60965d4b27bd3f$var$loadedModules["VehicleComparisonPriceAnalysis"] = await $fd60965d4b27bd3f$var$modules.VehicleComparisonPriceAnalysis();
                $fd60965d4b27bd3f$var$app.send((0, $dErh8.Msg).OnRoute((0, $6de9763b9e556850$export$e7b0ac011bb776c6).VehicleComparisonPriceAnalysis({
                    vehicleId: data.vehicle
                })));
            }
        },
        "/voertuig/:vehicle/vergelijk/prijshistorie": {
            as: "VehicleComparisonPriceHistory",
            uses: async ({ data: data })=>{
                $fd60965d4b27bd3f$var$loadedModules["VehicleComparisonPriceHistory"] = await $fd60965d4b27bd3f$var$modules.VehicleComparisonPriceHistory();
                $fd60965d4b27bd3f$var$app.send((0, $dErh8.Msg).OnRoute((0, $6de9763b9e556850$export$e7b0ac011bb776c6).VehicleComparisonPriceHistory({
                    vehicleId: data.vehicle
                })));
            }
        },
        "/voertuig/:vehicle/vergelijk/geografisch": {
            as: "VehicleComparisonGeographic",
            uses: async ({ data: data })=>{
                $fd60965d4b27bd3f$var$loadedModules["VehicleComparisonGeographic"] = await $fd60965d4b27bd3f$var$modules.VehicleComparisonGeographic();
                $fd60965d4b27bd3f$var$app.send((0, $dErh8.Msg).OnRoute((0, $6de9763b9e556850$export$e7b0ac011bb776c6).VehicleComparisonGeographic({
                    vehicleId: data.vehicle
                })));
            }
        },
        "/voertuig/:vehicle/settings": {
            as: "VehicleSettings",
            uses: async ({ data: data })=>{
                $fd60965d4b27bd3f$var$loadedModules["VehicleSettings"] = await $fd60965d4b27bd3f$var$modules.VehicleSettings();
                $fd60965d4b27bd3f$var$app.send((0, $dErh8.Msg).OnRoute((0, $6de9763b9e556850$export$e7b0ac011bb776c6).VehicleSettings({
                    vehicleId: data.vehicle
                })));
            }
        },
        "/taxation/zoek": {
            as: "TaxationSearch",
            uses: async ()=>{
                $fd60965d4b27bd3f$var$loadedModules["TaxationSearch"] = await $fd60965d4b27bd3f$var$modules.TaxationSearch();
                $fd60965d4b27bd3f$var$app.send((0, $dErh8.Msg).OnRoute((0, $6de9763b9e556850$export$e7b0ac011bb776c6).TaxationSearch()));
            }
        },
        "/taxatie/:vehicle/dashboard": {
            as: "TaxationDashboard",
            uses: async ({ data: data })=>{
                $fd60965d4b27bd3f$var$loadedModules["TaxationDashboard"] = await $fd60965d4b27bd3f$var$modules.TaxationDashboard();
                $fd60965d4b27bd3f$var$app.send((0, $dErh8.Msg).OnRoute((0, $6de9763b9e556850$export$e7b0ac011bb776c6).TaxationDashboard({
                    vehicleId: data.vehicle
                })));
            }
        },
        "taxatie/:vehicle/vergelijk/overzicht": {
            as: "TaxationComparisonOverview",
            uses: async ({ data: data })=>{
                $fd60965d4b27bd3f$var$loadedModules["TaxationComparisonOverview"] = await $fd60965d4b27bd3f$var$modules.TaxationComparisonOverview();
                $fd60965d4b27bd3f$var$app.send((0, $dErh8.Msg).OnRoute((0, $6de9763b9e556850$export$e7b0ac011bb776c6).TaxationComparisonOverview({
                    vehicleId: data.vehicle
                })));
            }
        },
        "taxatie/:vehicle/vergelijk/prijsanalyse": {
            as: "TaxationComparisonPriceAnalysis",
            uses: async ({ data: data })=>{
                $fd60965d4b27bd3f$var$loadedModules["TaxationComparisonPriceAnalysis"] = await $fd60965d4b27bd3f$var$modules.TaxationComparisonPriceAnalysis();
                $fd60965d4b27bd3f$var$app.send((0, $dErh8.Msg).OnRoute((0, $6de9763b9e556850$export$e7b0ac011bb776c6).TaxationComparisonPriceAnalysis({
                    vehicleId: data.vehicle
                })));
            }
        },
        "taxatie/:vehicle/vergelijk/prijshistorie": {
            as: "TaxationComparisonPriceHistory",
            uses: async ({ data: data })=>{
                $fd60965d4b27bd3f$var$loadedModules["TaxationComparisonPriceHistory"] = await $fd60965d4b27bd3f$var$modules.TaxationComparisonPriceHistory();
                $fd60965d4b27bd3f$var$app.send((0, $dErh8.Msg).OnRoute((0, $6de9763b9e556850$export$e7b0ac011bb776c6).TaxationComparisonPriceHistory({
                    vehicleId: data.vehicle
                })));
            }
        },
        "taxatie/:vehicle/vergelijk/geografisch": {
            as: "TaxationComparisonGeographic",
            uses: async ({ data: data })=>{
                $fd60965d4b27bd3f$var$loadedModules["TaxationComparisonGeographic"] = await $fd60965d4b27bd3f$var$modules.TaxationComparisonGeographic();
                $fd60965d4b27bd3f$var$app.send((0, $dErh8.Msg).OnRoute((0, $6de9763b9e556850$export$e7b0ac011bb776c6).TaxationComparisonGeographic({
                    vehicleId: data.vehicle
                })));
            }
        },
        "taxatie/:vehicle/settings": {
            as: "TaxationSettings",
            uses: async ({ data: data })=>{
                $fd60965d4b27bd3f$var$loadedModules["TaxationSettings"] = await $fd60965d4b27bd3f$var$modules.TaxationSettings();
                $fd60965d4b27bd3f$var$app.send((0, $dErh8.Msg).OnRoute((0, $6de9763b9e556850$export$e7b0ac011bb776c6).TaxationSettings({
                    vehicleId: data.vehicle
                })));
            }
        },
        "/instellingen/voorraad": {
            as: "SettingsStock",
            uses: async ()=>{
                $fd60965d4b27bd3f$var$loadedModules["SettingsStock"] = await $fd60965d4b27bd3f$var$modules.SettingsStock();
                $fd60965d4b27bd3f$var$app.send((0, $dErh8.Msg).OnRoute((0, $6de9763b9e556850$export$e7b0ac011bb776c6).SettingsStock()));
            }
        },
        "/instellingen/concurrentievoertuigen": {
            as: "SettingsCompetingVehicles",
            uses: async ()=>{
                $fd60965d4b27bd3f$var$loadedModules["SettingsCompetingVehicles"] = await $fd60965d4b27bd3f$var$modules.SettingsCompetingVehicles();
                $fd60965d4b27bd3f$var$app.send((0, $dErh8.Msg).OnRoute((0, $6de9763b9e556850$export$e7b0ac011bb776c6).SettingsCompetingVehicles()));
            }
        },
        "/instellingen/concurrentiebedrijven": {
            as: "SettingsCompetingCompanies",
            uses: async ()=>{
                $fd60965d4b27bd3f$var$loadedModules["SettingsCompetingCompanies"] = await $fd60965d4b27bd3f$var$modules.SettingsCompetingCompanies();
                $fd60965d4b27bd3f$var$app.send((0, $dErh8.Msg).OnRoute((0, $6de9763b9e556850$export$e7b0ac011bb776c6).SettingsCompetingCompanies()));
            }
        },
        "/instellingen/concurrentiebedrijven/:profile": {
            as: "SettingsCompetingCompaniesProfile",
            uses: async ({ data: data })=>{
                $fd60965d4b27bd3f$var$loadedModules["SettingsCompetingCompanies"] = await $fd60965d4b27bd3f$var$modules.SettingsCompetingCompanies();
                $fd60965d4b27bd3f$var$app.send((0, $dErh8.Msg).OnRoute((0, $6de9763b9e556850$export$e7b0ac011bb776c6).SettingsCompetingCompaniesProfile({
                    profileId: data?.profile === "new" ? null : data?.profile ?? null
                })));
            }
        },
        "/instellingen/doelenmeldingen": {
            as: "SettingsNotifications",
            uses: async ()=>{
                $fd60965d4b27bd3f$var$loadedModules["SettingsNotifications"] = await $fd60965d4b27bd3f$var$modules.SettingsNotifications();
                $fd60965d4b27bd3f$var$app.send((0, $dErh8.Msg).OnRoute((0, $6de9763b9e556850$export$e7b0ac011bb776c6).SettingsNotifications()));
            }
        },
        "/instellingen/vestigingen": {
            as: "SettingsBranches",
            uses: async ()=>{
                $fd60965d4b27bd3f$var$loadedModules["SettingsBranches"] = await $fd60965d4b27bd3f$var$modules.SettingsBranches();
                $fd60965d4b27bd3f$var$app.send((0, $dErh8.Msg).OnRoute((0, $6de9763b9e556850$export$e7b0ac011bb776c6).SettingsBranches()));
            }
        },
        "/instellingen/scenarios": {
            as: "SettingsScenarios",
            uses: async ()=>{
                $fd60965d4b27bd3f$var$loadedModules["SettingsScenarios"] = await $fd60965d4b27bd3f$var$modules.SettingsScenarios();
                $fd60965d4b27bd3f$var$app.send((0, $dErh8.Msg).OnRoute((0, $6de9763b9e556850$export$e7b0ac011bb776c6).SettingsScenarios()));
            }
        },
        "/instellingen/scenarios/:scenarioId": {
            as: "SettingsScenario",
            uses: async ({ data: data })=>{
                $fd60965d4b27bd3f$var$loadedModules["SettingsScenarios"] = await $fd60965d4b27bd3f$var$modules.SettingsScenarios();
                $fd60965d4b27bd3f$var$app.send((0, $dErh8.Msg).OnRoute((0, $6de9763b9e556850$export$e7b0ac011bb776c6).SettingsScenario({
                    scenarioId: data?.scenarioId === "new" ? null : data?.scenarioId ?? null
                })));
            }
        }
    }).notFound(()=>{
        $fd60965d4b27bd3f$var$app.send((0, $dErh8.Msg).OnRoute((0, $6de9763b9e556850$export$e7b0ac011bb776c6).NotFound()));
    });
    router.resolve();
    return router;
}
function $fd60965d4b27bd3f$var$setUpDeviceLayoutSubscription() {
    window.matchMedia("(min-width: 1200px)").addEventListener("change", (event)=>{
        $fd60965d4b27bd3f$var$app.send((0, $dErh8.Msg).DeviceLayout(event.matches ? "Desktop" : "Mobile"));
    });
}
function $fd60965d4b27bd3f$var$defaultPeriod() {
    const days = (amount)=>86400000 * amount;
    const toDate = (unix)=>new Date(unix).toISOString().split("T")[0];
    return {
        startDate: toDate(Date.now() - days(30)),
        endDate: toDate(Date.now() - days(1))
    };
}
function $fd60965d4b27bd3f$var$init(flags) {
    return [
        {
            deviceLayout: flags.deviceLayout,
            route: (0, $6de9763b9e556850$export$e7b0ac011bb776c6).NotFound(),
            isInitialized: false,
            isNavigationVisible: false,
            isAuthenticating: flags.authentication !== null,
            isRetrievingSession: false,
            account: null,
            cachedVehicles: new Map(),
            taxationWidget: {
                licensePlate: "",
                mileage: "",
                errorMessage: null
            },
            settings: {
                stockCount: null,
                dealerCount: null,
                daysInStockGoal: $1ubKN.init(),
                competingDealers: null,
                dealers: $1ubKN.init(),
                dealerFilter: $1ubKN.init()
            },
            page: {
                Login: {
                    username: "",
                    password: "",
                    captcha: null,
                    isCaptchaRequired: false,
                    error: null
                },
                Dashboard: {
                    isRetrieving: false,
                    isInfoBlockVisible: false,
                    sorting: "name",
                    data: null
                },
                Stock: {
                    isRetrieving: false,
                    isInfoBlockVisible: false,
                    search: "",
                    sort: "merk_model_uitv",
                    sortDirection: "ASC",
                    onlyWithWarnings: false,
                    page: 1,
                    amountPerPage: flags.permanentSettings.stockAmountPerPage ?? 10,
                    vehicles: [],
                    amountOfVehicles: 0
                },
                Reach: {
                    isRetrieving: false,
                    isInfoBlockVisible: false,
                    period: $fd60965d4b27bd3f$var$defaultPeriod(),
                    data: null
                },
                Leads: {
                    isRetrieving: false,
                    isInfoBlockVisible: false,
                    isFilterVisible: false,
                    page: 1,
                    amountPerPage: flags.permanentSettings.leadsAmountPerPage ?? 50,
                    sort: "date",
                    period: $fd60965d4b27bd3f$var$defaultPeriod(),
                    search: "",
                    filter: new Set(),
                    data: null
                },
                Prospects: {
                    isRetrieving: false,
                    isInfoBlockVisible: false,
                    period: $fd60965d4b27bd3f$var$defaultPeriod(),
                    page: 1,
                    amountPerPage: flags.permanentSettings.prospectsAmountPerPage ?? 50,
                    data: null
                },
                AnalysisOverview: {
                    isRetrieving: false,
                    isInfoBlockVisible: false,
                    profile: "0",
                    data: null
                },
                AnalysisLeadPerformance: {
                    isRetrieving: false,
                    isInfoBlockVisible: false,
                    period: $fd60965d4b27bd3f$var$defaultPeriod(),
                    data: null
                },
                AnalysisCostBenefit: {
                    isRetrieving: false,
                    isInfoBlockVisible: false,
                    data: null
                },
                AnalysisMakeModel: {
                    isRetrieving: false,
                    isInfoBlockVisible: false,
                    tab: "askingprice",
                    data: null
                },
                ComparisonAdvicePrice: {
                    isRetrieving: false,
                    isInfoBlockVisible: false,
                    activeProfile: null,
                    makeFilter: new Set(),
                    modelFilter: new Set(),
                    data: null
                },
                ComparisonDaysInStock: {
                    isRetrieving: false,
                    isInfoBlockVisible: false,
                    activeProfile: null,
                    makeFilter: new Set(),
                    modelFilter: new Set(),
                    data: null
                },
                ComparisonGeographic: {
                    isRetrieving: false,
                    isInfoBlockVisible: false,
                    activeTab: "adviceprice",
                    activeProfile: null,
                    data: null
                },
                ComparisonOverview: {
                    isRetrieving: false,
                    isInfoBlockVisible: false,
                    data: null
                },
                SettingsBranches: {
                    isSaving: false,
                    scenarioList: $1ubKN.init(),
                    scenario: $1ubKN.init(),
                    dealerFilter: $1ubKN.init(),
                    changes: {}
                },
                SettingsCompetingCompanies: {
                    profiles: $1ubKN.init()
                },
                SettingsCompetingCompaniesProfile: {
                    isSaving: false,
                    activeView: "Profile",
                    filtersMetadata: $1ubKN.init(),
                    filters: {
                        search: "",
                        dealerTypes: new Set(),
                        provinces: new Set(),
                        dealerMakes: new Set(),
                        stockMakes: new Set()
                    },
                    dealers: $1ubKN.init(),
                    profile: $1ubKN.init(),
                    changes: {
                        name: null,
                        dealers: $gUdlQ.init()
                    }
                },
                SettingsCompetingVehicles: {
                    isInfoBlockVisible: false,
                    isSaving: false,
                    isResetting: false,
                    data: $1ubKN.init(),
                    changes: {}
                },
                SettingsNotifications: {
                    isSaving: false,
                    isResetting: false,
                    isSendingTestMail: false,
                    isInfoBlockVisible: false,
                    data: $1ubKN.init(),
                    changes: {}
                },
                SettingsScenarios: {
                    data: $1ubKN.init()
                },
                SettingsScenario: {
                    isSaving: false,
                    selectedAvailableDealerPerCluster: new Map(),
                    data: $1ubKN.init(),
                    changes: {}
                },
                SettingsStock: {
                    isSaving: false,
                    isResetting: false,
                    isInfoBlockVisible: false,
                    stockCount: $1ubKN.init(),
                    searchVehicles: $1ubKN.init(),
                    data: $1ubKN.init(),
                    changes: {}
                },
                TaxationDashboard: {
                    isInfoBlockVisible: false,
                    data: $1ubKN.init()
                },
                TaxationComparisonGeographic: {
                    isInfoBlockVisible: false,
                    vehicleStatus: "Actual",
                    vehicleCompetition: $1ubKN.init(),
                    data: $1ubKN.init()
                },
                TaxationComparisonOverview: {
                    isInfoBlockVisible: false,
                    vehicleStatus: "Actual",
                    sort: "vraagprijs",
                    sortDirection: "DESC",
                    page: 1,
                    amountPerPage: 10,
                    vehicleCompetition: $1ubKN.init()
                },
                TaxationComparisonPriceAnalysis: {
                    isInfoBlockVisible: false,
                    vehicleStatus: "Actual",
                    vehicleCompetition: $1ubKN.init()
                },
                TaxationComparisonPriceHistory: {
                    isInfoBlockVisible: false,
                    vehicleStatus: "Actual",
                    vehicleCompetition: $1ubKN.init(),
                    data: $1ubKN.init()
                },
                TaxationSearch: {
                    isRetrieving: false,
                    isInfoBlockVisible: false,
                    data: null
                },
                TaxationSettings: {
                    isInfoBlockVisible: false,
                    isSaving: false,
                    isResetting: false,
                    data: $1ubKN.init(),
                    changes: {}
                },
                VehicleDashboard: {
                    isInfoBlockVisible: false,
                    data: $1ubKN.init()
                },
                VehicleComparisonOverview: {
                    isInfoBlockVisible: false,
                    vehicleStatus: "Actual",
                    sort: "vraagprijs",
                    sortDirection: "ASC",
                    page: 1,
                    amountPerPage: 10,
                    vehicleCompetition: $1ubKN.init()
                },
                VehicleComparisonPriceAnalysis: {
                    isInfoBlockVisible: false,
                    vehicleStatus: "Actual",
                    vehicleCompetition: $1ubKN.init()
                },
                VehicleComparisonPriceHistory: {
                    isInfoBlockVisible: false,
                    vehicleStatus: "Actual",
                    vehicleCompetition: $1ubKN.init(),
                    data: $1ubKN.init()
                },
                VehicleComparisonGeographic: {
                    isInfoBlockVisible: false,
                    vehicleStatus: "Actual",
                    vehicleCompetition: $1ubKN.init(),
                    data: $1ubKN.init()
                },
                VehicleReachOverview: {
                    isInfoBlockVisible: false,
                    data: $1ubKN.init()
                },
                VehicleReachPriceEffect: {
                    isInfoBlockVisible: false,
                    activeTab: "clicks",
                    data: {
                        found: $1ubKN.init(),
                        viewed: $1ubKN.init(),
                        clicks: $1ubKN.init(),
                        contact: $1ubKN.init(),
                        share: $1ubKN.init()
                    }
                },
                VehicleSettings: {
                    isInfoBlockVisible: false,
                    isSaving: false,
                    isResetting: false,
                    data: $1ubKN.init(),
                    changes: {}
                }
            }
        },
        flags.authentication ? [
            Promise.resolve((0, $dErh8.Msg).Incoming_Token({
                accessToken: flags.authentication.token,
                expiration: flags.authentication.expiration,
                isMasterAccount: flags.authentication.isMaster ?? false
            }))
        ] : []
    ];
}
//---- View ----//
function $fd60965d4b27bd3f$var$view(dispatch, state) {
    if ($fb0eT.debug) console.log("State", state);
    if (!state.isInitialized) return {
        title: "AutoTrack Analytics",
        body: $fd60965d4b27bd3f$var$viewTransitioningPage(state, (0, $9UZF0.html)``)
    };
    if (state.route.id !== "Login" && state.isAuthenticating) return {
        title: "AutoTrack Analytics",
        body: $fd60965d4b27bd3f$var$viewTransitioningPage(state, (0, $9UZF0.html)`U wordt ingelogd`)
    };
    if (state.isRetrievingSession) return {
        title: "AutoTrack Analytics",
        body: $fd60965d4b27bd3f$var$viewTransitioningPage(state, (0, $9UZF0.html)`U wordt ingelogd`)
    };
    switch(state.route.id){
        case "Login":
            return {
                title: "Login | AutoTrack Analytics",
                body: (0, $9cca11e6920deac5$export$2e2bcd8739ae039)(state.deviceLayout, $fd60965d4b27bd3f$var$loadedModules["Login"].view(dispatch, state))
            };
        case "Dashboard":
            return {
                title: "Dashboard | AutoTrack Analytics",
                body: $fd60965d4b27bd3f$var$viewMainShell(dispatch, state, {
                    pageTitle: "Dashboard",
                    content: $fd60965d4b27bd3f$var$loadedModules["Dashboard"].view(dispatch, state),
                    infoBlock: {
                        onToggle: dispatch((0, $dErh8.Msg).Dashboard_OnToggleInfoBlock),
                        isVisible: state.page.Dashboard.isInfoBlockVisible
                    },
                    onPrint: dispatch((0, $dErh8.Msg).Dashboard_OnPrint)
                })
            };
        case "Stock":
            return {
                title: "Voorraad | AutoTrack Analytics",
                body: $fd60965d4b27bd3f$var$viewMainShell(dispatch, state, {
                    pageTitle: "Voorraad",
                    content: $fd60965d4b27bd3f$var$loadedModules["Stock"].view(dispatch, state),
                    onDownloadExcel: dispatch((0, $dErh8.Msg).Stock_OnDownloadExcel),
                    infoBlock: {
                        onToggle: dispatch((0, $dErh8.Msg).Stock_OnToggleInfoBlock),
                        isVisible: state.page.Stock.isInfoBlockVisible
                    },
                    onPrint: dispatch((0, $dErh8.Msg).Stock_OnPrint),
                    pageNavigations: {
                        previous: {
                            href: "/dashboard",
                            label: "Dashboard"
                        },
                        next: {
                            href: "/bereik",
                            label: "Bereik"
                        }
                    }
                })
            };
        case "Reach":
            return {
                title: "Bereik | AutoTrack Analytics",
                body: $fd60965d4b27bd3f$var$viewMainShell(dispatch, state, {
                    pageTitle: "Netto bereik",
                    content: $fd60965d4b27bd3f$var$loadedModules["Reach"].view(dispatch, state),
                    infoBlock: {
                        onToggle: dispatch((0, $dErh8.Msg).Reach_OnToggleInfoBlock),
                        isVisible: state.page.Reach.isInfoBlockVisible
                    },
                    onPrint: dispatch((0, $dErh8.Msg).Reach_OnPrint),
                    pageNavigations: {
                        previous: {
                            href: "/voorraad",
                            label: "Voorraad"
                        },
                        next: {
                            href: "/leads",
                            label: "Leads"
                        }
                    }
                })
            };
        case "Leads":
            return {
                title: "Leads | AutoTrack Analytics",
                body: $fd60965d4b27bd3f$var$viewMainShell(dispatch, state, {
                    pageTitle: "Leads",
                    content: $fd60965d4b27bd3f$var$loadedModules["Leads"].view(dispatch, state),
                    onDownloadExcel: dispatch((0, $dErh8.Msg).Leads_OnDownloadExcel),
                    infoBlock: {
                        onToggle: dispatch((0, $dErh8.Msg).Leads_OnToggleInfoBlock),
                        isVisible: state.page.Leads.isInfoBlockVisible
                    },
                    onPrint: dispatch((0, $dErh8.Msg).Leads_OnPrint),
                    pageNavigations: {
                        previous: {
                            href: "/bereik",
                            label: "Bereik"
                        },
                        next: {
                            href: "/analyse/overzicht",
                            label: "Analyse overzicht"
                        }
                    }
                })
            };
        case "Prospects":
            return {
                title: "Prospects | AutoTrack Analytics",
                body: $fd60965d4b27bd3f$var$viewMainShell(dispatch, state, {
                    pageTitle: "Prospects",
                    content: $fd60965d4b27bd3f$var$loadedModules["Prospects"].view(dispatch, state),
                    onDownloadExcel: dispatch((0, $dErh8.Msg).Prospects_OnDownloadExcel),
                    infoBlock: {
                        onToggle: dispatch((0, $dErh8.Msg).Prospects_OnToggleInfoBlock),
                        isVisible: state.page.Prospects.isInfoBlockVisible
                    },
                    onPrint: dispatch((0, $dErh8.Msg).Prospects_OnPrint),
                    pageNavigations: {
                        previous: {
                            href: "/leads",
                            label: "Leads"
                        },
                        next: {
                            href: "/analyse/overzicht",
                            label: "Analyse overzicht"
                        }
                    }
                })
            };
        case "AnalysisOverview":
            return {
                title: "Analyse | AutoTrack Analytics",
                body: $fd60965d4b27bd3f$var$viewMainShell(dispatch, state, {
                    pageTitle: "Analyse overzicht",
                    content: state.account?.isPremium ? $fd60965d4b27bd3f$var$loadedModules["AnalysisOverview"].view(dispatch, state) : (0, $6cd550bbc3c7490c$export$a4111085dcbe77df)("Uw voorraad analyseren?", $fd60965d4b27bd3f$var$loadedModules["AnalysisOverview"].view(dispatch, state)),
                    infoBlock: {
                        onToggle: dispatch((0, $dErh8.Msg).AnalysisOverview_OnToggleInfoBlock),
                        isVisible: state.page.AnalysisOverview.isInfoBlockVisible
                    },
                    onPrint: dispatch((0, $dErh8.Msg).AnalysisOverview_OnPrint),
                    pageNavigations: {
                        previous: {
                            href: "/leads",
                            label: "Leads"
                        },
                        next: {
                            href: "/analyse/leadsprestatie",
                            label: "Leads prestatie"
                        }
                    }
                })
            };
        case "AnalysisLeadPerformance":
            return {
                title: "Analyse | AutoTrack Analytics",
                body: $fd60965d4b27bd3f$var$viewMainShell(dispatch, state, {
                    pageTitle: "Leads prestatie",
                    content: $fd60965d4b27bd3f$var$loadedModules["AnalysisLeadPerformance"].view(dispatch, state),
                    infoBlock: {
                        onToggle: dispatch((0, $dErh8.Msg).AnalysisLeadPerformance_OnToggleInfoBlock),
                        isVisible: state.page.AnalysisLeadPerformance.isInfoBlockVisible
                    },
                    onPrint: dispatch((0, $dErh8.Msg).AnalysisLeadPerformance_OnPrint),
                    pageNavigations: {
                        previous: {
                            href: "/analyse/overzicht",
                            label: "Overzicht"
                        },
                        next: {
                            href: "/analyse/merkmodel",
                            label: "Merk/model"
                        }
                    }
                })
            };
        case "AnalysisMakeModel":
            return {
                title: "Analyse | AutoTrack Analytics",
                body: $fd60965d4b27bd3f$var$viewMainShell(dispatch, state, {
                    pageTitle: "Merk/Model-analyse",
                    content: state.account?.isPremium ? $fd60965d4b27bd3f$var$loadedModules["AnalysisMakeModel"].view(dispatch, state) : (0, $6cd550bbc3c7490c$export$a4111085dcbe77df)("Uw voorraad analyseren?", $fd60965d4b27bd3f$var$loadedModules["AnalysisMakeModel"].view(dispatch, state)),
                    infoBlock: {
                        onToggle: dispatch((0, $dErh8.Msg).AnalysisMakeModel_OnToggleInfoBlock),
                        isVisible: state.page.AnalysisMakeModel.isInfoBlockVisible
                    },
                    onPrint: dispatch((0, $dErh8.Msg).AnalysisMakeModel_OnPrint),
                    pageNavigations: {
                        previous: {
                            href: "/analyse/leadsprestatie",
                            label: "Leads prestatie"
                        },
                        next: {
                            href: "/analyse/kostenbaten",
                            label: "Kosten en baten"
                        }
                    }
                })
            };
        case "AnalysisCostBenefit":
            return {
                title: "Analyse | AutoTrack Analytics",
                body: $fd60965d4b27bd3f$var$viewMainShell(dispatch, state, {
                    pageTitle: "Kosten en baten",
                    content: state.account?.isPremium ? $fd60965d4b27bd3f$var$loadedModules["AnalysisCostBenefit"].view(dispatch, state) : (0, $6cd550bbc3c7490c$export$a4111085dcbe77df)("De kosten en baten berekening bekijken?", $fd60965d4b27bd3f$var$loadedModules["AnalysisCostBenefit"].view(dispatch, state)),
                    onPrint: dispatch((0, $dErh8.Msg).AnalysisCostBenefit_OnPrint),
                    pageNavigations: {
                        previous: {
                            href: "/analyse/merkmodel",
                            label: "Merk/model"
                        },
                        next: {
                            href: "/vergelijk/adviesprijs",
                            label: "Adviesprijs"
                        }
                    }
                })
            };
        case "ComparisonOverview":
            return {
                title: "",
                body: $fd60965d4b27bd3f$var$loadedModules["ComparisonOverview"].view(dispatch, state)
            };
        case "ComparisonAdvicePrice":
            return {
                title: "Adviesprijs | AutoTrack Analytics",
                body: $fd60965d4b27bd3f$var$viewMainShell(dispatch, state, {
                    pageTitle: "Adviesprijs",
                    infoBlock: {
                        onToggle: dispatch((0, $dErh8.Msg).ComparisonAdvicePrice_OnToggleInfoBlock),
                        isVisible: state.page.ComparisonAdvicePrice.isInfoBlockVisible
                    },
                    onPrint: dispatch((0, $dErh8.Msg).ComparisonAdvicePrice_OnPrint),
                    content: state.account?.isPremium ? $fd60965d4b27bd3f$var$loadedModules["ComparisonAdvicePrice"].view(dispatch, state) : (0, $6cd550bbc3c7490c$export$a4111085dcbe77df)("Alle bedrijven vergelijken?", $fd60965d4b27bd3f$var$loadedModules["ComparisonAdvicePrice"].view(dispatch, state)),
                    pageNavigations: {
                        previous: {
                            href: "/bereik",
                            label: "Bereik"
                        },
                        next: {
                            href: "/vergelijk/statijd",
                            label: "Statijd"
                        }
                    }
                })
            };
        case "ComparisonDaysInStock":
            return {
                title: "Statijd | Autotrack Analytics",
                body: $fd60965d4b27bd3f$var$viewMainShell(dispatch, state, {
                    pageTitle: "Statijd",
                    content: state.account?.isPremium ? $fd60965d4b27bd3f$var$loadedModules["ComparisonDaysInStock"].view(dispatch, state) : (0, $6cd550bbc3c7490c$export$a4111085dcbe77df)("Alle bedrijven vergelijken?", $fd60965d4b27bd3f$var$loadedModules["ComparisonDaysInStock"].view(dispatch, state)),
                    infoBlock: {
                        onToggle: dispatch((0, $dErh8.Msg).ComparisonDaysInStock_OnToggleInfoBlock),
                        isVisible: state.page.ComparisonDaysInStock.isInfoBlockVisible
                    },
                    pageNavigations: {
                        previous: {
                            href: "/vergelijk/adviesprijs",
                            label: "Adviesprijs"
                        },
                        next: {
                            href: "/vergelijk/geografisch",
                            label: "Geografisch"
                        }
                    },
                    onPrint: dispatch((0, $dErh8.Msg).ComparisonDaysInStock_OnPrint)
                })
            };
        case "ComparisonGeographic":
            return {
                title: "Geographical | Autotrack Analytics",
                body: $fd60965d4b27bd3f$var$viewMainShell(dispatch, state, {
                    pageTitle: "Geografisch",
                    content: state.account?.isPremium ? $fd60965d4b27bd3f$var$loadedModules["ComparisonGeographic"].view(dispatch, state) : (0, $6cd550bbc3c7490c$export$a4111085dcbe77df)("Bekijken waar uw concurrenten zich bevinden?", $fd60965d4b27bd3f$var$loadedModules["ComparisonGeographic"].view(dispatch, state)),
                    infoBlock: {
                        onToggle: dispatch((0, $dErh8.Msg).ComparisonGeographic_OnToggleInfoBlock),
                        isVisible: state.page.ComparisonGeographic.isInfoBlockVisible
                    },
                    pageNavigations: {
                        previous: {
                            href: "/vergelijk/statijd",
                            label: "Statijd"
                        }
                    },
                    onPrint: dispatch((0, $dErh8.Msg).ComparisonGeographic_OnPrint)
                })
            };
        case "VehicleDashboard":
            {
                const vehicleId = state.route.params.vehicleId;
                const vehicle = state.cachedVehicles.get(vehicleId)?.[0];
                if (vehicle === undefined) return {
                    title: "",
                    body: $fd60965d4b27bd3f$var$viewTransitioningPage(state, (0, $9UZF0.html)`Voertuig wordt opgehaald`)
                };
                return {
                    title: "AutoTrack Analytics",
                    body: $fd60965d4b27bd3f$var$viewVehicleShell(dispatch, state, vehicle, {
                        pageTitle: "Dashboard",
                        content: $fd60965d4b27bd3f$var$loadedModules["VehicleDashboard"].view(dispatch, vehicle, state),
                        infoBlock: {
                            onToggle: dispatch((0, $dErh8.Msg).VehicleDashboard_OnToggleInfoBlock),
                            isVisible: state.page.VehicleDashboard.isInfoBlockVisible
                        },
                        onPrint: dispatch((0, $dErh8.Msg).VehicleDashboard_OnPrint)
                    })
                };
            }
        case "VehicleReachOverview":
            {
                const vehicleId = state.route.params.vehicleId;
                const vehicle = state.cachedVehicles.get(vehicleId)?.[0];
                if (vehicle === undefined) return {
                    title: "",
                    body: $fd60965d4b27bd3f$var$viewTransitioningPage(state, (0, $9UZF0.html)`Voertuig wordt opgehaald`)
                };
                return {
                    title: "AutoTrack Analytics",
                    body: $fd60965d4b27bd3f$var$viewVehicleShell(dispatch, state, vehicle, {
                        pageTitle: "Bereik",
                        content: $fd60965d4b27bd3f$var$loadedModules["VehicleReachOverview"].view(dispatch, state),
                        infoBlock: {
                            onToggle: dispatch((0, $dErh8.Msg).VehicleReachOverview_OnToggleInfoBlock),
                            isVisible: state.page.VehicleReachOverview.isInfoBlockVisible
                        },
                        pageNavigations: {
                            previous: {
                                href: `/voertuig/${vehicleId}/vergelijk/geografisch`,
                                label: "Geografisch"
                            },
                            next: {
                                href: `/voertuig/${vehicleId}/bereik/prijseffect`,
                                label: "Prijseffect"
                            }
                        },
                        onPrint: dispatch((0, $dErh8.Msg).VehicleReachOverview_OnPrint)
                    })
                };
            }
        case "VehicleReachPriceEffect":
            {
                const vehicleId = state.route.params.vehicleId;
                const vehicle = state.cachedVehicles.get(vehicleId)?.[0];
                if (vehicle === undefined) return {
                    title: "",
                    body: $fd60965d4b27bd3f$var$viewTransitioningPage(state, (0, $9UZF0.html)`Voertuig wordt opgehaald`)
                };
                return {
                    title: "AutoTrack Analytics",
                    body: $fd60965d4b27bd3f$var$viewVehicleShell(dispatch, state, vehicle, {
                        pageTitle: "Prijseffect",
                        content: $fd60965d4b27bd3f$var$loadedModules["VehicleReachPriceEffect"].view(dispatch, state, vehicle),
                        infoBlock: {
                            onToggle: dispatch((0, $dErh8.Msg).VehicleReachPriceEffect_OnToggleInfoBlock),
                            isVisible: state.page.VehicleReachPriceEffect.isInfoBlockVisible
                        },
                        pageNavigations: {
                            previous: {
                                href: `/voertuig/${vehicleId}/bereik/overzicht`,
                                label: "Bereik"
                            }
                        },
                        onPrint: dispatch((0, $dErh8.Msg).VehicleReachPriceEffect_OnPrint)
                    })
                };
            }
        case "VehicleComparisonOverview":
            {
                const vehicleId = state.route.params.vehicleId;
                const vehicle = state.cachedVehicles.get(vehicleId)?.[0];
                if (vehicle === undefined) return {
                    title: "",
                    body: $fd60965d4b27bd3f$var$viewTransitioningPage(state, (0, $9UZF0.html)`Voertuig wordt opgehaald`)
                };
                return {
                    title: "AutoTrack Analytics",
                    body: $fd60965d4b27bd3f$var$viewVehicleShell(dispatch, state, vehicle, {
                        pageTitle: "Overzicht auto's vergelijken",
                        content: state.account?.isPremium ? $fd60965d4b27bd3f$var$loadedModules["VehicleComparisonOverview"].view(dispatch, state, vehicle) : (0, $6cd550bbc3c7490c$export$a4111085dcbe77df)("Alle vergelijkbare auto's bekijken?", $fd60965d4b27bd3f$var$loadedModules["VehicleComparisonOverview"].view(dispatch, state, vehicle)),
                        infoBlock: {
                            onToggle: dispatch((0, $dErh8.Msg).VehicleComparisonOverview_OnToggleInfoBlock),
                            isVisible: state.page.VehicleComparisonOverview.isInfoBlockVisible
                        },
                        pageNavigations: {
                            previous: {
                                href: `/voertuig/${vehicleId}/dashboard`,
                                label: "Dashboard"
                            },
                            next: {
                                href: `/voertuig/${vehicleId}/vergelijk/prijsanalyse`,
                                label: "Prijsanalyse"
                            }
                        },
                        onPrint: dispatch((0, $dErh8.Msg).VehicleComparisonOverview_OnPrint)
                    })
                };
            }
        case "VehicleComparisonPriceAnalysis":
            {
                const vehicleId = state.route.params.vehicleId;
                const vehicle = state.cachedVehicles.get(vehicleId)?.[0];
                if (vehicle === undefined) return {
                    title: "",
                    body: $fd60965d4b27bd3f$var$viewTransitioningPage(state, (0, $9UZF0.html)`Voertuig wordt opgehaald`)
                };
                const competitionCount = $1ubKN.value(state.page.VehicleComparisonPriceAnalysis.vehicleCompetition)?.amountOfVehicles;
                return {
                    title: "AutoTrack Analytics",
                    body: $fd60965d4b27bd3f$var$viewVehicleShell(dispatch, state, vehicle, {
                        pageTitle: competitionCount !== undefined ? `Prijsanalyse van ${competitionCount} concurrerende auto's` : "Prijsanalyse",
                        content: state.account?.isPremium ? $fd60965d4b27bd3f$var$loadedModules["VehicleComparisonPriceAnalysis"].view(dispatch, state, vehicle) : (0, $6cd550bbc3c7490c$export$a4111085dcbe77df)("De prijsanalyse van alle vergelijkbare auto's bekijken?", $fd60965d4b27bd3f$var$loadedModules["VehicleComparisonPriceAnalysis"].view(dispatch, state, vehicle)),
                        infoBlock: {
                            onToggle: dispatch((0, $dErh8.Msg).VehicleComparisonPriceAnalysis_OnToggleInfoBlock),
                            isVisible: state.page.VehicleComparisonPriceAnalysis.isInfoBlockVisible
                        },
                        pageNavigations: {
                            previous: {
                                href: `/voertuig/${vehicleId}/vergelijk/overzicht`,
                                label: "Overzicht auto's vergelijken"
                            },
                            next: {
                                href: `/voertuig/${vehicleId}/vergelijk/prijshistorie`,
                                label: "Prijshistorie"
                            }
                        },
                        onPrint: dispatch((0, $dErh8.Msg).VehicleComparisonPriceAnalysis_OnPrint)
                    })
                };
            }
        case "VehicleComparisonPriceHistory":
            {
                const vehicleId = state.route.params.vehicleId;
                const vehicle = state.cachedVehicles.get(vehicleId)?.[0];
                if (vehicle === undefined) return {
                    title: "",
                    body: $fd60965d4b27bd3f$var$viewTransitioningPage(state, (0, $9UZF0.html)`Voertuig wordt opgehaald`)
                };
                const competitionCount = $1ubKN.value(state.page.VehicleComparisonPriceAnalysis.vehicleCompetition)?.amountOfVehicles;
                return {
                    title: "AutoTrack Analytics",
                    body: $fd60965d4b27bd3f$var$viewVehicleShell(dispatch, state, vehicle, {
                        pageTitle: competitionCount ? `Prijshistorie van ${competitionCount} concurrerende auto's` : "Prijshistorie",
                        content: state.account?.isPremium ? $fd60965d4b27bd3f$var$loadedModules["VehicleComparisonPriceHistory"].view(dispatch, state, vehicle) : (0, $6cd550bbc3c7490c$export$a4111085dcbe77df)("De prijshistorie van alle vergelijkbare auto's bekijken?", $fd60965d4b27bd3f$var$loadedModules["VehicleComparisonPriceHistory"].view(dispatch, state, vehicle)),
                        infoBlock: {
                            onToggle: dispatch((0, $dErh8.Msg).VehicleComparisonPriceHistory_OnToggleInfoBlock),
                            isVisible: state.page.VehicleComparisonPriceHistory.isInfoBlockVisible
                        },
                        pageNavigations: {
                            previous: {
                                href: `/voertuig/${vehicleId}/vergelijk/prijsanalyse`,
                                label: "Prijsanalyse"
                            },
                            next: {
                                href: `/voertuig/${vehicleId}/vergelijk/geografisch`,
                                label: "Geografisch"
                            }
                        },
                        onPrint: dispatch((0, $dErh8.Msg).VehicleComparisonPriceHistory_OnPrint)
                    })
                };
            }
        case "VehicleComparisonGeographic":
            {
                const vehicleId = state.route.params.vehicleId;
                const vehicle = state.cachedVehicles.get(vehicleId)?.[0];
                if (vehicle === undefined) return {
                    title: "",
                    body: $fd60965d4b27bd3f$var$viewTransitioningPage(state, (0, $9UZF0.html)`Voertuig wordt opgehaald`)
                };
                return {
                    title: "AutoTrack Analytics",
                    body: $fd60965d4b27bd3f$var$viewVehicleShell(dispatch, state, vehicle, {
                        pageTitle: "Geografisch",
                        content: state.account?.isPremium ? $fd60965d4b27bd3f$var$loadedModules["VehicleComparisonGeographic"].view(dispatch, state, vehicle) : (0, $6cd550bbc3c7490c$export$a4111085dcbe77df)("Bekijken waar de vergelijkbare auto's zich bevinden?", $fd60965d4b27bd3f$var$loadedModules["VehicleComparisonGeographic"].view(dispatch, state, vehicle)),
                        infoBlock: {
                            onToggle: dispatch((0, $dErh8.Msg).VehicleComparisonGeographic_OnToggleInfoBlock),
                            isVisible: state.page.VehicleComparisonGeographic.isInfoBlockVisible
                        },
                        pageNavigations: {
                            previous: {
                                href: `/voertuig/${vehicleId}/vergelijk/prijshistorie`,
                                label: "Prijshistorie"
                            },
                            next: {
                                href: `/voertuig/${vehicleId}/bereik/overzicht`,
                                label: "Bereik"
                            }
                        },
                        onPrint: dispatch((0, $dErh8.Msg).VehicleComparisonGeographic_OnPrint)
                    })
                };
            }
        case "VehicleSettings":
            {
                const vehicleId = state.route.params.vehicleId;
                const vehicle = state.cachedVehicles.get(vehicleId)?.[0];
                if (vehicle === undefined) return {
                    title: "",
                    body: $fd60965d4b27bd3f$var$viewTransitioningPage(state, (0, $9UZF0.html)`Voertuig wordt opgehaald`)
                };
                return {
                    title: "AutoTrack Analytics",
                    body: $fd60965d4b27bd3f$var$viewVehicleShell(dispatch, state, vehicle, {
                        pageTitle: "Eigenschappen",
                        content: $fd60965d4b27bd3f$var$loadedModules["VehicleSettings"].view(dispatch, state, vehicle),
                        infoBlock: {
                            onToggle: dispatch((0, $dErh8.Msg).VehicleSettings_OnToggleInfoBlock),
                            isVisible: state.page.VehicleSettings.isInfoBlockVisible
                        }
                    })
                };
            }
        case "TaxationSearch":
            return {
                title: "",
                body: $fd60965d4b27bd3f$var$loadedModules["TaxationSearch"].view(dispatch, state)
            };
        case "TaxationDashboard":
            {
                const vehicleId = state.route.params.vehicleId;
                const vehicle = state.cachedVehicles.get(vehicleId)?.[0];
                if (vehicle === undefined) return {
                    title: "",
                    body: $fd60965d4b27bd3f$var$viewTransitioningPage(state, (0, $9UZF0.html)`Voertuig wordt opgehaald`)
                };
                return {
                    title: "AutoTrack Analytics",
                    body: $fd60965d4b27bd3f$var$viewTaxationShell(dispatch, state, vehicle, {
                        pageTitle: "Dashboard",
                        content: $fd60965d4b27bd3f$var$loadedModules["TaxationDashboard"].view(dispatch, vehicle, state),
                        infoBlock: {
                            onToggle: dispatch((0, $dErh8.Msg).TaxationDashboard_OnToggleInfoBlock),
                            isVisible: state.page.TaxationDashboard.isInfoBlockVisible
                        },
                        onPrint: dispatch((0, $dErh8.Msg).TaxationDashboard_OnPrint)
                    })
                };
            }
        case "TaxationComparisonOverview":
            {
                const vehicleId = state.route.params.vehicleId;
                const vehicle = state.cachedVehicles.get(vehicleId)?.[0];
                if (vehicle === undefined) return {
                    title: "",
                    body: $fd60965d4b27bd3f$var$viewTransitioningPage(state, (0, $9UZF0.html)`Voertuig wordt opgehaald`)
                };
                return {
                    title: "AutoTrack Analytics",
                    body: $fd60965d4b27bd3f$var$viewTaxationShell(dispatch, state, vehicle, {
                        pageTitle: "Overzicht auto's vergelijken",
                        content: $fd60965d4b27bd3f$var$loadedModules["TaxationComparisonOverview"].view(dispatch, vehicle, state),
                        infoBlock: {
                            onToggle: dispatch((0, $dErh8.Msg).TaxationComparisonOverview_OnToggleInfoBlock),
                            isVisible: state.page.TaxationComparisonOverview.isInfoBlockVisible
                        },
                        pageNavigations: {
                            previous: {
                                href: `/taxatie/${vehicleId}/dashboard`,
                                label: "Dashboard"
                            },
                            next: {
                                href: `/taxatie/${vehicleId}/vergelijk/prijsanalyse`,
                                label: "Prijsanalyse"
                            }
                        },
                        onPrint: dispatch((0, $dErh8.Msg).TaxationComparisonOverview_OnPrint)
                    })
                };
            }
        case "TaxationComparisonPriceAnalysis":
            {
                const vehicleId = state.route.params.vehicleId;
                const vehicle = state.cachedVehicles.get(vehicleId)?.[0];
                if (vehicle === undefined) return {
                    title: "",
                    body: $fd60965d4b27bd3f$var$viewTransitioningPage(state, (0, $9UZF0.html)`Voertuig wordt opgehaald`)
                };
                const competitionCount = $1ubKN.value(state.page.TaxationComparisonPriceAnalysis.vehicleCompetition)?.amountOfVehicles;
                return {
                    title: "AutoTrack Analytics",
                    body: $fd60965d4b27bd3f$var$viewTaxationShell(dispatch, state, vehicle, {
                        pageTitle: competitionCount ? `Prijsanalyse van ${competitionCount} concurrerende auto's` : "Prijsanalyse",
                        content: $fd60965d4b27bd3f$var$loadedModules["TaxationComparisonPriceAnalysis"].view(dispatch, vehicle, state),
                        infoBlock: {
                            onToggle: dispatch((0, $dErh8.Msg).TaxationComparisonPriceAnalysis_OnToggleInfoBlock),
                            isVisible: state.page.TaxationComparisonPriceAnalysis.isInfoBlockVisible
                        },
                        pageNavigations: {
                            previous: {
                                href: `/taxatie/${vehicleId}/vergelijk/overzicht`,
                                label: "Overzicht auto's vergelijken"
                            },
                            next: {
                                href: `/taxatie/${vehicleId}/vergelijk/prijshistorie`,
                                label: "Prijshistorie"
                            }
                        },
                        onPrint: dispatch((0, $dErh8.Msg).TaxationComparisonPriceAnalysis_OnPrint)
                    })
                };
            }
        case "TaxationComparisonPriceHistory":
            {
                const vehicleId = state.route.params.vehicleId;
                const vehicle = state.cachedVehicles.get(vehicleId)?.[0];
                if (vehicle === undefined) return {
                    title: "",
                    body: $fd60965d4b27bd3f$var$viewTransitioningPage(state, (0, $9UZF0.html)`Voertuig wordt opgehaald`)
                };
                const competitionCount = $1ubKN.value(state.page.TaxationComparisonPriceHistory.vehicleCompetition)?.amountOfVehicles;
                return {
                    title: "AutoTrack Analytics",
                    body: $fd60965d4b27bd3f$var$viewTaxationShell(dispatch, state, vehicle, {
                        pageTitle: competitionCount ? `Prijshistorie van ${competitionCount} concurrerende auto's` : "Prijshistorie",
                        content: $fd60965d4b27bd3f$var$loadedModules["TaxationComparisonPriceHistory"].view(dispatch, vehicle, state),
                        infoBlock: {
                            onToggle: dispatch((0, $dErh8.Msg).TaxationComparisonPriceHistory_OnToggleInfoBlock),
                            isVisible: state.page.TaxationComparisonPriceHistory.isInfoBlockVisible
                        },
                        pageNavigations: {
                            previous: {
                                href: `/taxatie/${vehicleId}/vergelijk/prijsanalyse`,
                                label: "Prijsanalyse"
                            },
                            next: {
                                href: `/taxatie/${vehicleId}/vergelijk/geografisch`,
                                label: "Geografisch"
                            }
                        },
                        onPrint: dispatch((0, $dErh8.Msg).TaxationComparisonPriceHistory_OnPrint)
                    })
                };
            }
        case "TaxationComparisonGeographic":
            {
                const vehicleId = state.route.params.vehicleId;
                const vehicle = state.cachedVehicles.get(vehicleId)?.[0];
                if (vehicle === undefined) return {
                    title: "",
                    body: $fd60965d4b27bd3f$var$viewTransitioningPage(state, (0, $9UZF0.html)`Voertuig wordt opgehaald`)
                };
                return {
                    title: "AutoTrack Analytics",
                    body: $fd60965d4b27bd3f$var$viewTaxationShell(dispatch, state, vehicle, {
                        pageTitle: "Geografisch",
                        content: $fd60965d4b27bd3f$var$loadedModules["TaxationComparisonGeographic"].view(dispatch, vehicle, state),
                        infoBlock: {
                            onToggle: dispatch((0, $dErh8.Msg).TaxationComparisonGeographic_OnToggleInfoBlock),
                            isVisible: state.page.TaxationComparisonGeographic.isInfoBlockVisible
                        },
                        pageNavigations: {
                            previous: {
                                href: `/taxatie/${vehicleId}/vergelijk/prijshistorie`,
                                label: "Prijshistorie"
                            }
                        },
                        onPrint: dispatch((0, $dErh8.Msg).TaxationComparisonGeographic_OnPrint)
                    })
                };
            }
        case "TaxationSettings":
            {
                const vehicleId = state.route.params.vehicleId;
                const vehicle = state.cachedVehicles.get(vehicleId)?.[0];
                if (vehicle === undefined) return {
                    title: "",
                    body: $fd60965d4b27bd3f$var$viewTransitioningPage(state, (0, $9UZF0.html)`Voertuig wordt opgehaald`)
                };
                return {
                    title: "AutoTrackAnalytics",
                    body: $fd60965d4b27bd3f$var$viewTaxationShell(dispatch, state, vehicle, {
                        pageTitle: "Eigenschappen",
                        content: $fd60965d4b27bd3f$var$loadedModules["TaxationSettings"].view(dispatch, state, vehicle),
                        infoBlock: {
                            onToggle: dispatch((0, $dErh8.Msg).TaxationSettings_OnToggleInfoBlock),
                            isVisible: state.page.TaxationSettings.isInfoBlockVisible
                        }
                    })
                };
            }
        case "SettingsStock":
            return {
                title: "AutoTrack Analytics",
                body: $fd60965d4b27bd3f$var$viewMainShell(dispatch, state, {
                    pageTitle: "Voorraad instellingen",
                    content: $fd60965d4b27bd3f$var$loadedModules["SettingsStock"].view(dispatch, state),
                    hasSettings: true
                })
            };
        case "SettingsCompetingVehicles":
            return {
                title: "AutoTrack Analytics",
                body: $fd60965d4b27bd3f$var$viewMainShell(dispatch, state, {
                    pageTitle: "Vergelijkbare auto's",
                    content: $fd60965d4b27bd3f$var$loadedModules["SettingsCompetingVehicles"].view(dispatch, state),
                    hasSettings: true
                })
            };
        case "SettingsCompetingCompanies":
            return {
                title: "",
                body: $fd60965d4b27bd3f$var$viewMainShell(dispatch, state, {
                    pageTitle: "Profielen vergelijkbare bedrijven",
                    content: $fd60965d4b27bd3f$var$loadedModules["SettingsCompetingCompanies"].viewProfileList(dispatch, state),
                    hasSettings: true
                })
            };
        case "SettingsCompetingCompaniesProfile":
            return {
                title: "",
                body: $fd60965d4b27bd3f$var$viewMainShell(dispatch, state, {
                    pageTitle: "Profielen vergelijkbare bedrijven",
                    content: $fd60965d4b27bd3f$var$loadedModules["SettingsCompetingCompanies"].viewProfile(dispatch, state),
                    hasSettings: true
                })
            };
        case "SettingsNotifications":
            return {
                title: "AutoTrack Analytics",
                body: $fd60965d4b27bd3f$var$viewMainShell(dispatch, state, {
                    pageTitle: "Doelstellingen en meldingen",
                    content: $fd60965d4b27bd3f$var$loadedModules["SettingsNotifications"].view(dispatch, state),
                    hasSettings: true
                })
            };
        case "SettingsBranches":
            return {
                title: "",
                body: $fd60965d4b27bd3f$var$viewMainShell(dispatch, state, {
                    pageTitle: "Rapportage aanpassen",
                    content: $fd60965d4b27bd3f$var$loadedModules["SettingsBranches"].view(dispatch, state),
                    hasSettings: true
                })
            };
        case "SettingsScenarios":
            return {
                title: "",
                body: $fd60965d4b27bd3f$var$viewMainShell(dispatch, state, {
                    pageTitle: "Clusters aanpassen",
                    content: $fd60965d4b27bd3f$var$loadedModules["SettingsScenarios"].viewScenarioList(dispatch, state),
                    hasSettings: true
                })
            };
        case "SettingsScenario":
            return {
                title: "",
                body: $fd60965d4b27bd3f$var$viewMainShell(dispatch, state, {
                    pageTitle: "Clusters aanpassen",
                    content: $fd60965d4b27bd3f$var$loadedModules["SettingsScenarios"].viewScenario(dispatch, state),
                    hasSettings: true
                })
            };
        case "Logout":
            return {
                title: "AutoTrack Analytics",
                body: $fd60965d4b27bd3f$var$viewTransitioningPage(state, (0, $9UZF0.html)`U wordt uitgelogd`)
            };
        default:
            return {
                title: "Pagina niet gevonden | Autotrack Analytics",
                body: (0, $9cca11e6920deac5$export$2e2bcd8739ae039)(state.deviceLayout, (0, $04112eb0724539bf$export$2e2bcd8739ae039)({
                    onNavigateBack: dispatch((0, $dErh8.Msg).NavigateBack),
                    onNavigate: dispatch((0, $dErh8.Msg).Navigate)
                }))
            };
    }
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $fd60965d4b27bd3f$var$viewTransitioningPage(state, content) {
    return (0, $9cca11e6920deac5$export$2e2bcd8739ae039)(state.deviceLayout, (0, $kmtkw.loadingLogo)());
}
function $fd60965d4b27bd3f$var$viewMainShell(dispatch, state, config) {
    return (0, $7a662f5db96b23da$export$2e2bcd8739ae039)({
        deviceLayout: state.deviceLayout,
        account: state.account,
        activeRoute: state.route,
        isNavigationVisible: state.isNavigationVisible,
        onNavigate: dispatch((0, $dErh8.Msg).Navigate),
        onToggleNavigation: dispatch((0, $dErh8.Msg).ToggleNavigation),
        pageTitle: config.pageTitle,
        pageActions: [
            config.onDownloadExcel === undefined ? (0, $9UZF0.nothing) : (0, $7yG78.denseStrokedButton)({
                content: (0, $9UZF0.html)`${(0, $ac4D8.default).download()}
                          <span>Download excel</span>`,
                onClick: config.onDownloadExcel,
                theme: "Secondary"
            }),
            config.infoBlock === undefined ? (0, $9UZF0.nothing) : config.infoBlock.isVisible ? (0, $7yG78.denseFilledButton)({
                content: (0, $ac4D8.default).info(),
                onClick: config.infoBlock.onToggle,
                theme: "Secondary"
            }) : (0, $7yG78.denseStrokedButton)({
                content: (0, $ac4D8.default).info(),
                onClick: config.infoBlock.onToggle,
                theme: "Secondary"
            }),
            config.onPrint === undefined ? (0, $9UZF0.nothing) : (0, $7yG78.denseStrokedButton)({
                content: (0, $ac4D8.default).print(),
                onClick: config.onPrint,
                theme: "Secondary"
            })
        ],
        content: config.content,
        stockCount: state.settings.stockCount,
        dealerCount: state.settings.dealerCount,
        pageNavigations: config.pageNavigations,
        hasSettings: config.hasSettings,
        taxationWidget: $fd60965d4b27bd3f$var$toTaxationWidget(dispatch, state)
    });
}
function $fd60965d4b27bd3f$var$viewVehicleShell(dispatch, state, vehicle, config) {
    return (0, $933280e87f824615$export$2e2bcd8739ae039)({
        deviceLayout: state.deviceLayout,
        pageTitle: config.pageTitle,
        pageActions: [
            config.infoBlock === undefined ? (0, $9UZF0.nothing) : config.infoBlock.isVisible ? (0, $7yG78.denseFilledButton)({
                content: (0, $ac4D8.default).info(),
                onClick: config.infoBlock.onToggle,
                theme: "Secondary"
            }) : (0, $7yG78.denseStrokedButton)({
                content: (0, $ac4D8.default).info(),
                onClick: config.infoBlock.onToggle,
                theme: "Secondary"
            }),
            config.onPrint === undefined ? (0, $9UZF0.nothing) : (0, $7yG78.denseStrokedButton)({
                content: (0, $ac4D8.default).print(),
                onClick: config.onPrint,
                theme: "Secondary"
            })
        ],
        vehicle: vehicle,
        activeRoute: state.route,
        account: state.account,
        content: config.content,
        isNavigationVisible: state.isNavigationVisible,
        onNavigate: dispatch((0, $dErh8.Msg).Navigate),
        onToggleNavigation: dispatch((0, $dErh8.Msg).ToggleNavigation),
        pageNavigations: config.pageNavigations,
        taxationWidget: $fd60965d4b27bd3f$var$toTaxationWidget(dispatch, state)
    });
}
function $fd60965d4b27bd3f$var$viewTaxationShell(dispatch, state, vehicle, config) {
    return (0, $a7ab0f96a9239fab$export$2e2bcd8739ae039)({
        deviceLayout: state.deviceLayout,
        pageTitle: config.pageTitle,
        pageActions: [
            config.infoBlock === undefined ? (0, $9UZF0.nothing) : config.infoBlock.isVisible ? (0, $7yG78.denseFilledButton)({
                content: (0, $ac4D8.default).info(),
                onClick: config.infoBlock.onToggle,
                theme: "Secondary"
            }) : (0, $7yG78.denseStrokedButton)({
                content: (0, $ac4D8.default).info(),
                onClick: config.infoBlock.onToggle,
                theme: "Secondary"
            }),
            config.onPrint === undefined ? (0, $9UZF0.nothing) : (0, $7yG78.denseStrokedButton)({
                content: (0, $ac4D8.default).print(),
                onClick: config.onPrint,
                theme: "Secondary"
            })
        ],
        activeRoute: state.route,
        vehicle: vehicle,
        account: state.account,
        content: config.content,
        isNavigationVisible: state.isNavigationVisible,
        onNavigate: dispatch((0, $dErh8.Msg).Navigate),
        onToggleNavigation: dispatch((0, $dErh8.Msg).ToggleNavigation),
        pageNavigations: config.pageNavigations,
        taxationWidget: $fd60965d4b27bd3f$var$toTaxationWidget(dispatch, state)
    });
}
//---- Update ----//
function $fd60965d4b27bd3f$var$update(msg, state) {
    if ($fb0eT.debug) console.log("Msg", msg);
    switch(msg.type){
        case "DeviceLayout":
            state.deviceLayout = msg.payload;
            return [
                state,
                []
            ];
        case "NavigateBack":
            history.back();
            return [
                state,
                []
            ];
        case "Navigate":
            $fd60965d4b27bd3f$var$router.navigate(msg.payload);
            return [
                state,
                []
            ];
        case "OnRoute":
            {
                const route = msg.payload;
                state.isInitialized = true;
                state.route = route;
                if (state.account === null && !state.isAuthenticating && !state.isRetrievingSession && route.id !== "Login") return [
                    state,
                    [
                        Promise.resolve((0, $dErh8.Msg).Navigate("/login"))
                    ]
                ];
                else if (state.account !== null && route.id === "Login") return [
                    state,
                    [
                        Promise.resolve((0, $dErh8.Msg).Navigate("/"))
                    ]
                ];
                switch(route.id){
                    case "Login":
                        return [
                            state,
                            []
                        ];
                    case "Logout":
                        if (state.account === null) return [
                            state,
                            []
                        ];
                        return [
                            state,
                            [
                                $0b52e672722f75d2$export$226b0e9bbfe4903b(state.account.accessToken, (isSuccessful)=>(0, $dErh8.Msg).Application_IncomingLogout({
                                        isSuccessful: isSuccessful
                                    }))
                            ]
                        ];
                    case "Dashboard":
                        if (state.account === null) return [
                            state,
                            []
                        ];
                        return [
                            state,
                            [
                                $0b52e672722f75d2$export$95f8a3d197872fd8(state.account.accessToken, (0, $dErh8.Msg).Dashboard_IncomingDealerDashboard)
                            ]
                        ];
                    case "Stock":
                        if (state.account === null) return [
                            state,
                            []
                        ];
                        state.page.Stock.isRetrieving = true;
                        return [
                            state,
                            [
                                $fd60965d4b27bd3f$var$retrieveDealerStock(state.account.accessToken, state.page.Stock)
                            ]
                        ];
                    case "Reach":
                        if (state.account === null) return [
                            state,
                            []
                        ];
                        return [
                            state,
                            [
                                $0b52e672722f75d2$export$56de87f170f2f151(state.account.accessToken, state.page.Reach.period, (0, $dErh8.Msg).Reach_Incoming)
                            ]
                        ];
                    case "Leads":
                        if (state.account === null) return [
                            state,
                            []
                        ];
                        return [
                            state,
                            [
                                $fd60965d4b27bd3f$var$retrieveDealerLeads(state.account.accessToken, state.page.Leads)
                            ]
                        ];
                    case "Prospects":
                        if (state.account === null) return [
                            state,
                            []
                        ];
                        return [
                            state,
                            [
                                $fd60965d4b27bd3f$var$retrieveDealerProspects(state.account.accessToken, state.page.Prospects)
                            ]
                        ];
                    case "AnalysisOverview":
                        if (state.account === null) return [
                            state,
                            []
                        ];
                        state.page.AnalysisOverview.isRetrieving = true;
                        return [
                            state,
                            [
                                $fd60965d4b27bd3f$var$retrieveAnalysisOverview(state.account.accessToken, state.page.AnalysisOverview)
                            ]
                        ];
                    case "AnalysisLeadPerformance":
                        if (state.account === null) return [
                            state,
                            []
                        ];
                        state.page.AnalysisLeadPerformance.isRetrieving = true;
                        return [
                            state,
                            [
                                $fd60965d4b27bd3f$var$retrieveAnalysisLeadPerformance(state.account.accessToken, state.page.AnalysisLeadPerformance)
                            ]
                        ];
                    case "AnalysisMakeModel":
                        if (state.account === null) return [
                            state,
                            []
                        ];
                        state.page.AnalysisMakeModel.isRetrieving = true;
                        return [
                            state,
                            [
                                $0b52e672722f75d2$export$b3d015ef61bf89b9(state.account.accessToken, (0, $dErh8.Msg).AnalysisMakeModel_Incoming)
                            ]
                        ];
                    case "AnalysisCostBenefit":
                        if (state.account === null) return [
                            state,
                            []
                        ];
                        state.page.AnalysisCostBenefit.isRetrieving = true;
                        return [
                            state,
                            [
                                $0b52e672722f75d2$export$bb7ee46c8e4b6b24(state.account.accessToken, (0, $dErh8.Msg).AnalysisCostBenefit_Incoming)
                            ]
                        ];
                    case "ComparisonAdvicePrice":
                        if (state.account === null) return [
                            state,
                            []
                        ];
                        if (state.settings.competingDealers === null) return [
                            state,
                            []
                        ];
                        if (state.settings.competingDealers.length === 0) return [
                            state,
                            []
                        ];
                        state.page.ComparisonAdvicePrice.isRetrieving = true;
                        return [
                            state,
                            [
                                $fd60965d4b27bd3f$var$retrieveComparisonAdvicePrice(state.account.accessToken, state.settings.competingDealers[0], state.page.ComparisonAdvicePrice)
                            ]
                        ];
                    case "ComparisonDaysInStock":
                        if (state.account === null) return [
                            state,
                            []
                        ];
                        if (state.settings.competingDealers === null) return [
                            state,
                            []
                        ];
                        if (state.settings.competingDealers.length === 0) return [
                            state,
                            []
                        ];
                        state.page.ComparisonAdvicePrice.isRetrieving = true;
                        return [
                            state,
                            [
                                $fd60965d4b27bd3f$var$retrieveComparisonDaysInStock(state.account.accessToken, state.settings.competingDealers[0], state.page.ComparisonDaysInStock),
                                (0, $0b52e672722f75d2$export$b0a0681fc38b10d1)(state.account.accessToken, (payload)=>(0, $dErh8.Msg).Incoming_DaysInStockGoal($jqoka.map(payload, ({ goaldaysinstock: goaldaysinstock })=>goaldaysinstock)))
                            ]
                        ];
                    case "ComparisonGeographic":
                        if (state.account === null) return [
                            state,
                            []
                        ];
                        if (state.settings.competingDealers === null) return [
                            state,
                            []
                        ];
                        if (state.settings.competingDealers.length === 0) return [
                            state,
                            []
                        ];
                        state.page.ComparisonOverview.isRetrieving = true;
                        return [
                            state,
                            [
                                $fd60965d4b27bd3f$var$retrieveComparisonGeographic(state.account.accessToken, state.settings.competingDealers[0], state.page.ComparisonGeographic)
                            ]
                        ];
                    case "VehicleDashboard":
                        if (state.account === null) return [
                            state,
                            []
                        ];
                        state.page.VehicleDashboard.data = $1ubKN.markAsLoading(state.page.VehicleDashboard.data);
                        return $fd60965d4b27bd3f$var$onRouteToVehiclePage([
                            state,
                            [
                                $0b52e672722f75d2$export$d7b53e6d119ad4b4(state.account.accessToken, route.params.vehicleId, (result)=>(0, $dErh8.Msg).VehicleDashboard_Incoming({
                                        vehicleId: route.params.vehicleId,
                                        result: result
                                    }))
                            ]
                        ]);
                    case "VehicleReachOverview":
                        if (state.account === null) return [
                            state,
                            []
                        ];
                        state.page.VehicleReachOverview.data = $1ubKN.markAsLoading(state.page.VehicleReachOverview.data);
                        return $fd60965d4b27bd3f$var$onRouteToVehiclePage([
                            state,
                            [
                                $0b52e672722f75d2$export$2503cc23c03a566(state.account.accessToken, route.params.vehicleId, (result)=>(0, $dErh8.Msg).VehicleReachOverview_Incoming({
                                        vehicleId: route.params.vehicleId,
                                        result: result
                                    }))
                            ]
                        ]);
                    case "VehicleReachPriceEffect":
                        {
                            if (state.account === null) return [
                                state,
                                []
                            ];
                            const activeTab = state.page.VehicleReachPriceEffect.activeTab;
                            state.page.VehicleReachPriceEffect.data[activeTab] = $1ubKN.markAsLoading(state.page.VehicleReachPriceEffect.data[activeTab]);
                            return $fd60965d4b27bd3f$var$onRouteToVehiclePage([
                                state,
                                [
                                    $0b52e672722f75d2$export$e06b153790910c7a(state.account.accessToken, route.params.vehicleId, activeTab, (result)=>(0, $dErh8.Msg).VehicleReachPriceEffect_Incoming({
                                            vehicleId: route.params.vehicleId,
                                            type: activeTab,
                                            result: result
                                        }))
                                ]
                            ]);
                        }
                    case "VehicleComparisonOverview":
                        if (state.account === null) return [
                            state,
                            []
                        ];
                        state.page.VehicleComparisonOverview.vehicleCompetition = $1ubKN.markAsLoading(state.page.VehicleComparisonOverview.vehicleCompetition);
                        return $fd60965d4b27bd3f$var$onRouteToVehiclePage([
                            state,
                            [
                                $0b52e672722f75d2$export$fbbc9cbc96cb2f25(state.account.accessToken, route.params.vehicleId, false, (result)=>(0, $dErh8.Msg).VehicleComparison_Incoming({
                                        vehicleId: route.params.vehicleId,
                                        result: result
                                    }))
                            ]
                        ]);
                    case "VehicleComparisonPriceAnalysis":
                        if (state.account === null) return [
                            state,
                            []
                        ];
                        state.page.VehicleComparisonPriceAnalysis.vehicleCompetition = $1ubKN.markAsLoading(state.page.VehicleComparisonPriceAnalysis.vehicleCompetition);
                        return $fd60965d4b27bd3f$var$onRouteToVehiclePage([
                            state,
                            [
                                $0b52e672722f75d2$export$fbbc9cbc96cb2f25(state.account.accessToken, route.params.vehicleId, false, (result)=>(0, $dErh8.Msg).VehicleComparison_Incoming({
                                        vehicleId: route.params.vehicleId,
                                        result: result
                                    }))
                            ]
                        ]);
                    case "VehicleComparisonPriceHistory":
                        if (state.account === null) return [
                            state,
                            []
                        ];
                        state.page.VehicleComparisonPriceHistory.vehicleCompetition = $1ubKN.markAsLoading(state.page.VehicleComparisonPriceHistory.vehicleCompetition);
                        return $fd60965d4b27bd3f$var$onRouteToVehiclePage([
                            state,
                            [
                                $0b52e672722f75d2$export$fbbc9cbc96cb2f25(state.account.accessToken, route.params.vehicleId, false, (result)=>(0, $dErh8.Msg).VehicleComparison_Incoming({
                                        vehicleId: route.params.vehicleId,
                                        result: result
                                    })),
                                $0b52e672722f75d2$export$a26d195ae78841ad(state.account.accessToken, route.params.vehicleId, false, (result)=>(0, $dErh8.Msg).VehicleComparisonPriceHistory_Incoming({
                                        vehicleId: route.params.vehicleId,
                                        result: result
                                    }))
                            ]
                        ]);
                    case "VehicleComparisonGeographic":
                        if (state.account === null) return [
                            state,
                            []
                        ];
                        state.page.VehicleComparisonGeographic.vehicleCompetition = $1ubKN.markAsLoading(state.page.VehicleComparisonGeographic.vehicleCompetition);
                        return $fd60965d4b27bd3f$var$onRouteToVehiclePage([
                            state,
                            [
                                $0b52e672722f75d2$export$fbbc9cbc96cb2f25(state.account.accessToken, route.params.vehicleId, false, (result)=>(0, $dErh8.Msg).VehicleComparison_Incoming({
                                        vehicleId: route.params.vehicleId,
                                        result: result
                                    })),
                                $0b52e672722f75d2$export$b003f91e5f568c3f(state.account.accessToken, route.params.vehicleId, false, (result)=>(0, $dErh8.Msg).VehicleComparisonGeographic_Incoming({
                                        vehicleId: route.params.vehicleId,
                                        result: result
                                    }))
                            ]
                        ]);
                    case "VehicleSettings":
                        if (state.account === null) return [
                            state,
                            []
                        ];
                        state.page.VehicleSettings.data = $1ubKN.markAsLoading(state.page.VehicleSettings.data);
                        return $fd60965d4b27bd3f$var$onRouteToVehiclePage([
                            state,
                            [
                                $0b52e672722f75d2$export$f85c8b69eed70986(state.account.accessToken, route.params.vehicleId, (result)=>(0, $dErh8.Msg).VehicleSettings_Incoming({
                                        vehicleId: route.params.vehicleId,
                                        result: result
                                    }))
                            ]
                        ]);
                    case "SettingsScenarios":
                        if (state.account === null) return [
                            state,
                            []
                        ];
                        state.page.SettingsScenarios.data = $1ubKN.markAsLoading(state.page.SettingsScenarios.data);
                        return [
                            state,
                            [
                                $0b52e672722f75d2$export$d8d0b85dee5e278(state.account.accessToken, (result)=>(0, $dErh8.Msg).SettingsScenarios_Incoming(result))
                            ]
                        ];
                    case "SettingsScenario":
                        if (state.account === null) return [
                            state,
                            []
                        ];
                        if (route.params.scenarioId === null) {
                            state.page.SettingsScenario.data = $1ubKN.markAsLoaded(state.page.SettingsScenario.data, null);
                            return $fd60965d4b27bd3f$var$onRouteToPageWithDealers([
                                state,
                                []
                            ]);
                        }
                        state.page.SettingsScenario.data = $1ubKN.markAsLoading(state.page.SettingsScenario.data);
                        return $fd60965d4b27bd3f$var$onRouteToPageWithDealers([
                            state,
                            [
                                $0b52e672722f75d2$export$b2c8da529da96bfc(state.account.accessToken, route.params.scenarioId, (0, $dErh8.Msg).SettingsScenario_Incoming)
                            ]
                        ]);
                    case "SettingsBranches":
                        if (state.account === null) return [
                            state,
                            []
                        ];
                        state.page.SettingsBranches.scenarioList = $1ubKN.markAsLoading(state.page.SettingsBranches.scenarioList);
                        return $fd60965d4b27bd3f$var$onRouteToPageWithDealers([
                            state,
                            [
                                $0b52e672722f75d2$export$9760cea95b8456a5(state.account.accessToken, (0, $dErh8.Msg).SettingsBranches_IncomingDealerFilter),
                                $0b52e672722f75d2$export$d8d0b85dee5e278(state.account.accessToken, (0, $dErh8.Msg).SettingsBranches_IncomingScenarioList)
                            ]
                        ]);
                    case "SettingsCompetingCompanies":
                        if (state.account === null) return [
                            state,
                            []
                        ];
                        state.page.SettingsCompetingCompanies.profiles = $1ubKN.markAsLoading(state.page.SettingsCompetingCompanies.profiles);
                        return [
                            state,
                            [
                                $0b52e672722f75d2$export$5204726068cfc3f1(state.account.accessToken, (0, $dErh8.Msg).SettingsCompetingDealers_Incoming)
                            ]
                        ];
                    case "SettingsCompetingCompaniesProfile":
                        if (state.account === null) return [
                            state,
                            []
                        ];
                        state.page.SettingsCompetingCompaniesProfile.filtersMetadata = $1ubKN.markAsLoading(state.page.SettingsCompetingCompaniesProfile.filtersMetadata);
                        state.page.SettingsCompetingCompaniesProfile.profile = $1ubKN.markAsLoading(state.page.SettingsCompetingCompaniesProfile.profile);
                        return [
                            state,
                            [
                                $0b52e672722f75d2$export$6006eb61c8267e5d(state.account.accessToken, (0, $dErh8.Msg).SettingsCompetingDealersProfile_IncomingFilters),
                                $0b52e672722f75d2$export$5204726068cfc3f1(state.account.accessToken, (result)=>(0, $dErh8.Msg).SettingsCompetingDealersProfile_Incoming($jqoka.map(result, (profiles)=>profiles.find((profile)=>profile.id === route.params.profileId) ?? null)))
                            ]
                        ];
                    case "SettingsStock":
                        if (state.account === null) return [
                            state,
                            []
                        ];
                        state.page.SettingsStock.data = $1ubKN.markAsLoading(state.page.SettingsStock.data);
                        return [
                            state,
                            [
                                $0b52e672722f75d2$export$be6367adeb077076(state.account.accessToken, (result)=>(0, $dErh8.Msg).SettingsStock_Incoming({
                                        result: result
                                    })),
                                $fd60965d4b27bd3f$var$retrieveSettingsStockVehicleCount(state.account.accessToken)
                            ]
                        ];
                    case "SettingsNotifications":
                        if (state.account === null) return [
                            state,
                            []
                        ];
                        state.page.SettingsNotifications.data = $1ubKN.markAsLoading(state.page.SettingsNotifications.data);
                        return [
                            state,
                            [
                                $0b52e672722f75d2$export$b0a0681fc38b10d1(state.account.accessToken, (result)=>(0, $dErh8.Msg).SettingsNotifications_Incoming({
                                        result: result
                                    }))
                            ]
                        ];
                    case "SettingsCompetingVehicles":
                        if (state.account === null) return [
                            state,
                            []
                        ];
                        state.page.SettingsCompetingVehicles.data = $1ubKN.markAsLoading(state.page.SettingsCompetingVehicles.data);
                        return [
                            state,
                            [
                                $0b52e672722f75d2$export$f85c8b69eed70986(state.account.accessToken, "0", (result)=>(0, $dErh8.Msg).SettingsCompetingVehicles_Incoming({
                                        result: result
                                    }))
                            ]
                        ];
                    case "TaxationDashboard":
                        if (state.account == null) return [
                            state,
                            []
                        ];
                        state.page.TaxationDashboard.data = $1ubKN.markAsLoading(state.page.TaxationDashboard.data);
                        return $fd60965d4b27bd3f$var$onRouteToTaxationPage([
                            state,
                            [
                                $0b52e672722f75d2$export$f8f090d64e3c787a(state.account.accessToken, route.params.vehicleId, (result)=>(0, $dErh8.Msg).TaxationDashboard_Incoming({
                                        vehicleId: route.params.vehicleId,
                                        result: result
                                    }))
                            ]
                        ]);
                    case "TaxationComparisonOverview":
                        if (state.account === null) return [
                            state,
                            []
                        ];
                        state.page.TaxationComparisonOverview.vehicleCompetition = $1ubKN.markAsLoading(state.page.TaxationComparisonOverview.vehicleCompetition);
                        return $fd60965d4b27bd3f$var$onRouteToTaxationPage([
                            state,
                            [
                                $0b52e672722f75d2$export$ae36f7dda251b6f1(state.account.accessToken, route.params.vehicleId, false, (result)=>(0, $dErh8.Msg).TaxationComparison_Incoming({
                                        vehicleId: route.params.vehicleId,
                                        result: result
                                    }))
                            ]
                        ]);
                    case "TaxationComparisonPriceAnalysis":
                        if (state.account === null) return [
                            state,
                            []
                        ];
                        state.page.TaxationComparisonPriceAnalysis.vehicleCompetition = $1ubKN.markAsLoading(state.page.TaxationComparisonPriceAnalysis.vehicleCompetition);
                        return $fd60965d4b27bd3f$var$onRouteToTaxationPage([
                            state,
                            [
                                $0b52e672722f75d2$export$ae36f7dda251b6f1(state.account.accessToken, route.params.vehicleId, false, (result)=>(0, $dErh8.Msg).TaxationComparison_Incoming({
                                        vehicleId: route.params.vehicleId,
                                        result: result
                                    }))
                            ]
                        ]);
                    case "TaxationComparisonPriceHistory":
                        if (state.account === null) return [
                            state,
                            []
                        ];
                        state.page.TaxationComparisonPriceHistory.vehicleCompetition = $1ubKN.markAsLoading(state.page.TaxationComparisonPriceHistory.vehicleCompetition);
                        return $fd60965d4b27bd3f$var$onRouteToTaxationPage([
                            state,
                            [
                                $0b52e672722f75d2$export$ae36f7dda251b6f1(state.account.accessToken, route.params.vehicleId, false, (result)=>(0, $dErh8.Msg).TaxationComparison_Incoming({
                                        vehicleId: route.params.vehicleId,
                                        result: result
                                    })),
                                $0b52e672722f75d2$export$84de2582e4881aa3(state.account.accessToken, route.params.vehicleId, false, (result)=>(0, $dErh8.Msg).TaxationComparisonPriceHistory_Incoming({
                                        vehicleId: route.params.vehicleId,
                                        result: result
                                    }))
                            ]
                        ]);
                    case "TaxationComparisonGeographic":
                        if (state.account === null) return [
                            state,
                            []
                        ];
                        state.page.TaxationComparisonGeographic.vehicleCompetition = $1ubKN.markAsLoading(state.page.TaxationComparisonGeographic.vehicleCompetition);
                        return $fd60965d4b27bd3f$var$onRouteToTaxationPage([
                            state,
                            [
                                $0b52e672722f75d2$export$ae36f7dda251b6f1(state.account.accessToken, route.params.vehicleId, false, (result)=>(0, $dErh8.Msg).TaxationComparison_Incoming({
                                        vehicleId: route.params.vehicleId,
                                        result: result
                                    })),
                                $0b52e672722f75d2$export$e2ea3d25324bff83(state.account.accessToken, route.params.vehicleId, false, (result)=>(0, $dErh8.Msg).TaxationComparisonGeographic_Incoming({
                                        vehicleId: route.params.vehicleId,
                                        result: result
                                    }))
                            ]
                        ]);
                    case "TaxationSettings":
                        if (state.account === null) return [
                            state,
                            []
                        ];
                        state.page.TaxationSettings.data = $1ubKN.markAsLoading(state.page.TaxationSettings.data);
                        return $fd60965d4b27bd3f$var$onRouteToTaxationPage([
                            state,
                            [
                                $0b52e672722f75d2$export$c2ad421229fe9f15(state.account.accessToken, route.params.vehicleId, (result)=>(0, $dErh8.Msg).TaxationSettings_Incoming({
                                        vehicleId: route.params.vehicleId,
                                        result: result
                                    }))
                            ]
                        ]);
                }
                break;
            }
        case "ToggleNavigation":
            state.isNavigationVisible = !state.isNavigationVisible;
            return [
                state,
                []
            ];
        case "TaxationWidget_OnInputLicensePlate":
            state.taxationWidget.licensePlate = msg.payload;
            return [
                state,
                []
            ];
        case "TaxationWidget_OnInputMileage":
            state.taxationWidget.mileage = msg.payload;
            return [
                state,
                []
            ];
        case "TaxationWidget_OnSubmit":
            state.taxationWidget.errorMessage = null;
            if (state.account === null) return [
                state,
                []
            ];
            return [
                state,
                [
                    $0b52e672722f75d2$export$d941a330948d4ba8(state.account.accessToken, state.taxationWidget.licensePlate, Number(state.taxationWidget.mileage), (0, $dErh8.Msg).TaxationWidget_IncomingSubmit)
                ]
            ];
        case "TaxationWidget_OnClearErrorMessage":
            state.taxationWidget.errorMessage = null;
            return [
                state,
                []
            ];
        case "TaxationWidget_IncomingSubmit":
            return $jqoka.match(msg.payload, {
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    if (error.type === "TaxationNotFound") state.taxationWidget.errorMessage = "Voertuig niet gevonden";
                    else state.taxationWidget.errorMessage = "Er ging iets fout";
                    return [
                        state,
                        []
                    ];
                },
                Ok: ({ id: id })=>[
                        state,
                        [
                            Promise.resolve((0, $dErh8.Msg).Navigate(`/taxatie/${id}/dashboard`))
                        ]
                    ]
            });
        case "Application_LoginWithToken":
            {
                const defaultExpirationTime = 25200000;
                state.isAuthenticating = true;
                return [
                    state,
                    [
                        $0b52e672722f75d2$export$e6dad8e485f60ef8(msg.payload, (payload)=>(0, $dErh8.Msg).Incoming_Token({
                                accessToken: payload.accessToken,
                                expiration: new Date(Date.now() + defaultExpirationTime),
                                isMasterAccount: msg.payload.master
                            }))
                    ]
                ];
            }
        case "Application_IncomingLogout":
            if (msg.payload.isSuccessful) {
                state.account = null;
                sessionStorage.removeItem("authentication");
                return [
                    state,
                    [
                        Promise.resolve((0, $dErh8.Msg).Navigate("/login"))
                    ]
                ];
            } else return [
                state,
                []
            ];
        case "Incoming_Session":
            state.isRetrievingSession = false;
            return $jqoka.match(msg.payload, {
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    return [
                        state,
                        []
                    ];
                },
                Ok: (payload)=>{
                    state.account = {
                        name: payload.accountName,
                        type: payload.accountType,
                        accessToken: payload.accessToken,
                        isMaster: payload.isMasterAccount,
                        isPremium: payload.isPremiumAccount,
                        lastUpdate: payload.lastUpdate
                    };
                    state.settings.stockCount = payload.stockCount;
                    return [
                        state,
                        [
                            ...state.isInitialized ? [
                                Promise.resolve((0, $dErh8.Msg).OnRoute(state.route))
                            ] : [],
                            $0b52e672722f75d2$export$5204726068cfc3f1(state.account.accessToken, (0, $dErh8.Msg).Incoming_CompetingDealerProfiles),
                            $0b52e672722f75d2$export$9760cea95b8456a5(state.account.accessToken, (result)=>(0, $dErh8.Msg).Incoming_DealerFilter($jqoka.map(result, (data)=>data.dealers)))
                        ]
                    ];
                }
            });
        case "Incoming_Token":
            state.isAuthenticating = false;
            if (msg.payload.expiration < new Date()) {
                // console.error('Token expired');
                state.account = null;
                sessionStorage.removeItem("authentication");
                return [
                    state,
                    []
                ];
            }
            sessionStorage.setItem("authentication", JSON.stringify(msg.payload.isMasterAccount ? {
                token: msg.payload.accessToken,
                expiration: msg.payload.expiration.valueOf(),
                isMaster: true
            } : {
                token: msg.payload.accessToken,
                expiration: msg.payload.expiration.valueOf()
            }));
            state.isRetrievingSession = true;
            return [
                state,
                [
                    $0b52e672722f75d2$export$aceb985d559ad4(msg.payload.accessToken, (result)=>(0, $dErh8.Msg).Incoming_Session($jqoka.map(result, (payload)=>({
                                accountName: payload.accountName,
                                accountType: payload.accountType,
                                accessToken: msg.payload.accessToken,
                                isPremiumAccount: payload.isPremiumAccount,
                                isMasterAccount: msg.payload.isMasterAccount,
                                stockCount: {
                                    total: payload.totalStock,
                                    selected: payload.filteredStock
                                },
                                lastUpdate: payload.lastUpdate
                            }))))
                ]
            ];
        case "Incoming_Vehicle":
            return $jqoka.match(msg.payload, {
                Ok: (vehicle)=>{
                    state.cachedVehicles = (0, $c9d0f3356cb93170$export$2e2bcd8739ae039).set(vehicle.id.value, vehicle, new Date(), state.cachedVehicles);
                    return [
                        state,
                        []
                    ];
                },
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    return [
                        state,
                        []
                    ];
                }
            });
        case "Incoming_CompetingDealerProfiles":
            {
                const cmds = ()=>[
                        ...state.route.id === "ComparisonAdvicePrice" && state.page.ComparisonAdvicePrice.data === null ? [
                            Promise.resolve((0, $dErh8.Msg).OnRoute(state.route))
                        ] : [],
                        ...state.route.id === "ComparisonDaysInStock" && state.page.ComparisonDaysInStock.data === null ? [
                            Promise.resolve((0, $dErh8.Msg).OnRoute(state.route))
                        ] : [],
                        ...state.route.id === "ComparisonGeographic" && state.page.ComparisonGeographic.data === null ? [
                            Promise.resolve((0, $dErh8.Msg).OnRoute(state.route))
                        ] : []
                    ];
                return $jqoka.match(msg.payload, {
                    Ok: (profiles)=>{
                        state.settings.competingDealers = profiles;
                        return [
                            state,
                            cmds()
                        ];
                    },
                    Err: (error)=>{
                        const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                        if (handledError !== null) return handledError;
                        return [
                            state,
                            cmds()
                        ];
                    }
                });
            }
        case "Incoming_DaysInStockGoal":
            return $jqoka.match(msg.payload, {
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    state.settings.daysInStockGoal = $1ubKN.markAsFailed(state.settings.daysInStockGoal);
                    return [
                        state,
                        []
                    ];
                },
                Ok: (goal)=>{
                    state.settings.daysInStockGoal = $1ubKN.markAsLoaded(state.settings.daysInStockGoal, goal);
                    return [
                        state,
                        []
                    ];
                }
            });
        case "Incoming_Dealers":
            return $jqoka.match(msg.payload, {
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    state.settings.dealers = $1ubKN.markAsFailed(state.settings.dealers);
                    return [
                        state,
                        []
                    ];
                },
                Ok: (goal)=>{
                    state.settings.dealers = $1ubKN.markAsLoaded(state.settings.dealers, goal);
                    return [
                        state,
                        []
                    ];
                }
            });
        case "Incoming_DealerFilter":
            return $jqoka.match(msg.payload, {
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    state.settings.dealerFilter = $1ubKN.markAsFailed(state.settings.dealerFilter);
                    state.settings.dealerCount = null;
                    return [
                        state,
                        []
                    ];
                },
                Ok: (dealerFilter)=>{
                    state.settings.dealerFilter = $1ubKN.markAsLoaded(state.settings.dealerFilter, dealerFilter);
                    state.settings.dealerCount = {
                        total: Object.keys(dealerFilter).length,
                        selected: Object.values(dealerFilter).filter(Boolean).length
                    };
                    if (state.route.id === "Dashboard" && state.account) {
                        state.page.Dashboard.isRetrieving = true;
                        return [
                            state,
                            [
                                $0b52e672722f75d2$export$95f8a3d197872fd8(state.account.accessToken, (0, $dErh8.Msg).Dashboard_IncomingDealerDashboard)
                            ]
                        ];
                    }
                    return [
                        state,
                        []
                    ];
                }
            });
        case "Incoming_StockSelection":
            return $jqoka.match(msg.payload, {
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    return [
                        state,
                        []
                    ];
                },
                Ok: (payload)=>{
                    state.settings.stockCount = payload;
                    return [
                        state,
                        []
                    ];
                }
            });
        case "Login_OnInputUsername":
            state.page.Login.error = null;
            state.page.Login.username = msg.payload;
            return [
                state,
                []
            ];
        case "Login_OnInputPassword":
            state.page.Login.error = null;
            state.page.Login.password = msg.payload;
            return [
                state,
                []
            ];
        case "Login_OnInputCaptcha":
            state.page.Login.error = null;
            state.page.Login.captcha = msg.payload;
            return [
                state,
                []
            ];
        case "Login_OnSubmit":
            state.isAuthenticating = true;
            return [
                state,
                [
                    $0b52e672722f75d2$export$2225eabe1ff0179d(state.page.Login.username, state.page.Login.password, state.page.Login.captcha, (0, $dErh8.Msg).Login_IncomingAuthentication)
                ]
            ];
        case "Login_IncomingAuthentication":
            state.isAuthenticating = false;
            return $jqoka.match(msg.payload, {
                Ok: (payload)=>{
                    return [
                        state,
                        [
                            Promise.resolve((0, $dErh8.Msg).Incoming_Token({
                                accessToken: payload.accessToken,
                                expiration: payload.expiration,
                                isMasterAccount: false
                            }))
                        ]
                    ];
                },
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    switch(error.type){
                        case "CaptchaRequired":
                            if (!state.page.Login.isCaptchaRequired) state.page.Login.isCaptchaRequired = true;
                            else state.page.Login.error = {
                                type: "CaptchaNotProvided"
                            };
                            return [
                                state,
                                []
                            ];
                        case "LoginWithCredentialsFailed":
                            state.page.Login.error = {
                                type: "IncorrectCredentials"
                            };
                            return [
                                state,
                                []
                            ];
                        default:
                            return [
                                state,
                                []
                            ];
                    }
                }
            });
        case "Dashboard_IncomingDealerDashboard":
            state.page.Dashboard.isRetrieving = false;
            return $jqoka.match(msg.payload, {
                Ok: (payload)=>{
                    state.page.Dashboard.data = payload;
                    return [
                        state,
                        []
                    ];
                },
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    return [
                        state,
                        []
                    ];
                }
            });
        case "Stock_Incoming":
            state.page.Stock.isRetrieving = false;
            return $jqoka.match(msg.payload, {
                Ok: (value)=>{
                    state.page.Stock.vehicles = value.vehicles;
                    state.page.Stock.amountOfVehicles = value.totalVehicles;
                    return [
                        state,
                        []
                    ];
                },
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    return [
                        state,
                        []
                    ];
                }
            });
        case "Dashboard_OnSortStockSummary":
            state.page.Dashboard.sorting = msg.payload;
            return [
                state,
                []
            ];
        case "Dashboard_OnToggleInfoBlock":
            state.page.Dashboard.isInfoBlockVisible = !state.page.Dashboard.isInfoBlockVisible;
            return [
                state,
                []
            ];
        case "Dashboard_OnPrint":
            print();
            return [
                state,
                []
            ];
        case "Dashboard_OnSelectAllDealers":
            if (state.account === null) return [
                state,
                []
            ];
            return $1ubKN.match(state.settings.dealerFilter, {
                Loaded: (dealerFilter)=>{
                    return [
                        state,
                        [
                            $0b52e672722f75d2$export$3719284900695305(state.account.accessToken, Object.keys(dealerFilter).reduce((acc, dealerId)=>{
                                acc[dealerId] = true;
                                return acc;
                            }, {}), (0, $dErh8.Msg).Incoming_DealerFilter)
                        ]
                    ];
                },
                Idle: ()=>[
                        state,
                        []
                    ],
                Loading: ()=>[
                        state,
                        []
                    ],
                Failed: ()=>[
                        state,
                        []
                    ]
            });
        case "Dashboard_OnSelectDealer":
            if (state.account === null) return [
                state,
                []
            ];
            return $1ubKN.match(state.settings.dealerFilter, {
                Loaded: (dealerFilter)=>{
                    return [
                        state,
                        [
                            $0b52e672722f75d2$export$3719284900695305(state.account.accessToken, Object.keys(dealerFilter).reduce((acc, dealerId)=>{
                                acc[dealerId] = dealerId === msg.payload;
                                return acc;
                            }, {}), (0, $dErh8.Msg).Incoming_DealerFilter)
                        ]
                    ];
                },
                Idle: ()=>[
                        state,
                        []
                    ],
                Loading: ()=>[
                        state,
                        []
                    ],
                Failed: ()=>[
                        state,
                        []
                    ]
            });
        case "Stock_OnDownloadExcel":
            if (state.account) $0b52e672722f75d2$export$c409007959eb9b2f(state.account.accessToken, "stock", null, (success)=>success);
            return [
                state,
                []
            ];
        case "Stock_OnPrint":
            print();
            return [
                state,
                []
            ];
        case "Stock_OnToggleInfoBlock":
            state.page.Stock.isInfoBlockVisible = !state.page.Stock.isInfoBlockVisible;
            return [
                state,
                []
            ];
        case "Stock_OnInputSearch":
            state.page.Stock.search = msg.payload;
            return [
                state,
                []
            ];
        case "Stock_OnSearch":
            state.page.Stock.search = msg.payload;
            return [
                state,
                [
                    $fd60965d4b27bd3f$var$retrieveDealerStock(state.account.accessToken, state.page.Stock)
                ]
            ];
        case "Stock_OnSort":
            state.page.Stock.sort = msg.payload;
            return [
                state,
                [
                    $fd60965d4b27bd3f$var$retrieveDealerStock(state.account.accessToken, state.page.Stock)
                ]
            ];
        case "Stock_OnSortDirection":
            state.page.Stock.sortDirection = msg.payload;
            return [
                state,
                [
                    $fd60965d4b27bd3f$var$retrieveDealerStock(state.account.accessToken, state.page.Stock)
                ]
            ];
        case "Stock_OnOnlyWithWarnings":
            state.page.Stock.onlyWithWarnings = msg.payload;
            return [
                state,
                [
                    $fd60965d4b27bd3f$var$retrieveDealerStock(state.account.accessToken, state.page.Stock)
                ]
            ];
        case "Stock_OnPageChange":
            state.page.Stock.page = msg.payload;
            return [
                state,
                [
                    $fd60965d4b27bd3f$var$retrieveDealerStock(state.account.accessToken, state.page.Stock)
                ]
            ];
        case "Stock_OnAmountPerPageChange":
            state.page.Stock.amountPerPage = msg.payload;
            $1eae9a5514e9fcfb$export$a1544dad697b423d("stockAmountPerPage", msg.payload);
            return [
                state,
                [
                    $fd60965d4b27bd3f$var$retrieveDealerStock(state.account.accessToken, state.page.Stock)
                ]
            ];
        case "Reach_Incoming":
            state.page.Stock.isRetrieving = false;
            return $jqoka.match(msg.payload, {
                Ok: (data)=>{
                    state.page.Reach.data = data;
                    return [
                        state,
                        []
                    ];
                },
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    return [
                        state,
                        []
                    ];
                }
            });
        case "Reach_OnToggleInfoBlock":
            state.page.Reach.isInfoBlockVisible = !state.page.Reach.isInfoBlockVisible;
            return [
                state,
                []
            ];
        case "Reach_OnPrint":
            print();
            return [
                state,
                []
            ];
        case "Reach_OnDateRangeChange":
            state.page.Reach.period = {
                startDate: (0, $ls5dD.toISODateString)(msg.payload[0]),
                endDate: (0, $ls5dD.toISODateString)(msg.payload[1])
            };
            return [
                state,
                [
                    $0b52e672722f75d2$export$56de87f170f2f151(state.account.accessToken, state.page.Reach.period, (0, $dErh8.Msg).Reach_Incoming)
                ]
            ];
        case "Leads_Incoming":
            state.page.Leads.isRetrieving = false;
            return $jqoka.match(msg.payload, {
                Ok: (data)=>{
                    state.page.Leads.data = data;
                    return [
                        state,
                        []
                    ];
                },
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    return [
                        state,
                        []
                    ];
                }
            });
        case "Leads_OnToggleInfoBlock":
            state.page.Leads.isInfoBlockVisible = !state.page.Leads.isInfoBlockVisible;
            return [
                state,
                []
            ];
        case "Leads_OnToggleFilterVisibility":
            state.page.Leads.isFilterVisible = !state.page.Leads.isFilterVisible;
            return [
                state,
                []
            ];
        case "Leads_OnDownloadExcel":
            if (state.account) $0b52e672722f75d2$export$c409007959eb9b2f(state.account.accessToken, "leads", [
                state.page.Leads.period.startDate,
                state.page.Leads.period.endDate
            ], (success)=>success);
            return [
                state,
                []
            ];
        case "Leads_OnPrint":
            print();
            return [
                state,
                []
            ];
        case "Leads_OnSortChange":
            if (state.account == null) return [
                state,
                []
            ];
            state.page.Leads.isRetrieving = true;
            state.page.Leads.sort = msg.payload;
            return [
                state,
                [
                    $fd60965d4b27bd3f$var$retrieveDealerLeads(state.account.accessToken, state.page.Leads)
                ]
            ];
        case "Leads_OnAmountPerPageChange":
            if (state.account == null) return [
                state,
                []
            ];
            state.page.Leads.isRetrieving = true;
            state.page.Leads.amountPerPage = msg.payload;
            $1eae9a5514e9fcfb$export$a1544dad697b423d("leadsAmountPerPage", msg.payload);
            return [
                state,
                [
                    $fd60965d4b27bd3f$var$retrieveDealerLeads(state.account.accessToken, state.page.Leads)
                ]
            ];
        case "Leads_OnPageChange":
            if (state.account == null) return [
                state,
                []
            ];
            state.page.Leads.isRetrieving = true;
            state.page.Leads.page = msg.payload;
            return [
                state,
                [
                    $fd60965d4b27bd3f$var$retrieveDealerLeads(state.account.accessToken, state.page.Leads)
                ]
            ];
        case "Leads_OnFilterChange":
            if (state.account == null) return [
                state,
                []
            ];
            state.page.Leads.isRetrieving = true;
            state.page.Leads.filter = msg.payload;
            return [
                state,
                [
                    $fd60965d4b27bd3f$var$retrieveDealerLeads(state.account.accessToken, state.page.Leads)
                ]
            ];
        case "Leads_OnSearchInput":
            if (state.account == null) return [
                state,
                []
            ];
            state.page.Leads.isRetrieving = true;
            state.page.Leads.search = msg.payload;
            return [
                state,
                [
                    $fd60965d4b27bd3f$var$retrieveDealerLeads(state.account.accessToken, state.page.Leads)
                ]
            ];
        case "Leads_OnPeriodChange":
            if (state.account == null) return [
                state,
                []
            ];
            state.page.Leads.isRetrieving = true;
            state.page.Leads.period = {
                startDate: (0, $ls5dD.toISODateString)(msg.payload[0]),
                endDate: (0, $ls5dD.toISODateString)(msg.payload[1])
            };
            return [
                state,
                [
                    $fd60965d4b27bd3f$var$retrieveDealerLeads(state.account.accessToken, state.page.Leads)
                ]
            ];
        case "Prospects_Incoming":
            state.page.Prospects.isRetrieving = false;
            return $jqoka.match(msg.payload, {
                Ok: (data)=>{
                    state.page.Prospects.data = data;
                    return [
                        state,
                        []
                    ];
                },
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    return [
                        state,
                        []
                    ];
                }
            });
        case "Prospects_OnDownloadExcel":
            if (state.account) $0b52e672722f75d2$export$c409007959eb9b2f(state.account.accessToken, "prospects", [
                state.page.Prospects.period.startDate,
                state.page.Prospects.period.endDate
            ], (success)=>success);
            return [
                state,
                []
            ];
        case "Prospects_OnToggleInfoBlock":
            state.page.Prospects.isInfoBlockVisible = !state.page.Prospects.isInfoBlockVisible;
            return [
                state,
                []
            ];
        case "Prospects_OnPrint":
            print();
            return [
                state,
                []
            ];
        case "Prospects_OnPageChange":
            if (state.account == null) return [
                state,
                []
            ];
            state.page.Prospects.isRetrieving = true;
            state.page.Prospects.page = msg.payload;
            return [
                state,
                [
                    $fd60965d4b27bd3f$var$retrieveDealerProspects(state.account.accessToken, state.page.Prospects)
                ]
            ];
        case "Prospects_OnAmountPerPageChange":
            if (state.account == null) return [
                state,
                []
            ];
            state.page.Prospects.isRetrieving = true;
            state.page.Prospects.amountPerPage = msg.payload;
            $1eae9a5514e9fcfb$export$a1544dad697b423d("prospectsAmountPerPage", msg.payload);
            return [
                state,
                [
                    $fd60965d4b27bd3f$var$retrieveDealerProspects(state.account.accessToken, state.page.Prospects)
                ]
            ];
        case "Prospects_OnPeriodChange":
            if (state.account == null) return [
                state,
                []
            ];
            state.page.Prospects.isRetrieving = true;
            state.page.Prospects.period = {
                startDate: (0, $ls5dD.toISODateString)(msg.payload[0]),
                endDate: (0, $ls5dD.toISODateString)(msg.payload[1])
            };
            return [
                state,
                [
                    $fd60965d4b27bd3f$var$retrieveDealerProspects(state.account.accessToken, state.page.Prospects)
                ]
            ];
        case "AnalysisOverview_Incoming":
            state.page.AnalysisOverview.isRetrieving = false;
            return $jqoka.match(msg.payload, {
                Ok: (data)=>{
                    state.page.AnalysisOverview.data = data;
                    return [
                        state,
                        []
                    ];
                },
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    return [
                        state,
                        []
                    ];
                }
            });
        case "AnalysisOverview_OnPrint":
            print();
            return [
                state,
                []
            ];
        case "AnalysisOverview_OnToggleInfoBlock":
            state.page.AnalysisOverview.isInfoBlockVisible = !state.page.AnalysisOverview.isInfoBlockVisible;
            return [
                state,
                []
            ];
        case "AnalysisOverview_OnProfileChange":
            if (state.account == null) return [
                state,
                []
            ];
            state.page.AnalysisOverview.isRetrieving = true;
            state.page.AnalysisOverview.profile = msg.payload;
            return [
                state,
                [
                    $fd60965d4b27bd3f$var$retrieveAnalysisOverview(state.account.accessToken, state.page.AnalysisOverview)
                ]
            ];
        case "AnalysisLeadPerformance_Incoming":
            state.page.AnalysisLeadPerformance.isRetrieving = false;
            return $jqoka.match(msg.payload, {
                Ok: (data)=>{
                    state.page.AnalysisLeadPerformance.data = data;
                    return [
                        state,
                        []
                    ];
                },
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    return [
                        state,
                        []
                    ];
                }
            });
        case "AnalysisLeadPerformance_OnPrint":
            print();
            return [
                state,
                []
            ];
        case "AnalysisLeadPerformance_OnToggleInfoBlock":
            state.page.AnalysisLeadPerformance.isInfoBlockVisible = !state.page.AnalysisLeadPerformance.isInfoBlockVisible;
            return [
                state,
                []
            ];
        case "AnalysisLeadPerformance_OnPeriodChange":
            if (state.account == null) return [
                state,
                []
            ];
            state.page.AnalysisLeadPerformance.isRetrieving = true;
            state.page.AnalysisLeadPerformance.period = {
                startDate: (0, $ls5dD.toISODateString)(msg.payload[0]),
                endDate: (0, $ls5dD.toISODateString)(msg.payload[1])
            };
            return [
                state,
                [
                    $fd60965d4b27bd3f$var$retrieveAnalysisLeadPerformance(state.account.accessToken, state.page.AnalysisLeadPerformance)
                ]
            ];
        case "AnalysisMakeModel_Incoming":
            state.page.AnalysisMakeModel.isRetrieving = false;
            return $jqoka.match(msg.payload, {
                Ok: (data)=>{
                    state.page.AnalysisMakeModel.data = data;
                    return [
                        state,
                        []
                    ];
                },
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    return [
                        state,
                        []
                    ];
                }
            });
        case "AnalysisMakeModel_OnToggleInfoBlock":
            state.page.AnalysisMakeModel.isInfoBlockVisible = !state.page.AnalysisMakeModel.isInfoBlockVisible;
            return [
                state,
                []
            ];
        case "AnalysisMakeModel_OnPrint":
            print();
            return [
                state,
                []
            ];
        case "AnalysisMakeModel_OnChangeTab":
            state.page.AnalysisMakeModel.tab = msg.payload;
            return [
                state,
                []
            ];
        case "AnalysisCostBenefit_Incoming":
            state.page.AnalysisCostBenefit.isRetrieving = false;
            return $jqoka.match(msg.payload, {
                Ok: (data)=>{
                    state.page.AnalysisCostBenefit.data = data;
                    return [
                        state,
                        []
                    ];
                },
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    return [
                        state,
                        []
                    ];
                }
            });
        case "AnalysisCostBenefit_OnPrint":
            print();
            return [
                state,
                []
            ];
        case "ComparisonAdvicePrice_Incoming":
            state.page.ComparisonAdvicePrice.isRetrieving = false;
            return $jqoka.match(msg.payload, {
                Ok: (data)=>{
                    if (state.page.ComparisonAdvicePrice.activeProfile === null && data.profiles.length > 0) state.page.ComparisonAdvicePrice.activeProfile = data.profiles[0].id;
                    state.page.ComparisonAdvicePrice.data = data;
                    return [
                        state,
                        []
                    ];
                },
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    return [
                        state,
                        []
                    ];
                }
            });
        case "ComparisonAdvicePrice_OnPrint":
            print();
            return [
                state,
                []
            ];
        case "ComparisonAdvicePrice_OnToggleInfoBlock":
            state.page.ComparisonAdvicePrice.isInfoBlockVisible = !state.page.ComparisonAdvicePrice.isInfoBlockVisible;
            return [
                state,
                []
            ];
        case "ComparisonAdvicePrice_OnProfileChange":
            state = $fd60965d4b27bd3f$var$onComparisonProfileChange(msg.payload, state);
            return [
                state,
                [
                    $fd60965d4b27bd3f$var$retrieveComparisonAdvicePrice(state.account.accessToken, state.settings.competingDealers[0], state.page.ComparisonAdvicePrice)
                ]
            ];
        case "ComparisonAdvicePrice_OnMakeFilterChange":
            state = $fd60965d4b27bd3f$var$onComparisonMakeFilterChange(msg.payload, state.page.ComparisonAdvicePrice.data?.models ?? [], state.page.ComparisonAdvicePrice.modelFilter, state);
            return [
                state,
                [
                    $fd60965d4b27bd3f$var$retrieveComparisonAdvicePrice(state.account.accessToken, state.settings.competingDealers[0], state.page.ComparisonAdvicePrice)
                ]
            ];
        case "ComparisonAdvicePrice_OnModelFilterChange":
            state = $fd60965d4b27bd3f$var$onComparisonModelFilterChange(msg.payload, state);
            return [
                state,
                [
                    $fd60965d4b27bd3f$var$retrieveComparisonAdvicePrice(state.account.accessToken, state.settings.competingDealers[0], state.page.ComparisonAdvicePrice)
                ]
            ];
        case "ComparisonDaysInStock_Incoming":
            state.page.ComparisonDaysInStock.isRetrieving = false;
            return $jqoka.match(msg.payload, {
                Ok: (data)=>{
                    if (state.page.ComparisonDaysInStock.activeProfile === null && data.profiles.length > 0) state.page.ComparisonDaysInStock.activeProfile = data.profiles[0].id;
                    state.page.ComparisonDaysInStock.data = data;
                    return [
                        state,
                        []
                    ];
                },
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    return [
                        state,
                        []
                    ];
                }
            });
        case "ComparisonDaysInStock_OnPrint":
            print();
            return [
                state,
                []
            ];
        case "ComparisonDaysInStock_OnToggleInfoBlock":
            state.page.ComparisonDaysInStock.isInfoBlockVisible = !state.page.ComparisonDaysInStock.isInfoBlockVisible;
            return [
                state,
                []
            ];
        case "ComparisonDaysInStock_OnProfileChange":
            state = $fd60965d4b27bd3f$var$onComparisonProfileChange(msg.payload, state);
            return [
                state,
                [
                    $fd60965d4b27bd3f$var$retrieveComparisonDaysInStock(state.account.accessToken, state.settings.competingDealers[0], state.page.ComparisonDaysInStock)
                ]
            ];
        case "ComparisonDaysInStock_OnMakeFilterChange":
            state = $fd60965d4b27bd3f$var$onComparisonMakeFilterChange(msg.payload, state.page.ComparisonDaysInStock.data?.models ?? [], state.page.ComparisonDaysInStock.modelFilter, state);
            return [
                state,
                [
                    $fd60965d4b27bd3f$var$retrieveComparisonDaysInStock(state.account.accessToken, state.settings.competingDealers[0], state.page.ComparisonDaysInStock)
                ]
            ];
        case "ComparisonDaysInStock_OnModelFilterChange":
            state = $fd60965d4b27bd3f$var$onComparisonModelFilterChange(msg.payload, state);
            return [
                state,
                [
                    $fd60965d4b27bd3f$var$retrieveComparisonDaysInStock(state.account.accessToken, state.settings.competingDealers[0], state.page.ComparisonDaysInStock)
                ]
            ];
        case "ComparisonGeographic_Incoming":
            state.page.ComparisonGeographic.isRetrieving = false;
            return $jqoka.match(msg.payload, {
                Ok: (data)=>{
                    if (state.page.ComparisonGeographic.activeProfile === null && data.profiles.length > 0) state.page.ComparisonGeographic.activeProfile = data.profiles[0].id;
                    state.page.ComparisonGeographic.data = data;
                    return [
                        state,
                        []
                    ];
                },
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    return [
                        state,
                        []
                    ];
                }
            });
        case "ComparisonGeographic_OnToggleInfoBlock":
            state.page.ComparisonGeographic.isInfoBlockVisible = !state.page.ComparisonGeographic.isInfoBlockVisible;
            return [
                state,
                []
            ];
        case "ComparisonGeographic_OnPrint":
            print();
            return [
                state,
                []
            ];
        case "ComparisonGeographic_OnTabChange":
            state.page.ComparisonGeographic.activeTab = msg.payload;
            return [
                state,
                []
            ];
        case "ComparisonGeographic_OnProfileChange":
            state = $fd60965d4b27bd3f$var$onComparisonProfileChange(msg.payload, state);
            return [
                state,
                [
                    $fd60965d4b27bd3f$var$retrieveComparisonGeographic(state.account.accessToken, state.settings.competingDealers[0], state.page.ComparisonGeographic)
                ]
            ];
        case "SettingsScenarios_Incoming":
            if (state.account === null) return [
                state,
                []
            ];
            return $jqoka.match(msg.payload, {
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    state.page.SettingsScenarios.data = $1ubKN.markAsFailed(state.page.SettingsScenarios.data);
                    return [
                        state,
                        []
                    ];
                },
                Ok: (scenarios)=>{
                    state.page.SettingsScenarios.data = $1ubKN.markAsLoaded(state.page.SettingsScenarios.data, scenarios);
                    return [
                        state,
                        []
                    ];
                }
            });
        case "SettingsScenarios_IncomingDelete":
            if (state.account === null) return [
                state,
                []
            ];
            if (!msg.payload.wasSuccessful) return [
                state,
                []
            ];
            state.page.SettingsScenarios.data = $1ubKN.map(state.page.SettingsScenarios.data, (scenarios)=>scenarios.filter((scenario)=>scenario.id !== msg.payload.scenario.id));
            return [
                state,
                []
            ];
        case "SettingsScenarios_OnDelete":
            if (state.account === null) return [
                state,
                []
            ];
            return [
                state,
                [
                    $0b52e672722f75d2$export$87e53aa8c3bba037(state.account.accessToken, msg.payload, (wasSuccessful)=>(0, $dErh8.Msg).SettingsScenarios_IncomingDelete({
                            scenario: msg.payload,
                            wasSuccessful: wasSuccessful
                        }))
                ]
            ];
        case "SettingsScenario_Incoming":
            if (state.account === null) return [
                state,
                []
            ];
            return $jqoka.match(msg.payload, {
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    state.page.SettingsScenario.data = $1ubKN.markAsFailed(state.page.SettingsScenario.data);
                    return [
                        state,
                        []
                    ];
                },
                Ok: (scenario)=>{
                    state.page.SettingsScenario.data = $1ubKN.markAsLoaded(state.page.SettingsScenario.data, scenario);
                    return [
                        state,
                        []
                    ];
                }
            });
        case "SettingsScenario_IncomingSave":
            if (state.account === null) return [
                state,
                []
            ];
            state.page.SettingsScenario.isSaving = false;
            state.page.SettingsScenario.data = $1ubKN.fromResult(msg.payload);
            return $jqoka.match(msg.payload, {
                Ok: ()=>{
                    state.page.SettingsScenario.changes = {};
                    return [
                        state,
                        [
                            Promise.resolve((0, $dErh8.Msg).Navigate("/instellingen/scenarios"))
                        ]
                    ];
                },
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    return [
                        state,
                        []
                    ];
                }
            });
        case "SettingsScenario_OnUpdate":
            if (state.account === null) return [
                state,
                []
            ];
            state.page.SettingsScenario.changes = msg.payload;
            return [
                state,
                []
            ];
        case "SettingsScenario_OnSave":
            {
                if (state.account === null) return [
                    state,
                    []
                ];
                if (!$1ubKN.isLoaded(state.page.SettingsScenario.data)) return [
                    state,
                    []
                ];
                const originalScenario = $bKIDm.fromNullable($1ubKN.value(state.page.SettingsScenario.data));
                state.page.SettingsScenario.isSaving = true;
                return $bKIDm.match(originalScenario, {
                    Nothing: ()=>{
                        const newScenario = {
                            ...$aY56T.create(),
                            ...state.page.SettingsScenario.changes
                        };
                        return [
                            state,
                            [
                                $0b52e672722f75d2$export$249d34085d7c95ed(state.account.accessToken, newScenario, (0, $dErh8.Msg).SettingsScenario_IncomingSave)
                            ]
                        ];
                    },
                    Just: (scenario)=>{
                        const newScenario = {
                            ...scenario,
                            ...state.page.SettingsScenario.changes
                        };
                        return [
                            state,
                            [
                                $0b52e672722f75d2$export$cd857b2e3fb3b50(state.account.accessToken, newScenario, (0, $dErh8.Msg).SettingsScenario_IncomingSave)
                            ]
                        ];
                    }
                });
            }
        case "SettingsScenario_OnCancel":
            if (state.account === null) return [
                state,
                []
            ];
            state.page.SettingsScenario.changes = {};
            return [
                state,
                [
                    Promise.resolve((0, $dErh8.Msg).Navigate("/instellingen/scenarios"))
                ]
            ];
        case "SettingsScenario_OnSelectedAvailableDealerChange":
            if (state.account === null) return [
                state,
                []
            ];
            state.page.SettingsScenario.selectedAvailableDealerPerCluster = state.page.SettingsScenario.selectedAvailableDealerPerCluster.set(msg.payload.index, msg.payload.dealerId);
            return [
                state,
                []
            ];
        case "SettingsBranches_IncomingScenarioList":
            if (state.account === null) return [
                state,
                []
            ];
            return $jqoka.match(msg.payload, {
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    state.page.SettingsBranches.scenarioList = $1ubKN.markAsFailed(state.page.SettingsBranches.scenarioList);
                    return [
                        state,
                        []
                    ];
                },
                Ok: (scenarios)=>{
                    state.page.SettingsBranches.scenarioList = $1ubKN.markAsLoaded(state.page.SettingsBranches.scenarioList, scenarios);
                    return [
                        state,
                        []
                    ];
                }
            });
        case "SettingsBranches_IncomingScenario":
            if (state.account === null) return [
                state,
                []
            ];
            return $jqoka.match(msg.payload, {
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    state.page.SettingsBranches.scenario = $1ubKN.markAsFailed(state.page.SettingsBranches.scenario);
                    return [
                        state,
                        []
                    ];
                },
                Ok: (scenario)=>{
                    state.page.SettingsBranches.scenario = $1ubKN.markAsLoaded(state.page.SettingsBranches.scenario, scenario);
                    return [
                        state,
                        []
                    ];
                }
            });
        case "SettingsBranches_IncomingDealerFilter":
            if (state.account === null) return [
                state,
                []
            ];
            return $jqoka.match(msg.payload, {
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    state.page.SettingsBranches.dealerFilter = $1ubKN.markAsFailed(state.page.SettingsBranches.dealerFilter);
                    return [
                        state,
                        []
                    ];
                },
                Ok: ({ scenario: scenarioId, dealers: dealers })=>{
                    state.page.SettingsBranches.dealerFilter = $1ubKN.markAsLoaded(state.page.SettingsBranches.dealerFilter, dealers);
                    return [
                        state,
                        [
                            $0b52e672722f75d2$export$b2c8da529da96bfc(state.account.accessToken, localStorage.getItem("selectedScenario") ?? scenarioId, (0, $dErh8.Msg).SettingsBranches_IncomingScenario)
                        ]
                    ];
                }
            });
        case "SettingsBranches_IncomingSave":
            if (state.account === null) return [
                state,
                []
            ];
            state.page.SettingsBranches.isSaving = false;
            state.page.SettingsBranches.dealerFilter = $1ubKN.fromResult(msg.payload, state.page.SettingsBranches.dealerFilter);
            if ($jqoka.isOk(msg.payload)) state.page.SettingsBranches.changes = {};
            return $jqoka.match(msg.payload, {
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    return [
                        state,
                        []
                    ];
                },
                Ok: (dealerFilter)=>{
                    state.settings.dealerCount.selected = Object.entries(dealerFilter).filter(([, x])=>!!x).length;
                    if (state.account === null) return [
                        state,
                        []
                    ];
                    return [
                        state,
                        [
                            $0b52e672722f75d2$export$aceb985d559ad4(state.account.accessToken, (result)=>(0, $dErh8.Msg).Incoming_StockSelection($jqoka.map(result, (payload)=>({
                                        total: payload.totalStock,
                                        selected: payload.filteredStock
                                    }))))
                        ]
                    ];
                }
            });
        case "SettingsBranches_OnChangeScenario":
            if (state.account === null) return [
                state,
                []
            ];
            state.page.SettingsBranches.scenario = $1ubKN.markAsLoading(state.page.SettingsBranches.scenario);
            if (msg.payload) localStorage.setItem("selectedScenario", msg.payload);
            return [
                state,
                [
                    $0b52e672722f75d2$export$b2c8da529da96bfc(state.account.accessToken, msg.payload, (0, $dErh8.Msg).SettingsBranches_IncomingScenario)
                ]
            ];
        case "SettingsBranches_OnUpdate":
            if (state.account === null) return [
                state,
                []
            ];
            state.page.SettingsBranches.changes = msg.payload;
            return [
                state,
                []
            ];
        case "SettingsBranches_OnSave":
            if (state.account === null) return [
                state,
                []
            ];
            if (!$1ubKN.isLoaded(state.page.SettingsBranches.dealerFilter)) return [
                state,
                []
            ];
            state.page.SettingsBranches.isSaving = true;
            state.page.SettingsBranches.dealerFilter = $1ubKN.markAsLoading(state.page.SettingsBranches.dealerFilter);
            return [
                state,
                [
                    $0b52e672722f75d2$export$3719284900695305(state.account.accessToken, state.page.SettingsBranches.changes, (0, $dErh8.Msg).SettingsBranches_IncomingSave)
                ]
            ];
        case "SettingsCompetingDealers_Incoming":
            if (state.account === null) return [
                state,
                []
            ];
            return $jqoka.match(msg.payload, {
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    state.page.SettingsCompetingCompanies.profiles = $1ubKN.markAsFailed(state.page.SettingsCompetingCompanies.profiles);
                    return [
                        state,
                        []
                    ];
                },
                Ok: (profiles)=>{
                    state.page.SettingsCompetingCompanies.profiles = $1ubKN.markAsLoaded(state.page.SettingsCompetingCompanies.profiles, profiles);
                    return [
                        state,
                        []
                    ];
                }
            });
        case "SettingsCompetingDealers_IncomingRemove":
            if (state.account === null) return [
                state,
                []
            ];
            if (!msg.payload.wasSuccessful) return [
                state,
                []
            ];
            state.page.SettingsCompetingCompanies.profiles = $1ubKN.map(state.page.SettingsCompetingCompanies.profiles, (profiles)=>profiles.filter((profile)=>profile.id !== msg.payload.profile.id));
            return [
                state,
                []
            ];
        case "SettingsCompetingDealers_OnRemove":
            if (state.account === null) return [
                state,
                []
            ];
            return [
                state,
                [
                    $0b52e672722f75d2$export$a372f3ec5b6effb0(state.account.accessToken, msg.payload, (wasSuccessful)=>(0, $dErh8.Msg).SettingsCompetingDealers_IncomingRemove({
                            profile: msg.payload,
                            wasSuccessful: wasSuccessful
                        }))
                ]
            ];
        case "SettingsCompetingDealersProfile_Incoming":
            if (state.account === null) return [
                state,
                []
            ];
            return $jqoka.match(msg.payload, {
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    state.page.SettingsCompetingCompaniesProfile.profile = $1ubKN.markAsFailed(state.page.SettingsCompetingCompaniesProfile.profile);
                    return [
                        state,
                        []
                    ];
                },
                Ok: (profile)=>{
                    state.page.SettingsCompetingCompaniesProfile.profile = $1ubKN.markAsLoaded(state.page.SettingsCompetingCompaniesProfile.profile, profile);
                    return [
                        state,
                        []
                    ];
                }
            });
        case "SettingsCompetingDealersProfile_IncomingFilters":
            if (state.account === null) return [
                state,
                []
            ];
            return $jqoka.match(msg.payload, {
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    state.page.SettingsCompetingCompaniesProfile.filtersMetadata = $1ubKN.markAsFailed(state.page.SettingsCompetingCompaniesProfile.filtersMetadata);
                    return [
                        state,
                        []
                    ];
                },
                Ok: (filters)=>{
                    state.page.SettingsCompetingCompaniesProfile.filtersMetadata = $1ubKN.markAsLoaded(state.page.SettingsCompetingCompaniesProfile.filtersMetadata, filters);
                    return [
                        state,
                        []
                    ];
                }
            });
        case "SettingsCompetingDealersProfile_IncomingDealers":
            if (state.account === null) return [
                state,
                []
            ];
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($02YGq)))(msg.payload.filters, state.page.SettingsCompetingCompaniesProfile.filters)) return [
                state,
                []
            ];
            return $jqoka.match(msg.payload.result, {
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    state.page.SettingsCompetingCompaniesProfile.dealers = $1ubKN.markAsFailed(state.page.SettingsCompetingCompaniesProfile.dealers);
                    return [
                        state,
                        []
                    ];
                },
                Ok: (dealers)=>{
                    state.page.SettingsCompetingCompaniesProfile.dealers = $1ubKN.markAsLoaded(state.page.SettingsCompetingCompaniesProfile.dealers, dealers);
                    return [
                        state,
                        []
                    ];
                }
            });
        case "SettingsCompetingDealersProfile_IncomingSave":
            state.page.SettingsCompetingCompaniesProfile.isSaving = false;
            if (state.account === null) return [
                state,
                []
            ];
            return $jqoka.match(msg.payload, {
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    return [
                        state,
                        []
                    ];
                },
                Ok: ()=>{
                    return [
                        state,
                        [
                            Promise.resolve((0, $dErh8.Msg).Navigate("/instellingen/concurrentiebedrijven"))
                        ]
                    ];
                }
            });
        case "SettingsCompetingDealersProfile_OnViewChange":
            state.page.SettingsCompetingCompaniesProfile.activeView = msg.payload;
            return [
                state,
                []
            ];
        case "SettingsCompetingDealersProfile_OnChangeName":
            if (state.account === null) return [
                state,
                []
            ];
            state.page.SettingsCompetingCompaniesProfile.changes.name = msg.payload;
            return [
                state,
                []
            ];
        case "SettingsCompetingDealersProfile_OnChangeSearch":
            if (state.account === null) return [
                state,
                []
            ];
            state.page.SettingsCompetingCompaniesProfile.filters.search = msg.payload;
            state.page.SettingsCompetingCompaniesProfile.dealers = $1ubKN.markAsLoading(state.page.SettingsCompetingCompaniesProfile.dealers);
            return [
                state,
                [
                    $fd60965d4b27bd3f$var$retrieveCompetitionDealers(state.account.accessToken, state)
                ]
            ];
        case "SettingsCompetingDealersProfile_OnChangeDealerFilter":
            if (state.account === null) return [
                state,
                []
            ];
            state.page.SettingsCompetingCompaniesProfile.filters.dealerTypes = msg.payload;
            state.page.SettingsCompetingCompaniesProfile.dealers = $1ubKN.markAsLoading(state.page.SettingsCompetingCompaniesProfile.dealers);
            return [
                state,
                [
                    $fd60965d4b27bd3f$var$retrieveCompetitionDealers(state.account.accessToken, state)
                ]
            ];
        case "SettingsCompetingDealersProfile_OnChangeProvinceFilter":
            if (state.account === null) return [
                state,
                []
            ];
            state.page.SettingsCompetingCompaniesProfile.filters.provinces = msg.payload;
            state.page.SettingsCompetingCompaniesProfile.dealers = $1ubKN.markAsLoading(state.page.SettingsCompetingCompaniesProfile.dealers);
            return [
                state,
                [
                    $fd60965d4b27bd3f$var$retrieveCompetitionDealers(state.account.accessToken, state)
                ]
            ];
        case "SettingsCompetingDealersProfile_OnChangeDealerMakeFilter":
            if (state.account === null) return [
                state,
                []
            ];
            state.page.SettingsCompetingCompaniesProfile.filters.dealerMakes = msg.payload;
            state.page.SettingsCompetingCompaniesProfile.dealers = $1ubKN.markAsLoading(state.page.SettingsCompetingCompaniesProfile.dealers);
            return [
                state,
                [
                    $fd60965d4b27bd3f$var$retrieveCompetitionDealers(state.account.accessToken, state)
                ]
            ];
        case "SettingsCompetingDealersProfile_OnChangeStockMakeFilter":
            if (state.account === null) return [
                state,
                []
            ];
            state.page.SettingsCompetingCompaniesProfile.filters.stockMakes = msg.payload;
            state.page.SettingsCompetingCompaniesProfile.dealers = $1ubKN.markAsLoading(state.page.SettingsCompetingCompaniesProfile.dealers);
            return [
                state,
                [
                    $fd60965d4b27bd3f$var$retrieveCompetitionDealers(state.account.accessToken, state)
                ]
            ];
        case "SettingsCompetingDealersProfile_OnAddCompetition":
            if (state.account === null) return [
                state,
                []
            ];
            state.page.SettingsCompetingCompaniesProfile.changes.dealers = $gUdlQ.add(state.page.SettingsCompetingCompaniesProfile.changes.dealers, (dealer)=>dealer.id, msg.payload.value);
            return [
                state,
                []
            ];
        case "SettingsCompetingDealersProfile_OnRemoveCompetition":
            if (state.account === null) return [
                state,
                []
            ];
            state.page.SettingsCompetingCompaniesProfile.changes.dealers = $gUdlQ.remove(state.page.SettingsCompetingCompaniesProfile.changes.dealers, (dealer)=>dealer.id, msg.payload.value);
            return [
                state,
                []
            ];
        case "SettingsCompetingDealersProfile_OnAddCompetitionAll":
            if (state.account === null) return [
                state,
                []
            ];
            if (!$1ubKN.isLoaded(state.page.SettingsCompetingCompaniesProfile.dealers)) return [
                state,
                []
            ];
            for (const dealer of state.page.SettingsCompetingCompaniesProfile.dealers.value)state.page.SettingsCompetingCompaniesProfile.changes.dealers = $gUdlQ.add(state.page.SettingsCompetingCompaniesProfile.changes.dealers, (dealer)=>dealer.id, dealer);
            return [
                state,
                []
            ];
        case "SettingsCompetingDealersProfile_OnRemoveCompetitionAll":
            if (state.account === null) return [
                state,
                []
            ];
            if (!$1ubKN.isLoaded(state.page.SettingsCompetingCompaniesProfile.dealers)) return [
                state,
                []
            ];
            for (const dealer of state.page.SettingsCompetingCompaniesProfile.dealers.value)state.page.SettingsCompetingCompaniesProfile.changes.dealers = $gUdlQ.remove(state.page.SettingsCompetingCompaniesProfile.changes.dealers, (dealer)=>dealer.id, dealer);
            return [
                state,
                []
            ];
        case "SettingsCompetingDealersProfile_OnSave":
            {
                if (state.account === null) return [
                    state,
                    []
                ];
                if (!$1ubKN.isLoaded(state.page.SettingsCompetingCompaniesProfile.profile)) return [
                    state,
                    []
                ];
                const originalProfile = $bKIDm.fromNullable($1ubKN.value(state.page.SettingsCompetingCompaniesProfile.profile));
                return $bKIDm.match(originalProfile, {
                    Nothing: ()=>{
                        const newProfile = $5yZNA.create();
                        if (state.page.SettingsCompetingCompaniesProfile.changes.name) newProfile.name = state.page.SettingsCompetingCompaniesProfile.changes.name;
                        if ((0, $gUdlQ.hasChanges)(state.page.SettingsCompetingCompaniesProfile.changes.dealers)) newProfile.dealers = $gUdlQ.applyTo(newProfile.dealers, (dealer)=>dealer.id, state.page.SettingsCompetingCompaniesProfile.changes.dealers);
                        state.page.SettingsCompetingCompaniesProfile.isSaving = true;
                        return [
                            state,
                            [
                                $0b52e672722f75d2$export$691258cc176f24b7(state.account.accessToken, newProfile, (0, $dErh8.Msg).SettingsCompetingDealersProfile_IncomingSave)
                            ]
                        ];
                    },
                    Just: (profile)=>{
                        const newProfile = structuredClone(profile);
                        if (state.page.SettingsCompetingCompaniesProfile.changes.name) newProfile.name = state.page.SettingsCompetingCompaniesProfile.changes.name;
                        if ((0, $gUdlQ.hasChanges)(state.page.SettingsCompetingCompaniesProfile.changes.dealers)) newProfile.dealers = $gUdlQ.applyTo(newProfile.dealers, (dealer)=>dealer.id, state.page.SettingsCompetingCompaniesProfile.changes.dealers);
                        state.page.SettingsCompetingCompaniesProfile.isSaving = true;
                        return [
                            state,
                            [
                                $0b52e672722f75d2$export$3ff10d26a93adf19(state.account.accessToken, newProfile, (0, $dErh8.Msg).SettingsCompetingDealersProfile_IncomingSave)
                            ]
                        ];
                    }
                });
            }
        case "SettingsCompetingDealersProfile_OnCancel":
            if (state.account === null) return [
                state,
                []
            ];
            state.page.SettingsCompetingCompaniesProfile.changes = {
                name: null,
                dealers: $gUdlQ.init()
            };
            return [
                state,
                [
                    Promise.resolve((0, $dErh8.Msg).Navigate("/instellingen/concurrentiebedrijven"))
                ]
            ];
        case "SettingsBranches_OnCancel":
            if (state.account === null) return [
                state,
                []
            ];
            state.page.SettingsBranches.changes = {};
            return [
                state,
                []
            ];
        case "TaxationDashboard_Incoming":
            if (state.account === null) return [
                state,
                []
            ];
            return $jqoka.match(msg.payload.result, {
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    state.page.TaxationDashboard.data = $1ubKN.markAsFailed(state.page.TaxationDashboard.data);
                    return [
                        state,
                        []
                    ];
                },
                Ok: (data)=>{
                    state.page.TaxationDashboard.data = $1ubKN.markAsLoaded(state.page.TaxationDashboard.data, data);
                    return [
                        state,
                        []
                    ];
                }
            });
        case "TaxationDashboard_OnToggleInfoBlock":
            state.page.TaxationDashboard.isInfoBlockVisible = !state.page.TaxationDashboard.isInfoBlockVisible;
            return [
                state,
                []
            ];
        case "TaxationDashboard_OnPrint":
            print();
            return [
                state,
                []
            ];
        case "TaxationComparisonOverview_OnAmountPerPageChange":
            state.page.TaxationComparisonOverview.amountPerPage = msg.payload;
            return [
                state,
                []
            ];
        case "TaxationComparisonOverview_OnPageChange":
            state.page.TaxationComparisonOverview.page = msg.payload;
            return [
                state,
                []
            ];
        case "TaxationComparisonOverview_OnSortChange":
            state.page.TaxationComparisonOverview.sort = msg.payload.value;
            return [
                state,
                []
            ];
        case "TaxationComparisonOverview_OnSortDirectionChange":
            state.page.TaxationComparisonOverview.sortDirection = msg.payload.value;
            return [
                state,
                []
            ];
        case "TaxationComparisonOverview_OnStatusChange":
            $fd60965d4b27bd3f$var$onTaxationComparisonStatusChange(msg.payload.value, state);
            if (state.account === null) return [
                state,
                []
            ];
            return [
                state,
                [
                    $0b52e672722f75d2$export$ae36f7dda251b6f1(state.account.accessToken, msg.payload.vehicleId, state.page.TaxationComparisonOverview.vehicleStatus === "Sold", (result)=>(0, $dErh8.Msg).TaxationComparison_Incoming({
                            vehicleId: msg.payload.vehicleId,
                            result: result
                        }))
                ]
            ];
        case "TaxationComparisonOverview_OnToggleInfoBlock":
            state.page.TaxationComparisonOverview.isInfoBlockVisible = !state.page.TaxationComparisonOverview.isInfoBlockVisible;
            return [
                state,
                []
            ];
        case "TaxationComparisonOverview_OnPrint":
            print();
            return [
                state,
                []
            ];
        case "TaxationComparisonPriceAnalysis_OnPrint":
            print();
            return [
                state,
                []
            ];
        case "TaxationComparisonPriceAnalysis_OnStatusChange":
            $fd60965d4b27bd3f$var$onTaxationComparisonStatusChange(msg.payload.value, state);
            if (state.account === null) return [
                state,
                []
            ];
            return [
                state,
                [
                    $0b52e672722f75d2$export$ae36f7dda251b6f1(state.account.accessToken, msg.payload.vehicleId, state.page.TaxationComparisonPriceAnalysis.vehicleStatus === "Sold", (result)=>(0, $dErh8.Msg).TaxationComparison_Incoming({
                            vehicleId: msg.payload.vehicleId,
                            result: result
                        }))
                ]
            ];
        case "TaxationComparisonPriceAnalysis_OnToggleInfoBlock":
            state.page.TaxationComparisonPriceAnalysis.isInfoBlockVisible = !state.page.TaxationComparisonPriceAnalysis.isInfoBlockVisible;
            return [
                state,
                []
            ];
        case "TaxationComparisonPriceHistory_Incoming":
            return $jqoka.match(msg.payload.result, {
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    state.page.TaxationComparisonPriceHistory.data = $1ubKN.markAsFailed(state.page.TaxationComparisonPriceHistory.data);
                    return [
                        state,
                        []
                    ];
                },
                Ok: (data)=>{
                    state.page.TaxationComparisonPriceHistory.data = $1ubKN.markAsLoaded(state.page.TaxationComparisonPriceHistory.data, data);
                    return [
                        state,
                        []
                    ];
                }
            });
        case "TaxationComparisonPriceHistory_OnStatusChange":
            $fd60965d4b27bd3f$var$onTaxationComparisonStatusChange(msg.payload.value, state);
            if (state.account === null) return [
                state,
                []
            ];
            return [
                state,
                [
                    $0b52e672722f75d2$export$ae36f7dda251b6f1(state.account.accessToken, msg.payload.vehicleId, state.page.TaxationComparisonPriceHistory.vehicleStatus === "Sold", (result)=>(0, $dErh8.Msg).TaxationComparison_Incoming({
                            vehicleId: msg.payload.vehicleId,
                            result: result
                        })),
                    $0b52e672722f75d2$export$84de2582e4881aa3(state.account.accessToken, msg.payload.vehicleId, state.page.TaxationComparisonPriceHistory.vehicleStatus === "Sold", (result)=>(0, $dErh8.Msg).TaxationComparisonPriceHistory_Incoming({
                            vehicleId: msg.payload.vehicleId,
                            result: result
                        }))
                ]
            ];
        case "TaxationComparisonPriceHistory_OnToggleInfoBlock":
            state.page.TaxationComparisonPriceHistory.isInfoBlockVisible = !state.page.TaxationComparisonPriceHistory.isInfoBlockVisible;
            return [
                state,
                []
            ];
        case "TaxationComparisonPriceHistory_OnPrint":
            print();
            return [
                state,
                []
            ];
        case "TaxationComparisonGeographic_Incoming":
            return $jqoka.match(msg.payload.result, {
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    state.page.TaxationComparisonGeographic.data = $1ubKN.markAsFailed(state.page.TaxationComparisonGeographic.data);
                    return [
                        state,
                        []
                    ];
                },
                Ok: (data)=>{
                    state.page.TaxationComparisonGeographic.data = $1ubKN.markAsLoaded(state.page.TaxationComparisonGeographic.data, data);
                    return [
                        state,
                        []
                    ];
                }
            });
        case "TaxationComparisonGeographic_OnStatusChange":
            $fd60965d4b27bd3f$var$onTaxationComparisonStatusChange(msg.payload.value, state);
            if (state.account === null) return [
                state,
                []
            ];
            return [
                state,
                [
                    $0b52e672722f75d2$export$ae36f7dda251b6f1(state.account.accessToken, msg.payload.vehicleId, state.page.TaxationComparisonGeographic.vehicleStatus === "Sold", (result)=>(0, $dErh8.Msg).TaxationComparison_Incoming({
                            vehicleId: msg.payload.vehicleId,
                            result: result
                        })),
                    $0b52e672722f75d2$export$e2ea3d25324bff83(state.account.accessToken, msg.payload.vehicleId, state.page.TaxationComparisonGeographic.vehicleStatus === "Sold", (result)=>(0, $dErh8.Msg).TaxationComparisonGeographic_Incoming({
                            vehicleId: msg.payload.vehicleId,
                            result: result
                        }))
                ]
            ];
        case "TaxationComparisonGeographic_OnToggleInfoBlock":
            state.page.TaxationComparisonGeographic.isInfoBlockVisible = !state.page.TaxationComparisonGeographic.isInfoBlockVisible;
            return [
                state,
                []
            ];
        case "TaxationComparisonGeographic_OnPrint":
            print();
            return [
                state,
                []
            ];
        case "TaxationSettings_Incoming":
            return $jqoka.match(msg.payload.result, {
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    state.page.TaxationSettings.data = $1ubKN.markAsFailed(state.page.TaxationSettings.data);
                    return [
                        state,
                        []
                    ];
                },
                Ok: (data)=>{
                    state.page.TaxationSettings.data = $1ubKN.markAsLoaded(state.page.TaxationSettings.data, data);
                    return [
                        state,
                        []
                    ];
                }
            });
        case "TaxationSettings_OnToggleInfoBlock":
            state.page.TaxationSettings.isInfoBlockVisible = !state.page.TaxationSettings.isInfoBlockVisible;
            return [
                state,
                []
            ];
        case "TaxationSettings_IncomingSave":
            state.page.TaxationSettings.isSaving = false;
            return $jqoka.match(msg.payload.result, {
                Ok: (value)=>{
                    state.page.TaxationSettings.data = $1ubKN.markAsLoaded(state.page.TaxationSettings.data, value);
                    state.page.TaxationSettings.changes = {};
                    return [
                        state,
                        []
                    ];
                },
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    return [
                        state,
                        []
                    ];
                }
            });
        case "TaxationSettings_IncomingReset":
            if (state.account === null) return [
                state,
                []
            ];
            state.page.TaxationSettings.isResetting = false;
            if (!msg.payload.wasSuccessful) return [
                state,
                []
            ];
            state.page.TaxationSettings.data = $1ubKN.markAsLoading(state.page.TaxationSettings.data);
            state.page.TaxationSettings.changes = {};
            return [
                state,
                [
                    $0b52e672722f75d2$export$c2ad421229fe9f15(state.account.accessToken, msg.payload.vehicleId, (result)=>(0, $dErh8.Msg).TaxationSettings_Incoming({
                            vehicleId: msg.payload.vehicleId,
                            result: result
                        }))
                ]
            ];
        case "TaxationSettings_OnChange":
            state.page.TaxationSettings.changes = msg.payload.value;
            return [
                state,
                []
            ];
        case "TaxationSettings_OnSave":
            {
                if (state.account === null) return [
                    state,
                    []
                ];
                if (Object.keys(state.page.TaxationSettings.changes).length === 0) return [
                    state,
                    []
                ];
                const originalValue = $1ubKN.value(state.page.TaxationSettings.data);
                if (originalValue === undefined) return [
                    state,
                    []
                ];
                const value = {
                    ...originalValue,
                    ...state.page.TaxationSettings.changes
                };
                state.page.TaxationSettings.isSaving = true;
                return [
                    state,
                    [
                        $0b52e672722f75d2$export$f266afe8beaa0c7e(state.account.accessToken, msg.payload.vehicleId, value, (result)=>(0, $dErh8.Msg).TaxationSettings_IncomingSave({
                                vehicleId: msg.payload.vehicleId,
                                result: $jqoka.map(result, ()=>value)
                            }))
                    ]
                ];
            }
        case "TaxationSettings_OnCancel":
            state.page.TaxationSettings.changes = {};
            return [
                state,
                []
            ];
        case "TaxationSettings_OnReset":
            if (state.account === null) return [
                state,
                []
            ];
            state.page.TaxationSettings.isResetting = true;
            return [
                state,
                [
                    $0b52e672722f75d2$export$d3a3464fecdcf9d2(state.account.accessToken, msg.payload.vehicleId, (wasSuccessful)=>(0, $dErh8.Msg).TaxationSettings_IncomingReset({
                            vehicleId: msg.payload.vehicleId,
                            wasSuccessful: wasSuccessful
                        }))
                ]
            ];
        case "TaxationComparison_Incoming":
            {
                const value = $1ubKN.fromResult(msg.payload.result);
                state.page.TaxationComparisonOverview.vehicleCompetition = value;
                state.page.TaxationComparisonGeographic.vehicleCompetition = value;
                state.page.TaxationComparisonPriceAnalysis.vehicleCompetition = value;
                state.page.TaxationComparisonPriceHistory.vehicleCompetition = value;
                return $jqoka.match(msg.payload.result, {
                    Err: (error)=>{
                        const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                        if (handledError !== null) return handledError;
                        return [
                            state,
                            []
                        ];
                    },
                    Ok: ()=>{
                        return [
                            state,
                            []
                        ];
                    }
                });
            }
        case "VehicleDashboard_Incoming":
            if (state.account === null) return [
                state,
                []
            ];
            return $jqoka.match(msg.payload.result, {
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    state.page.VehicleDashboard.data = $1ubKN.markAsFailed(state.page.VehicleDashboard.data);
                    return [
                        state,
                        []
                    ];
                },
                Ok: (data)=>{
                    state.page.VehicleDashboard.data = $1ubKN.markAsLoaded(state.page.VehicleDashboard.data, data);
                    return [
                        state,
                        []
                    ];
                }
            });
        case "VehicleDashboard_OnToggleInfoBlock":
            state.page.VehicleDashboard.isInfoBlockVisible = !state.page.VehicleDashboard.isInfoBlockVisible;
            return [
                state,
                []
            ];
        case "VehicleDashboard_OnPrint":
            print();
            return [
                state,
                []
            ];
        case "VehicleReachOverview_Incoming":
            return $jqoka.match(msg.payload.result, {
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    state.page.VehicleReachOverview.data = $1ubKN.markAsFailed(state.page.VehicleReachOverview.data);
                    return [
                        state,
                        []
                    ];
                },
                Ok: (data)=>{
                    state.page.VehicleReachOverview.data = $1ubKN.markAsLoaded(state.page.VehicleReachOverview.data, data);
                    return [
                        state,
                        []
                    ];
                }
            });
        case "VehicleReachOverview_OnToggleInfoBlock":
            state.page.VehicleReachOverview.isInfoBlockVisible = !state.page.VehicleReachOverview.isInfoBlockVisible;
            return [
                state,
                []
            ];
        case "VehicleReachOverview_OnPrint":
            print();
            return [
                state,
                []
            ];
        case "VehicleReachPriceEffect_Incoming":
            return $jqoka.match(msg.payload.result, {
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    state.page.VehicleReachPriceEffect.data[msg.payload.type] = $1ubKN.markAsFailed(state.page.VehicleReachPriceEffect.data[msg.payload.type]);
                    return [
                        state,
                        []
                    ];
                },
                Ok: (data)=>{
                    state.page.VehicleReachPriceEffect.data[msg.payload.type] = $1ubKN.markAsLoaded(state.page.VehicleReachPriceEffect.data[msg.payload.type], data);
                    return [
                        state,
                        []
                    ];
                }
            });
        case "VehicleReachPriceEffect_OnToggleInfoBlock":
            state.page.VehicleReachPriceEffect.isInfoBlockVisible = !state.page.VehicleReachPriceEffect.isInfoBlockVisible;
            return [
                state,
                []
            ];
        case "VehicleReachPriceEffect_OnPrint":
            print();
            return [
                state,
                []
            ];
        case "VehicleReachPriceEffect_OnTabClick":
            if (state.account === null) return [
                state,
                []
            ];
            state.page.VehicleReachPriceEffect.activeTab = msg.payload.value;
            state.page.VehicleReachPriceEffect.data[msg.payload.value] = $1ubKN.markAsLoading(state.page.VehicleReachPriceEffect.data[msg.payload.value]);
            return [
                state,
                [
                    $0b52e672722f75d2$export$e06b153790910c7a(state.account.accessToken, msg.payload.vehicleId, msg.payload.value, (result)=>(0, $dErh8.Msg).VehicleReachPriceEffect_Incoming({
                            vehicleId: msg.payload.vehicleId,
                            type: msg.payload.value,
                            result: result
                        }))
                ]
            ];
        case "VehicleComparison_Incoming":
            {
                const value = $1ubKN.fromResult(msg.payload.result);
                state.page.VehicleComparisonOverview.vehicleCompetition = value;
                state.page.VehicleComparisonPriceAnalysis.vehicleCompetition = value;
                state.page.VehicleComparisonPriceHistory.vehicleCompetition = value;
                state.page.VehicleComparisonGeographic.vehicleCompetition = value;
                return $jqoka.match(msg.payload.result, {
                    Err: (error)=>{
                        const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                        if (handledError !== null) return handledError;
                        return [
                            state,
                            []
                        ];
                    },
                    Ok: ()=>{
                        return [
                            state,
                            []
                        ];
                    }
                });
            }
        case "VehicleComparisonOverview_OnToggleInfoBlock":
            state.page.VehicleComparisonOverview.isInfoBlockVisible = !state.page.VehicleComparisonOverview.isInfoBlockVisible;
            return [
                state,
                []
            ];
        case "VehicleComparisonOverview_OnPrint":
            print();
            return [
                state,
                []
            ];
        case "VehicleComparisonOverview_OnStatusChange":
            $fd60965d4b27bd3f$var$onVehicleComparisonStatusChange(msg.payload.value, state);
            if (state.account === null) return [
                state,
                []
            ];
            return [
                state,
                [
                    $0b52e672722f75d2$export$fbbc9cbc96cb2f25(state.account.accessToken, msg.payload.vehicleId, state.page.VehicleComparisonOverview.vehicleStatus === "Sold", (result)=>(0, $dErh8.Msg).VehicleComparison_Incoming({
                            vehicleId: msg.payload.vehicleId,
                            result: result
                        }))
                ]
            ];
        case "VehicleComparisonOverview_OnSortChange":
            state.page.VehicleComparisonOverview.sort = msg.payload.value;
            return [
                state,
                []
            ];
        case "VehicleComparisonOverview_OnSortDirectionChange":
            state.page.VehicleComparisonOverview.sortDirection = msg.payload.value;
            return [
                state,
                []
            ];
        case "VehicleComparisonOverview_OnPageChange":
            state.page.VehicleComparisonOverview.page = msg.payload;
            return [
                state,
                []
            ];
        case "VehicleComparisonOverview_OnAmountPerPageChange":
            state.page.VehicleComparisonOverview.amountPerPage = msg.payload;
            return [
                state,
                []
            ];
        case "VehicleComparisonPriceAnalysis_OnToggleInfoBlock":
            state.page.VehicleComparisonPriceAnalysis.isInfoBlockVisible = !state.page.VehicleComparisonPriceAnalysis.isInfoBlockVisible;
            return [
                state,
                []
            ];
        case "VehicleComparisonPriceAnalysis_OnPrint":
            print();
            return [
                state,
                []
            ];
        case "VehicleComparisonPriceAnalysis_OnStatusChange":
            $fd60965d4b27bd3f$var$onVehicleComparisonStatusChange(msg.payload.value, state);
            if (state.account === null) return [
                state,
                []
            ];
            return [
                state,
                [
                    $0b52e672722f75d2$export$fbbc9cbc96cb2f25(state.account.accessToken, msg.payload.vehicleId, state.page.VehicleComparisonPriceAnalysis.vehicleStatus === "Sold", (result)=>(0, $dErh8.Msg).VehicleComparison_Incoming({
                            vehicleId: msg.payload.vehicleId,
                            result: result
                        }))
                ]
            ];
        case "VehicleComparisonPriceHistory_Incoming":
            return $jqoka.match(msg.payload.result, {
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    state.page.VehicleComparisonPriceHistory.data = $1ubKN.markAsFailed(state.page.VehicleComparisonPriceHistory.data);
                    return [
                        state,
                        []
                    ];
                },
                Ok: (data)=>{
                    state.page.VehicleComparisonPriceHistory.data = $1ubKN.markAsLoaded(state.page.VehicleComparisonPriceHistory.data, data);
                    return [
                        state,
                        []
                    ];
                }
            });
        case "VehicleComparisonPriceHistory_OnToggleInfoBlock":
            state.page.VehicleComparisonPriceHistory.isInfoBlockVisible = !state.page.VehicleComparisonPriceHistory.isInfoBlockVisible;
            return [
                state,
                []
            ];
        case "VehicleComparisonPriceHistory_OnPrint":
            print();
            return [
                state,
                []
            ];
        case "VehicleComparisonPriceHistory_OnStatusChange":
            $fd60965d4b27bd3f$var$onVehicleComparisonStatusChange(msg.payload.value, state);
            if (state.account === null) return [
                state,
                []
            ];
            return [
                state,
                [
                    $0b52e672722f75d2$export$fbbc9cbc96cb2f25(state.account.accessToken, msg.payload.vehicleId, state.page.VehicleComparisonPriceHistory.vehicleStatus === "Sold", (result)=>(0, $dErh8.Msg).VehicleComparison_Incoming({
                            vehicleId: msg.payload.vehicleId,
                            result: result
                        })),
                    $0b52e672722f75d2$export$a26d195ae78841ad(state.account.accessToken, msg.payload.vehicleId, state.page.VehicleComparisonPriceHistory.vehicleStatus === "Sold", (result)=>(0, $dErh8.Msg).VehicleComparisonPriceHistory_Incoming({
                            vehicleId: msg.payload.vehicleId,
                            result: result
                        }))
                ]
            ];
        case "VehicleComparisonGeographic_Incoming":
            return $jqoka.match(msg.payload.result, {
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    state.page.VehicleComparisonGeographic.data = $1ubKN.markAsFailed(state.page.VehicleComparisonGeographic.data);
                    return [
                        state,
                        []
                    ];
                },
                Ok: (data)=>{
                    state.page.VehicleComparisonGeographic.data = $1ubKN.markAsLoaded(state.page.VehicleComparisonGeographic.data, data);
                    return [
                        state,
                        []
                    ];
                }
            });
        case "VehicleComparisonGeographic_OnToggleInfoBlock":
            state.page.VehicleComparisonGeographic.isInfoBlockVisible = !state.page.VehicleComparisonGeographic.isInfoBlockVisible;
            return [
                state,
                []
            ];
        case "VehicleComparisonGeographic_OnPrint":
            print();
            return [
                state,
                []
            ];
        case "VehicleComparisonGeographic_OnStatusChange":
            $fd60965d4b27bd3f$var$onVehicleComparisonStatusChange(msg.payload.value, state);
            if (state.account === null) return [
                state,
                []
            ];
            return [
                state,
                [
                    $0b52e672722f75d2$export$fbbc9cbc96cb2f25(state.account.accessToken, msg.payload.vehicleId, state.page.VehicleComparisonGeographic.vehicleStatus === "Sold", (result)=>(0, $dErh8.Msg).VehicleComparison_Incoming({
                            vehicleId: msg.payload.vehicleId,
                            result: result
                        })),
                    $0b52e672722f75d2$export$b003f91e5f568c3f(state.account.accessToken, msg.payload.vehicleId, state.page.VehicleComparisonGeographic.vehicleStatus === "Sold", (result)=>(0, $dErh8.Msg).VehicleComparisonGeographic_Incoming({
                            vehicleId: msg.payload.vehicleId,
                            result: result
                        }))
                ]
            ];
        case "VehicleSettings_Incoming":
            return $jqoka.match(msg.payload.result, {
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    state.page.VehicleSettings.data = $1ubKN.markAsFailed(state.page.VehicleSettings.data);
                    return [
                        state,
                        []
                    ];
                },
                Ok: (data)=>{
                    state.page.VehicleSettings.data = $1ubKN.markAsLoaded(state.page.VehicleSettings.data, data);
                    return [
                        state,
                        []
                    ];
                }
            });
        case "VehicleSettings_OnToggleInfoBlock":
            state.page.VehicleSettings.isInfoBlockVisible = !state.page.VehicleSettings.isInfoBlockVisible;
            return [
                state,
                []
            ];
        case "VehicleSettings_IncomingSave":
            state.page.VehicleSettings.isSaving = false;
            return $jqoka.match(msg.payload.result, {
                Ok: (value)=>{
                    state.page.VehicleSettings.data = $1ubKN.markAsLoaded(state.page.VehicleSettings.data, value);
                    state.page.VehicleSettings.changes = {};
                    return [
                        state,
                        []
                    ];
                },
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    return [
                        state,
                        []
                    ];
                }
            });
        case "VehicleSettings_IncomingReset":
            if (state.account === null) return [
                state,
                []
            ];
            state.page.VehicleSettings.isResetting = false;
            if (!msg.payload.wasSuccessful) return [
                state,
                []
            ];
            state.page.VehicleSettings.data = $1ubKN.markAsLoading(state.page.VehicleSettings.data);
            state.page.VehicleSettings.changes = {};
            return [
                state,
                [
                    $0b52e672722f75d2$export$f85c8b69eed70986(state.account.accessToken, msg.payload.vehicleId, (result)=>(0, $dErh8.Msg).VehicleSettings_Incoming({
                            vehicleId: msg.payload.vehicleId,
                            result: result
                        }))
                ]
            ];
        case "VehicleSettings_OnChange":
            state.page.VehicleSettings.changes = msg.payload.value;
            return [
                state,
                []
            ];
        case "VehicleSettings_OnSave":
            {
                if (state.account === null) return [
                    state,
                    []
                ];
                if (Object.keys(state.page.VehicleSettings.changes).length === 0) return [
                    state,
                    []
                ];
                const originalValue = $1ubKN.value(state.page.VehicleSettings.data);
                if (originalValue === undefined) return [
                    state,
                    []
                ];
                const value = {
                    ...originalValue,
                    ...state.page.VehicleSettings.changes
                };
                state.page.VehicleSettings.isSaving = true;
                return [
                    state,
                    [
                        $0b52e672722f75d2$export$de4a167f7c9d1b43(state.account.accessToken, msg.payload.vehicleId, value, (result)=>(0, $dErh8.Msg).VehicleSettings_IncomingSave({
                                vehicleId: msg.payload.vehicleId,
                                result: $jqoka.map(result, ()=>value)
                            }))
                    ]
                ];
            }
        case "VehicleSettings_OnCancel":
            state.page.VehicleSettings.changes = {};
            return [
                state,
                []
            ];
        case "VehicleSettings_OnReset":
            if (state.account === null) return [
                state,
                []
            ];
            state.page.VehicleSettings.isResetting = true;
            return [
                state,
                [
                    $0b52e672722f75d2$export$f30d7d3a2dd4715(state.account.accessToken, msg.payload.vehicleId, (wasSuccessful)=>(0, $dErh8.Msg).VehicleSettings_IncomingReset({
                            vehicleId: msg.payload.vehicleId,
                            wasSuccessful: wasSuccessful
                        }))
                ]
            ];
        case "SettingsNotifications_Incoming":
            return $jqoka.match(msg.payload.result, {
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    state.page.SettingsNotifications.data = $1ubKN.markAsFailed(state.page.SettingsNotifications.data);
                    return [
                        state,
                        []
                    ];
                },
                Ok: (data)=>{
                    state.page.SettingsNotifications.data = $1ubKN.markAsLoaded(state.page.SettingsNotifications.data, data);
                    return [
                        state,
                        []
                    ];
                }
            });
        case "SettingsNotifications_IncomingSave":
            state.page.SettingsNotifications.isSaving = false;
            return $jqoka.match(msg.payload.result, {
                Ok: ()=>{
                    state.page.SettingsNotifications.data = $1ubKN.map(state.page.SettingsNotifications.data, (settings)=>({
                            ...settings,
                            ...state.page.SettingsNotifications.changes
                        }));
                    state.page.SettingsNotifications.changes = {};
                    return [
                        state,
                        []
                    ];
                },
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    return [
                        state,
                        []
                    ];
                }
            });
        case "SettingsNotifications_IncomingReset":
            if (state.account === null) return [
                state,
                []
            ];
            state.page.SettingsNotifications.isResetting = false;
            if (!msg.payload.wasSuccessful) return [
                state,
                []
            ];
            state.page.SettingsNotifications.data = $1ubKN.markAsLoading(state.page.SettingsNotifications.data);
            state.page.SettingsNotifications.changes = {};
            return [
                state,
                [
                    $0b52e672722f75d2$export$b0a0681fc38b10d1(state.account.accessToken, (result)=>(0, $dErh8.Msg).SettingsNotifications_Incoming({
                            result: result
                        }))
                ]
            ];
        case "SettingsNotifications_IncomingSendTestMail":
            state.page.SettingsNotifications.isSendingTestMail = false;
            return [
                state,
                []
            ];
        case "SettingsNotifications_OnSendTestMail":
            if (state.account === null) return [
                state,
                []
            ];
            state.page.SettingsNotifications.isSendingTestMail = true;
            return [
                state,
                [
                    $0b52e672722f75d2$export$e76d47496ef8fe27(state.account.accessToken, (0, $dErh8.Msg).SettingsNotifications_IncomingSendTestMail)
                ]
            ];
        case "SettingsNotifications_OnChange":
            state.page.SettingsNotifications.changes = msg.payload;
            return [
                state,
                []
            ];
        case "SettingsNotifications_OnSave":
            {
                if (state.account === null) return [
                    state,
                    []
                ];
                if (Object.keys(state.page.SettingsNotifications.changes).length === 0) return [
                    state,
                    []
                ];
                const originalValue = $1ubKN.value(state.page.SettingsNotifications.data);
                if (originalValue === undefined) return [
                    state,
                    []
                ];
                const value = {
                    ...originalValue,
                    ...state.page.SettingsNotifications.changes
                };
                state.page.SettingsNotifications.isSaving = true;
                return [
                    state,
                    [
                        $0b52e672722f75d2$export$521c0d1ccb71a481(state.account.accessToken, value, (result)=>(0, $dErh8.Msg).SettingsNotifications_IncomingSave({
                                result: result
                            }))
                    ]
                ];
            }
        case "SettingsNotifications_OnReset":
            if (state.account === null) return [
                state,
                []
            ];
            state.page.SettingsNotifications.isResetting = true;
            return [
                state,
                [
                    $0b52e672722f75d2$export$688471111d91c7fb(state.account.accessToken, (wasSuccessful)=>(0, $dErh8.Msg).SettingsNotifications_IncomingReset({
                            wasSuccessful: wasSuccessful
                        }))
                ]
            ];
        case "SettingsNotifications_OnCancel":
            state.page.SettingsNotifications.changes = {};
            return [
                state,
                []
            ];
        case "SettingsStock_Incoming":
            return $jqoka.match(msg.payload.result, {
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    state.page.SettingsStock.data = $1ubKN.markAsFailed(state.page.SettingsStock.data);
                    return [
                        state,
                        $fd60965d4b27bd3f$var$cacheExcludedVehicles(state)
                    ];
                },
                Ok: (data)=>{
                    state.page.SettingsStock.data = $1ubKN.markAsLoaded(state.page.SettingsStock.data, data);
                    return [
                        state,
                        $fd60965d4b27bd3f$var$cacheExcludedVehicles(state)
                    ];
                }
            });
        case "SettingsStock_IncomingVehicleCount":
            return $jqoka.match(msg.payload.result, {
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    state.page.SettingsStock.stockCount = $1ubKN.markAsFailed(state.page.SettingsStock.stockCount);
                    return [
                        state,
                        []
                    ];
                },
                Ok: (data)=>{
                    state.page.SettingsStock.stockCount = $1ubKN.markAsLoaded(state.page.SettingsStock.stockCount, data);
                    return [
                        state,
                        []
                    ];
                }
            });
        case "SettingsStock_IncomingSave":
            state.page.SettingsStock.isSaving = false;
            return $jqoka.match(msg.payload.result, {
                Ok: ()=>{
                    state.page.SettingsStock.changes = {};
                    return [
                        state,
                        [
                            $0b52e672722f75d2$export$be6367adeb077076(state.account.accessToken, (result)=>(0, $dErh8.Msg).SettingsStock_Incoming({
                                    result: result
                                })),
                            $0b52e672722f75d2$export$aceb985d559ad4(state.account.accessToken, (result)=>(0, $dErh8.Msg).Incoming_StockSelection($jqoka.map(result, (payload)=>({
                                        total: payload.totalStock,
                                        selected: payload.filteredStock
                                    })))),
                            $fd60965d4b27bd3f$var$retrieveSettingsStockVehicleCount(state.account.accessToken)
                        ]
                    ];
                },
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    return [
                        state,
                        []
                    ];
                }
            });
        case "SettingsStock_IncomingReset":
            if (state.account === null) return [
                state,
                []
            ];
            state.page.SettingsStock.isResetting = false;
            if (!msg.payload.wasSuccessful) return [
                state,
                []
            ];
            state.page.SettingsStock.data = $1ubKN.markAsLoading(state.page.SettingsStock.data);
            state.page.SettingsStock.changes = {};
            return [
                state,
                [
                    $0b52e672722f75d2$export$be6367adeb077076(state.account.accessToken, (result)=>(0, $dErh8.Msg).SettingsStock_Incoming({
                            result: result
                        }))
                ]
            ];
        case "SettingsStock_OnChange":
            state.page.SettingsStock.changes = msg.payload;
            return [
                state,
                $fd60965d4b27bd3f$var$cacheExcludedVehicles(state)
            ];
        case "SettingsStock_OnSave":
            {
                if (state.account === null) return [
                    state,
                    []
                ];
                if (Object.keys(state.page.SettingsStock.changes).length === 0) return [
                    state,
                    []
                ];
                const originalValue = $1ubKN.value(state.page.SettingsStock.data);
                if (originalValue === undefined) return [
                    state,
                    []
                ];
                const value = $210eY.fromForm($210eY.toForm(originalValue, state.page.SettingsStock.changes));
                state.page.SettingsStock.isSaving = true;
                return [
                    state,
                    [
                        $0b52e672722f75d2$export$528313ee297bca90(state.account.accessToken, value, (result)=>(0, $dErh8.Msg).SettingsStock_IncomingSave({
                                result: result
                            }))
                    ]
                ];
            }
        case "SettingsStock_OnCancel":
            state.page.SettingsStock.changes = {};
            return [
                state,
                []
            ];
        case "SettingsStock_OnReset":
            if (state.account === null) return [
                state,
                []
            ];
            state.page.SettingsStock.isResetting = true;
            return [
                state,
                [
                    $0b52e672722f75d2$export$d39fb861e07ce4f0(state.account.accessToken, (wasSuccessful)=>(0, $dErh8.Msg).SettingsStock_IncomingReset({
                            wasSuccessful: wasSuccessful
                        })),
                    $fd60965d4b27bd3f$var$retrieveSettingsStockVehicleCount(state.account.accessToken)
                ]
            ];
        case "SettingsStock_OnSearchVehicle":
            if (state.account === null) return [
                state,
                []
            ];
            state.page.SettingsStock.searchVehicles = $1ubKN.markAsLoading(state.page.SettingsStock.searchVehicles);
            return [
                state,
                [
                    $0b52e672722f75d2$export$5dc3064b6db5b9c(state.account.accessToken, {
                        search: msg.payload,
                        page: 1,
                        amountPerPage: 10,
                        sort: "merk_model_uitv",
                        sortDirection: "ASC",
                        onlyWithWarnings: false
                    }, (result)=>(0, $dErh8.Msg).SettingsStock_IncomingSearchVehicle($jqoka.map(result, ({ vehicles: vehicles })=>vehicles)))
                ]
            ];
        case "SettingsStock_IncomingSearchVehicle":
            return $jqoka.match(msg.payload, {
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    state.page.SettingsStock.searchVehicles = $1ubKN.markAsFailed(state.page.SettingsStock.searchVehicles);
                    return [
                        state,
                        []
                    ];
                },
                Ok: (data)=>{
                    state.page.SettingsStock.searchVehicles = $1ubKN.markAsLoaded(state.page.SettingsStock.searchVehicles, data);
                    return [
                        state,
                        []
                    ];
                }
            });
        case "SettingsCompetingVehicles_Incoming":
            return $jqoka.match(msg.payload.result, {
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    state.page.SettingsCompetingVehicles.data = $1ubKN.markAsFailed(state.page.SettingsCompetingVehicles.data);
                    return [
                        state,
                        []
                    ];
                },
                Ok: (data)=>{
                    state.page.SettingsCompetingVehicles.data = $1ubKN.markAsLoaded(state.page.SettingsCompetingVehicles.data, data);
                    return [
                        state,
                        []
                    ];
                }
            });
        case "SettingsCompetingVehicles_IncomingSave":
            state.page.SettingsCompetingVehicles.isSaving = false;
            return $jqoka.match(msg.payload.result, {
                Ok: ()=>{
                    state.page.SettingsCompetingVehicles.data = $1ubKN.map(state.page.SettingsCompetingVehicles.data, (settings)=>({
                            ...settings,
                            ...state.page.SettingsCompetingVehicles.changes
                        }));
                    state.page.SettingsCompetingVehicles.changes = {};
                    return [
                        state,
                        []
                    ];
                },
                Err: (error)=>{
                    const handledError = $fd60965d4b27bd3f$var$onApplicationError(error, state);
                    if (handledError !== null) return handledError;
                    return [
                        state,
                        []
                    ];
                }
            });
        case "SettingsCompetingVehicles_IncomingReset":
            if (state.account === null) return [
                state,
                []
            ];
            state.page.SettingsCompetingVehicles.isResetting = false;
            if (!msg.payload.wasSuccessful) return [
                state,
                []
            ];
            state.page.SettingsCompetingVehicles.data = $1ubKN.markAsLoading(state.page.SettingsCompetingVehicles.data);
            state.page.SettingsCompetingVehicles.changes = {};
            return [
                state,
                [
                    $0b52e672722f75d2$export$f85c8b69eed70986(state.account.accessToken, "0", (result)=>(0, $dErh8.Msg).SettingsCompetingVehicles_Incoming({
                            result: result
                        }))
                ]
            ];
        case "SettingsCompetingVehicles_OnChange":
            state.page.SettingsCompetingVehicles.changes = msg.payload.value;
            return [
                state,
                []
            ];
        case "SettingsCompetingVehicles_OnSave":
            {
                if (state.account === null) return [
                    state,
                    []
                ];
                if (Object.keys(state.page.SettingsCompetingVehicles.changes).length === 0) return [
                    state,
                    []
                ];
                const originalValue = $1ubKN.value(state.page.SettingsCompetingVehicles.data);
                if (originalValue === undefined) return [
                    state,
                    []
                ];
                const value = {
                    ...originalValue,
                    ...state.page.SettingsCompetingVehicles.changes
                };
                state.page.SettingsCompetingVehicles.isSaving = true;
                return [
                    state,
                    [
                        $0b52e672722f75d2$export$de4a167f7c9d1b43(state.account.accessToken, "0", value, (result)=>(0, $dErh8.Msg).SettingsCompetingVehicles_IncomingSave({
                                result: result
                            }))
                    ]
                ];
            }
        case "SettingsCompetingVehicles_OnReset":
            if (state.account === null) return [
                state,
                []
            ];
            state.page.SettingsCompetingVehicles.isResetting = true;
            return [
                state,
                [
                    $0b52e672722f75d2$export$f30d7d3a2dd4715(state.account.accessToken, "0", (wasSuccessful)=>(0, $dErh8.Msg).SettingsCompetingVehicles_IncomingReset({
                            wasSuccessful: wasSuccessful
                        }))
                ]
            ];
        case "SettingsCompetingVehicles_OnCancel":
            state.page.SettingsCompetingVehicles.changes = {};
            return [
                state,
                []
            ];
        default:
            (0, $3b66fc74e6759da7$export$7212e0e3e3b6e766)(msg);
    }
    return [
        state,
        []
    ];
}
function $fd60965d4b27bd3f$var$onApplicationError(error, state) {
    if ($fb0eT.debug) console.error("Application error:", error);
    switch(error.type){
        case "AuthenticationError":
            return $fd60965d4b27bd3f$var$onAuthenticationError(state);
        case "RedirectError":
            return $fd60965d4b27bd3f$var$onRedirectError(error.location, state);
        case "UnexpectedError":
            console.error("Unexpected error:", error.originalError);
            return null;
        default:
            return null;
    }
}
function $fd60965d4b27bd3f$var$onAuthenticationError(state) {
    const [initState] = $fd60965d4b27bd3f$var$init({
        deviceLayout: state.deviceLayout,
        authentication: null,
        permanentSettings: {
            stockAmountPerPage: state.page.Stock.amountPerPage,
            leadsAmountPerPage: state.page.Leads.amountPerPage,
            prospectsAmountPerPage: state.page.Prospects.amountPerPage
        }
    });
    sessionStorage.removeItem("authentication");
    return [
        initState,
        [
            Promise.resolve((0, $dErh8.Msg).Navigate("/login"))
        ]
    ];
}
function $fd60965d4b27bd3f$var$onRedirectError(location, state) {
    if (location !== undefined) window.location.href = location;
    return [
        state,
        []
    ];
}
function $fd60965d4b27bd3f$var$onRouteToVehiclePage([state, cmd]) {
    if (state.account === null) return [
        state,
        cmd
    ];
    switch(state.route.id){
        case "VehicleDashboard":
        case "VehicleSettings":
        case "VehicleReachOverview":
        case "VehicleReachPriceEffect":
        case "VehicleComparisonOverview":
        case "VehicleComparisonPriceAnalysis":
        case "VehicleComparisonPriceHistory":
        case "VehicleComparisonGeographic":
            {
                state.cachedVehicles = (0, $c9d0f3356cb93170$export$2e2bcd8739ae039).clearExpired($fd60965d4b27bd3f$var$vehicleCachePredicate, state.cachedVehicles);
                const vehicleId = state.route.params.vehicleId;
                const cachedVehicle = (0, $c9d0f3356cb93170$export$2e2bcd8739ae039).getValue(vehicleId, state.cachedVehicles);
                if (cachedVehicle === undefined) return [
                    state,
                    [
                        ...cmd,
                        $0b52e672722f75d2$export$12f64674bb7bf6e4(state.account.accessToken, vehicleId, (0, $dErh8.Msg).Incoming_Vehicle)
                    ]
                ];
            }
    }
    return [
        state,
        cmd
    ];
}
function $fd60965d4b27bd3f$var$onRouteToTaxationPage([state, cmd]) {
    if (state.account === null) return [
        state,
        cmd
    ];
    switch(state.route.id){
        case "TaxationDashboard":
        case "TaxationSettings":
        case "TaxationComparisonOverview":
        case "TaxationComparisonPriceAnalysis":
        case "TaxationComparisonPriceHistory":
        case "TaxationComparisonGeographic":
            {
                state.cachedVehicles = (0, $c9d0f3356cb93170$export$2e2bcd8739ae039).clearExpired($fd60965d4b27bd3f$var$vehicleCachePredicate, state.cachedVehicles);
                const vehicleId = state.route.params.vehicleId;
                const cachedVehicle = (0, $c9d0f3356cb93170$export$2e2bcd8739ae039).getValue(vehicleId, state.cachedVehicles);
                if (cachedVehicle === undefined) return [
                    state,
                    [
                        ...cmd,
                        $0b52e672722f75d2$export$f0c25d078d304456(state.account.accessToken, vehicleId, (0, $dErh8.Msg).Incoming_Vehicle)
                    ]
                ];
            }
    }
    return [
        state,
        cmd
    ];
}
function $fd60965d4b27bd3f$var$vehicleCachePredicate(_, createdOn) {
    return createdOn.valueOf() + 86400000 < Date.now();
}
function $fd60965d4b27bd3f$var$onRouteToPageWithDealers([state, cmd]) {
    if (!$1ubKN.isIdle(state.settings.dealers)) return [
        state,
        cmd
    ];
    state.settings.dealers = $1ubKN.markAsLoading(state.settings.dealers);
    return [
        state,
        [
            ...cmd,
            $0b52e672722f75d2$export$95f519620f38a864(state.account.accessToken, (0, $dErh8.Msg).Incoming_Dealers)
        ]
    ];
}
function $fd60965d4b27bd3f$var$onComparisonProfileChange(payload, state) {
    state.page.ComparisonAdvicePrice.activeProfile = payload;
    state.page.ComparisonDaysInStock.activeProfile = payload;
    state.page.ComparisonGeographic.activeProfile = payload;
    return state;
}
function $fd60965d4b27bd3f$var$onComparisonMakeFilterChange(payload, availableModels, selectedModels, state) {
    const models = new Set(availableModels.filter((model)=>payload.has(model.make)).filter((model)=>selectedModels.has(model.model)).map((model)=>model.model));
    state.page.ComparisonAdvicePrice.makeFilter = payload;
    state.page.ComparisonDaysInStock.makeFilter = payload;
    state.page.ComparisonAdvicePrice.modelFilter = models;
    state.page.ComparisonDaysInStock.modelFilter = models;
    return state;
}
function $fd60965d4b27bd3f$var$onComparisonModelFilterChange(payload, state) {
    state.page.ComparisonAdvicePrice.modelFilter = payload;
    state.page.ComparisonDaysInStock.modelFilter = payload;
    return state;
}
function $fd60965d4b27bd3f$var$onVehicleComparisonStatusChange(payload, state) {
    state.page.VehicleComparisonOverview.vehicleStatus = payload;
    state.page.VehicleComparisonPriceAnalysis.vehicleStatus = payload;
    state.page.VehicleComparisonPriceHistory.vehicleStatus = payload;
    state.page.VehicleComparisonGeographic.vehicleStatus = payload;
    return state;
}
function $fd60965d4b27bd3f$var$onTaxationComparisonStatusChange(payload, state) {
    state.page.TaxationComparisonOverview.vehicleStatus = payload;
    state.page.TaxationComparisonPriceAnalysis.vehicleStatus = payload;
    state.page.TaxationComparisonPriceHistory.vehicleStatus = payload;
    state.page.TaxationComparisonGeographic.vehicleStatus = payload;
    return state;
}
function $fd60965d4b27bd3f$var$cacheExcludedVehicles(state) {
    const isCached = (vehicleId)=>{
        return (0, $c9d0f3356cb93170$export$2e2bcd8739ae039).getValue(vehicleId, state.cachedVehicles) !== undefined;
    };
    return $1ubKN.match(state.page.SettingsStock.data, {
        Loaded: ({ excludedvehicleids: excludedvehicleids })=>{
            if (state.account === null) return [];
            const accessToken = state.account.accessToken;
            const vehicleIds = [
                ...excludedvehicleids,
                ...Array.from(state.page.SettingsStock.changes.excludedvehicleids ?? new Set())
            ];
            return vehicleIds.filter((x)=>!isCached(x)).map((vehicleId)=>$0b52e672722f75d2$export$12f64674bb7bf6e4(accessToken, vehicleId, (0, $dErh8.Msg).Incoming_Vehicle));
        },
        Idle: ()=>[],
        Loading: ()=>[],
        Failed: ()=>[]
    });
}
function $fd60965d4b27bd3f$var$retrieveDealerStock(authentication, state) {
    return $0b52e672722f75d2$export$5dc3064b6db5b9c(authentication, {
        page: state.page,
        amountPerPage: state.amountPerPage,
        sort: state.sort,
        sortDirection: state.sortDirection,
        search: state.search === "" ? undefined : state.search,
        onlyWithWarnings: state.onlyWithWarnings
    }, (0, $dErh8.Msg).Stock_Incoming);
}
function $fd60965d4b27bd3f$var$retrieveDealerLeads(authentication, state) {
    return $0b52e672722f75d2$export$80dce8f245200185(authentication, {
        sort: state.sort,
        period: state.period,
        search: state.search,
        filter: state.filter,
        page: state.page,
        amountPerPage: state.amountPerPage
    }, (0, $dErh8.Msg).Leads_Incoming);
}
function $fd60965d4b27bd3f$var$retrieveDealerProspects(authentication, state) {
    return $0b52e672722f75d2$export$1478c0c5a627cf4d(authentication, {
        period: state.period
    }, (0, $dErh8.Msg).Prospects_Incoming);
}
function $fd60965d4b27bd3f$var$retrieveAnalysisOverview(authentication, state) {
    return $0b52e672722f75d2$export$3918dddb3fcdd1e2(authentication, state.profile, (0, $dErh8.Msg).AnalysisOverview_Incoming);
}
function $fd60965d4b27bd3f$var$retrieveAnalysisLeadPerformance(authentication, state) {
    return $0b52e672722f75d2$export$6f2cf8dc2683e0aa(authentication, state.period, (0, $dErh8.Msg).AnalysisLeadPerformance_Incoming);
}
function $fd60965d4b27bd3f$var$retrieveComparisonAdvicePrice(authentication, fallbackProfile, state) {
    return $0b52e672722f75d2$export$f99ffec57e6e1e1f(authentication, {
        profile: state.activeProfile ?? fallbackProfile.id,
        makes: state.makeFilter,
        models: state.modelFilter
    }, (0, $dErh8.Msg).ComparisonAdvicePrice_Incoming);
}
function $fd60965d4b27bd3f$var$retrieveComparisonDaysInStock(authentication, fallbackProfile, state) {
    return $0b52e672722f75d2$export$f99ffec57e6e1e1f(authentication, {
        profile: state.activeProfile ?? fallbackProfile.id,
        makes: state.makeFilter,
        models: state.modelFilter
    }, (0, $dErh8.Msg).ComparisonDaysInStock_Incoming);
}
function $fd60965d4b27bd3f$var$retrieveComparisonGeographic(authentication, fallbackProfile, state) {
    return $0b52e672722f75d2$export$f99ffec57e6e1e1f(authentication, {
        profile: state.activeProfile ?? fallbackProfile.id,
        makes: new Set(),
        models: new Set()
    }, (0, $dErh8.Msg).ComparisonGeographic_Incoming);
}
function $fd60965d4b27bd3f$var$retrieveCompetitionDealers(authentication, state) {
    return $0b52e672722f75d2$export$5c0f379364891dee(authentication, {
        search: state.page.SettingsCompetingCompaniesProfile.filters.search,
        dealerTypes: state.page.SettingsCompetingCompaniesProfile.filters.dealerTypes,
        provinces: state.page.SettingsCompetingCompaniesProfile.filters.provinces,
        dealerMakes: state.page.SettingsCompetingCompaniesProfile.filters.dealerMakes,
        stockMakes: state.page.SettingsCompetingCompaniesProfile.filters.stockMakes
    }, (result)=>(0, $dErh8.Msg).SettingsCompetingDealersProfile_IncomingDealers({
            filters: state.page.SettingsCompetingCompaniesProfile.filters,
            result: result
        }));
}
function $fd60965d4b27bd3f$var$retrieveSettingsStockVehicleCount(authentication) {
    return $0b52e672722f75d2$export$5dc3064b6db5b9c(authentication, {
        page: 1,
        amountPerPage: 10,
        sort: "merk_model_uitv"
    }, (result)=>(0, $dErh8.Msg).SettingsStock_IncomingVehicleCount({
            result: $jqoka.map(result, ({ totalVehicles: totalVehicles })=>totalVehicles)
        }));
}
function $fd60965d4b27bd3f$var$toTaxationWidget(dispatch, state) {
    if (state.deviceLayout !== "Desktop") return;
    if (state.account?.type !== "Dealer") return;
    return {
        licensePlate: state.taxationWidget.licensePlate,
        mileage: state.taxationWidget.mileage,
        errorMessage: state.taxationWidget.errorMessage,
        onLicensePlateChange: dispatch((0, $dErh8.Msg).TaxationWidget_OnInputLicensePlate),
        onMileageChange: dispatch((0, $dErh8.Msg).TaxationWidget_OnInputMileage),
        onSubmit: dispatch((0, $dErh8.Msg).TaxationWidget_OnSubmit),
        onClearErrorMessage: dispatch((0, $dErh8.Msg).TaxationWidget_OnClearErrorMessage)
    };
}


//# sourceMappingURL=index.3363f7b6.js.map
